import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  JSON: any;
  Timestamp: any;
};

export type AdminNotesInput = {
  notes?: InputMaybe<Scalars['String']>;
};

export type Answer = {
  __typename: 'Answer';
  application: Application;
  applicationId: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  /** Returns a the cloudinary public video url with transformations */
  mediaUrlWithTransformations?: Maybe<Scalars['String']>;
  question: Question;
  questionId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type AnswerCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type AnswerMediaUrlWithTransformationsArgs = {
  mediaConfigName?: InputMaybe<VideoConfigNameEnum>;
};


export type AnswerUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type AnswerInput = {
  essay?: InputMaybe<EssayAnswerInput>;
  video?: InputMaybe<VideoAnswerInput>;
};

export type AnswerListRelationFilter = {
  every?: InputMaybe<AnswerWhereInput>;
  none?: InputMaybe<AnswerWhereInput>;
  some?: InputMaybe<AnswerWhereInput>;
};

export type AnswerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnswerOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<MediaOrderByWithRelationInput>;
  mediaId?: InputMaybe<SortOrder>;
  question?: InputMaybe<QuestionOrderByWithRelationInput>;
  questionId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnswerScalarFieldEnum {
  ApplicationId = 'applicationId',
  Comment = 'comment',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  MediaId = 'mediaId',
  QuestionId = 'questionId',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type AnswerWhereInput = {
  AND?: InputMaybe<Array<AnswerWhereInput>>;
  NOT?: InputMaybe<Array<AnswerWhereInput>>;
  OR?: InputMaybe<Array<AnswerWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  media?: InputMaybe<MediaRelationFilter>;
  mediaId?: InputMaybe<StringNullableFilter>;
  question?: InputMaybe<QuestionRelationFilter>;
  questionId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnswerWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApplePaymentTransactionIntent = {
  __typename: 'ApplePaymentTransactionIntent';
  product: PaymentProviderProduct;
  productQty: Scalars['Int'];
  transaction: Transaction;
};

export type Application = {
  __typename: 'Application';
  _count?: Maybe<ApplicationCount>;
  acceptedContentTOSAt?: Maybe<Scalars['DateTime']>;
  answers: Array<Answer>;
  applicationTickets: Array<ApplicationTicket>;
  classificationTags: Array<PublicCommonContentTag>;
  clonedFromTag?: Maybe<CommonTagContent>;
  clonedToTag?: Maybe<CommonTagContent>;
  cohort: Cohort;
  cohortId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credential_assignment: Array<CredentialAssignment>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  featured_application: Array<FeaturedApplication>;
  hasAcceptedContentTOS: Scalars['Boolean'];
  id: Scalars['ID'];
  isExpired: Scalars['Boolean'];
  isFinalist: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isScholarship: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoExpiresAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  metadata: Scalars['JSON'];
  price: Scalars['Int'];
  rating?: Maybe<Scalars['Int']>;
  referralCodeAttempt?: Maybe<ReferralCodeAttempt>;
  referralCodeAttemptId?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  reviews: Array<Review>;
  scholarshipApplication?: Maybe<ScholarshipApplication>;
  state: ApplicationStateEnum;
  tasks: Array<Task>;
  ticketsReceived: Scalars['Float'];
  totalUnreadMessages: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};


export type ApplicationAnswersArgs = {
  cursor?: InputMaybe<AnswerWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnswerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnswerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnswerWhereInput>;
};


export type ApplicationApplicationTicketsArgs = {
  cursor?: InputMaybe<ApplicationTicketWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationTicketScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationTicketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationTicketWhereInput>;
};


export type ApplicationClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


export type ApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ApplicationCredential_AssignmentArgs = {
  cursor?: InputMaybe<CredentialAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialAssignmentWhereInput>;
};


export type ApplicationExpiresAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ApplicationFeatured_ApplicationArgs = {
  cursor?: InputMaybe<FeaturedApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedApplicationWhereInput>;
};


export type ApplicationReviewsArgs = {
  cursor?: InputMaybe<ReviewWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReviewScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReviewOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewWhereInput>;
};


export type ApplicationTasksArgs = {
  cursor?: InputMaybe<TaskWhereUniqueInput>;
  distinct?: InputMaybe<Array<TaskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TaskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskWhereInput>;
};


export type ApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Actions to update the application state */
export enum ApplicationAction {
  Accept = 'ACCEPT',
  AnswersAdded = 'ANSWERS_ADDED',
  AnswersCompleted = 'ANSWERS_COMPLETED',
  Draft = 'DRAFT',
  DraftRemoved = 'DRAFT_REMOVED',
  Expire = 'EXPIRE',
  Final = 'FINAL',
  ModerationApprove = 'MODERATION_APPROVE',
  ModerationBan = 'MODERATION_BAN',
  ModerationReject = 'MODERATION_REJECT',
  Paid = 'PAID',
  PaidWithoutAnswers = 'PAID_WITHOUT_ANSWERS',
  ProfileAdded = 'PROFILE_ADDED',
  ProfileRemoved = 'PROFILE_REMOVED',
  Reject = 'REJECT',
  RemoveByAdmin = 'REMOVE_BY_ADMIN',
  Review = 'REVIEW',
  ScholarshipAwarded = 'SCHOLARSHIP_AWARDED',
  ScholarshipCanceled = 'SCHOLARSHIP_CANCELED',
  ScholarshipDraftConfirmed = 'SCHOLARSHIP_DRAFT_CONFIRMED',
  ScholarshipNotAwarded = 'SCHOLARSHIP_NOT_AWARDED',
  Skip = 'SKIP',
  StudentRefunded = 'STUDENT_REFUNDED'
}

export type ApplicationCount = {
  __typename: 'ApplicationCount';
  answers: Scalars['Int'];
  applicationTickets: Scalars['Int'];
  credential_assignment: Scalars['Int'];
  featured_application: Scalars['Int'];
  reviews: Scalars['Int'];
  tasks: Scalars['Int'];
};

export type ApplicationListRelationFilter = {
  every?: InputMaybe<ApplicationWhereInput>;
  none?: InputMaybe<ApplicationWhereInput>;
  some?: InputMaybe<ApplicationWhereInput>;
};

export type ApplicationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApplicationOrderByWithRelationInput = {
  acceptedContentTOSAt?: InputMaybe<SortOrder>;
  answers?: InputMaybe<AnswerOrderByRelationAggregateInput>;
  applicationTickets?: InputMaybe<ApplicationTicketOrderByRelationAggregateInput>;
  cohort?: InputMaybe<CohortOrderByWithRelationInput>;
  cohortId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credential_assignment?: InputMaybe<CredentialAssignmentOrderByRelationAggregateInput>;
  expiresAt?: InputMaybe<SortOrder>;
  featured_application?: InputMaybe<FeaturedApplicationOrderByRelationAggregateInput>;
  hasAcceptedContentTOS?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isFinalist?: InputMaybe<SortOrder>;
  isPublic?: InputMaybe<SortOrder>;
  isScholarship?: InputMaybe<SortOrder>;
  lastViewedAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  referralCodeAttempt?: InputMaybe<ReferralCodeAttemptOrderByWithRelationInput>;
  referralCodeAttemptId?: InputMaybe<SortOrder>;
  rejectionReason?: InputMaybe<SortOrder>;
  reviews?: InputMaybe<ReviewOrderByRelationAggregateInput>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationOrderByWithRelationInput>;
  state?: InputMaybe<SortOrder>;
  tasks?: InputMaybe<TaskOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

/** An error that occurs when a student ask for an application refund */
export type ApplicationRefundErrorResponse = {
  __typename: 'ApplicationRefundErrorResponse';
  message?: Maybe<Scalars['String']>;
  type: ApplicationRefundErrorType;
};

/** Errors related to an application refund */
export enum ApplicationRefundErrorType {
  InvalidState = 'INVALID_STATE',
  IsScholarship = 'IS_SCHOLARSHIP',
  NotFound = 'NOT_FOUND',
  NotTheOwner = 'NOT_THE_OWNER',
  RefundFailed = 'REFUND_FAILED'
}

export type ApplicationRefundResponse = ApplicationRefundErrorResponse | PrivilegedApplication;

export type ApplicationRelationFilter = {
  is?: InputMaybe<ApplicationWhereInput>;
  isNot?: InputMaybe<ApplicationWhereInput>;
};

export type ApplicationRemovalByAdminInput = {
  applicationId: Scalars['ID'];
  reason: Scalars['String'];
};

export enum ApplicationScalarFieldEnum {
  AcceptedContentTosAt = 'acceptedContentTOSAt',
  CohortId = 'cohortId',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  HasAcceptedContentTos = 'hasAcceptedContentTOS',
  Id = 'id',
  IsFinalist = 'isFinalist',
  IsPublic = 'isPublic',
  IsScholarship = 'isScholarship',
  LastViewedAt = 'lastViewedAt',
  Metadata = 'metadata',
  Price = 'price',
  Rating = 'rating',
  ReferralCodeAttemptId = 'referralCodeAttemptId',
  RejectionReason = 'rejectionReason',
  State = 'state',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum ApplicationStateEnum {
  Accepted = 'Accepted',
  CohortProspect = 'CohortProspect',
  Create = 'Create',
  DraftNoPayment = 'DraftNoPayment',
  DraftNoProfile = 'DraftNoProfile',
  DraftPaidNotPublished = 'DraftPaidNotPublished',
  DraftPaidProcessing = 'DraftPaidProcessing',
  Final = 'Final',
  PublishedBan = 'PublishedBan',
  PublishedCollectingScholarshipReferrals = 'PublishedCollectingScholarshipReferrals',
  PublishedCollectingVotes = 'PublishedCollectingVotes',
  PublishedPendingApproval = 'PublishedPendingApproval',
  PublishedPendingExpert = 'PublishedPendingExpert',
  PublishedPendingJudging = 'PublishedPendingJudging',
  PublishedRejected = 'PublishedRejected',
  Rejected = 'Rejected',
  RemovedByAdmin = 'RemovedByAdmin',
  Reviewed = 'Reviewed',
  ScholarshipNotAwarded = 'ScholarshipNotAwarded',
  StudentRefunded = 'StudentRefunded',
  Unprocessed = 'Unprocessed'
}

export type ApplicationTicket = {
  __typename: 'ApplicationTicket';
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type ApplicationTicketListRelationFilter = {
  every?: InputMaybe<ApplicationTicketWhereInput>;
  none?: InputMaybe<ApplicationTicketWhereInput>;
  some?: InputMaybe<ApplicationTicketWhereInput>;
};

export type ApplicationTicketOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApplicationTicketOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ApplicationTicketScalarFieldEnum {
  ApplicationId = 'applicationId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Quantity = 'quantity',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ApplicationTicketWhereInput = {
  AND?: InputMaybe<Array<ApplicationTicketWhereInput>>;
  NOT?: InputMaybe<Array<ApplicationTicketWhereInput>>;
  OR?: InputMaybe<Array<ApplicationTicketWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApplicationTicketWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApplicationWhereInput = {
  AND?: InputMaybe<Array<ApplicationWhereInput>>;
  NOT?: InputMaybe<Array<ApplicationWhereInput>>;
  OR?: InputMaybe<Array<ApplicationWhereInput>>;
  acceptedContentTOSAt?: InputMaybe<DateTimeNullableFilter>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  applicationTickets?: InputMaybe<ApplicationTicketListRelationFilter>;
  cohort?: InputMaybe<CohortRelationFilter>;
  cohortId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential_assignment?: InputMaybe<CredentialAssignmentListRelationFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  featured_application?: InputMaybe<FeaturedApplicationListRelationFilter>;
  hasAcceptedContentTOS?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  isFinalist?: InputMaybe<BoolFilter>;
  isPublic?: InputMaybe<BoolFilter>;
  isScholarship?: InputMaybe<BoolFilter>;
  lastViewedAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonFilter>;
  price?: InputMaybe<IntFilter>;
  rating?: InputMaybe<IntNullableFilter>;
  referralCodeAttempt?: InputMaybe<ReferralCodeAttemptRelationFilter>;
  referralCodeAttemptId?: InputMaybe<StringNullableFilter>;
  rejectionReason?: InputMaybe<StringNullableFilter>;
  reviews?: InputMaybe<ReviewListRelationFilter>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationRelationFilter>;
  state?: InputMaybe<EnumApplicationStateEnumFilter>;
  tasks?: InputMaybe<TaskListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApplicationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  referralCodeAttemptId?: InputMaybe<Scalars['String']>;
};

/** An error that occurs when authentication fails */
export type AuthErrorResponse = {
  __typename: 'AuthErrorResponse';
  message?: Maybe<Scalars['String']>;
  type: AuthErrorType;
};

/** Errors related to an user authentication */
export enum AuthErrorType {
  InitAuthFailed = 'INIT_AUTH_FAILED',
  InternalError = 'INTERNAL_ERROR',
  InvalidInput = 'INVALID_INPUT',
  OtpVerificationFailed = 'OTP_VERIFICATION_FAILED',
  RefreshTokenFailed = 'REFRESH_TOKEN_FAILED',
  SignoutFailed = 'SIGNOUT_FAILED',
  UserNotFound = 'USER_NOT_FOUND',
  VipAccessCodeNotFound = 'VIP_ACCESS_CODE_NOT_FOUND'
}

export type AuthUserInput = {
  auth0Id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  referred?: InputMaybe<AuthUserReferred>;
  vipAccessCode?: InputMaybe<Scalars['String']>;
};

export type AuthUserReferred = {
  scholarshipApplicationId: Scalars['String'];
};

export type BaseFeaturedApplication = {
  __typename: 'BaseFeaturedApplication';
  application?: Maybe<PublicApplication>;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  review?: Maybe<PublicReview>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


export type BaseFeaturedApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type BaseFeaturedApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type Category = {
  __typename: 'Category';
  _count?: Maybe<CategoryCount>;
  backgroundColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fontColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type CategoryCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CategoryUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CategoryCount = {
  __typename: 'CategoryCount';
  category: Scalars['Int'];
  cohort: Scalars['Int'];
  userCategories: Scalars['Int'];
};

export type CategoryListRelationFilter = {
  every?: InputMaybe<CategoryWhereInput>;
  none?: InputMaybe<CategoryWhereInput>;
  some?: InputMaybe<CategoryWhereInput>;
};

export type CategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationInput = {
  backgroundColor?: InputMaybe<SortOrder>;
  category?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  cohort?: InputMaybe<CohortOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  fontColor?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parent?: InputMaybe<CategoryOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userCategories?: InputMaybe<UserCategoryOrderByRelationAggregateInput>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  BackgroundColor = 'backgroundColor',
  CreatedAt = 'createdAt',
  FontColor = 'fontColor',
  Id = 'id',
  Name = 'name',
  ParentId = 'parentId',
  SortOrder = 'sortOrder',
  UpdatedAt = 'updatedAt'
}

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  backgroundColor?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<CategoryListRelationFilter>;
  cohort?: InputMaybe<CohortListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fontColor?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<CategoryRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userCategories?: InputMaybe<UserCategoryListRelationFilter>;
};

export type CategoryWhereUniqueInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Cohort = {
  __typename: 'Cohort';
  _count?: Maybe<CohortCount>;
  aggregateApplicationLimit?: Maybe<Scalars['Int']>;
  applicationExpirationDeadline?: Maybe<Scalars['String']>;
  applicationExpirationWindow?: Maybe<Scalars['Int']>;
  applicationType: CohortApplicationTypeEnum;
  applications: Array<Application>;
  areApplicationsAvailable: Scalars['Boolean'];
  arePaidApplicationsAvailable: Scalars['Boolean'];
  areScholarshipsAvailable: Scalars['Boolean'];
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']>;
  charityBadge?: Maybe<CommonTagContent>;
  classificationTags: Array<PublicCommonContentTag>;
  comingSoon: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  credentialAssignmentGranted: Array<PublicCredentialAssignment>;
  credentialAssignmentReceived: Array<PublicCredentialAssignment>;
  description?: Maybe<Scalars['String']>;
  details: Array<DetailTagContent>;
  /** As cohort can have more than one expert, this returns the Featured Expert */
  expert: PublicUser;
  experts: Array<PublicUser>;
  featured: Scalars['Boolean'];
  featuredExperts: Array<FeaturedExpert>;
  featuredIndex?: Maybe<Scalars['Int']>;
  feedApplications: Array<PublicApplication>;
  hasPublishDeadlineExpired: Scalars['Boolean'];
  hasReviewDeadlineExpired: Scalars['Boolean'];
  /** @deprecated This deadline is going to be moved to the application itself */
  hasScholarshipDeadlineExpired: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isPaidOnly: Scalars['Boolean'];
  isScholarshipOnly: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoPublishedAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  numberOfCredentialsGranted: Scalars['Int'];
  numberOfCredentialsReceived: Scalars['Int'];
  paidApplicationLimit?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  prize?: Maybe<Scalars['String']>;
  prizeDetails?: Maybe<PrizeDetailTagContent>;
  publishDeadline?: Maybe<Scalars['String']>;
  publishDeadlineTimeLeft: Scalars['Timestamp'];
  publishWindow?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  purchaseOptions: Array<CohortApplicationPurchaseOption>;
  questions: Array<Question>;
  responseDetail?: Maybe<Scalars['String']>;
  /** @deprecated this field will be removed. use applicationExpirationDeadline instead */
  reviewDeadline?: Maybe<Scalars['String']>;
  reviewWindow?: Maybe<Scalars['Int']>;
  rules?: Maybe<Scalars['String']>;
  sampleAuditionVideo?: Maybe<Media>;
  sampleAuditionVideoId?: Maybe<Scalars['String']>;
  sampleReviewVideo?: Maybe<Media>;
  sampleReviewVideoId?: Maybe<Scalars['String']>;
  scholarshipApplicationLimit?: Maybe<Scalars['Int']>;
  /** @deprecated This deadline is going to be moved to the application itself */
  scholarshipDeadline?: Maybe<Scalars['String']>;
  scholarshipReferralsThreshold: Scalars['Int'];
  scholarshipVotesThreshold: Scalars['Int'];
  scholarshipWindow?: Maybe<Scalars['Int']>;
  scholarshipsAwarded: Scalars['Int'];
  /** @deprecated This field is going to be replaced by scholarshipApplicationLimit */
  scholarshipsEnabled?: Maybe<Scalars['Float']>;
  state: CohortStateEnum;
  symbol?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['JSON']>;
  totalApplications: Scalars['Int'];
  totalApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalFeedApplications: Scalars['Float'];
  totalPaidApplications: Scalars['Int'];
  totalPaidApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalScholarshipApplications: Scalars['Int'];
  totalScholarshipApplicationsRemaining?: Maybe<Scalars['Int']>;
  type: CohortTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userCohorts: Array<UserCohort>;
  whatToSend: Array<CommonTagContent>;
  whatYouReceive: Array<CommonTagContent>;
};


export type CohortApplicationExpirationDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


export type CohortClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


export type CohortCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortCredentialAssignmentGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


export type CohortCredentialAssignmentReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


export type CohortDetailsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


export type CohortExpertsArgs = {
  roles?: InputMaybe<Array<CohortManagementRole>>;
};


export type CohortFeaturedExpertsArgs = {
  cursor?: InputMaybe<FeaturedExpertWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedExpertScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedExpertOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedExpertWhereInput>;
};


export type CohortFeedApplicationsArgs = {
  idx?: InputMaybe<Scalars['ID']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CohortNumberOfCredentialsGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


export type CohortNumberOfCredentialsReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


export type CohortPublishDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortPublishedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortQuestionsArgs = {
  cursor?: InputMaybe<QuestionWhereUniqueInput>;
  distinct?: InputMaybe<Array<QuestionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<QuestionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuestionWhereInput>;
};


export type CohortReviewDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortScholarshipDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CohortUserCohortsArgs = {
  cursor?: InputMaybe<UserCohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCohortScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCohortOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserCohortWhereInput>;
};


export type CohortWhatToSendArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


export type CohortWhatYouReceiveArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};

/** Purchase options that can be used to acquire an application */
export enum CohortApplicationPurchaseOption {
  Paid = 'PAID',
  Scholarship = 'SCHOLARSHIP'
}

export enum CohortApplicationTypeEnum {
  CodeApplication = 'CodeApplication',
  EssayApplication = 'EssayApplication',
  VideoApplication = 'VideoApplication'
}

export type CohortCount = {
  __typename: 'CohortCount';
  applications: Scalars['Int'];
  featuredExperts: Scalars['Int'];
  questions: Scalars['Int'];
  userCohorts: Scalars['Int'];
};

export type CohortInput = {
  applicationType: CohortApplicationTypeEnum;
  categoryId: Scalars['String'];
  description: Scalars['String'];
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Featured cohort position index */
  featuredIndex?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  /** Limit of the cohort paid applications */
  paidApplicationLimit?: InputMaybe<Scalars['Int']>;
  /** Price in USD cents ($10.00 = 1000 cents) */
  price: Scalars['Int'];
  prize?: InputMaybe<Scalars['String']>;
  /** Publish window in days */
  publishWindow?: InputMaybe<Scalars['Int']>;
  questionSubmissions: Array<QuestionInput>;
  responseDetail?: InputMaybe<Scalars['String']>;
  /** Review window in days */
  reviewWindow?: InputMaybe<Scalars['Int']>;
  rules?: InputMaybe<Scalars['String']>;
  scholarship?: InputMaybe<CohortScholarshipInput>;
  state?: InputMaybe<CohortStateEnum>;
  symbol?: InputMaybe<Scalars['String']>;
  type: CohortTypeEnum;
  updateStatus?: InputMaybe<Scalars['String']>;
};

export type CohortListRelationFilter = {
  every?: InputMaybe<CohortWhereInput>;
  none?: InputMaybe<CohortWhereInput>;
  some?: InputMaybe<CohortWhereInput>;
};

/** Possible cohort management role names */
export enum CohortManagementRole {
  Expert = 'Expert',
  Judge = 'Judge',
  Observer = 'Observer'
}

export type CohortOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CohortOrderByWithRelationInput = {
  applicationExpirationWindow?: InputMaybe<SortOrder>;
  applicationType?: InputMaybe<SortOrder>;
  applications?: InputMaybe<ApplicationOrderByRelationAggregateInput>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  featuredExperts?: InputMaybe<FeaturedExpertOrderByRelationAggregateInput>;
  featuredIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paidApplicationLimit?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  prize?: InputMaybe<SortOrder>;
  publishWindow?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  questions?: InputMaybe<QuestionOrderByRelationAggregateInput>;
  responseDetail?: InputMaybe<SortOrder>;
  reviewWindow?: InputMaybe<SortOrder>;
  rules?: InputMaybe<SortOrder>;
  sampleAuditionVideo?: InputMaybe<MediaOrderByWithRelationInput>;
  sampleAuditionVideoId?: InputMaybe<SortOrder>;
  sampleReviewVideo?: InputMaybe<MediaOrderByWithRelationInput>;
  sampleReviewVideoId?: InputMaybe<SortOrder>;
  scholarshipApplicationLimit?: InputMaybe<SortOrder>;
  scholarshipReferralsThreshold?: InputMaybe<SortOrder>;
  scholarshipVotesThreshold?: InputMaybe<SortOrder>;
  scholarshipWindow?: InputMaybe<SortOrder>;
  scholarshipsAwarded?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  symbol?: InputMaybe<SortOrder>;
  timeline?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updateStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userCohorts?: InputMaybe<UserCohortOrderByRelationAggregateInput>;
};

export type CohortRelationFilter = {
  is?: InputMaybe<CohortWhereInput>;
  isNot?: InputMaybe<CohortWhereInput>;
};

/** Possible cohort role names */
export enum CohortRole {
  Expert = 'Expert',
  Judge = 'Judge',
  Observer = 'Observer',
  Student = 'Student'
}

export enum CohortScalarFieldEnum {
  ApplicationExpirationWindow = 'applicationExpirationWindow',
  ApplicationType = 'applicationType',
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Featured = 'featured',
  FeaturedIndex = 'featuredIndex',
  Id = 'id',
  Name = 'name',
  PaidApplicationLimit = 'paidApplicationLimit',
  Price = 'price',
  Prize = 'prize',
  PublishWindow = 'publishWindow',
  PublishedAt = 'publishedAt',
  ResponseDetail = 'responseDetail',
  ReviewWindow = 'reviewWindow',
  Rules = 'rules',
  SampleAuditionVideoId = 'sampleAuditionVideoId',
  SampleReviewVideoId = 'sampleReviewVideoId',
  ScholarshipApplicationLimit = 'scholarshipApplicationLimit',
  ScholarshipReferralsThreshold = 'scholarshipReferralsThreshold',
  ScholarshipVotesThreshold = 'scholarshipVotesThreshold',
  ScholarshipWindow = 'scholarshipWindow',
  ScholarshipsAwarded = 'scholarshipsAwarded',
  State = 'state',
  Symbol = 'symbol',
  Timeline = 'timeline',
  Type = 'type',
  UpdateStatus = 'updateStatus',
  UpdatedAt = 'updatedAt'
}

export type CohortScholarshipInput = {
  /** number of scholarships enabled */
  scholarshipApplicationLimit?: InputMaybe<Scalars['Int']>;
  /** number of referrals required for the scholarship to be accepted */
  scholarshipReferralsThreshold: Scalars['Int'];
  /** Scholarship window in days */
  scholarshipWindow?: InputMaybe<Scalars['Int']>;
};

export enum CohortStateEnum {
  Completed = 'Completed',
  Draft = 'Draft',
  Final = 'Final',
  InReview = 'InReview',
  Published = 'Published',
  Started = 'Started'
}

export enum CohortTypeEnum {
  Coaching = 'Coaching',
  Opportunity = 'Opportunity',
  TalentShow = 'TalentShow'
}

export type CohortWhereInput = {
  AND?: InputMaybe<Array<CohortWhereInput>>;
  NOT?: InputMaybe<Array<CohortWhereInput>>;
  OR?: InputMaybe<Array<CohortWhereInput>>;
  applicationExpirationWindow?: InputMaybe<IntNullableFilter>;
  applicationType?: InputMaybe<EnumCohortApplicationTypeEnumFilter>;
  applications?: InputMaybe<ApplicationListRelationFilter>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  featured?: InputMaybe<BoolFilter>;
  featuredExperts?: InputMaybe<FeaturedExpertListRelationFilter>;
  featuredIndex?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  paidApplicationLimit?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<IntFilter>;
  prize?: InputMaybe<StringNullableFilter>;
  publishWindow?: InputMaybe<IntNullableFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  questions?: InputMaybe<QuestionListRelationFilter>;
  responseDetail?: InputMaybe<StringNullableFilter>;
  reviewWindow?: InputMaybe<IntNullableFilter>;
  rules?: InputMaybe<StringNullableFilter>;
  sampleAuditionVideo?: InputMaybe<MediaRelationFilter>;
  sampleAuditionVideoId?: InputMaybe<StringNullableFilter>;
  sampleReviewVideo?: InputMaybe<MediaRelationFilter>;
  sampleReviewVideoId?: InputMaybe<StringNullableFilter>;
  scholarshipApplicationLimit?: InputMaybe<IntNullableFilter>;
  scholarshipReferralsThreshold?: InputMaybe<IntFilter>;
  scholarshipVotesThreshold?: InputMaybe<IntFilter>;
  scholarshipWindow?: InputMaybe<IntNullableFilter>;
  scholarshipsAwarded?: InputMaybe<IntFilter>;
  state?: InputMaybe<EnumCohortStateEnumFilter>;
  symbol?: InputMaybe<StringNullableFilter>;
  timeline?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumCohortTypeEnumFilter>;
  updateStatus?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userCohorts?: InputMaybe<UserCohortListRelationFilter>;
};

export type CohortWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  sampleAuditionVideoId?: InputMaybe<Scalars['String']>;
  sampleReviewVideoId?: InputMaybe<Scalars['String']>;
};

export type CohortsRecommendationInput = {
  entityId: Scalars['ID'];
  entityType: EntityTagEntityTypeEnum;
};

export type CommonEntityTagInput = {
  entityId: Scalars['String'];
  entityType: EntityTagEntityTypeEnum;
  tagContent: CommonTagContentInput;
  tagType: TagTypeEnum;
};

export type CommonTagContent = {
  __typename: 'CommonTagContent';
  iconCloudinaryPublicId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CommonTagContentInput = {
  iconCloudinaryPublicId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CompleteAndPurchaseApplicationInput = {
  answerSubmissions: Array<AnswerInput>;
  applicationId: Scalars['ID'];
  hasAcceptedContentTOS?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
};

export type CompleteApplicationScholarshipReferralInput = {
  demoMediaId: Scalars['String'];
  id: Scalars['String'];
};

export type CompleteApplicationwithAnswersInput = {
  answerSubmissions: Array<AnswerInput>;
  applicationId: Scalars['ID'];
};

/** An error that occurs when a student ask for an application refund */
export type CompleteScholarshipApplicationReferralErrorResponse = {
  __typename: 'CompleteScholarshipApplicationReferralErrorResponse';
  message?: Maybe<Scalars['String']>;
  type: CompleteScholarshipApplicationReferralErrorType;
};

/** Errors related to complete scholarship referral */
export enum CompleteScholarshipApplicationReferralErrorType {
  DemoMediaNotFound = 'DEMO_MEDIA_NOT_FOUND',
  InvalidState = 'INVALID_STATE',
  NotFound = 'NOT_FOUND'
}

export type CompleteScholarshipApplicationReferralResponseUnion = CompleteScholarshipApplicationReferralErrorResponse | PrivilegedScholarshipApplicationReferral;

export type Conversation = {
  __typename: 'Conversation';
  _count?: Maybe<ConversationCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  ownerId: Scalars['String'];
  state: ConversationStateEnum;
  title?: Maybe<Scalars['String']>;
  type: ConversationTypeEnum;
  updatedAt: Scalars['DateTime'];
};


export type ConversationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ConversationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ConversationCount = {
  __typename: 'ConversationCount';
  messages: Scalars['Int'];
  userConversations: Scalars['Int'];
};

export type ConversationEntityResponseUnion = PrivilegedCohort;

/** Available types to find a conversation participant */
export enum ConversationEntityTypeEnum {
  Cohort = 'Cohort',
  Expert = 'Expert'
}

export type ConversationListRelationFilter = {
  every?: InputMaybe<ConversationWhereInput>;
  none?: InputMaybe<ConversationWhereInput>;
  some?: InputMaybe<ConversationWhereInput>;
};

export type ConversationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ConversationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  owner?: InputMaybe<UserOrderByWithRelationInput>;
  ownerId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userConversations?: InputMaybe<UserConversationOrderByRelationAggregateInput>;
};

export type ConversationRelationFilter = {
  is?: InputMaybe<ConversationWhereInput>;
  isNot?: InputMaybe<ConversationWhereInput>;
};

export enum ConversationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OwnerId = 'ownerId',
  State = 'state',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum ConversationStateEnum {
  Active = 'Active',
  Blocked = 'Blocked',
  Closed = 'Closed',
  Deleted = 'Deleted'
}

export enum ConversationTypeEnum {
  System = 'System',
  User = 'User'
}

export type ConversationWhereInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>;
  NOT?: InputMaybe<Array<ConversationWhereInput>>;
  OR?: InputMaybe<Array<ConversationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  owner?: InputMaybe<UserRelationFilter>;
  ownerId?: InputMaybe<StringFilter>;
  state?: InputMaybe<EnumConversationStateEnumFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumConversationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userConversations?: InputMaybe<UserConversationListRelationFilter>;
};

export type ConversationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** An error that occurs when creating an application */
export type CreateApplicationErrorResponse = {
  __typename: 'CreateApplicationErrorResponse';
  type: CreateApplicationErrorType;
};

/** Errors related to creating an application */
export enum CreateApplicationErrorType {
  CohortNoLongerAcceptingApplications = 'COHORT_NO_LONGER_ACCEPTING_APPLICATIONS',
  CohortNoLongerAcceptingPaidApplications = 'COHORT_NO_LONGER_ACCEPTING_PAID_APPLICATIONS',
  CohortNoLongerAcceptingScholarships = 'COHORT_NO_LONGER_ACCEPTING_SCHOLARSHIPS',
  CohortOnlyAcceptScholarships = 'COHORT_ONLY_ACCEPT_SCHOLARSHIPS',
  NotFound = 'NOT_FOUND'
}

export type CreateApplicationInput = {
  answerSubmissions: Array<AnswerInput>;
  cohortId: Scalars['ID'];
  isProfileUpdated?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  isScholarship?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type CreateApplicationResponse = CreateApplicationErrorResponse | ManagementReferralCodeErrorResponse | PrivilegedApplication;

export type CreateCategoryInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type CreateExpertOnboardingInput = {
  applications: Array<ExpertOnboardingApplicationInput>;
  cohortSettings: ExpertOnboardingCohortSettingsInput;
  vipAccessCode: Scalars['String'];
};

export type CreateFeaturedApplicationInput = {
  applicationId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type CreateFeaturedExpertInput = {
  cohortId?: InputMaybe<Scalars['ID']>;
  customVideoId?: InputMaybe<Scalars['ID']>;
  expertId: Scalars['ID'];
  headline: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  subHeadline: Scalars['String'];
  type?: InputMaybe<FeaturedExpertTypeEnum>;
  updateStatus?: InputMaybe<Scalars['String']>;
};

export type CreateFeaturedFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  name: Scalars['String'];
  options?: InputMaybe<Scalars['JSON']>;
  users?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateMessageFromSocialInput = {
  content: Scalars['String'];
  expertId: Scalars['ID'];
  source: MessageSourceEnum;
  type: MessageTypeToCreateEnum;
};

export type CreateMessageInput = {
  content: Scalars['String'];
  conversationId: Scalars['ID'];
  source?: InputMaybe<MessageSourceEnum>;
  type: MessageTypeToCreateEnum;
};

export type CreateReferralCodeInput = {
  code: Scalars['String'];
  expertId?: InputMaybe<Scalars['ID']>;
  expiredAt?: InputMaybe<Scalars['DateTime']>;
  maxUse?: InputMaybe<Scalars['Int']>;
  target: ReferralCodeTargetEnum;
  type: ReferralCodeTypeEnum;
  value: Scalars['Int'];
};

export type CreateReviewInput = {
  applicationId: Scalars['ID'];
  cloudinaryPublicId?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<ReviewKindEnum>;
  rating?: InputMaybe<Scalars['Float']>;
  requestedMedia?: InputMaybe<InitializeMediaInput>;
};

export type CreateThreadItemInput = {
  content: ThreadItemContentInput;
  parentId?: InputMaybe<Scalars['ID']>;
  threadEntityInput?: InputMaybe<ThreadThreadEntityUniqueIndexCompoundUniqueInput>;
  threadId?: InputMaybe<Scalars['ID']>;
};

export type Credential = {
  __typename: 'Credential';
  _count?: Maybe<CredentialCount>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CredentialCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CredentialUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CredentialAssignment = {
  __typename: 'CredentialAssignment';
  createdAt: Scalars['DateTime'];
  credentialId: Scalars['String'];
  fromEntityId?: Maybe<Scalars['String']>;
  fromEntityType: CredentialAssignmentEntityTypeEnum;
  id: Scalars['ID'];
  ratedApplicationId?: Maybe<Scalars['String']>;
  toEntityId: Scalars['String'];
  toEntityType: CredentialAssignmentEntityTypeEnum;
  updatedAt: Scalars['DateTime'];
};


export type CredentialAssignmentCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type CredentialAssignmentUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CredentialAssignmentEntityType = HouseCredentialAssignmentEntityType | PublicCohort | PublicUser;

export enum CredentialAssignmentEntityTypeEnum {
  Cohort = 'Cohort',
  House = 'House',
  Review = 'Review',
  User = 'User'
}

export type CredentialAssignmentListRelationFilter = {
  every?: InputMaybe<CredentialAssignmentWhereInput>;
  none?: InputMaybe<CredentialAssignmentWhereInput>;
  some?: InputMaybe<CredentialAssignmentWhereInput>;
};

export type CredentialAssignmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CredentialAssignmentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  credentialId?: InputMaybe<SortOrder>;
  fromEntityId?: InputMaybe<SortOrder>;
  fromEntityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ratedApplication?: InputMaybe<ApplicationOrderByWithRelationInput>;
  ratedApplicationId?: InputMaybe<SortOrder>;
  toEntityId?: InputMaybe<SortOrder>;
  toEntityType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CredentialAssignmentScalarFieldEnum {
  CreatedAt = 'createdAt',
  CredentialId = 'credentialId',
  FromEntityId = 'fromEntityId',
  FromEntityType = 'fromEntityType',
  Id = 'id',
  RatedApplicationId = 'ratedApplicationId',
  ToEntityId = 'toEntityId',
  ToEntityType = 'toEntityType',
  UpdatedAt = 'updatedAt'
}

export type CredentialAssignmentWhereInput = {
  AND?: InputMaybe<Array<CredentialAssignmentWhereInput>>;
  NOT?: InputMaybe<Array<CredentialAssignmentWhereInput>>;
  OR?: InputMaybe<Array<CredentialAssignmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialRelationFilter>;
  credentialId?: InputMaybe<StringFilter>;
  fromEntityId?: InputMaybe<StringNullableFilter>;
  fromEntityType?: InputMaybe<EnumCredentialAssignmentEntityTypeEnumFilter>;
  id?: InputMaybe<StringFilter>;
  ratedApplication?: InputMaybe<ApplicationRelationFilter>;
  ratedApplicationId?: InputMaybe<StringNullableFilter>;
  toEntityId?: InputMaybe<StringFilter>;
  toEntityType?: InputMaybe<EnumCredentialAssignmentEntityTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CredentialAssignmentWhereUniqueInput = {
  CredentialAssignmentUniqueIndex?: InputMaybe<Credential_AssignmentCredentialAssignmentUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type CredentialCount = {
  __typename: 'CredentialCount';
  credentialAssignments: Scalars['Int'];
};

/** Available credentials */
export enum CredentialName {
  Like = 'Like',
  Protege = 'Protege',
  TopProspect = 'TopProspect'
}

export type CredentialOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credentialAssignments?: InputMaybe<CredentialAssignmentOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CredentialRelationFilter = {
  is?: InputMaybe<CredentialWhereInput>;
  isNot?: InputMaybe<CredentialWhereInput>;
};

export type CredentialWhereInput = {
  AND?: InputMaybe<Array<CredentialWhereInput>>;
  NOT?: InputMaybe<Array<CredentialWhereInput>>;
  OR?: InputMaybe<Array<CredentialWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialAssignments?: InputMaybe<CredentialAssignmentListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum CreditActionTypeEnum {
  Deposit = 'Deposit',
  Transfer = 'Transfer',
  Withdrawal = 'Withdrawal'
}

export enum CreditEntityTypeEnum {
  Application = 'Application',
  Cash = 'Cash',
  House = 'House',
  ReferralCode = 'ReferralCode',
  Scholarship = 'Scholarship',
  User = 'User'
}

export type CreditOrderByWithRelationInput = {
  actionType?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  transaction?: InputMaybe<TransactionOrderByWithRelationInput>;
  transactionGroupId?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CreditRelationFilter = {
  is?: InputMaybe<CreditWhereInput>;
  isNot?: InputMaybe<CreditWhereInput>;
};

export type CreditWhereInput = {
  AND?: InputMaybe<Array<CreditWhereInput>>;
  NOT?: InputMaybe<Array<CreditWhereInput>>;
  OR?: InputMaybe<Array<CreditWhereInput>>;
  actionType?: InputMaybe<EnumCreditActionTypeEnumFilter>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  entityType?: InputMaybe<EnumCreditEntityTypeEnumFilter>;
  id?: InputMaybe<StringFilter>;
  transaction?: InputMaybe<TransactionRelationFilter>;
  transactionGroupId?: InputMaybe<StringNullableFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUser = {
  __typename: 'CurrentUser';
  acceptedTOSAt?: Maybe<Scalars['DateTime']>;
  application?: Maybe<PrivilegedApplication>;
  applications: Array<PrivilegedApplication>;
  availableTickets?: Maybe<Scalars['Int']>;
  balance: Scalars['Int'];
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classificationTags: Array<PublicCommonContentTag>;
  cohort?: Maybe<PrivilegedCohort>;
  cohorts: Array<PrivilegedCohort>;
  conversation?: Maybe<PrivilegedConversation>;
  conversationByCohort?: Maybe<PrivilegedConversation>;
  conversations: Array<PrivilegedConversation>;
  createSetupIntentForStripe?: Maybe<StripeSetupIntent>;
  createdAt: Scalars['String'];
  credentialAssignmentGranted: Array<PublicCredentialAssignment>;
  credentialAssignmentReceived: Array<PublicCredentialAssignment>;
  /** Year to date earnings in cents */
  earningsYTD: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  /** Estimated earnings (includes not yet settled transactions) */
  estimatedEarnings: Scalars['Int'];
  expertCredentials: Array<CommonTagContent>;
  /** @deprecated replaced by expertRelationsName { name } */
  expertRelationsName?: Maybe<Scalars['String']>;
  /** @deprecated replaced by expertRelationsName { phone } */
  expertRelationsPhone?: Maybe<Scalars['String']>;
  expertRelationsUser?: Maybe<PublicExpertRelationsUser>;
  expertise: Array<PrivilegedCategory>;
  facebookLogin: Scalars['Boolean'];
  facebookUrl?: Maybe<Scalars['String']>;
  facebookUsername?: Maybe<Scalars['String']>;
  featuredFlags: Array<PublicFeaturedFlag>;
  firstName?: Maybe<Scalars['String']>;
  freeMessagesEnabled: Scalars['Boolean'];
  hasAcceptedAgeVerification?: Maybe<Scalars['Boolean']>;
  hasAcceptedTOS?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instagramUrl?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
  interest: Array<PrivilegedCategory>;
  isAdmin: Scalars['Boolean'];
  isExpert: Scalars['Boolean'];
  isProfileComplete: Scalars['Boolean'];
  isStudent: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  linkedInUrl?: Maybe<Scalars['String']>;
  linkedInUsername?: Maybe<Scalars['String']>;
  /** @deprecated renamed to "medias" */
  media: Array<PrivilegedMedia>;
  medias: Array<PrivilegedMedia>;
  myCohorts: Array<PrivilegedCohort>;
  name?: Maybe<Scalars['String']>;
  notification?: Maybe<PrivilegedNotification>;
  notifications: Array<PrivilegedNotification>;
  numberOfCredentialsGranted: Scalars['Int'];
  numberOfCredentialsReceived: Scalars['Int'];
  ownTasks: Array<PrivilegedTask>;
  phone?: Maybe<Scalars['String']>;
  /** Potentital earnings in cents */
  potentialEarnings: Scalars['Int'];
  profileImageUrl?: Maybe<Scalars['String']>;
  profileVisibility: ProfileVisibilityEnum;
  publicApplications: Array<PublicApplication>;
  refundsForStripe: Array<StripeRefund>;
  reviews?: Maybe<Array<PublicReview>>;
  settings: UserSetting;
  soundcloudUrl?: Maybe<Scalars['String']>;
  soundcloudUsername?: Maybe<Scalars['String']>;
  spotifyArtistId?: Maybe<Scalars['String']>;
  spotifyUrl?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storedCardPaymentMethodsForStripe: Array<StripeStoredCardPaymentMethod>;
  task?: Maybe<PrivilegedTask>;
  tasks: Array<PrivilegedTask>;
  tiktokUrl?: Maybe<Scalars['String']>;
  tiktokUsername?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topics: Array<PrivilegedTopic>;
  /** Total earnings in cents */
  totalEarnings: Scalars['Float'];
  totalPendingTasks: Scalars['Int'];
  totalUnreadMessages: Scalars['Int'];
  transactions: Array<Transaction>;
  twitterUrl?: Maybe<Scalars['String']>;
  twitterUsername?: Maybe<Scalars['String']>;
  uniqueMedia?: Maybe<Media>;
  updatedAt: Scalars['String'];
  userFacts?: Maybe<Scalars['JSON']>;
  userProfileAlternateImage?: Maybe<Media>;
  userProfileAlternateImageId?: Maybe<Scalars['ID']>;
  userProfileCoverImage?: Maybe<Media>;
  userProfileCoverImageId?: Maybe<Scalars['ID']>;
  userProfileImage?: Maybe<Media>;
  userProfileImageId?: Maybe<Scalars['ID']>;
  userProfileVideo?: Maybe<Media>;
  userProfileVideoId?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
  waitlistEnabled?: Maybe<Scalars['Boolean']>;
  withdrawMethodsForStripe: Array<StripeWithdrawMethod>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserApplicationArgs = {
  id: Scalars['String'];
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserCohortArgs = {
  id: Scalars['String'];
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserCohortsArgs = {
  cursor?: InputMaybe<CohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<CohortScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CohortOrderByWithRelationInput>>;
  role: UserRole;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CohortWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserConversationArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConversationWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserConversationByCohortArgs = {
  cohortId: Scalars['String'];
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserConversationsArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput>>;
  orderByMessage?: InputMaybe<MessageOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConversationWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserCredentialAssignmentGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserCredentialAssignmentReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserExpertCredentialsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserExpertiseArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserFeaturedFlagsArgs = {
  cursor?: InputMaybe<FeaturedFlagWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedFlagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedFlagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedFlagWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserFreeMessagesEnabledArgs = {
  entityId: Scalars['String'];
  entityType: FindConversationParticipantByEnum;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserInterestArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserMediaArgs = {
  cursor?: InputMaybe<MediaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MediaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MediaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserMediasArgs = {
  cursor?: InputMaybe<MediaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MediaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MediaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserMyCohortsArgs = {
  cursor?: InputMaybe<CohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<CohortScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CohortOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CohortWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserNotificationArgs = {
  id: Scalars['String'];
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserNumberOfCredentialsGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserNumberOfCredentialsReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserOwnTasksArgs = {
  cursor?: InputMaybe<TaskWhereUniqueInput>;
  distinct?: InputMaybe<Array<TaskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TaskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserPublicApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserReviewsArgs = {
  input: ReviewFilterInput;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserTaskArgs = {
  id: Scalars['String'];
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserTasksArgs = {
  cursor?: InputMaybe<TaskWhereUniqueInput>;
  distinct?: InputMaybe<Array<TaskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TaskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserUniqueMediaArgs = {
  cloudinaryPublicId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the User object this is exclusively readable by the user currently logged into the application. Used to type the `viewer` object. */
export type CurrentUserWithdrawMethodsForStripeArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
};

export type CustomEmailNotificationInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
};

export type CustomInternalNotificationInput = {
  body: Scalars['String'];
  resourceRelatedId?: InputMaybe<Scalars['ID']>;
  resourceRelatedType?: InputMaybe<NotificationResourceRelatedTypeEnum>;
  title: Scalars['String'];
};

export type CustomNotificationInput = {
  email?: InputMaybe<CustomEmailNotificationInput>;
  internal: CustomInternalNotificationInput;
  userId: Scalars['ID'];
};

export enum DateFormatEnum {
  NoDay = 'NO_DAY',
  NoYear = 'NO_YEAR',
  Numeric = 'NUMERIC',
  Relative = 'RELATIVE',
  RelativeNoSuffix = 'RELATIVE_NO_SUFFIX',
  Short = 'SHORT',
  Timestamp = 'TIMESTAMP',
  TwelveHours = 'TWELVE_HOURS',
  TwentyFourHours = 'TWENTY_FOUR_HOURS'
}

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type DetailTagContent = {
  __typename: 'DetailTagContent';
  active?: Maybe<Scalars['Boolean']>;
  content: Array<TagDetailContent>;
  iconCloudinaryPublicId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DetailTagContentInput = {
  content: Array<TagDetailContentInput>;
  iconCloudinaryPublicId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum EntityTagEntityTypeEnum {
  Application = 'Application',
  Category = 'Category',
  Cohort = 'Cohort',
  InterstitialAd = 'InterstitialAd',
  User = 'User'
}

export type EntityTagInput = {
  entityId: Scalars['String'];
  entityType: EntityTagEntityTypeEnum;
  tagContent: Scalars['JSON'];
  tagType: TagTypeEnum;
};

export type EntityTagListRelationFilter = {
  every?: InputMaybe<EntityTagWhereInput>;
  none?: InputMaybe<EntityTagWhereInput>;
  some?: InputMaybe<EntityTagWhereInput>;
};

export type EntityTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EntityTagWhereInput = {
  AND?: InputMaybe<Array<EntityTagWhereInput>>;
  NOT?: InputMaybe<Array<EntityTagWhereInput>>;
  OR?: InputMaybe<Array<EntityTagWhereInput>>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTagEntityTypeEnumFilter>;
  tag?: InputMaybe<TagRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
  tagPageExcluded?: InputMaybe<BoolFilter>;
  tagPageOrder?: InputMaybe<IntNullableFilter>;
};

export type EnumApplicationStateEnumFilter = {
  equals?: InputMaybe<ApplicationStateEnum>;
  in?: InputMaybe<Array<ApplicationStateEnum>>;
  not?: InputMaybe<NestedEnumApplicationStateEnumFilter>;
  notIn?: InputMaybe<Array<ApplicationStateEnum>>;
};

export type EnumCohortApplicationTypeEnumFilter = {
  equals?: InputMaybe<CohortApplicationTypeEnum>;
  in?: InputMaybe<Array<CohortApplicationTypeEnum>>;
  not?: InputMaybe<NestedEnumCohortApplicationTypeEnumFilter>;
  notIn?: InputMaybe<Array<CohortApplicationTypeEnum>>;
};

export type EnumCohortStateEnumFilter = {
  equals?: InputMaybe<CohortStateEnum>;
  in?: InputMaybe<Array<CohortStateEnum>>;
  not?: InputMaybe<NestedEnumCohortStateEnumFilter>;
  notIn?: InputMaybe<Array<CohortStateEnum>>;
};

export type EnumCohortTypeEnumFilter = {
  equals?: InputMaybe<CohortTypeEnum>;
  in?: InputMaybe<Array<CohortTypeEnum>>;
  not?: InputMaybe<NestedEnumCohortTypeEnumFilter>;
  notIn?: InputMaybe<Array<CohortTypeEnum>>;
};

export type EnumConversationStateEnumFilter = {
  equals?: InputMaybe<ConversationStateEnum>;
  in?: InputMaybe<Array<ConversationStateEnum>>;
  not?: InputMaybe<NestedEnumConversationStateEnumFilter>;
  notIn?: InputMaybe<Array<ConversationStateEnum>>;
};

export type EnumConversationTypeEnumFilter = {
  equals?: InputMaybe<ConversationTypeEnum>;
  in?: InputMaybe<Array<ConversationTypeEnum>>;
  not?: InputMaybe<NestedEnumConversationTypeEnumFilter>;
  notIn?: InputMaybe<Array<ConversationTypeEnum>>;
};

export type EnumCredentialAssignmentEntityTypeEnumFilter = {
  equals?: InputMaybe<CredentialAssignmentEntityTypeEnum>;
  in?: InputMaybe<Array<CredentialAssignmentEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumCredentialAssignmentEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<CredentialAssignmentEntityTypeEnum>>;
};

export type EnumCreditActionTypeEnumFilter = {
  equals?: InputMaybe<CreditActionTypeEnum>;
  in?: InputMaybe<Array<CreditActionTypeEnum>>;
  not?: InputMaybe<NestedEnumCreditActionTypeEnumFilter>;
  notIn?: InputMaybe<Array<CreditActionTypeEnum>>;
};

export type EnumCreditEntityTypeEnumFilter = {
  equals?: InputMaybe<CreditEntityTypeEnum>;
  in?: InputMaybe<Array<CreditEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumCreditEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<CreditEntityTypeEnum>>;
};

export type EnumEntityTagEntityTypeEnumFilter = {
  equals?: InputMaybe<EntityTagEntityTypeEnum>;
  in?: InputMaybe<Array<EntityTagEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumEntityTagEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<EntityTagEntityTypeEnum>>;
};

export type EnumFeaturedExpertTypeEnumFilter = {
  equals?: InputMaybe<FeaturedExpertTypeEnum>;
  in?: InputMaybe<Array<FeaturedExpertTypeEnum>>;
  not?: InputMaybe<NestedEnumFeaturedExpertTypeEnumFilter>;
  notIn?: InputMaybe<Array<FeaturedExpertTypeEnum>>;
};

export type EnumMediaConfigTypeEnumFilter = {
  equals?: InputMaybe<MediaConfigTypeEnum>;
  in?: InputMaybe<Array<MediaConfigTypeEnum>>;
  not?: InputMaybe<NestedEnumMediaConfigTypeEnumFilter>;
  notIn?: InputMaybe<Array<MediaConfigTypeEnum>>;
};

export type EnumMediaStateEnumFilter = {
  equals?: InputMaybe<MediaStateEnum>;
  in?: InputMaybe<Array<MediaStateEnum>>;
  not?: InputMaybe<NestedEnumMediaStateEnumFilter>;
  notIn?: InputMaybe<Array<MediaStateEnum>>;
};

export type EnumMediaTypeEnumFilter = {
  equals?: InputMaybe<MediaTypeEnum>;
  in?: InputMaybe<Array<MediaTypeEnum>>;
  not?: InputMaybe<NestedEnumMediaTypeEnumFilter>;
  notIn?: InputMaybe<Array<MediaTypeEnum>>;
};

export type EnumMessageSourceEnumFilter = {
  equals?: InputMaybe<MessageSourceEnum>;
  in?: InputMaybe<Array<MessageSourceEnum>>;
  not?: InputMaybe<NestedEnumMessageSourceEnumFilter>;
  notIn?: InputMaybe<Array<MessageSourceEnum>>;
};

export type EnumMessageStateEnumFilter = {
  equals?: InputMaybe<MessageStateEnum>;
  in?: InputMaybe<Array<MessageStateEnum>>;
  not?: InputMaybe<NestedEnumMessageStateEnumFilter>;
  notIn?: InputMaybe<Array<MessageStateEnum>>;
};

export type EnumMessageTypeEnumFilter = {
  equals?: InputMaybe<MessageTypeEnum>;
  in?: InputMaybe<Array<MessageTypeEnum>>;
  not?: InputMaybe<NestedEnumMessageTypeEnumFilter>;
  notIn?: InputMaybe<Array<MessageTypeEnum>>;
};

export type EnumNotificationResourceRelatedTypeEnumNullableFilter = {
  equals?: InputMaybe<NotificationResourceRelatedTypeEnum>;
  in?: InputMaybe<Array<NotificationResourceRelatedTypeEnum>>;
  not?: InputMaybe<NestedEnumNotificationResourceRelatedTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<NotificationResourceRelatedTypeEnum>>;
};

export type EnumNotificationTypeEnumFilter = {
  equals?: InputMaybe<NotificationTypeEnum>;
  in?: InputMaybe<Array<NotificationTypeEnum>>;
  not?: InputMaybe<NestedEnumNotificationTypeEnumFilter>;
  notIn?: InputMaybe<Array<NotificationTypeEnum>>;
};

export type EnumPaymentProviderEnumFilter = {
  equals?: InputMaybe<PaymentProviderEnum>;
  in?: InputMaybe<Array<PaymentProviderEnum>>;
  not?: InputMaybe<NestedEnumPaymentProviderEnumFilter>;
  notIn?: InputMaybe<Array<PaymentProviderEnum>>;
};

export type EnumProfileVisibilityEnumFilter = {
  equals?: InputMaybe<ProfileVisibilityEnum>;
  in?: InputMaybe<Array<ProfileVisibilityEnum>>;
  not?: InputMaybe<NestedEnumProfileVisibilityEnumFilter>;
  notIn?: InputMaybe<Array<ProfileVisibilityEnum>>;
};

export type EnumQuestionTypeEnumFilter = {
  equals?: InputMaybe<QuestionTypeEnum>;
  in?: InputMaybe<Array<QuestionTypeEnum>>;
  not?: InputMaybe<NestedEnumQuestionTypeEnumFilter>;
  notIn?: InputMaybe<Array<QuestionTypeEnum>>;
};

export type EnumReferralCodeTargetEnumFilter = {
  equals?: InputMaybe<ReferralCodeTargetEnum>;
  in?: InputMaybe<Array<ReferralCodeTargetEnum>>;
  not?: InputMaybe<NestedEnumReferralCodeTargetEnumFilter>;
  notIn?: InputMaybe<Array<ReferralCodeTargetEnum>>;
};

export type EnumReferralCodeTypeEnumFilter = {
  equals?: InputMaybe<ReferralCodeTypeEnum>;
  in?: InputMaybe<Array<ReferralCodeTypeEnum>>;
  not?: InputMaybe<NestedEnumReferralCodeTypeEnumFilter>;
  notIn?: InputMaybe<Array<ReferralCodeTypeEnum>>;
};

export type EnumReviewKindEnumFilter = {
  equals?: InputMaybe<ReviewKindEnum>;
  in?: InputMaybe<Array<ReviewKindEnum>>;
  not?: InputMaybe<NestedEnumReviewKindEnumFilter>;
  notIn?: InputMaybe<Array<ReviewKindEnum>>;
};

export type EnumScholarshipApplicationReferralStateEnumFilter = {
  equals?: InputMaybe<ScholarshipApplicationReferralStateEnum>;
  in?: InputMaybe<Array<ScholarshipApplicationReferralStateEnum>>;
  not?: InputMaybe<NestedEnumScholarshipApplicationReferralStateEnumFilter>;
  notIn?: InputMaybe<Array<ScholarshipApplicationReferralStateEnum>>;
};

export type EnumTagTypeEnumFilter = {
  equals?: InputMaybe<TagTypeEnum>;
  in?: InputMaybe<Array<TagTypeEnum>>;
  not?: InputMaybe<NestedEnumTagTypeEnumFilter>;
  notIn?: InputMaybe<Array<TagTypeEnum>>;
};

export type EnumTaskStateEnumFilter = {
  equals?: InputMaybe<TaskStateEnum>;
  in?: InputMaybe<Array<TaskStateEnum>>;
  not?: InputMaybe<NestedEnumTaskStateEnumFilter>;
  notIn?: InputMaybe<Array<TaskStateEnum>>;
};

export type EnumTaskTypeEnumFilter = {
  equals?: InputMaybe<TaskTypeEnum>;
  in?: InputMaybe<Array<TaskTypeEnum>>;
  not?: InputMaybe<NestedEnumTaskTypeEnumFilter>;
  notIn?: InputMaybe<Array<TaskTypeEnum>>;
};

export type EnumTemplateTypeEnumFilter = {
  equals?: InputMaybe<TemplateTypeEnum>;
  in?: InputMaybe<Array<TemplateTypeEnum>>;
  not?: InputMaybe<NestedEnumTemplateTypeEnumFilter>;
  notIn?: InputMaybe<Array<TemplateTypeEnum>>;
};

export type EnumThreadEntityTypeEnumFilter = {
  equals?: InputMaybe<ThreadEntityTypeEnum>;
  in?: InputMaybe<Array<ThreadEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumThreadEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<ThreadEntityTypeEnum>>;
};

export type EnumThreadItemStateEnumFilter = {
  equals?: InputMaybe<ThreadItemStateEnum>;
  in?: InputMaybe<Array<ThreadItemStateEnum>>;
  not?: InputMaybe<NestedEnumThreadItemStateEnumFilter>;
  notIn?: InputMaybe<Array<ThreadItemStateEnum>>;
};

export type EnumTransactionTypeEnumFilter = {
  equals?: InputMaybe<TransactionTypeEnum>;
  in?: InputMaybe<Array<TransactionTypeEnum>>;
  not?: InputMaybe<NestedEnumTransactionTypeEnumFilter>;
  notIn?: InputMaybe<Array<TransactionTypeEnum>>;
};

export type EnumUserCategoryTypeEnumFilter = {
  equals?: InputMaybe<UserCategoryTypeEnum>;
  in?: InputMaybe<Array<UserCategoryTypeEnum>>;
  not?: InputMaybe<NestedEnumUserCategoryTypeEnumFilter>;
  notIn?: InputMaybe<Array<UserCategoryTypeEnum>>;
};

export type EnumUserConversationRoleEnumFilter = {
  equals?: InputMaybe<UserConversationRoleEnum>;
  in?: InputMaybe<Array<UserConversationRoleEnum>>;
  not?: InputMaybe<NestedEnumUserConversationRoleEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationRoleEnum>>;
};

export type EnumUserConversationStateEnumFilter = {
  equals?: InputMaybe<UserConversationStateEnum>;
  in?: InputMaybe<Array<UserConversationStateEnum>>;
  not?: InputMaybe<NestedEnumUserConversationStateEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationStateEnum>>;
};

export type EnumUserConversationTypeEnumFilter = {
  equals?: InputMaybe<UserConversationTypeEnum>;
  in?: InputMaybe<Array<UserConversationTypeEnum>>;
  not?: InputMaybe<NestedEnumUserConversationTypeEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationTypeEnum>>;
};

export type EssayAnswerInput = {
  comment?: InputMaybe<Scalars['String']>;
  data: Scalars['String'];
  questionId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type EssayQuestionInput = {
  maxLength?: InputMaybe<Scalars['Float']>;
  prompt?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ExpertFacebookLoginInput = {
  fbAppAT: Scalars['String'];
};

export type ExpertOnboarding = {
  __typename: 'ExpertOnboarding';
  active: Scalars['Boolean'];
  applications?: Maybe<Scalars['JSON']>;
  cohortSettings?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isPersonalCode: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  updatedAt: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  userSettings?: Maybe<Scalars['JSON']>;
  vipAccessCode: Scalars['String'];
};


export type ExpertOnboardingCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ExpertOnboardingUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ExpertOnboardingAnswerInput = {
  comment?: InputMaybe<Scalars['String']>;
  /** required for EssayQuestion */
  data?: InputMaybe<Scalars['String']>;
  /** Used to could associate the application answers to the cohort question */
  index: Scalars['Int'];
  /** required for VideoQuestion */
  mediaId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type: QuestionTypeEnum;
};

export type ExpertOnboardingApplicationInput = {
  answers: Array<ExpertOnboardingAnswerInput>;
  studentId?: InputMaybe<Scalars['ID']>;
  taskType?: InputMaybe<TaskTypeEnum>;
};

export type ExpertOnboardingCohortSettingsInput = {
  applicationExpirationWindow?: InputMaybe<Scalars['Int']>;
  applicationType: CohortApplicationTypeEnum;
  categoryId: Scalars['ID'];
  description: Scalars['String'];
  name: Scalars['String'];
  /** Limit of the cohort paid applications */
  paidApplicationLimit?: InputMaybe<Scalars['Int']>;
  /** Price in USD cents ($10.00 = 1000 cents) */
  price: Scalars['Int'];
  /** Publish window in days */
  publishWindow?: InputMaybe<Scalars['Int']>;
  questions: Array<ExpertOnboardingQuestionInput>;
  /** Review window in days */
  reviewWindow?: InputMaybe<Scalars['Int']>;
  scholarshipApplicationLimit?: InputMaybe<Scalars['Int']>;
  scholarshipReferralsThreshold?: InputMaybe<Scalars['Int']>;
  scholarshipWindow?: InputMaybe<Scalars['Int']>;
  symbol?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  type: CohortTypeEnum;
  updateStatus?: InputMaybe<Scalars['String']>;
};

export type ExpertOnboardingListRelationFilter = {
  every?: InputMaybe<ExpertOnboardingWhereInput>;
  none?: InputMaybe<ExpertOnboardingWhereInput>;
  some?: InputMaybe<ExpertOnboardingWhereInput>;
};

export type ExpertOnboardingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExpertOnboardingOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  applications?: InputMaybe<SortOrder>;
  cohortSettings?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPersonalCode?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userSettings?: InputMaybe<SortOrder>;
  vipAccessCode?: InputMaybe<SortOrder>;
};

export type ExpertOnboardingQuestionInput = {
  /** Used to could associate the application answers to the cohort question */
  index: Scalars['Int'];
  maxDuration?: InputMaybe<Scalars['Float']>;
  maxLength?: InputMaybe<Scalars['Float']>;
  prompt?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: QuestionTypeEnum;
};

export enum ExpertOnboardingScalarFieldEnum {
  Active = 'active',
  Applications = 'applications',
  CohortSettings = 'cohortSettings',
  Id = 'id',
  IsPersonalCode = 'isPersonalCode',
  UserId = 'userId',
  UserSettings = 'userSettings',
  VipAccessCode = 'vipAccessCode'
}

export type ExpertOnboardingWhereInput = {
  AND?: InputMaybe<Array<ExpertOnboardingWhereInput>>;
  NOT?: InputMaybe<Array<ExpertOnboardingWhereInput>>;
  OR?: InputMaybe<Array<ExpertOnboardingWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  applications?: InputMaybe<JsonNullableFilter>;
  cohortSettings?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPersonalCode?: InputMaybe<BoolFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userSettings?: InputMaybe<JsonNullableFilter>;
  vipAccessCode?: InputMaybe<StringFilter>;
};

export type ExpertOnboardingWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  vipAccessCode?: InputMaybe<Scalars['String']>;
};

export type FeaturedApplication = {
  __typename: 'FeaturedApplication';
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type FeaturedApplicationListRelationFilter = {
  every?: InputMaybe<FeaturedApplicationWhereInput>;
  none?: InputMaybe<FeaturedApplicationWhereInput>;
  some?: InputMaybe<FeaturedApplicationWhereInput>;
};

export type FeaturedApplicationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FeaturedApplicationOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FeaturedApplicationScalarFieldEnum {
  ApplicationId = 'applicationId',
  CreatedAt = 'createdAt',
  Id = 'id',
  SortOrder = 'sortOrder',
  UpdatedAt = 'updatedAt'
}

export type FeaturedApplicationWhereInput = {
  AND?: InputMaybe<Array<FeaturedApplicationWhereInput>>;
  NOT?: InputMaybe<Array<FeaturedApplicationWhereInput>>;
  OR?: InputMaybe<Array<FeaturedApplicationWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FeaturedApplicationWhereUniqueInput = {
  applicationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type FeaturedExpert = {
  __typename: 'FeaturedExpert';
  active: Scalars['Boolean'];
  cohortId?: Maybe<Scalars['String']>;
  customVideoId?: Maybe<Scalars['String']>;
  expertId: Scalars['String'];
  headline: Scalars['String'];
  hoursToReview?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  subHeadline: Scalars['String'];
  type: FeaturedExpertTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
};

export type FeaturedExpertListRelationFilter = {
  every?: InputMaybe<FeaturedExpertWhereInput>;
  none?: InputMaybe<FeaturedExpertWhereInput>;
  some?: InputMaybe<FeaturedExpertWhereInput>;
};

export type FeaturedExpertOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FeaturedExpertOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  cohort?: InputMaybe<CohortOrderByWithRelationInput>;
  cohortId?: InputMaybe<SortOrder>;
  customVideo?: InputMaybe<MediaOrderByWithRelationInput>;
  customVideoId?: InputMaybe<SortOrder>;
  expert?: InputMaybe<UserOrderByWithRelationInput>;
  expertId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  hoursToReview?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subHeadline?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updateStatus?: InputMaybe<SortOrder>;
};

export enum FeaturedExpertScalarFieldEnum {
  Active = 'active',
  CohortId = 'cohortId',
  CustomVideoId = 'customVideoId',
  ExpertId = 'expertId',
  Headline = 'headline',
  HoursToReview = 'hoursToReview',
  Id = 'id',
  SortOrder = 'sortOrder',
  Status = 'status',
  SubHeadline = 'subHeadline',
  Type = 'type',
  UpdateStatus = 'updateStatus'
}

export enum FeaturedExpertTypeEnum {
  CohortSummary = 'CohortSummary',
  GenericUpdate = 'GenericUpdate'
}

export type FeaturedExpertWhereInput = {
  AND?: InputMaybe<Array<FeaturedExpertWhereInput>>;
  NOT?: InputMaybe<Array<FeaturedExpertWhereInput>>;
  OR?: InputMaybe<Array<FeaturedExpertWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  cohort?: InputMaybe<CohortRelationFilter>;
  cohortId?: InputMaybe<StringNullableFilter>;
  customVideo?: InputMaybe<MediaRelationFilter>;
  customVideoId?: InputMaybe<StringNullableFilter>;
  expert?: InputMaybe<UserRelationFilter>;
  expertId?: InputMaybe<StringFilter>;
  headline?: InputMaybe<StringFilter>;
  hoursToReview?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  subHeadline?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumFeaturedExpertTypeEnumFilter>;
  updateStatus?: InputMaybe<StringNullableFilter>;
};

export type FeaturedExpertWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type FeaturedFlagOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  options?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  users?: InputMaybe<SortOrder>;
};

export enum FeaturedFlagScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  IsActive = 'isActive',
  Key = 'key',
  Name = 'name',
  Options = 'options',
  UpdatedAt = 'updatedAt',
  Users = 'users'
}

export type FeaturedFlagWhereInput = {
  AND?: InputMaybe<Array<FeaturedFlagWhereInput>>;
  NOT?: InputMaybe<Array<FeaturedFlagWhereInput>>;
  OR?: InputMaybe<Array<FeaturedFlagWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  isActive?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  options?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  users?: InputMaybe<StringNullableListFilter>;
};

export type FeaturedFlagWhereUniqueInput = {
  key?: InputMaybe<Scalars['String']>;
};

export type FeaturedReview = {
  __typename: 'FeaturedReview';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  review: PublicReview;
  reviewId: Scalars['String'];
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type FeaturedReviewCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type FeaturedReviewUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type FeaturedReviewOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  review?: InputMaybe<ReviewOrderByWithRelationInput>;
  reviewId?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FeaturedReviewRelationFilter = {
  is?: InputMaybe<FeaturedReviewWhereInput>;
  isNot?: InputMaybe<FeaturedReviewWhereInput>;
};

export type FeaturedReviewWhereInput = {
  AND?: InputMaybe<Array<FeaturedReviewWhereInput>>;
  NOT?: InputMaybe<Array<FeaturedReviewWhereInput>>;
  OR?: InputMaybe<Array<FeaturedReviewWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  review?: InputMaybe<ReviewRelationFilter>;
  reviewId?: InputMaybe<StringFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Feed = {
  __typename: 'Feed';
  createdAt: Scalars['DateTime'];
  entries: Scalars['JSON'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type FeedOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  entries?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type FeedRelationFilter = {
  is?: InputMaybe<FeedWhereInput>;
  isNot?: InputMaybe<FeedWhereInput>;
};

export type FeedWhereInput = {
  AND?: InputMaybe<Array<FeedWhereInput>>;
  NOT?: InputMaybe<Array<FeedWhereInput>>;
  OR?: InputMaybe<Array<FeedWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entries?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

/** Available types to find a conversation participant */
export enum FindConversationParticipantByEnum {
  Cohort = 'Cohort',
  Conversation = 'Conversation',
  Expert = 'Expert'
}

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** A Representation of a House (Protege) Entity type that grant or receive credentials */
export type HouseCredentialAssignmentEntityType = {
  __typename: 'HouseCredentialAssignmentEntityType';
  name: Scalars['String'];
};

export type IReview = {
  applicationId: Scalars['ID'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  kind: ReviewKindEnum;
  labels?: Maybe<Scalars['JSON']>;
  rating?: Maybe<Scalars['Int']>;
  responseMediaId?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type IThreadItem = {
  content: ThreadItemContent;
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  state: ThreadItemStateEnum;
  threadId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type InitAuthInput = {
  name?: InputMaybe<Scalars['String']>;
  referred?: InputMaybe<UserReferred>;
  /** User email or phone number */
  username: Scalars['String'];
  vipAccessCode?: InputMaybe<Scalars['String']>;
};

export type InitAuthResponse = {
  __typename: 'InitAuthResponse';
  error?: Maybe<AuthErrorResponse>;
  success: Scalars['Boolean'];
};

export type InitializeMediaInput = {
  type: MediaTypeEnum;
};

export type InitializedMediaResponse = {
  __typename: 'InitializedMediaResponse';
  parameters: Scalars['String'];
  publicId: Scalars['String'];
  signature: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type InterstitialAdListRelationFilter = {
  every?: InputMaybe<InterstitialAdWhereInput>;
  none?: InputMaybe<InterstitialAdWhereInput>;
  some?: InputMaybe<InterstitialAdWhereInput>;
};

export type InterstitialAdOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InterstitialAdWhereInput = {
  AND?: InputMaybe<Array<InterstitialAdWhereInput>>;
  NOT?: InputMaybe<Array<InterstitialAdWhereInput>>;
  OR?: InputMaybe<Array<InterstitialAdWhereInput>>;
  buttonPath?: InputMaybe<StringFilter>;
  buttonText?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  headline?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  media?: InputMaybe<MediaRelationFilter>;
  mediaId?: InputMaybe<StringFilter>;
  subHeadline?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

/** An error that occurs when redeem/remove a referral code */
export type ManagementReferralCodeErrorResponse = {
  __typename: 'ManagementReferralCodeErrorResponse';
  type: ManagementReferralCodeErrorType;
};

/** Errors related to redeem/remove a referral code */
export enum ManagementReferralCodeErrorType {
  ActionNotAllowed = 'ACTION_NOT_ALLOWED',
  ApplicationAlreadyHaveReferralCode = 'APPLICATION_ALREADY_HAVE_REFERRAL_CODE',
  ReferralCodeAlreadyUsedByUser = 'REFERRAL_CODE_ALREADY_USED_BY_USER',
  ReferralCodeMaxUseReached = 'REFERRAL_CODE_MAX_USE_REACHED',
  ReferralCodeNotApplicable = 'REFERRAL_CODE_NOT_APPLICABLE',
  ReferralCodeNotFound = 'REFERRAL_CODE_NOT_FOUND'
}

export type Media = {
  __typename: 'Media';
  _count?: Maybe<MediaCount>;
  bytes?: Maybe<Scalars['Int']>;
  cloudinaryPublicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  duration?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  resourceId?: Maybe<Scalars['String']>;
  state: MediaStateEnum;
  type: MediaTypeEnum;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};


export type MediaCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MediaUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Contains configuration info and utilities for Media */
export type MediaConfig = {
  __typename: 'MediaConfig';
  APPLICATION_SHAREABLE_ASSET_VIDEO?: Maybe<MediaVideoConfiguration>;
  APPLICATION_VIDEO_720p: MediaVideoConfiguration;
  APPLICATION_VIDEO_720p_WITH_WATERMARK: MediaVideoConfiguration;
  /** @deprecated replaced by APPLICATION_VIDEO_720p_WITH_WATERMARK */
  APPLICATION_VIDEO_720p_WITH_WATERMARK_03292022: MediaVideoConfiguration;
  REVIEW_VIDEO_720p: MediaVideoConfiguration;
  REVIEW_VIDEO_720p_WITH_WATERMARK: MediaVideoConfiguration;
  /** @deprecated no longer used */
  REVIEW_VIDEO_720p_WITH_WATERMARK_03082022: MediaVideoConfiguration;
  /** @deprecated replaced by REVIEW_VIDEO_720p_WITH_WATERMARK */
  REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: MediaVideoConfiguration;
  STATUS_VIDEO_720p: MediaVideoConfiguration;
  /** Returns a one-time use Cloudinary Media Signature that can be used to sign Cloudinary uploads */
  cloudinaryMediaSignature: MediaSignature;
};


/** Contains configuration info and utilities for Media */
export type MediaConfigApplication_Shareable_Asset_VideoArgs = {
  cohortId?: InputMaybe<Scalars['String']>;
};


/** Contains configuration info and utilities for Media */
export type MediaConfigCloudinaryMediaSignatureArgs = {
  eager?: InputMaybe<Scalars['String']>;
  eagerAsync?: InputMaybe<Scalars['Boolean']>;
  eagerNotificationUrl?: InputMaybe<Scalars['String']>;
  notificationUrl?: InputMaybe<Scalars['String']>;
  uploadPreset?: InputMaybe<Scalars['String']>;
};

export type MediaConfigOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  transformation?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MediaConfigScalarFieldEnum {
  CreatedAt = 'createdAt',
  Name = 'name',
  Transformation = 'transformation',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum MediaConfigTypeEnum {
  ApplicationShareableAssetVideo = 'ApplicationShareableAssetVideo',
  ApplicationVideo = 'ApplicationVideo',
  ReviewVideo = 'ReviewVideo',
  StatusVideo = 'StatusVideo'
}

export type MediaConfigWhereInput = {
  AND?: InputMaybe<Array<MediaConfigWhereInput>>;
  NOT?: InputMaybe<Array<MediaConfigWhereInput>>;
  OR?: InputMaybe<Array<MediaConfigWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  transformation?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumMediaConfigTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MediaConfigWhereUniqueInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type MediaCount = {
  __typename: 'MediaCount';
  answers: Scalars['Int'];
  featuredExperts: Scalars['Int'];
  interstitialAds: Scalars['Int'];
  media: Scalars['Int'];
  reviews: Scalars['Int'];
  scholarshipApplicationReferrals: Scalars['Int'];
};

export type MediaListRelationFilter = {
  every?: InputMaybe<MediaWhereInput>;
  none?: InputMaybe<MediaWhereInput>;
  some?: InputMaybe<MediaWhereInput>;
};

export type MediaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MediaOrderByWithRelationInput = {
  answers?: InputMaybe<AnswerOrderByRelationAggregateInput>;
  bytes?: InputMaybe<SortOrder>;
  cloudinaryPublicId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  featuredExperts?: InputMaybe<FeaturedExpertOrderByRelationAggregateInput>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interstitialAds?: InputMaybe<InterstitialAdOrderByRelationAggregateInput>;
  media?: InputMaybe<MediaOrderByRelationAggregateInput>;
  resource?: InputMaybe<MediaOrderByWithRelationInput>;
  resourceId?: InputMaybe<SortOrder>;
  reviews?: InputMaybe<ReviewOrderByRelationAggregateInput>;
  sampleAuditionVideo?: InputMaybe<CohortOrderByWithRelationInput>;
  sampleReviewVideo?: InputMaybe<CohortOrderByWithRelationInput>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralOrderByRelationAggregateInput>;
  state?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userProfileAlternateImage?: InputMaybe<UserOrderByWithRelationInput>;
  userProfileCoverImage?: InputMaybe<UserOrderByWithRelationInput>;
  userProfileImage?: InputMaybe<UserOrderByWithRelationInput>;
  userProfileVideo?: InputMaybe<UserOrderByWithRelationInput>;
  width?: InputMaybe<SortOrder>;
};

export type MediaRelationFilter = {
  is?: InputMaybe<MediaWhereInput>;
  isNot?: InputMaybe<MediaWhereInput>;
};

export enum MediaScalarFieldEnum {
  Bytes = 'bytes',
  CloudinaryPublicId = 'cloudinaryPublicId',
  CreatedAt = 'createdAt',
  Duration = 'duration',
  Height = 'height',
  Id = 'id',
  ResourceId = 'resourceId',
  State = 'state',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Url = 'url',
  UserId = 'userId',
  Width = 'width'
}

/** Returns a one-time use Cloudinary Media Signature that can be used to sign Cloudinary uploads */
export type MediaSignature = {
  __typename: 'MediaSignature';
  publicId: Scalars['String'];
  signature: Scalars['String'];
  timestamp: Scalars['Int'];
};

export enum MediaStateEnum {
  Final = 'Final',
  UploadComplete = 'UploadComplete',
  Uploading = 'Uploading'
}

export enum MediaTypeEnum {
  Image = 'Image',
  Video = 'Video'
}

export type MediaVideoConfigNameFilter = {
  equals?: InputMaybe<VideoConfigNameEnum>;
  in?: InputMaybe<Array<VideoConfigNameEnum>>;
  notIn?: InputMaybe<Array<VideoConfigNameEnum>>;
};

export type MediaVideoConfigWhereInput = {
  AND?: InputMaybe<Array<MediaVideoConfigWhereInput>>;
  NOT?: InputMaybe<Array<MediaVideoConfigWhereInput>>;
  OR?: InputMaybe<Array<MediaVideoConfigWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<MediaVideoConfigNameFilter>;
  transformation?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumMediaConfigTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** Returns a Media video configuration */
export type MediaVideoConfiguration = {
  __typename: 'MediaVideoConfiguration';
  transformation?: Maybe<Scalars['JSON']>;
};

export type MediaWhereInput = {
  AND?: InputMaybe<Array<MediaWhereInput>>;
  NOT?: InputMaybe<Array<MediaWhereInput>>;
  OR?: InputMaybe<Array<MediaWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  bytes?: InputMaybe<IntNullableFilter>;
  cloudinaryPublicId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<FloatNullableFilter>;
  featuredExperts?: InputMaybe<FeaturedExpertListRelationFilter>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interstitialAds?: InputMaybe<InterstitialAdListRelationFilter>;
  media?: InputMaybe<MediaListRelationFilter>;
  resource?: InputMaybe<MediaRelationFilter>;
  resourceId?: InputMaybe<StringNullableFilter>;
  reviews?: InputMaybe<ReviewListRelationFilter>;
  sampleAuditionVideo?: InputMaybe<CohortRelationFilter>;
  sampleReviewVideo?: InputMaybe<CohortRelationFilter>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralListRelationFilter>;
  state?: InputMaybe<EnumMediaStateEnumFilter>;
  type?: InputMaybe<EnumMediaTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userProfileAlternateImage?: InputMaybe<UserRelationFilter>;
  userProfileCoverImage?: InputMaybe<UserRelationFilter>;
  userProfileImage?: InputMaybe<UserRelationFilter>;
  userProfileVideo?: InputMaybe<UserRelationFilter>;
  width?: InputMaybe<IntNullableFilter>;
};

export type MediaWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Message = {
  __typename: 'Message';
  _count?: Maybe<MessageCount>;
  content?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['String']>;
  sentAt: Scalars['DateTime'];
  source: MessageSourceEnum;
  state: MessageStateEnum;
  type: MessageTypeEnum;
  updatedAt: Scalars['DateTime'];
  userConversationId: Scalars['String'];
  userId: Scalars['String'];
};


export type MessageCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MessageSentAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MessageUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type MessageCount = {
  __typename: 'MessageCount';
  messages: Scalars['Int'];
};

export type MessageEntityResponseUnion = Media | PrivilegedApplication | PrivilegedReview;

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

export type MessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MessageOrderByWithRelationInput = {
  content?: InputMaybe<SortOrder>;
  conversation?: InputMaybe<ConversationOrderByWithRelationInput>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  parent?: InputMaybe<MessageOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userConversation?: InputMaybe<UserConversationOrderByWithRelationInput>;
  userConversationId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MessageRelationFilter = {
  is?: InputMaybe<MessageWhereInput>;
  isNot?: InputMaybe<MessageWhereInput>;
};

export enum MessageScalarFieldEnum {
  Content = 'content',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  Id = 'id',
  ParentId = 'parentId',
  SentAt = 'sentAt',
  Source = 'source',
  State = 'state',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserConversationId = 'userConversationId',
  UserId = 'userId'
}

export enum MessageSourceEnum {
  Api = 'Api',
  Facebook = 'Facebook',
  Instagram = 'Instagram'
}

export enum MessageStateEnum {
  Blocked = 'Blocked',
  Complete = 'Complete',
  Delivered = 'Delivered',
  Draft = 'Draft',
  Pending = 'Pending',
  Read = 'Read',
  Removed = 'Removed'
}

export enum MessageTypeEnum {
  Application = 'Application',
  Review = 'Review',
  Text = 'Text',
  Video = 'Video'
}

/** Available types to create messages */
export enum MessageTypeToCreateEnum {
  Text = 'Text',
  Video = 'Video'
}

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  conversation?: InputMaybe<ConversationRelationFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  parent?: InputMaybe<MessageRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  sentAt?: InputMaybe<DateTimeFilter>;
  source?: InputMaybe<EnumMessageSourceEnumFilter>;
  state?: InputMaybe<EnumMessageStateEnumFilter>;
  type?: InputMaybe<EnumMessageTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userConversation?: InputMaybe<UserConversationRelationFilter>;
  userConversationId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ModerateApplicationScholarshipReferralAction {
  Approve = 'APPROVE',
  Refuse = 'REFUSE'
}

export type ModerateApplicationScholarshipReferralInput = {
  action: ModerateApplicationScholarshipReferralAction;
  expertRecommendationId?: InputMaybe<Scalars['ID']>;
  id: Scalars['String'];
  moderationComment?: InputMaybe<Scalars['String']>;
};

export type ModerationApproveApplicationInput = {
  applicationId: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<ModerationNotesInput>;
  rating: Scalars['Int'];
};

export type ModerationBanApplicationInput = {
  applicationId: Scalars['ID'];
  reason: Scalars['String'];
};

export type ModerationNotesInput = {
  songName?: InputMaybe<Scalars['String']>;
};

export type ModerationRejectApplicationInput = {
  applicationId: Scalars['ID'];
  reason: Scalars['String'];
};

export type Mutation = {
  __typename: 'Mutation';
  addApplicationAsFinalist: PrivilegedApplication;
  addApplicationClassificationTags: Array<PrivilegedTag>;
  addCategoryTags: Array<PrivilegedTag>;
  addCohortTag: PrivilegedTag;
  addExpertCredential: PrivilegedTag;
  addExpertToCohort: PrivilegedCohort;
  addFeaturedFlagUsers: PrivilegedFeaturedFlag;
  addFinalist: PrivilegedReview;
  addStudentToCohort: PrivilegedCohort;
  /** add a quantity of tickets to an application */
  addTicketsToApplication: PrivilegedApplication;
  addUserClassificationTags: Array<PrivilegedTag>;
  addUserExpertise: CurrentUser;
  addUserInterest: CurrentUser;
  applicationRead: PrivilegedApplication;
  applicationRefund: ApplicationRefundResponse;
  applyVideoMediaConfiguration: Scalars['Boolean'];
  authUser: Scalars['Boolean'];
  authUserFromSocial?: Maybe<Scalars['String']>;
  comingSoonCohort: PrivilegedCohort;
  completeAndPurchaseApplicationWithStripe: PurchaseApplicationResponseUnion;
  completeApplicationScholarshipReferral: CompleteScholarshipApplicationReferralResponseUnion;
  completeApplicationWithAnswers: PurchaseApplicationResponseUnion;
  completeCohort: PrivilegedCohort;
  createApplication: CreateApplicationResponse;
  createCategory: PrivilegedCategory;
  createCohort: PrivilegedCohort;
  createCommonEntityTag: PrivilegedTag;
  createCommonTag: PrivilegedTag;
  createDetailTag: PrivilegedTag;
  createEntityTag: PrivilegedTag;
  createExpert: PublicUser;
  createExpertOnboarding: ExpertOnboarding;
  createFeaturedApplication: PrivilegedFeaturedApplication;
  createFeaturedExpert: PrivilegedFeaturedExpert;
  createFeaturedFlag: PrivilegedFeaturedFlag;
  createFeaturedReview: PublicFeaturedReview;
  createMessage: PrivilegedMessage;
  createMessageFromSocial: PrivilegedMessage;
  createReferralCode: PrivilegedReferralCode;
  createSampleApplications: Array<PublicApplication>;
  createTag: PrivilegedTag;
  createThreadItem: PrivilegedThreadItem;
  customNotification: Scalars['Boolean'];
  deleteFeaturedApplication: PrivilegedFeaturedApplication;
  deleteFeaturedReview: PublicFeaturedReview;
  deleteNotificationById: Scalars['Boolean'];
  deleteNotificationsByResource: UpdateNotificationsByResourceResult;
  deleteReferralCode: PrivilegedReferralCode;
  deleteThreadItem: PrivilegedThreadItem;
  expertFacebookLogin: Scalars['Boolean'];
  expertWaitlistSubcribe: WaitlistSubscribeResponse;
  initAuth: InitAuthResponse;
  initializeMedia: PrivilegedMedia;
  likeReview: PublicReview;
  /**
   * Sets the Current User's auth0Id to a different user, allowing them
   *       to log in as that user. A dangerous operation that should only be used in local environments.
   */
  loginAsUser?: Maybe<CurrentUser>;
  messagesRead: Array<PrivilegedMessage>;
  moderateScholarshipApplicationReferral: PrivilegedScholarshipApplicationReferral;
  moderationApproveApplication: Application;
  moderationBanApplication: Application;
  moderationRejectApplication: Application;
  newUnknownStudent: User;
  notAwardedScholarshipRollback: PrivilegedScholarshipApplication;
  publishCohort: PrivilegedCohort;
  purchaseApplicationWithApple: PurchaseApplicationResponseUnion;
  purchaseApplicationWithStripe: PurchaseApplicationResponseUnion;
  /** give an upvote to a scholarship application */
  redeemReferralCode: RedeemReferralCodeResponseUnion;
  refreshToken: RefreshTokenResponseUnion;
  removeApplication: Application;
  removeApplicationAsFinalist: PrivilegedApplication;
  removeApplicationClassificationTags: Array<PrivilegedTag>;
  removeCardForStripe: StripeStoredCardPaymentMethod;
  removeCategory: PrivilegedCategory;
  removeCategoryTag: PrivilegedTag;
  removeCohortTag: PrivilegedTag;
  removeExpertCredential: PrivilegedTag;
  removeExpertFromCohort: PrivilegedCohort;
  removeExpertOnboarding: ExpertOnboarding;
  /** Returns the feature expert that was deleted */
  removeFeaturedExpert: PrivilegedFeaturedExpert;
  removeFeaturedFlag: PrivilegedFeaturedFlag;
  removeFeaturedFlagUsers: PrivilegedFeaturedFlag;
  removeFinalist: PrivilegedReview;
  /** soft deletion of referral code */
  removeReferralCode: RedeemReferralCodeResponseUnion;
  removeStudentFromCohort: PrivilegedCohort;
  removeTag: PrivilegedTag;
  removeUserClassificationTags: Array<PrivilegedTag>;
  removeUserExpertise: CurrentUser;
  removeUserInterest: CurrentUser;
  retryReviewMediaUpload: MediaSignature;
  reviewApplication: PrivilegedReview;
  reviewCohort: PrivilegedCohort;
  /** creates a new paid application from an scholarship */
  scholarshipToPaidApplication: ScholarshipToPaidApplicationResponseUnion;
  /**
   * give an upvote to a scholarship application
   * @deprecated non-functional due to migration to new scholarship model (referrals)
   */
  scholarshipUpvote: ScholarshipUpvoteResponse;
  setAdminNotes: CurrentUser;
  setApplicationExpiration: PrivilegedApplication;
  setFeaturedFlagOptions: PrivilegedFeaturedFlag;
  setFeedPosition: Scalars['Boolean'];
  setUserFacts: CurrentUser;
  signOut: SignOutResponse;
  skipApplication: PrivilegedApplication;
  startCohort: PrivilegedCohort;
  /** submit a scholarship application */
  submitScholarshipApplication: PrivilegedApplication;
  syncEmailTemplate: PrivilegedTemplate;
  syncUser: Scalars['Boolean'];
  taskRead: PrivilegedTask;
  /** Change the application between private (required permissions) and public */
  toggleApplicationVisibility: PrivilegedApplication;
  toggleCohortFeatured: PrivilegedCohort;
  toggleExpertOnboarding: ExpertOnboarding;
  /** Returns the feature expert that was deleted */
  toggleFeaturedExpert: PrivilegedFeaturedExpert;
  toggleFeaturedFlag: PrivilegedFeaturedFlag;
  toggleFreeMessages: Scalars['Boolean'];
  toggleReviewIsPublic: PrivilegedReview;
  updateApplicationState: PrivilegedApplication;
  updateCategory: PrivilegedCategory;
  updateCohort: PrivilegedCohort;
  updateCohortCategory: PrivilegedCohort;
  updateCohortPaidApplicationsLimit: PrivilegedCohort;
  updateCohortSampleAuditionVideo: PrivilegedCohort;
  updateCohortSampleReviewVideo: PrivilegedCohort;
  updateCommonTag: PrivilegedTag;
  updateDetailTag: PrivilegedTag;
  updateEssayAnswer: PrivilegedAnswer;
  updateExpertOnboarding: ExpertOnboarding;
  updateExpertWaitlistEnabled: CurrentUser;
  updateFeaturedApplication: PrivilegedFeaturedApplication;
  updateFeaturedExpert: PrivilegedFeaturedExpert;
  /** Returns the feature expert that was deleted */
  updateFeaturedExpertCustomVideo: PrivilegedFeaturedExpert;
  updateFeaturedFlag: PrivilegedFeaturedFlag;
  updateFeaturedReview: PublicFeaturedReview;
  updateMyAvailability: Scalars['Boolean'];
  updateNotificationAsReadById: PrivilegedNotification;
  updateNotificationsAsReadByResource: UpdateNotificationsByResourceResult;
  updateProfileForApplication: PrivilegedApplication;
  updateReviewRating: PrivilegedReview;
  updateTag: PrivilegedTag;
  updateUser: UpdateUserResponse;
  updateUserAvailability: Scalars['Boolean'];
  updateUserProfileAlternateImage: CurrentUser;
  updateUserProfileCoverImage: CurrentUser;
  updateUserProfileImage: CurrentUser;
  updateUserProfileVideo: CurrentUser;
  updateVideoAnswer: PrivilegedAnswer;
  upsertUserSettings: UserSetting;
  verifyOtp: VerifyAuthResponseUnion;
  withdrawForStripe: Array<StripeRefundTransactionIntent>;
};


export type MutationAddApplicationAsFinalistArgs = {
  applicationId: Scalars['ID'];
};


export type MutationAddApplicationClassificationTagsArgs = {
  applicationId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type MutationAddCategoryTagsArgs = {
  categoryId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type MutationAddCohortTagArgs = {
  cohortId: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationAddExpertCredentialArgs = {
  credential: CommonTagContentInput;
  expertId: Scalars['ID'];
};


export type MutationAddExpertToCohortArgs = {
  cohortId: Scalars['ID'];
  expertId: Scalars['ID'];
  roleName?: InputMaybe<CohortRole>;
};


export type MutationAddFeaturedFlagUsersArgs = {
  featuredFlagKey: Scalars['String'];
  featuredFlagUsers: Array<Scalars['ID']>;
};


export type MutationAddFinalistArgs = {
  reviewId: Scalars['ID'];
};


export type MutationAddStudentToCohortArgs = {
  cohortId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationAddTicketsToApplicationArgs = {
  applicationId: Scalars['ID'];
  quantity: Scalars['Float'];
};


export type MutationAddUserClassificationTagsArgs = {
  tagIds: Array<Scalars['ID']>;
};


export type MutationAddUserExpertiseArgs = {
  categoryIds: Array<Scalars['ID']>;
};


export type MutationAddUserInterestArgs = {
  categoryIds: Array<Scalars['ID']>;
};


export type MutationApplicationReadArgs = {
  applicationId: Scalars['String'];
};


export type MutationApplicationRefundArgs = {
  applicationId: Scalars['String'];
};


export type MutationApplyVideoMediaConfigurationArgs = {
  cloudinaryPublicIds?: InputMaybe<Array<Scalars['String']>>;
  mediaConfigName: VideoConfigNameEnum;
};


export type MutationAuthUserArgs = {
  input: AuthUserInput;
};


export type MutationAuthUserFromSocialArgs = {
  input: AuthUserInput;
};


export type MutationComingSoonCohortArgs = {
  cohortId: Scalars['ID'];
  toBePublishedAt: Scalars['DateTime'];
};


export type MutationCompleteAndPurchaseApplicationWithStripeArgs = {
  input: CompleteAndPurchaseApplicationInput;
};


export type MutationCompleteApplicationScholarshipReferralArgs = {
  input: CompleteApplicationScholarshipReferralInput;
};


export type MutationCompleteApplicationWithAnswersArgs = {
  input: CompleteApplicationwithAnswersInput;
};


export type MutationCompleteCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationCreateApplicationArgs = {
  classificationTagIds?: InputMaybe<Array<Scalars['String']>>;
  input: CreateApplicationInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCohortArgs = {
  input: CohortInput;
};


export type MutationCreateCommonEntityTagArgs = {
  input: CommonEntityTagInput;
};


export type MutationCreateCommonTagArgs = {
  content: CommonTagContentInput;
  description?: InputMaybe<Scalars['String']>;
  type: TagTypeEnum;
};


export type MutationCreateDetailTagArgs = {
  content: DetailTagContentInput;
  description?: InputMaybe<Scalars['String']>;
  type: TagTypeEnum;
};


export type MutationCreateEntityTagArgs = {
  input: EntityTagInput;
};


export type MutationCreateExpertArgs = {
  input: AuthUserInput;
};


export type MutationCreateExpertOnboardingArgs = {
  input: CreateExpertOnboardingInput;
};


export type MutationCreateFeaturedApplicationArgs = {
  input: CreateFeaturedApplicationInput;
};


export type MutationCreateFeaturedExpertArgs = {
  input: CreateFeaturedExpertInput;
};


export type MutationCreateFeaturedFlagArgs = {
  input: CreateFeaturedFlagInput;
};


export type MutationCreateFeaturedReviewArgs = {
  reviewId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateMessageFromSocialArgs = {
  input: CreateMessageFromSocialInput;
};


export type MutationCreateReferralCodeArgs = {
  input: CreateReferralCodeInput;
};


export type MutationCreateSampleApplicationsArgs = {
  cohortId: Scalars['ID'];
  expertId: Scalars['ID'];
  vipAccessCode: Scalars['String'];
};


export type MutationCreateTagArgs = {
  content: Scalars['JSON'];
  description?: InputMaybe<Scalars['String']>;
  type: TagTypeEnum;
};


export type MutationCreateThreadItemArgs = {
  input: CreateThreadItemInput;
};


export type MutationCustomNotificationArgs = {
  input: CustomNotificationInput;
};


export type MutationDeleteFeaturedApplicationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeaturedReviewArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNotificationByIdArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNotificationsByResourceArgs = {
  resource: NotificationRelatedResourceInput;
};


export type MutationDeleteReferralCodeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteThreadItemArgs = {
  thredItemId: Scalars['ID'];
};


export type MutationExpertFacebookLoginArgs = {
  input: ExpertFacebookLoginInput;
};


export type MutationExpertWaitlistSubcribeArgs = {
  input: WaitlistSubscribeInput;
};


export type MutationInitAuthArgs = {
  input: InitAuthInput;
};


export type MutationInitializeMediaArgs = {
  cloudinaryPublicId: Scalars['String'];
  type?: InputMaybe<MediaTypeEnum>;
};


export type MutationLikeReviewArgs = {
  reviewId: Scalars['ID'];
};


export type MutationLoginAsUserArgs = {
  userId: Scalars['String'];
};


export type MutationMessagesReadArgs = {
  conversationId: Scalars['ID'];
};


export type MutationModerateScholarshipApplicationReferralArgs = {
  input: ModerateApplicationScholarshipReferralInput;
};


export type MutationModerationApproveApplicationArgs = {
  input: ModerationApproveApplicationInput;
};


export type MutationModerationBanApplicationArgs = {
  input: ModerationBanApplicationInput;
};


export type MutationModerationRejectApplicationArgs = {
  input: ModerationRejectApplicationInput;
};


export type MutationNewUnknownStudentArgs = {
  input: NewUnknownStudentInput;
};


export type MutationNotAwardedScholarshipRollbackArgs = {
  applicationId: Scalars['ID'];
};


export type MutationPublishCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationPurchaseApplicationWithAppleArgs = {
  input: PurchaseApplicationWithAppleInput;
};


export type MutationPurchaseApplicationWithStripeArgs = {
  input: PurchaseApplicationWithStripeInput;
};


export type MutationRedeemReferralCodeArgs = {
  applicationId: Scalars['ID'];
  code: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRemoveApplicationArgs = {
  input: ApplicationRemovalByAdminInput;
};


export type MutationRemoveApplicationAsFinalistArgs = {
  applicationId: Scalars['ID'];
};


export type MutationRemoveApplicationClassificationTagsArgs = {
  applicationId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type MutationRemoveCardForStripeArgs = {
  cardId: Scalars['String'];
};


export type MutationRemoveCategoryArgs = {
  categoryName: Scalars['String'];
};


export type MutationRemoveCategoryTagArgs = {
  categoryId: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationRemoveCohortTagArgs = {
  cohortId: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationRemoveExpertCredentialArgs = {
  expertId: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationRemoveExpertFromCohortArgs = {
  cohortId: Scalars['ID'];
  expertId: Scalars['ID'];
};


export type MutationRemoveExpertOnboardingArgs = {
  vipAccessCode: Scalars['String'];
};


export type MutationRemoveFeaturedExpertArgs = {
  featuredExpertId: Scalars['ID'];
};


export type MutationRemoveFeaturedFlagArgs = {
  featuredFlagKey: Scalars['String'];
};


export type MutationRemoveFeaturedFlagUsersArgs = {
  featuredFlagKey: Scalars['String'];
  featuredFlagUsers: Array<Scalars['ID']>;
};


export type MutationRemoveFinalistArgs = {
  reviewId: Scalars['ID'];
};


export type MutationRemoveReferralCodeArgs = {
  applicationId: Scalars['ID'];
};


export type MutationRemoveStudentFromCohortArgs = {
  cohortId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationRemoveTagArgs = {
  tagId: Scalars['ID'];
};


export type MutationRemoveUserClassificationTagsArgs = {
  tagIds: Array<Scalars['ID']>;
};


export type MutationRemoveUserExpertiseArgs = {
  categoryIds: Array<Scalars['ID']>;
};


export type MutationRemoveUserInterestArgs = {
  categoryIds: Array<Scalars['ID']>;
};


export type MutationRetryReviewMediaUploadArgs = {
  input: RetryReviewMediaUploadInput;
};


export type MutationReviewApplicationArgs = {
  input: CreateReviewInput;
};


export type MutationReviewCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationScholarshipToPaidApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type MutationScholarshipUpvoteArgs = {
  applicationId: Scalars['ID'];
};


export type MutationSetAdminNotesArgs = {
  notes: AdminNotesInput;
  userId: Scalars['ID'];
};


export type MutationSetApplicationExpirationArgs = {
  applicationId: Scalars['ID'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
};


export type MutationSetFeaturedFlagOptionsArgs = {
  featuredFlagKey: Scalars['String'];
  featuredFlagOptions: Scalars['JSON'];
};


export type MutationSetFeedPositionArgs = {
  applicationId: Scalars['ID'];
  cohortId: Scalars['ID'];
};


export type MutationSetUserFactsArgs = {
  input?: InputMaybe<Scalars['JSON']>;
  userId: Scalars['ID'];
};


export type MutationSignOutArgs = {
  token: Scalars['String'];
};


export type MutationSkipApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type MutationStartCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationSubmitScholarshipApplicationArgs = {
  input: SubmitScholarshipApplicationInput;
};


export type MutationSyncEmailTemplateArgs = {
  input: SyncEmailTemplateInput;
};


export type MutationSyncUserArgs = {
  auth0Key: Scalars['String'];
};


export type MutationTaskReadArgs = {
  taskId: Scalars['String'];
};


export type MutationToggleApplicationVisibilityArgs = {
  applicationId: Scalars['ID'];
};


export type MutationToggleCohortFeaturedArgs = {
  cohortId: Scalars['ID'];
};


export type MutationToggleExpertOnboardingArgs = {
  vipAccessCode: Scalars['String'];
};


export type MutationToggleFeaturedExpertArgs = {
  featuredExpertId: Scalars['ID'];
};


export type MutationToggleFeaturedFlagArgs = {
  featuredFlagKey: Scalars['String'];
};


export type MutationToggleFreeMessagesArgs = {
  participantId: Scalars['ID'];
};


export type MutationToggleReviewIsPublicArgs = {
  reviewId: Scalars['ID'];
};


export type MutationUpdateApplicationStateArgs = {
  input: UpdateApplicationStateInput;
};


export type MutationUpdateCategoryArgs = {
  categoryName: Scalars['String'];
  input: UpdateCategoryInput;
};


export type MutationUpdateCohortArgs = {
  cohortId: Scalars['ID'];
  input: UpdateCohortInput;
};


export type MutationUpdateCohortCategoryArgs = {
  cohortId: Scalars['ID'];
  input: UpdateCohortCategoryInput;
};


export type MutationUpdateCohortPaidApplicationsLimitArgs = {
  cohortId: Scalars['ID'];
  paidApplicationLimit?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCohortSampleAuditionVideoArgs = {
  cohortId: Scalars['ID'];
  input: UpdateCohortVideoInput;
};


export type MutationUpdateCohortSampleReviewVideoArgs = {
  cohortId: Scalars['ID'];
  input: UpdateCohortVideoInput;
};


export type MutationUpdateCommonTagArgs = {
  content: CommonTagContentInput;
  description?: InputMaybe<Scalars['String']>;
  tagId: Scalars['ID'];
};


export type MutationUpdateDetailTagArgs = {
  content: DetailTagContentInput;
  description?: InputMaybe<Scalars['String']>;
  tagId: Scalars['ID'];
};


export type MutationUpdateEssayAnswerArgs = {
  answerId: Scalars['String'];
  input: EssayAnswerInput;
};


export type MutationUpdateExpertOnboardingArgs = {
  input: UpdateExpertOnboardingInput;
  vipAccessCode: Scalars['String'];
};


export type MutationUpdateExpertWaitlistEnabledArgs = {
  enabled: Scalars['Boolean'];
  expertId: Scalars['ID'];
};


export type MutationUpdateFeaturedApplicationArgs = {
  id: Scalars['String'];
  input: UpdateFeaturedApplicationInput;
};


export type MutationUpdateFeaturedExpertArgs = {
  featuredExpertId: Scalars['ID'];
  input: UpdateFeaturedExpertInput;
};


export type MutationUpdateFeaturedExpertCustomVideoArgs = {
  cloudinaryPublicId: Scalars['String'];
  featuredExpertId: Scalars['ID'];
};


export type MutationUpdateFeaturedFlagArgs = {
  featuredFlagKey: Scalars['String'];
  input: UpdateFeaturedFlagInput;
};


export type MutationUpdateFeaturedReviewArgs = {
  id: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateMyAvailabilityArgs = {
  available: Scalars['Boolean'];
  cohortId: Scalars['ID'];
};


export type MutationUpdateNotificationAsReadByIdArgs = {
  id: Scalars['String'];
};


export type MutationUpdateNotificationsAsReadByResourceArgs = {
  resource: NotificationRelatedResourceInput;
};


export type MutationUpdateProfileForApplicationArgs = {
  input: UpdateProfileForApplicationInput;
};


export type MutationUpdateReviewRatingArgs = {
  input: UpdateReviewRatingInput;
};


export type MutationUpdateTagArgs = {
  content: Scalars['JSON'];
  description?: InputMaybe<Scalars['String']>;
  tagId: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserAvailabilityArgs = {
  available: Scalars['Boolean'];
  cohortId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateUserProfileAlternateImageArgs = {
  input: UpdateProfileImageInput;
};


export type MutationUpdateUserProfileCoverImageArgs = {
  input: UpdateProfileImageInput;
};


export type MutationUpdateUserProfileImageArgs = {
  input: UpdateProfileImageInput;
};


export type MutationUpdateUserProfileVideoArgs = {
  input: UpdateProfileVideoInput;
};


export type MutationUpdateVideoAnswerArgs = {
  answerId: Scalars['String'];
  input: VideoAnswerInput;
};


export type MutationUpsertUserSettingsArgs = {
  input: UserSettingInput;
};


export type MutationVerifyOtpArgs = {
  input: VerifyAuthInput;
};


export type MutationWithdrawForStripeArgs = {
  input: WithdrawInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedEnumApplicationStateEnumFilter = {
  equals?: InputMaybe<ApplicationStateEnum>;
  in?: InputMaybe<Array<ApplicationStateEnum>>;
  not?: InputMaybe<NestedEnumApplicationStateEnumFilter>;
  notIn?: InputMaybe<Array<ApplicationStateEnum>>;
};

export type NestedEnumCohortApplicationTypeEnumFilter = {
  equals?: InputMaybe<CohortApplicationTypeEnum>;
  in?: InputMaybe<Array<CohortApplicationTypeEnum>>;
  not?: InputMaybe<NestedEnumCohortApplicationTypeEnumFilter>;
  notIn?: InputMaybe<Array<CohortApplicationTypeEnum>>;
};

export type NestedEnumCohortStateEnumFilter = {
  equals?: InputMaybe<CohortStateEnum>;
  in?: InputMaybe<Array<CohortStateEnum>>;
  not?: InputMaybe<NestedEnumCohortStateEnumFilter>;
  notIn?: InputMaybe<Array<CohortStateEnum>>;
};

export type NestedEnumCohortTypeEnumFilter = {
  equals?: InputMaybe<CohortTypeEnum>;
  in?: InputMaybe<Array<CohortTypeEnum>>;
  not?: InputMaybe<NestedEnumCohortTypeEnumFilter>;
  notIn?: InputMaybe<Array<CohortTypeEnum>>;
};

export type NestedEnumConversationStateEnumFilter = {
  equals?: InputMaybe<ConversationStateEnum>;
  in?: InputMaybe<Array<ConversationStateEnum>>;
  not?: InputMaybe<NestedEnumConversationStateEnumFilter>;
  notIn?: InputMaybe<Array<ConversationStateEnum>>;
};

export type NestedEnumConversationTypeEnumFilter = {
  equals?: InputMaybe<ConversationTypeEnum>;
  in?: InputMaybe<Array<ConversationTypeEnum>>;
  not?: InputMaybe<NestedEnumConversationTypeEnumFilter>;
  notIn?: InputMaybe<Array<ConversationTypeEnum>>;
};

export type NestedEnumCredentialAssignmentEntityTypeEnumFilter = {
  equals?: InputMaybe<CredentialAssignmentEntityTypeEnum>;
  in?: InputMaybe<Array<CredentialAssignmentEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumCredentialAssignmentEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<CredentialAssignmentEntityTypeEnum>>;
};

export type NestedEnumCreditActionTypeEnumFilter = {
  equals?: InputMaybe<CreditActionTypeEnum>;
  in?: InputMaybe<Array<CreditActionTypeEnum>>;
  not?: InputMaybe<NestedEnumCreditActionTypeEnumFilter>;
  notIn?: InputMaybe<Array<CreditActionTypeEnum>>;
};

export type NestedEnumCreditEntityTypeEnumFilter = {
  equals?: InputMaybe<CreditEntityTypeEnum>;
  in?: InputMaybe<Array<CreditEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumCreditEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<CreditEntityTypeEnum>>;
};

export type NestedEnumEntityTagEntityTypeEnumFilter = {
  equals?: InputMaybe<EntityTagEntityTypeEnum>;
  in?: InputMaybe<Array<EntityTagEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumEntityTagEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<EntityTagEntityTypeEnum>>;
};

export type NestedEnumFeaturedExpertTypeEnumFilter = {
  equals?: InputMaybe<FeaturedExpertTypeEnum>;
  in?: InputMaybe<Array<FeaturedExpertTypeEnum>>;
  not?: InputMaybe<NestedEnumFeaturedExpertTypeEnumFilter>;
  notIn?: InputMaybe<Array<FeaturedExpertTypeEnum>>;
};

export type NestedEnumMediaConfigTypeEnumFilter = {
  equals?: InputMaybe<MediaConfigTypeEnum>;
  in?: InputMaybe<Array<MediaConfigTypeEnum>>;
  not?: InputMaybe<NestedEnumMediaConfigTypeEnumFilter>;
  notIn?: InputMaybe<Array<MediaConfigTypeEnum>>;
};

export type NestedEnumMediaStateEnumFilter = {
  equals?: InputMaybe<MediaStateEnum>;
  in?: InputMaybe<Array<MediaStateEnum>>;
  not?: InputMaybe<NestedEnumMediaStateEnumFilter>;
  notIn?: InputMaybe<Array<MediaStateEnum>>;
};

export type NestedEnumMediaTypeEnumFilter = {
  equals?: InputMaybe<MediaTypeEnum>;
  in?: InputMaybe<Array<MediaTypeEnum>>;
  not?: InputMaybe<NestedEnumMediaTypeEnumFilter>;
  notIn?: InputMaybe<Array<MediaTypeEnum>>;
};

export type NestedEnumMessageSourceEnumFilter = {
  equals?: InputMaybe<MessageSourceEnum>;
  in?: InputMaybe<Array<MessageSourceEnum>>;
  not?: InputMaybe<NestedEnumMessageSourceEnumFilter>;
  notIn?: InputMaybe<Array<MessageSourceEnum>>;
};

export type NestedEnumMessageStateEnumFilter = {
  equals?: InputMaybe<MessageStateEnum>;
  in?: InputMaybe<Array<MessageStateEnum>>;
  not?: InputMaybe<NestedEnumMessageStateEnumFilter>;
  notIn?: InputMaybe<Array<MessageStateEnum>>;
};

export type NestedEnumMessageTypeEnumFilter = {
  equals?: InputMaybe<MessageTypeEnum>;
  in?: InputMaybe<Array<MessageTypeEnum>>;
  not?: InputMaybe<NestedEnumMessageTypeEnumFilter>;
  notIn?: InputMaybe<Array<MessageTypeEnum>>;
};

export type NestedEnumNotificationResourceRelatedTypeEnumNullableFilter = {
  equals?: InputMaybe<NotificationResourceRelatedTypeEnum>;
  in?: InputMaybe<Array<NotificationResourceRelatedTypeEnum>>;
  not?: InputMaybe<NestedEnumNotificationResourceRelatedTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<NotificationResourceRelatedTypeEnum>>;
};

export type NestedEnumNotificationTypeEnumFilter = {
  equals?: InputMaybe<NotificationTypeEnum>;
  in?: InputMaybe<Array<NotificationTypeEnum>>;
  not?: InputMaybe<NestedEnumNotificationTypeEnumFilter>;
  notIn?: InputMaybe<Array<NotificationTypeEnum>>;
};

export type NestedEnumPaymentProviderEnumFilter = {
  equals?: InputMaybe<PaymentProviderEnum>;
  in?: InputMaybe<Array<PaymentProviderEnum>>;
  not?: InputMaybe<NestedEnumPaymentProviderEnumFilter>;
  notIn?: InputMaybe<Array<PaymentProviderEnum>>;
};

export type NestedEnumProfileVisibilityEnumFilter = {
  equals?: InputMaybe<ProfileVisibilityEnum>;
  in?: InputMaybe<Array<ProfileVisibilityEnum>>;
  not?: InputMaybe<NestedEnumProfileVisibilityEnumFilter>;
  notIn?: InputMaybe<Array<ProfileVisibilityEnum>>;
};

export type NestedEnumQuestionTypeEnumFilter = {
  equals?: InputMaybe<QuestionTypeEnum>;
  in?: InputMaybe<Array<QuestionTypeEnum>>;
  not?: InputMaybe<NestedEnumQuestionTypeEnumFilter>;
  notIn?: InputMaybe<Array<QuestionTypeEnum>>;
};

export type NestedEnumReferralCodeTargetEnumFilter = {
  equals?: InputMaybe<ReferralCodeTargetEnum>;
  in?: InputMaybe<Array<ReferralCodeTargetEnum>>;
  not?: InputMaybe<NestedEnumReferralCodeTargetEnumFilter>;
  notIn?: InputMaybe<Array<ReferralCodeTargetEnum>>;
};

export type NestedEnumReferralCodeTypeEnumFilter = {
  equals?: InputMaybe<ReferralCodeTypeEnum>;
  in?: InputMaybe<Array<ReferralCodeTypeEnum>>;
  not?: InputMaybe<NestedEnumReferralCodeTypeEnumFilter>;
  notIn?: InputMaybe<Array<ReferralCodeTypeEnum>>;
};

export type NestedEnumReviewKindEnumFilter = {
  equals?: InputMaybe<ReviewKindEnum>;
  in?: InputMaybe<Array<ReviewKindEnum>>;
  not?: InputMaybe<NestedEnumReviewKindEnumFilter>;
  notIn?: InputMaybe<Array<ReviewKindEnum>>;
};

export type NestedEnumScholarshipApplicationReferralStateEnumFilter = {
  equals?: InputMaybe<ScholarshipApplicationReferralStateEnum>;
  in?: InputMaybe<Array<ScholarshipApplicationReferralStateEnum>>;
  not?: InputMaybe<NestedEnumScholarshipApplicationReferralStateEnumFilter>;
  notIn?: InputMaybe<Array<ScholarshipApplicationReferralStateEnum>>;
};

export type NestedEnumTagTypeEnumFilter = {
  equals?: InputMaybe<TagTypeEnum>;
  in?: InputMaybe<Array<TagTypeEnum>>;
  not?: InputMaybe<NestedEnumTagTypeEnumFilter>;
  notIn?: InputMaybe<Array<TagTypeEnum>>;
};

export type NestedEnumTaskStateEnumFilter = {
  equals?: InputMaybe<TaskStateEnum>;
  in?: InputMaybe<Array<TaskStateEnum>>;
  not?: InputMaybe<NestedEnumTaskStateEnumFilter>;
  notIn?: InputMaybe<Array<TaskStateEnum>>;
};

export type NestedEnumTaskTypeEnumFilter = {
  equals?: InputMaybe<TaskTypeEnum>;
  in?: InputMaybe<Array<TaskTypeEnum>>;
  not?: InputMaybe<NestedEnumTaskTypeEnumFilter>;
  notIn?: InputMaybe<Array<TaskTypeEnum>>;
};

export type NestedEnumTemplateTypeEnumFilter = {
  equals?: InputMaybe<TemplateTypeEnum>;
  in?: InputMaybe<Array<TemplateTypeEnum>>;
  not?: InputMaybe<NestedEnumTemplateTypeEnumFilter>;
  notIn?: InputMaybe<Array<TemplateTypeEnum>>;
};

export type NestedEnumThreadEntityTypeEnumFilter = {
  equals?: InputMaybe<ThreadEntityTypeEnum>;
  in?: InputMaybe<Array<ThreadEntityTypeEnum>>;
  not?: InputMaybe<NestedEnumThreadEntityTypeEnumFilter>;
  notIn?: InputMaybe<Array<ThreadEntityTypeEnum>>;
};

export type NestedEnumThreadItemStateEnumFilter = {
  equals?: InputMaybe<ThreadItemStateEnum>;
  in?: InputMaybe<Array<ThreadItemStateEnum>>;
  not?: InputMaybe<NestedEnumThreadItemStateEnumFilter>;
  notIn?: InputMaybe<Array<ThreadItemStateEnum>>;
};

export type NestedEnumTransactionTypeEnumFilter = {
  equals?: InputMaybe<TransactionTypeEnum>;
  in?: InputMaybe<Array<TransactionTypeEnum>>;
  not?: InputMaybe<NestedEnumTransactionTypeEnumFilter>;
  notIn?: InputMaybe<Array<TransactionTypeEnum>>;
};

export type NestedEnumUserCategoryTypeEnumFilter = {
  equals?: InputMaybe<UserCategoryTypeEnum>;
  in?: InputMaybe<Array<UserCategoryTypeEnum>>;
  not?: InputMaybe<NestedEnumUserCategoryTypeEnumFilter>;
  notIn?: InputMaybe<Array<UserCategoryTypeEnum>>;
};

export type NestedEnumUserConversationRoleEnumFilter = {
  equals?: InputMaybe<UserConversationRoleEnum>;
  in?: InputMaybe<Array<UserConversationRoleEnum>>;
  not?: InputMaybe<NestedEnumUserConversationRoleEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationRoleEnum>>;
};

export type NestedEnumUserConversationStateEnumFilter = {
  equals?: InputMaybe<UserConversationStateEnum>;
  in?: InputMaybe<Array<UserConversationStateEnum>>;
  not?: InputMaybe<NestedEnumUserConversationStateEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationStateEnum>>;
};

export type NestedEnumUserConversationTypeEnumFilter = {
  equals?: InputMaybe<UserConversationTypeEnum>;
  in?: InputMaybe<Array<UserConversationTypeEnum>>;
  not?: InputMaybe<NestedEnumUserConversationTypeEnumFilter>;
  notIn?: InputMaybe<Array<UserConversationTypeEnum>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NewUnknownStudentInput = {
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Notification = {
  __typename: 'Notification';
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  readAt?: Maybe<Scalars['DateTime']>;
  resourceRelatedId?: Maybe<Scalars['String']>;
  resourceRelatedType?: Maybe<NotificationResourceRelatedTypeEnum>;
  title: Scalars['String'];
  type: NotificationTypeEnum;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  readAt?: InputMaybe<SortOrder>;
  resourceRelatedId?: InputMaybe<SortOrder>;
  resourceRelatedType?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationRelatedResourceInput = {
  resourceRelatedId: Scalars['ID'];
  resourceRelatedType: NotificationResourceRelatedTypeEnum;
};

export enum NotificationResourceRelatedTypeEnum {
  Application = 'Application',
  Cohort = 'Cohort',
  Message = 'Message',
  Post = 'Post',
  ScholarshipApplicationReferral = 'ScholarshipApplicationReferral'
}

export enum NotificationScalarFieldEnum {
  Body = 'body',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ReadAt = 'readAt',
  ResourceRelatedId = 'resourceRelatedId',
  ResourceRelatedType = 'resourceRelatedType',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum NotificationTypeEnum {
  AbandonedApplication = 'AbandonedApplication',
  ApplicationAccepted = 'ApplicationAccepted',
  ApplicationCloseToExpire = 'ApplicationCloseToExpire',
  ApplicationCoachingSubmitted = 'ApplicationCoachingSubmitted',
  ApplicationCoachingUnprocessed = 'ApplicationCoachingUnprocessed',
  ApplicationExpiredExtension = 'ApplicationExpiredExtension',
  ApplicationModeratedAndBanned = 'ApplicationModeratedAndBanned',
  ApplicationModeratedAndRejected = 'ApplicationModeratedAndRejected',
  ApplicationPublishedPendingExpert = 'ApplicationPublishedPendingExpert',
  ApplicationPublishedPendingJudging = 'ApplicationPublishedPendingJudging',
  ApplicationRejected = 'ApplicationRejected',
  ApplicationRemovedByAdmin = 'ApplicationRemovedByAdmin',
  ApplicationReviewReceived = 'ApplicationReviewReceived',
  ApplicationSubmitted = 'ApplicationSubmitted',
  ApplicationTalentShowUnprocessed = 'ApplicationTalentShowUnprocessed',
  ApplicationUnprocessed = 'ApplicationUnprocessed',
  ApplicationsPendingReview = 'ApplicationsPendingReview',
  CohortStarted = 'CohortStarted',
  Custom = 'Custom',
  MessageDelivered = 'MessageDelivered',
  RefundIntentInitiated = 'RefundIntentInitiated',
  ScholarshipApplicationReferralUpdate = 'ScholarshipApplicationReferralUpdate',
  ScholarshipAwarded = 'ScholarshipAwarded',
  ScholarshipNotAwarded = 'ScholarshipNotAwarded',
  ScholarshipProgressUpdate = 'ScholarshipProgressUpdate',
  ScholarshipPublished = 'ScholarshipPublished',
  ScholarshipSubmitted = 'ScholarshipSubmitted'
}

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  resourceRelatedId?: InputMaybe<StringNullableFilter>;
  resourceRelatedType?: InputMaybe<EnumNotificationResourceRelatedTypeEnumNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  activePage: Scalars['Float'];
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  perPage: Scalars['Float'];
  totalCount: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PaginatedPrivilegedMessageResponse = {
  __typename: 'PaginatedPrivilegedMessageResponse';
  data: Array<PrivilegedMessage>;
  pageInfo: PageInfo;
};

export type PaginatedPrivilegedThreadItemChildrenResponse = {
  __typename: 'PaginatedPrivilegedThreadItemChildrenResponse';
  data: Array<PrivilegedThreadItem>;
  pageInfo: PageInfo;
};

export type PaginatedPublicThreadItemChildrenResponse = {
  __typename: 'PaginatedPublicThreadItemChildrenResponse';
  data: Array<PublicThreadItem>;
  pageInfo: PageInfo;
};

export type PaginatedPublicThreadItemResponse = {
  __typename: 'PaginatedPublicThreadItemResponse';
  data: Array<PublicThreadItem>;
  pageInfo: PageInfo;
};

export enum PaymentProviderEnum {
  Apple = 'Apple',
  Google = 'Google',
  Stripe = 'Stripe'
}

export type PaymentProviderProduct = {
  __typename: 'PaymentProviderProduct';
  _count?: Maybe<PaymentProviderProductCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  price: Scalars['Int'];
  provider: PaymentProviderEnum;
  providerProductId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentProviderProductCount = {
  __typename: 'PaymentProviderProductCount';
  transactions: Scalars['Int'];
};

export type PaymentProviderProductOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerProductId?: InputMaybe<SortOrder>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentProviderProductRelationFilter = {
  is?: InputMaybe<PaymentProviderProductWhereInput>;
  isNot?: InputMaybe<PaymentProviderProductWhereInput>;
};

export enum PaymentProviderProductScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Price = 'price',
  Provider = 'provider',
  ProviderProductId = 'providerProductId',
  UpdatedAt = 'updatedAt'
}

export type PaymentProviderProductWhereInput = {
  AND?: InputMaybe<Array<PaymentProviderProductWhereInput>>;
  NOT?: InputMaybe<Array<PaymentProviderProductWhereInput>>;
  OR?: InputMaybe<Array<PaymentProviderProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<IntFilter>;
  provider?: InputMaybe<EnumPaymentProviderEnumFilter>;
  providerProductId?: InputMaybe<StringFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentProviderProductWhereUniqueInput = {
  PaymentProviderPriceUniqueIndex?: InputMaybe<Payment_Provider_ProductPaymentProviderPriceUniqueIndexCompoundUniqueInput>;
  PaymentProviderProductUniqueIndex?: InputMaybe<Payment_Provider_ProductPaymentProviderProductUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

/** A variation of the Answer object that is readable by the user who created the Answer and by the expert who owns the Application that the Answer was submitted to. */
export type PrivilegedAnswer = {
  __typename: 'PrivilegedAnswer';
  application: PrivilegedApplication;
  applicationId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['String']>;
  /** Returns a the cloudinary public video url with transformations */
  mediaUrlWithTransformations?: Maybe<Scalars['String']>;
  question: PublicQuestion;
  questionId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};


/** A variation of the Answer object that is readable by the user who created the Answer and by the expert who owns the Application that the Answer was submitted to. */
export type PrivilegedAnswerCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Answer object that is readable by the user who created the Answer and by the expert who owns the Application that the Answer was submitted to. */
export type PrivilegedAnswerMediaUrlWithTransformationsArgs = {
  mediaConfigName?: InputMaybe<VideoConfigNameEnum>;
};


/** A variation of the Answer object that is readable by the user who created the Answer and by the expert who owns the Application that the Answer was submitted to. */
export type PrivilegedAnswerUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplication = {
  __typename: 'PrivilegedApplication';
  /** returns the adjusted price for an application, taking into account user credits and discounts */
  adjustedPrice: Scalars['Int'];
  answers: Array<PrivilegedAnswer>;
  balance: Scalars['Int'];
  classificationTags: Array<PublicCommonContentTag>;
  clonedFromTag?: Maybe<CommonTagContent>;
  clonedToTag?: Maybe<CommonTagContent>;
  cohort: PrivilegedCohort;
  cohortId: Scalars['ID'];
  createTransactionIntentForApple?: Maybe<ApplePaymentTransactionIntent>;
  createTransactionIntentForStripe?: Maybe<StripePaymentTransactionIntent>;
  createdAt: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  hasAcceptedContentTOS: Scalars['Boolean'];
  id: Scalars['ID'];
  isExpirationExtended: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  isFinalist: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isScholarship: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoExpiresAt?: Maybe<Scalars['DateTime']>;
  isoLastViewedAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  lastViewedAt?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  referralCode?: Maybe<PrivilegedReferralCode>;
  referralCodeApplicableDiscount: Scalars['Float'];
  referralCodeAttemptId?: Maybe<Scalars['ID']>;
  reviews: Array<PrivilegedReview>;
  scholarshipApplication?: Maybe<PublicScholarshipApplication>;
  /** @deprecated replaced by eager transformation returned by MediaConfig.APPLICATION_SHAREABLE_ASSET_VIDEO field resolver */
  shareableAssetMediaUrl?: Maybe<ShareableAssetMediaUrl>;
  state: ApplicationStateEnum;
  ticketsReceived: Scalars['Int'];
  totalUnreadMessages: Scalars['Int'];
  updatedAt: Scalars['String'];
  user: PublicUser;
  userId: Scalars['ID'];
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationAnswersArgs = {
  cursor?: InputMaybe<AnswerWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnswerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnswerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnswerWhereInput>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationExpiresAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationLastViewedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationReviewsArgs = {
  cursor?: InputMaybe<ReviewWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReviewScalarFieldEnum>>;
  onlyPublicExperts?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<ReviewOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewWhereInput>;
};


/** A variation of the Application object that is readable by the user who created the Application and by the expert who the Application was submitted to. */
export type PrivilegedApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Category object that is readable by admins */
export type PrivilegedCategory = {
  __typename: 'PrivilegedCategory';
  backgroundColor?: Maybe<Scalars['String']>;
  classificationTags: Array<PublicCommonContentTag>;
  createdAt: Scalars['String'];
  fontColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  parent?: Maybe<PrivilegedCategory>;
  parentId?: Maybe<Scalars['ID']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


/** A variation of the Category object that is readable by admins */
export type PrivilegedCategoryClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Category object that is readable by admins */
export type PrivilegedCategoryCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Category object that is readable by admins */
export type PrivilegedCategoryUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohort = {
  __typename: 'PrivilegedCohort';
  aggregateApplicationLimit?: Maybe<Scalars['Int']>;
  application?: Maybe<PrivilegedApplication>;
  applicationExpirationDeadline?: Maybe<Scalars['String']>;
  applicationType: CohortApplicationTypeEnum;
  applications: Array<PrivilegedApplication>;
  areApplicationsAvailable: Scalars['Boolean'];
  arePaidApplicationsAvailable: Scalars['Boolean'];
  areScholarshipsAvailable: Scalars['Boolean'];
  category?: Maybe<PublicCategory>;
  charityBadge?: Maybe<CommonTagContent>;
  classificationTags: Array<PublicCommonContentTag>;
  comingSoon: Scalars['Boolean'];
  createdAt: Scalars['String'];
  credentialAssignmentGranted: Array<PublicCredentialAssignment>;
  credentialAssignmentReceived: Array<PublicCredentialAssignment>;
  description?: Maybe<Scalars['String']>;
  details: Array<DetailTagContent>;
  /** As cohort can have more than one expert, this returns the Featured Expert */
  expert: PublicUser;
  experts: Array<PublicUser>;
  featured: Scalars['Boolean'];
  featuredIndex?: Maybe<Scalars['Int']>;
  feedApplications: Array<PublicApplication>;
  hasPublishDeadlineExpired: Scalars['Boolean'];
  hasReviewDeadlineExpired: Scalars['Boolean'];
  /** @deprecated This deadline is going to be moved to the application itself */
  hasScholarshipDeadlineExpired: Scalars['Boolean'];
  iAmAvailable: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isPaidOnly: Scalars['Boolean'];
  isScholarshipOnly: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoPublishedAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  myApplications: Array<PrivilegedApplication>;
  name: Scalars['String'];
  numberOfCredentialsGranted: Scalars['Int'];
  numberOfCredentialsReceived: Scalars['Int'];
  paidApplicationLimit?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  prize?: Maybe<Scalars['String']>;
  prizeDetails?: Maybe<PrizeDetailTagContent>;
  publishDeadline?: Maybe<Scalars['String']>;
  publishDeadlineTimeLeft: Scalars['Timestamp'];
  publishWindow?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['String']>;
  purchaseOptions: Array<CohortApplicationPurchaseOption>;
  questions: Array<PublicQuestion>;
  responseDetail?: Maybe<Scalars['String']>;
  /** @deprecated this field will be removed. use applicationExpirationDeadline instead */
  reviewDeadline?: Maybe<Scalars['String']>;
  reviewWindow?: Maybe<Scalars['Int']>;
  rules?: Maybe<Scalars['String']>;
  sampleAuditionVideo?: Maybe<Media>;
  sampleAuditionVideoId?: Maybe<Scalars['ID']>;
  sampleReviewVideo?: Maybe<Media>;
  sampleReviewVideoId?: Maybe<Scalars['ID']>;
  scholarshipApplicationLimit?: Maybe<Scalars['Int']>;
  /** @deprecated This deadline is going to be moved to the application itself */
  scholarshipDeadline?: Maybe<Scalars['String']>;
  scholarshipReferralsThreshold: Scalars['Int'];
  /** @deprecated // TO-REMOVE when migrate to scholarship V2 (referral) */
  scholarshipVotesThreshold: Scalars['Int'];
  scholarshipWindow?: Maybe<Scalars['Int']>;
  scholarshipsAwarded: Scalars['Int'];
  /** @deprecated This field is going to be replaced by scholarshipApplicationLimit */
  scholarshipsEnabled?: Maybe<Scalars['Float']>;
  state: CohortStateEnum;
  students: Array<PublicUser>;
  symbol?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['JSON']>;
  totalApplications: Scalars['Int'];
  totalApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalFeedApplications: Scalars['Float'];
  totalPaidApplications: Scalars['Int'];
  totalPaidApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalScholarshipApplications: Scalars['Int'];
  totalScholarshipApplicationsRemaining?: Maybe<Scalars['Int']>;
  type: CohortTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  whatToSend: Array<CommonTagContent>;
  whatYouReceive: Array<CommonTagContent>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortApplicationArgs = {
  id: Scalars['String'];
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortApplicationExpirationDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortCredentialAssignmentGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortCredentialAssignmentReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortDetailsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortExpertsArgs = {
  roles?: InputMaybe<Array<CohortManagementRole>>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortFeedApplicationsArgs = {
  idx?: InputMaybe<Scalars['ID']>;
  take?: InputMaybe<Scalars['Int']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortMyApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortNumberOfCredentialsGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortNumberOfCredentialsReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortPublishDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortPublishedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortReviewDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortScholarshipDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortWhatToSendArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by experts who own the cohort, and students who have submitted applications to the cohort. */
export type PrivilegedCohortWhatYouReceiveArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};

/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversation = {
  __typename: 'PrivilegedConversation';
  canSendMessage: Scalars['Boolean'];
  createdAt: Scalars['String'];
  entity?: Maybe<ConversationEntityResponseUnion>;
  /** @deprecated Use canSendMessage instead */
  freeMessagesEnabled: Scalars['Boolean'];
  highestRating?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  messages: PaginatedPrivilegedMessageResponse;
  ownerId: Scalars['ID'];
  participants: Array<PrivilegedUserConversation>;
  state: ConversationStateEnum;
  title?: Maybe<Scalars['String']>;
  totalUnreadMessages: Scalars['Int'];
  type: ConversationTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversationEntityArgs = {
  entityType: ConversationEntityTypeEnum;
};


/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversationMessagesArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<MessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageWhereInput>;
};


/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversationParticipantsArgs = {
  cursor?: InputMaybe<UserConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserConversationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserConversationWhereInput>;
};


/** A variation of the Conversation object that is readable by authenticated users */
export type PrivilegedConversationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PrivilegedFeaturedApplication = {
  __typename: 'PrivilegedFeaturedApplication';
  application?: Maybe<PublicApplication>;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  review?: Maybe<PublicReview>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


export type PrivilegedFeaturedApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PrivilegedFeaturedApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the FeaturedExpert object that is readable by admins */
export type PrivilegedFeaturedExpert = {
  __typename: 'PrivilegedFeaturedExpert';
  active: Scalars['Boolean'];
  cohort?: Maybe<PrivilegedCohort>;
  cohortId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  customVideo?: Maybe<Media>;
  expert: PublicUser;
  expertId: Scalars['ID'];
  featuredApplications: Array<PrivilegedFeaturedApplication>;
  headline: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  sortOrder?: Maybe<Scalars['Int']>;
  subHeadline: Scalars['String'];
  type: FeaturedExpertTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};


/** A variation of the FeaturedExpert object that is readable by admins */
export type PrivilegedFeaturedExpertCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the FeaturedExpert object that is readable by admins */
export type PrivilegedFeaturedExpertFeaturedApplicationsArgs = {
  cursor?: InputMaybe<FeaturedApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedApplicationWhereInput>;
};


/** A variation of the FeaturedExpert object that is readable by admins */
export type PrivilegedFeaturedExpertUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the FeaturedFlag object that is readable by admins */
export type PrivilegedFeaturedFlag = {
  __typename: 'PrivilegedFeaturedFlag';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  key: Scalars['String'];
  name: Scalars['String'];
  options: Scalars['JSON'];
  updatedAt: Scalars['String'];
  users: Array<Scalars['String']>;
};


/** A variation of the FeaturedFlag object that is readable by admins */
export type PrivilegedFeaturedFlagCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the FeaturedFlag object that is readable by admins */
export type PrivilegedFeaturedFlagUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Media object that is readable by the user who created the Media */
export type PrivilegedMedia = {
  __typename: 'PrivilegedMedia';
  answers?: Maybe<Array<PrivilegedAnswer>>;
  bytes?: Maybe<Scalars['Int']>;
  cloudinaryPublicId: Scalars['ID'];
  createdAt: Scalars['String'];
  duration?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  state: MediaStateEnum;
  type: MediaTypeEnum;
  updatedAt: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  width?: Maybe<Scalars['Int']>;
};


/** A variation of the Media object that is readable by the user who created the Media */
export type PrivilegedMediaCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Media object that is readable by the user who created the Media */
export type PrivilegedMediaUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Message object that is readable by authenticated users */
export type PrivilegedMessage = {
  __typename: 'PrivilegedMessage';
  content?: Maybe<Scalars['String']>;
  conversation?: Maybe<PrivilegedConversation>;
  conversationId: Scalars['ID'];
  createdAt: Scalars['String'];
  entity?: Maybe<MessageEntityResponseUnion>;
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoSentAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  parentId?: Maybe<Scalars['String']>;
  sender: PublicUser;
  sentAt: Scalars['String'];
  source: MessageSourceEnum;
  state: MessageStateEnum;
  type: MessageTypeEnum;
  updatedAt: Scalars['String'];
  userConversationId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** A variation of the Message object that is readable by authenticated users */
export type PrivilegedMessageCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Message object that is readable by authenticated users */
export type PrivilegedMessageSentAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Message object that is readable by authenticated users */
export type PrivilegedMessageUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Notification object that is readable by the user owner of the Notification */
export type PrivilegedNotification = {
  __typename: 'PrivilegedNotification';
  body: Scalars['String'];
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoDeletedAt?: Maybe<Scalars['DateTime']>;
  isoReadAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  readAt?: Maybe<Scalars['String']>;
  resourceRelatedId?: Maybe<Scalars['ID']>;
  resourceRelatedType?: Maybe<NotificationResourceRelatedTypeEnum>;
  resourceRelatedUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: NotificationTypeEnum;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};


/** A variation of the Notification object that is readable by the user owner of the Notification */
export type PrivilegedNotificationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Notification object that is readable by the user owner of the Notification */
export type PrivilegedNotificationDeletedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Notification object that is readable by the user owner of the Notification */
export type PrivilegedNotificationReadAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Notification object that is readable by the user owner of the Notification */
export type PrivilegedNotificationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PrivilegedPaymentProviderProduct = {
  __typename: 'PrivilegedPaymentProviderProduct';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  price: Scalars['Int'];
  provider: PaymentProviderEnum;
  providerProductId: Scalars['String'];
  updatedAt: Scalars['String'];
};


export type PrivilegedPaymentProviderProductCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PrivilegedPaymentProviderProductUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the ReferralCode object that is readable by the USER role */
export type PrivilegedReferralCode = {
  __typename: 'PrivilegedReferralCode';
  code: Scalars['String'];
  createdAt: Scalars['String'];
  expertId?: Maybe<Scalars['ID']>;
  expertTarget?: Maybe<PublicUser>;
  expiredAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoExpiredAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  maxUse?: Maybe<Scalars['Int']>;
  target: ReferralCodeTargetEnum;
  type: ReferralCodeTypeEnum;
  updatedAt: Scalars['String'];
  value: Scalars['Int'];
};


/** A variation of the ReferralCode object that is readable by the USER role */
export type PrivilegedReferralCodeCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ReferralCode object that is readable by the USER role */
export type PrivilegedReferralCodeExpiredAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ReferralCode object that is readable by the USER role */
export type PrivilegedReferralCodeUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PrivilegedReview = IReview & {
  __typename: 'PrivilegedReview';
  application: PrivilegedApplication;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  credentialAssignments?: Maybe<Array<PublicCredentialAssignment>>;
  data?: Maybe<Scalars['String']>;
  finalist?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  initializedMedia: InitializedMediaResponse;
  isPublic?: Maybe<Scalars['Boolean']>;
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  kind: ReviewKindEnum;
  labels?: Maybe<Scalars['JSON']>;
  likeCount?: Maybe<Scalars['Float']>;
  likedByMe?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  /** Returns a the cloudinary public video url with transformations */
  mediaUrlWithTransformations?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  /** Returns a map of Reaction Video URLs */
  reactionVideo: ReactionVideoResponse;
  responseMediaId?: Maybe<Scalars['String']>;
  thread?: Maybe<PublicThread>;
  updatedAt: Scalars['String'];
  user: PublicUser;
  userId: Scalars['ID'];
};


export type PrivilegedReviewCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PrivilegedReviewCredentialAssignmentsArgs = {
  cursor?: InputMaybe<CredentialAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialAssignmentWhereInput>;
};


export type PrivilegedReviewInitializedMediaArgs = {
  notificationUrl?: InputMaybe<Scalars['String']>;
};


export type PrivilegedReviewMediaUrlWithTransformationsArgs = {
  mediaConfigName?: InputMaybe<VideoConfigNameEnum>;
};


export type PrivilegedReviewUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the ScholarshipApplication object that is readable by admins */
export type PrivilegedScholarshipApplication = {
  __typename: 'PrivilegedScholarshipApplication';
  application: PrivilegedApplication;
  applicationId: Scalars['ID'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  canVote: Scalars['Boolean'];
  createdAt: Scalars['String'];
  deadline?: Maybe<Scalars['String']>;
  hasDeadlineExpired: Scalars['Boolean'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  hasVoted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  shortCode?: Maybe<Scalars['String']>;
  totalApprovedReferrals: Scalars['Int'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  totalUpvote: Scalars['Int'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  upVotes: Array<PublicScholarshipApplicationUpvote>;
  updatedAt: Scalars['String'];
};


/** A variation of the ScholarshipApplication object that is readable by admins */
export type PrivilegedScholarshipApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ScholarshipApplication object that is readable by admins */
export type PrivilegedScholarshipApplicationDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ScholarshipApplication object that is readable by admins */
export type PrivilegedScholarshipApplicationUpVotesArgs = {
  cursor?: InputMaybe<ScholarshipApplicationUpvoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScholarshipApplicationUpvoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScholarshipApplicationUpvoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
};


/** A variation of the ScholarshipApplication object that is readable by admins */
export type PrivilegedScholarshipApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PrivilegedScholarshipApplicationReferral = {
  __typename: 'PrivilegedScholarshipApplicationReferral';
  createdAt: Scalars['String'];
  demoMedia?: Maybe<PrivilegedMedia>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  moderationComment?: Maybe<Scalars['String']>;
  publicScholarshipApplication: PublicScholarshipApplication;
  referredUser: PublicUser;
  updatedAt: Scalars['String'];
};


export type PrivilegedScholarshipApplicationReferralCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PrivilegedScholarshipApplicationReferralUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Tag object that is readable by admins */
export type PrivilegedTag = {
  __typename: 'PrivilegedTag';
  content: Scalars['JSON'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  type: TagTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Tag object that is readable by admins */
export type PrivilegedTagCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Tag object that is readable by admins */
export type PrivilegedTagUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Task object that is readable by experts who own the task */
export type PrivilegedTask = {
  __typename: 'PrivilegedTask';
  application: PrivilegedApplication;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoLastViewedAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  lastViewedAt?: Maybe<Scalars['String']>;
  state: TaskStateEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


/** A variation of the Task object that is readable by experts who own the task */
export type PrivilegedTaskCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Task object that is readable by experts who own the task */
export type PrivilegedTaskLastViewedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Task object that is readable by experts who own the task */
export type PrivilegedTaskUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Template object that is readable by admins */
export type PrivilegedTemplate = {
  __typename: 'PrivilegedTemplate';
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  externalId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  type: TemplateTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Template object that is readable by admins */
export type PrivilegedTemplateCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Template object that is readable by admins */
export type PrivilegedTemplateUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the ThreadItem object that is readable by owner user or admins */
export type PrivilegedThreadItem = IThreadItem & {
  __typename: 'PrivilegedThreadItem';
  author: PublicUser;
  children: PaginatedPrivilegedThreadItemChildrenResponse;
  content: ThreadItemContent;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  parent?: Maybe<PrivilegedThreadItem>;
  parentId?: Maybe<Scalars['ID']>;
  state: ThreadItemStateEnum;
  thread: PublicThread;
  threadId: Scalars['ID'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


/** A variation of the ThreadItem object that is readable by owner user or admins */
export type PrivilegedThreadItemChildrenArgs = {
  cursor?: InputMaybe<ThreadItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThreadItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThreadItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThreadItemWhereInput>;
};


/** A variation of the ThreadItem object that is readable by owner user or admins */
export type PrivilegedThreadItemCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ThreadItem object that is readable by owner user or admins */
export type PrivilegedThreadItemUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** TODO 16 Jan 2022 - remove this type once a new iOS expert app is published with calls to the `topics` resolver removed. */
export type PrivilegedTopic = {
  __typename: 'PrivilegedTopic';
  communityWebUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** A variation of the UserConversation object that is readable by authenticated users */
export type PrivilegedUserConversation = {
  __typename: 'PrivilegedUserConversation';
  conversationId: Scalars['ID'];
  createdAt: Scalars['String'];
  freeMessagesEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  lastAccessedAt: Scalars['DateTime'];
  role: UserConversationRoleEnum;
  state: UserConversationStateEnum;
  type: UserConversationTypeEnum;
  updatedAt: Scalars['String'];
  user: PublicUser;
  userId: Scalars['ID'];
};


/** A variation of the UserConversation object that is readable by authenticated users */
export type PrivilegedUserConversationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the UserConversation object that is readable by authenticated users */
export type PrivilegedUserConversationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PrizeDetailTagContent = {
  __typename: 'PrizeDetailTagContent';
  iconCloudinaryPublicId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  textMapping: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ProfileVisibilityEnum {
  FullVisibility = 'FullVisibility',
  NoVisibility = 'NoVisibility'
}

/** A variation of the Answer object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicAnswer = {
  __typename: 'PublicAnswer';
  applicationId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['ID']>;
  /** Returns a the cloudinary public video url with transformations */
  mediaUrlWithTransformations?: Maybe<Scalars['String']>;
  question: PublicQuestion;
  questionId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};


/** A variation of the Answer object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicAnswerCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Answer object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicAnswerMediaUrlWithTransformationsArgs = {
  mediaConfigName?: InputMaybe<VideoConfigNameEnum>;
};


/** A variation of the Answer object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicAnswerUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplication = {
  __typename: 'PublicApplication';
  answers: Array<PublicAnswer>;
  classificationTags: Array<PublicCommonContentTag>;
  clonedFromTag?: Maybe<CommonTagContent>;
  clonedToTag?: Maybe<CommonTagContent>;
  cohort: PublicCohort;
  cohortId: Scalars['ID'];
  createdAt: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isExpired: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  isScholarship: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoExpiresAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  reviews: Array<PublicReview>;
  scholarshipApplication?: Maybe<PublicScholarshipApplication>;
  state: ApplicationStateEnum;
  ticketsReceived: Scalars['Int'];
  totalUnreadMessages: Scalars['Int'];
  updatedAt: Scalars['String'];
  user: PublicUser;
  userId: Scalars['ID'];
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationAnswersArgs = {
  cursor?: InputMaybe<AnswerWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnswerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnswerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnswerWhereInput>;
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationExpiresAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationReviewsArgs = {
  cursor?: InputMaybe<ReviewWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReviewScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReviewOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewWhereInput>;
};


/** A variation of the Application object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Category object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCategory = {
  __typename: 'PublicCategory';
  backgroundColor?: Maybe<Scalars['String']>;
  classificationTags: Array<PublicCommonContentTag>;
  createdAt: Scalars['String'];
  fontColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  parent?: Maybe<PublicCategory>;
  parentId?: Maybe<Scalars['ID']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


/** A variation of the Category object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCategoryClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Category object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCategoryCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Category object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCategoryUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohort = {
  __typename: 'PublicCohort';
  aggregateApplicationLimit?: Maybe<Scalars['Int']>;
  applicationExpirationDeadline?: Maybe<Scalars['String']>;
  applicationType: CohortApplicationTypeEnum;
  areApplicationsAvailable: Scalars['Boolean'];
  arePaidApplicationsAvailable: Scalars['Boolean'];
  areScholarshipsAvailable: Scalars['Boolean'];
  category?: Maybe<PublicCategory>;
  charityBadge?: Maybe<CommonTagContent>;
  classificationTags: Array<PublicCommonContentTag>;
  comingSoon: Scalars['Boolean'];
  createdAt: Scalars['String'];
  credentialAssignmentGranted: Array<PublicCredentialAssignment>;
  credentialAssignmentReceived: Array<PublicCredentialAssignment>;
  description?: Maybe<Scalars['String']>;
  details: Array<DetailTagContent>;
  /** As cohort can have more than one expert, this returns the Featured Expert */
  expert: PublicUser;
  experts: Array<PublicUser>;
  featured: Scalars['Boolean'];
  featuredIndex?: Maybe<Scalars['Int']>;
  feedApplications: Array<PublicApplication>;
  hasPublishDeadlineExpired: Scalars['Boolean'];
  hasReviewDeadlineExpired: Scalars['Boolean'];
  /** @deprecated This deadline is going to be moved to the application itself */
  hasScholarshipDeadlineExpired: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isPaidOnly: Scalars['Boolean'];
  isScholarshipOnly: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoPublishedAt?: Maybe<Scalars['DateTime']>;
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  numberOfCredentialsGranted: Scalars['Int'];
  numberOfCredentialsReceived: Scalars['Int'];
  paidApplicationLimit?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  prize?: Maybe<Scalars['String']>;
  prizeDetails?: Maybe<PrizeDetailTagContent>;
  publishDeadline?: Maybe<Scalars['String']>;
  publishDeadlineTimeLeft: Scalars['Timestamp'];
  publishWindow?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['String']>;
  purchaseOptions: Array<CohortApplicationPurchaseOption>;
  questions: Array<PublicQuestion>;
  responseDetail?: Maybe<Scalars['String']>;
  /** @deprecated this field will be removed. use applicationExpirationDeadline instead */
  reviewDeadline?: Maybe<Scalars['String']>;
  reviewWindow?: Maybe<Scalars['Int']>;
  rules?: Maybe<Scalars['String']>;
  sampleAuditionVideo?: Maybe<Media>;
  sampleAuditionVideoId?: Maybe<Scalars['ID']>;
  sampleReviewVideo?: Maybe<Media>;
  sampleReviewVideoId?: Maybe<Scalars['ID']>;
  scholarshipApplicationLimit?: Maybe<Scalars['Int']>;
  /** @deprecated This deadline is going to be moved to the application itself */
  scholarshipDeadline?: Maybe<Scalars['String']>;
  scholarshipReferralsThreshold: Scalars['Int'];
  /** @deprecated // TO-REMOVE when migrate to scholarship V2 (referral) */
  scholarshipVotesThreshold: Scalars['Int'];
  scholarshipWindow?: Maybe<Scalars['Int']>;
  scholarshipsAwarded: Scalars['Int'];
  /** @deprecated This field is going to be replaced by scholarshipApplicationLimit */
  scholarshipsEnabled?: Maybe<Scalars['Float']>;
  state: CohortStateEnum;
  symbol?: Maybe<Scalars['String']>;
  timeline?: Maybe<Scalars['JSON']>;
  totalApplications: Scalars['Int'];
  totalApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalFeedApplications: Scalars['Float'];
  totalPaidApplications: Scalars['Int'];
  totalPaidApplicationsRemaining?: Maybe<Scalars['Int']>;
  totalScholarshipApplications: Scalars['Int'];
  totalScholarshipApplicationsRemaining?: Maybe<Scalars['Int']>;
  type: CohortTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  whatToSend: Array<CommonTagContent>;
  whatYouReceive: Array<CommonTagContent>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortApplicationExpirationDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortCredentialAssignmentGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortCredentialAssignmentReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortDetailsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortExpertsArgs = {
  roles?: InputMaybe<Array<CohortManagementRole>>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortFeedApplicationsArgs = {
  idx?: InputMaybe<Scalars['ID']>;
  take?: InputMaybe<Scalars['Int']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortNumberOfCredentialsGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortNumberOfCredentialsReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortPublishDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortPublishedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortReviewDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortScholarshipDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortWhatToSendArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the Cohort object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicCohortWhatYouReceiveArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};

/** A variation of the Common Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicCommonContentTag = {
  __typename: 'PublicCommonContentTag';
  content: CommonTagContent;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  taggedCohorts: Array<TaggedEntityUnion>;
  type: TagTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Common Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicCommonContentTagCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Common Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicCommonContentTagTaggedCohortsArgs = {
  pagination?: InputMaybe<TaggedCohortPaginationInput>;
};


/** A variation of the Common Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicCommonContentTagUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the CredentialAssignment object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCredentialAssignment = {
  __typename: 'PublicCredentialAssignment';
  createdAt: Scalars['String'];
  credential: Credential;
  credentialId: Scalars['ID'];
  from: CredentialAssignmentEntityType;
  fromEntityId?: Maybe<Scalars['ID']>;
  fromEntityType: CredentialAssignmentEntityTypeEnum;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  ratedApplication?: Maybe<PublicApplication>;
  ratedApplicationId?: Maybe<Scalars['ID']>;
  to: CredentialAssignmentEntityType;
  toEntityId: Scalars['ID'];
  toEntityType: CredentialAssignmentEntityTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the CredentialAssignment object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCredentialAssignmentCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the CredentialAssignment object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicCredentialAssignmentUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PublicExpertRelationsUser = {
  __typename: 'PublicExpertRelationsUser';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type PublicFeaturedApplication = {
  __typename: 'PublicFeaturedApplication';
  application?: Maybe<PublicApplication>;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  review?: Maybe<PublicReview>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


export type PublicFeaturedApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PublicFeaturedApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the FeaturedExpert object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedExpert = {
  __typename: 'PublicFeaturedExpert';
  active: Scalars['Boolean'];
  cohort?: Maybe<PublicCohort>;
  cohortId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  customVideo?: Maybe<Media>;
  expert: PublicUser;
  expertId: Scalars['ID'];
  featuredApplications: Array<PublicFeaturedApplication>;
  headline: Scalars['String'];
  hoursToReview?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  subHeadline: Scalars['String'];
  type: FeaturedExpertTypeEnum;
  updateStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};


/** A variation of the FeaturedExpert object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedExpertCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the FeaturedExpert object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedExpertFeaturedApplicationsArgs = {
  cursor?: InputMaybe<FeaturedApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedApplicationWhereInput>;
};


/** A variation of the FeaturedExpert object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedExpertUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the FeaturedFlag object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedFlag = {
  __typename: 'PublicFeaturedFlag';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  key: Scalars['String'];
  name: Scalars['String'];
  options: Scalars['JSON'];
  updatedAt: Scalars['String'];
};


/** A variation of the FeaturedFlag object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedFlagCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the FeaturedFlag object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicFeaturedFlagUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PublicFeaturedReview = {
  __typename: 'PublicFeaturedReview';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  review?: Maybe<PublicReview>;
  reviewId: Scalars['ID'];
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['String'];
};


export type PublicFeaturedReviewCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PublicFeaturedReviewUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PublicInterstitialAd = {
  __typename: 'PublicInterstitialAd';
  buttonPath: Scalars['String'];
  buttonText: Scalars['String'];
  headline: Scalars['String'];
  id: Scalars['ID'];
  media?: Maybe<Media>;
  mediaId: Scalars['ID'];
  subHeadline: Scalars['String'];
};

/** A variation of the Media Config object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicMediaConfig = {
  __typename: 'PublicMediaConfig';
  createdAt: Scalars['String'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  transformation?: Maybe<Scalars['JSON']>;
  type: MediaConfigTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Media Config object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicMediaConfigCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Media Config object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive priviledged information. */
export type PublicMediaConfigUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Question object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive or priviledged information. */
export type PublicQuestion = {
  __typename: 'PublicQuestion';
  cohortId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  maxDuration?: Maybe<Scalars['Int']>;
  maxLength?: Maybe<Scalars['Int']>;
  prompt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: QuestionTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Question object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive or priviledged information. */
export type PublicQuestionCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Question object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive or priviledged information. */
export type PublicQuestionUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type PublicReview = IReview & {
  __typename: 'PublicReview';
  application?: Maybe<Application>;
  applicationId: Scalars['ID'];
  createdAt: Scalars['String'];
  credentialAssignments?: Maybe<Array<PublicCredentialAssignment>>;
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  kind: ReviewKindEnum;
  labels?: Maybe<Scalars['JSON']>;
  likeCount?: Maybe<Scalars['Float']>;
  likedByMe?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  /** Returns a the cloudinary public video url with transformations */
  mediaUrlWithTransformations?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  responseMediaId?: Maybe<Scalars['String']>;
  thread?: Maybe<PublicThread>;
  updatedAt: Scalars['String'];
  user: PublicUser;
  userId: Scalars['ID'];
};


export type PublicReviewCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type PublicReviewCredentialAssignmentsArgs = {
  cursor?: InputMaybe<CredentialAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialAssignmentWhereInput>;
};


export type PublicReviewMediaUrlWithTransformationsArgs = {
  mediaConfigName?: InputMaybe<VideoConfigNameEnum>;
};


export type PublicReviewUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the ScholarshipApplication object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplication = {
  __typename: 'PublicScholarshipApplication';
  application: PublicApplication;
  applicationId: Scalars['ID'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  canVote: Scalars['Boolean'];
  createdAt: Scalars['String'];
  deadline?: Maybe<Scalars['String']>;
  hasDeadlineExpired: Scalars['Boolean'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  hasVoted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  shortCode?: Maybe<Scalars['String']>;
  totalApprovedReferrals: Scalars['Int'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  totalUpvote: Scalars['Int'];
  /** @deprecated this field will be removed when migrate to scholarship V2 (referrer) */
  upVotes: Array<PublicScholarshipApplicationUpvote>;
  updatedAt: Scalars['String'];
};


/** A variation of the ScholarshipApplication object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ScholarshipApplication object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationDeadlineArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ScholarshipApplication object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationUpVotesArgs = {
  cursor?: InputMaybe<ScholarshipApplicationUpvoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScholarshipApplicationUpvoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScholarshipApplicationUpvoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
};


/** A variation of the ScholarshipApplication object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the ScholarshipApplicationUpvote object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationUpvote = {
  __typename: 'PublicScholarshipApplicationUpvote';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  scholarshipApplicationId: Scalars['ID'];
  updatedAt: Scalars['String'];
  /** @deprecated to remove when migrate to scholarship V2 (referral) */
  voter: PublicUser;
  voterId: Scalars['ID'];
};


/** A variation of the ScholarshipApplicationUpvote object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationUpvoteCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the ScholarshipApplicationUpvote object that is readable by both authenticated and unauthenricated users.  Does not contain any sensitive priviledged information. */
export type PublicScholarshipApplicationUpvoteUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicTag = {
  __typename: 'PublicTag';
  content: CommonTagContent;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  taggedCohorts: Array<TaggedEntityUnion>;
  type: TagTypeEnum;
  updatedAt: Scalars['String'];
};


/** A variation of the Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicTagCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicTagTaggedCohortsArgs = {
  pagination?: InputMaybe<TaggedCohortPaginationInput>;
};


/** A variation of the Tag object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicTagUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Thread object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThread = {
  __typename: 'PublicThread';
  createdAt: Scalars['String'];
  entity: ThreadEntityUnion;
  entityId: Scalars['ID'];
  entityType: ThreadEntityTypeEnum;
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  items: PaginatedPublicThreadItemResponse;
  updatedAt: Scalars['String'];
};


/** A variation of the Thread object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Thread object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadItemsArgs = {
  cursor?: InputMaybe<ThreadItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThreadItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThreadItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThreadItemWhereInput>;
};


/** A variation of the Thread object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the Thread Item object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadItem = IThreadItem & {
  __typename: 'PublicThreadItem';
  author: PublicUser;
  children: PaginatedPublicThreadItemChildrenResponse;
  content: ThreadItemContent;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  parent?: Maybe<PublicThreadItem>;
  parentId?: Maybe<Scalars['ID']>;
  state: ThreadItemStateEnum;
  thread: PublicThread;
  threadId: Scalars['ID'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};


/** A variation of the Thread Item object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadItemChildrenArgs = {
  cursor?: InputMaybe<ThreadItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThreadItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThreadItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThreadItemWhereInput>;
};


/** A variation of the Thread Item object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadItemCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the Thread Item object that is readable by both authenticated and unauthenticated users. Does not contain any sensitive privileged information. */
export type PublicThreadItemUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUser = {
  __typename: 'PublicUser';
  bio?: Maybe<Scalars['String']>;
  classificationTags: Array<PublicCommonContentTag>;
  cohorts: Array<PublicCohort>;
  createdAt: Scalars['String'];
  credentialAssignmentGranted: Array<PublicCredentialAssignment>;
  credentialAssignmentReceived: Array<PublicCredentialAssignment>;
  expertCredentials: Array<CommonTagContent>;
  /** @deprecated replaced by expertRelationsUser { name } */
  expertRelationsName?: Maybe<Scalars['String']>;
  /** @deprecated replaced by expertRelationsUser { phone } */
  expertRelationsPhone?: Maybe<Scalars['String']>;
  expertRelationsUser?: Maybe<PublicExpertRelationsUser>;
  expertRelationsUserId?: Maybe<Scalars['ID']>;
  expertise: Array<PublicCategory>;
  facebookUrl?: Maybe<Scalars['String']>;
  facebookUsername?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instagramUrl?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
  interest: Array<PublicCategory>;
  isAdmin: Scalars['Boolean'];
  isExpert: Scalars['Boolean'];
  isProfileComplete: Scalars['Boolean'];
  isStudent: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  linkedInUrl?: Maybe<Scalars['String']>;
  linkedInUsername?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberOfCredentialsGranted: Scalars['Int'];
  numberOfCredentialsReceived: Scalars['Int'];
  profileImageUrl?: Maybe<Scalars['String']>;
  profileVisibility: ProfileVisibilityEnum;
  publicApplication?: Maybe<PublicApplication>;
  publicApplications: Array<PublicApplication>;
  reviews?: Maybe<Array<PublicReview>>;
  soundcloudUrl?: Maybe<Scalars['String']>;
  soundcloudUsername?: Maybe<Scalars['String']>;
  spotifyArtistId?: Maybe<Scalars['String']>;
  spotifyUrl?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
  tiktokUsername?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  twitterUsername?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  userFacts?: Maybe<Scalars['JSON']>;
  userProfileAlternateImage?: Maybe<Media>;
  userProfileAlternateImageId?: Maybe<Scalars['ID']>;
  userProfileCoverImage?: Maybe<Media>;
  userProfileCoverImageId?: Maybe<Scalars['ID']>;
  userProfileImage?: Maybe<Media>;
  userProfileImageId?: Maybe<Scalars['ID']>;
  userProfileVideo?: Maybe<Media>;
  userProfileVideoId?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
  waitlistEnabled?: Maybe<Scalars['Boolean']>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserClassificationTagsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserCohortsArgs = {
  role: UserRole;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserCredentialAssignmentGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserCredentialAssignmentReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserExpertCredentialsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserExpertiseArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserInterestArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserNumberOfCredentialsGrantedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserNumberOfCredentialsReceivedArgs = {
  credentialNames?: InputMaybe<Array<CredentialName>>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserPublicApplicationArgs = {
  where: ApplicationWhereUniqueInput;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserPublicApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserReviewsArgs = {
  input?: InputMaybe<ReviewFilterInput>;
};


/** A variation of the User object that is readable by both authenticated and unauthenticated users.  Does not contain any sensitive or privileged information. */
export type PublicUserUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** An error that occurs when purchasing an application */
export type PurchaseApplicationErrorResponse = {
  __typename: 'PurchaseApplicationErrorResponse';
  applicationId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  type: PurchaseApplicationErrorType;
};

/** Errors related to purchasing an application */
export enum PurchaseApplicationErrorType {
  ActionNotAllowed = 'ACTION_NOT_ALLOWED',
  InsufficientPermissions = 'INSUFFICIENT_PERMISSIONS',
  NotFound = 'NOT_FOUND',
  PurchaseCreditsError = 'PURCHASE_CREDITS_ERROR',
  TransferCreditsError = 'TRANSFER_CREDITS_ERROR',
  Unknown = 'UNKNOWN'
}

export type PurchaseApplicationResponseUnion = PrivilegedApplication | PurchaseApplicationErrorResponse;

export type PurchaseApplicationWithAppleInput = {
  applicationId: Scalars['ID'];
  hasAcceptedContentTOS?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  transaction?: InputMaybe<PurchaseApplicationWithAppleTxnInput>;
};

export type PurchaseApplicationWithAppleTxnInput = {
  appleTransactionId: Scalars['ID'];
  id: Scalars['ID'];
};

export type PurchaseApplicationWithStripeInput = {
  applicationId: Scalars['ID'];
  hasAcceptedContentTOS?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename: 'Query';
  /** Contains configuration info and utilities for Media */
  MediaConfig: MediaConfig;
  applePaymentProducts: Array<PrivilegedPaymentProviderProduct>;
  application?: Maybe<Application>;
  applications: Array<Application>;
  /** @deprecated you can do the same query using the query called tasks */
  applicationsToReview: Array<PrivilegedApplication>;
  cohort?: Maybe<Cohort>;
  expertOnboarding?: Maybe<ExpertOnboarding>;
  expertOnboardings: Array<ExpertOnboarding>;
  experts: Array<PublicUser>;
  featuredApplication?: Maybe<BaseFeaturedApplication>;
  featuredApplications: Array<BaseFeaturedApplication>;
  featuredReviews: Array<PublicReview>;
  feed: Array<FeaturedReview>;
  getCohortRecommendations: Array<PublicCohort>;
  getCohortRecommendationsForTypeForm: Array<PublicCohort>;
  myScholarshipApplicationReferral?: Maybe<PrivilegedScholarshipApplicationReferral>;
  /** @deprecated you can do the same query using the query called tasks */
  nextApplicationToReview?: Maybe<PrivilegedApplication>;
  privilegedTemplate: PrivilegedTemplate;
  privilegedTemplates: Array<PrivilegedTemplate>;
  publicApplication?: Maybe<PublicApplication>;
  publicApplications: Array<PublicApplication>;
  publicCategories: Array<PublicCategory>;
  publicCategory: PublicCategory;
  publicCohort?: Maybe<PublicCohort>;
  publicCohorts: Array<PublicCohort>;
  publicFeaturedExpert?: Maybe<PublicFeaturedExpert>;
  publicFeaturedExperts: Array<PublicFeaturedExpert>;
  publicFeaturedFlag: PublicFeaturedFlag;
  publicFeaturedFlags: Array<PublicFeaturedFlag>;
  publicMediaConfig: PublicMediaConfig;
  publicMediaConfigs: Array<PublicMediaConfig>;
  publicReview?: Maybe<PublicReview>;
  publicScholarshipApplication?: Maybe<PublicScholarshipApplication>;
  publicTag?: Maybe<PublicTag>;
  publicTags: Array<PublicTag>;
  publicThread?: Maybe<PublicThread>;
  publicThreadItem?: Maybe<PublicThreadItem>;
  publicVideoConfigs: Array<PublicMediaConfig>;
  referralCode?: Maybe<ReferralCode>;
  referralCodeInfo?: Maybe<PrivilegedReferralCode>;
  referralCodes: Array<ReferralCode>;
  review?: Maybe<IReview>;
  role?: Maybe<Role>;
  /** Get the total active valid applications. at least one of the arguments must be provided */
  totalActiveApplications: Scalars['Int'];
  user?: Maybe<User>;
  userById?: Maybe<PublicUser>;
  userByUsername?: Maybe<PublicUser>;
  users: Array<User>;
  validateExpertVipAccessCode: Scalars['Boolean'];
  viewer?: Maybe<CurrentUser>;
};


export type QueryApplePaymentProductsArgs = {
  cursor?: InputMaybe<PaymentProviderProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentProviderProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentProviderProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentProviderProductWhereInput>;
};


export type QueryApplicationArgs = {
  where: ApplicationWhereUniqueInput;
};


export type QueryApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


export type QueryApplicationsToReviewArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


export type QueryCohortArgs = {
  where: CohortWhereUniqueInput;
};


export type QueryExpertOnboardingArgs = {
  where: ExpertOnboardingWhereUniqueInput;
};


export type QueryExpertOnboardingsArgs = {
  cursor?: InputMaybe<ExpertOnboardingWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExpertOnboardingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExpertOnboardingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExpertOnboardingWhereInput>;
};


export type QueryExpertsArgs = {
  featured?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFeaturedApplicationArgs = {
  where: FeaturedApplicationWhereUniqueInput;
};


export type QueryFeaturedApplicationsArgs = {
  cursor?: InputMaybe<FeaturedApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedApplicationWhereInput>;
};


export type QueryFeaturedReviewsArgs = {
  afterReviewId?: InputMaybe<Scalars['ID']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryFeedArgs = {
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryGetCohortRecommendationsArgs = {
  input: CohortsRecommendationInput;
};


export type QueryGetCohortRecommendationsForTypeFormArgs = {
  responseId: Scalars['String'];
};


export type QueryNextApplicationToReviewArgs = {
  cohortId?: InputMaybe<Scalars['ID']>;
};


export type QueryPrivilegedTemplateArgs = {
  where: TemplateWhereUniqueInput;
};


export type QueryPrivilegedTemplatesArgs = {
  cursor?: InputMaybe<TemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<TemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryPublicApplicationArgs = {
  where: ApplicationWhereUniqueInput;
};


export type QueryPublicApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


export type QueryPublicCategoriesArgs = {
  activeCohortsOnly?: InputMaybe<Scalars['Boolean']>;
  comingSoonCohorts?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  featuredCohortsOnly?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryPublicCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryPublicCohortArgs = {
  where: CohortWhereUniqueInput;
};


export type QueryPublicCohortsArgs = {
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<CohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<CohortScalarFieldEnum>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<CohortOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CohortWhereInput>;
};


export type QueryPublicFeaturedExpertArgs = {
  where: FeaturedExpertWhereUniqueInput;
};


export type QueryPublicFeaturedExpertsArgs = {
  cursor?: InputMaybe<FeaturedExpertWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedExpertScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedExpertOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedExpertWhereInput>;
};


export type QueryPublicFeaturedFlagArgs = {
  cursor?: InputMaybe<FeaturedFlagWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedFlagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedFlagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedFlagWhereInput>;
};


export type QueryPublicFeaturedFlagsArgs = {
  cursor?: InputMaybe<FeaturedFlagWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedFlagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedFlagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedFlagWhereInput>;
};


export type QueryPublicMediaConfigArgs = {
  where: MediaConfigWhereUniqueInput;
};


export type QueryPublicMediaConfigsArgs = {
  cursor?: InputMaybe<MediaConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<MediaConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MediaConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaConfigWhereInput>;
};


export type QueryPublicReviewArgs = {
  id: Scalars['ID'];
};


export type QueryPublicScholarshipApplicationArgs = {
  where: ScholarshipApplicationWhereUniqueInput;
};


export type QueryPublicTagArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<Array<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryPublicTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  distinct?: InputMaybe<Array<TagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryPublicThreadArgs = {
  where: ThreadWhereUniqueInput;
};


export type QueryPublicThreadItemArgs = {
  cursor?: InputMaybe<ThreadItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThreadItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThreadItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThreadItemWhereInput>;
};


export type QueryPublicVideoConfigsArgs = {
  cursor?: InputMaybe<MediaConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<MediaConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MediaConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaVideoConfigWhereInput>;
};


export type QueryReferralCodeArgs = {
  where: ReferralCodeWhereUniqueInput;
};


export type QueryReferralCodeInfoArgs = {
  code: Scalars['String'];
};


export type QueryReferralCodesArgs = {
  cursor?: InputMaybe<ReferralCodeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReferralCodeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReferralCodeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReferralCodeWhereInput>;
};


export type QueryReviewArgs = {
  id: Scalars['ID'];
};


export type QueryRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryTotalActiveApplicationsArgs = {
  cohortId?: InputMaybe<Scalars['String']>;
  expertId?: InputMaybe<Scalars['String']>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserByIdArgs = {
  id: Scalars['String'];
};


export type QueryUserByUsernameArgs = {
  username: Scalars['String'];
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryValidateExpertVipAccessCodeArgs = {
  vipAccessCode: Scalars['String'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Question = {
  __typename: 'Question';
  _count?: Maybe<QuestionCount>;
  answers: Array<Answer>;
  cohort: Cohort;
  cohortId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  maxDuration?: Maybe<Scalars['Int']>;
  maxLength?: Maybe<Scalars['Int']>;
  prompt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: QuestionTypeEnum;
  updatedAt: Scalars['DateTime'];
};


export type QuestionAnswersArgs = {
  cursor?: InputMaybe<AnswerWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnswerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnswerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnswerWhereInput>;
};

export type QuestionCount = {
  __typename: 'QuestionCount';
  answers: Scalars['Int'];
};

export type QuestionInput = {
  essay?: InputMaybe<EssayQuestionInput>;
  video?: InputMaybe<VideoQuestionInput>;
};

export type QuestionListRelationFilter = {
  every?: InputMaybe<QuestionWhereInput>;
  none?: InputMaybe<QuestionWhereInput>;
  some?: InputMaybe<QuestionWhereInput>;
};

export type QuestionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuestionOrderByWithRelationInput = {
  answers?: InputMaybe<AnswerOrderByRelationAggregateInput>;
  cohort?: InputMaybe<CohortOrderByWithRelationInput>;
  cohortId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxDuration?: InputMaybe<SortOrder>;
  maxLength?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type QuestionRelationFilter = {
  is?: InputMaybe<QuestionWhereInput>;
  isNot?: InputMaybe<QuestionWhereInput>;
};

export enum QuestionScalarFieldEnum {
  CohortId = 'cohortId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MaxDuration = 'maxDuration',
  MaxLength = 'maxLength',
  Prompt = 'prompt',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum QuestionTypeEnum {
  EssayQuestion = 'EssayQuestion',
  VideoQuestion = 'VideoQuestion'
}

export type QuestionWhereInput = {
  AND?: InputMaybe<Array<QuestionWhereInput>>;
  NOT?: InputMaybe<Array<QuestionWhereInput>>;
  OR?: InputMaybe<Array<QuestionWhereInput>>;
  answers?: InputMaybe<AnswerListRelationFilter>;
  cohort?: InputMaybe<CohortRelationFilter>;
  cohortId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  maxDuration?: InputMaybe<IntNullableFilter>;
  maxLength?: InputMaybe<IntNullableFilter>;
  prompt?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumQuestionTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type QuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ReactionVideoResponse = {
  __typename: 'ReactionVideoResponse';
  /** URL to the horizaontal (or left/right) Reaction Video variant */
  horizontalReactionVideoUrl?: Maybe<Scalars['String']>;
  /** URL to the vertical (or top/bottom) Reaction Video variant */
  verticalReactionVideoUrl?: Maybe<Scalars['String']>;
};

export type RedeemReferralCodeResponseUnion = ManagementReferralCodeErrorResponse | PrivilegedApplication;

export type ReferralCode = {
  __typename: 'ReferralCode';
  _count?: Maybe<ReferralCodeCount>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expertId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maxUse?: Maybe<Scalars['Int']>;
  target: ReferralCodeTargetEnum;
  type: ReferralCodeTypeEnum;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Int'];
};

export type ReferralCodeAttempt = {
  __typename: 'ReferralCodeAttempt';
  createdAt: Scalars['DateTime'];
  discountApplied?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  redeemed: Scalars['Boolean'];
  referralCodeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReferralCodeAttemptListRelationFilter = {
  every?: InputMaybe<ReferralCodeAttemptWhereInput>;
  none?: InputMaybe<ReferralCodeAttemptWhereInput>;
  some?: InputMaybe<ReferralCodeAttemptWhereInput>;
};

export type ReferralCodeAttemptOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReferralCodeAttemptOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  discountApplied?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  redeemed?: InputMaybe<SortOrder>;
  referralCode?: InputMaybe<ReferralCodeOrderByWithRelationInput>;
  referralCodeId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReferralCodeAttemptRelationFilter = {
  is?: InputMaybe<ReferralCodeAttemptWhereInput>;
  isNot?: InputMaybe<ReferralCodeAttemptWhereInput>;
};

export type ReferralCodeAttemptWhereInput = {
  AND?: InputMaybe<Array<ReferralCodeAttemptWhereInput>>;
  NOT?: InputMaybe<Array<ReferralCodeAttemptWhereInput>>;
  OR?: InputMaybe<Array<ReferralCodeAttemptWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discountApplied?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  redeemed?: InputMaybe<BoolFilter>;
  referralCode?: InputMaybe<ReferralCodeRelationFilter>;
  referralCodeId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReferralCodeCount = {
  __typename: 'ReferralCodeCount';
  referralCodeAttempts: Scalars['Int'];
};

export type ReferralCodeListRelationFilter = {
  every?: InputMaybe<ReferralCodeWhereInput>;
  none?: InputMaybe<ReferralCodeWhereInput>;
  some?: InputMaybe<ReferralCodeWhereInput>;
};

export type ReferralCodeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReferralCodeOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expert?: InputMaybe<UserOrderByWithRelationInput>;
  expertId?: InputMaybe<SortOrder>;
  expiredAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxUse?: InputMaybe<SortOrder>;
  referralCodeAttempts?: InputMaybe<ReferralCodeAttemptOrderByRelationAggregateInput>;
  target?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type ReferralCodeRelationFilter = {
  is?: InputMaybe<ReferralCodeWhereInput>;
  isNot?: InputMaybe<ReferralCodeWhereInput>;
};

export enum ReferralCodeScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExpertId = 'expertId',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  MaxUse = 'maxUse',
  Target = 'target',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export enum ReferralCodeTargetEnum {
  Expert = 'Expert',
  Global = 'Global'
}

export enum ReferralCodeTypeEnum {
  FixedAmount = 'FixedAmount',
  Percentage = 'Percentage'
}

export type ReferralCodeWhereInput = {
  AND?: InputMaybe<Array<ReferralCodeWhereInput>>;
  NOT?: InputMaybe<Array<ReferralCodeWhereInput>>;
  OR?: InputMaybe<Array<ReferralCodeWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expert?: InputMaybe<UserRelationFilter>;
  expertId?: InputMaybe<StringNullableFilter>;
  expiredAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  maxUse?: InputMaybe<IntNullableFilter>;
  referralCodeAttempts?: InputMaybe<ReferralCodeAttemptListRelationFilter>;
  target?: InputMaybe<EnumReferralCodeTargetEnumFilter>;
  type?: InputMaybe<EnumReferralCodeTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntFilter>;
};

export type ReferralCodeWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type RefreshTokenResponse = {
  __typename: 'RefreshTokenResponse';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
};

export type RefreshTokenResponseUnion = AuthErrorResponse | RefreshTokenResponse;

export type RetryReviewMediaUploadInput = {
  cloudinaryPublicId: Scalars['String'];
  notificationUrl?: InputMaybe<Scalars['String']>;
  uploadPreset?: InputMaybe<Scalars['String']>;
};

export type Review = {
  __typename: 'Review';
  application: Application;
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  featuredReview?: Maybe<FeaturedReview>;
  finalist: Scalars['Boolean'];
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  kind: ReviewKindEnum;
  labels?: Maybe<Scalars['JSON']>;
  media?: Maybe<Media>;
  rating?: Maybe<Scalars['Int']>;
  responseMediaId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};


export type ReviewCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ReviewUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ReviewFilterInput = {
  credentialTypes?: InputMaybe<Array<Array<CredentialName>>>;
  kinds?: InputMaybe<Array<Array<ReviewKindEnum>>>;
};

export enum ReviewKindEnum {
  Duet = 'Duet',
  Response = 'Response',
  Stitch = 'Stitch'
}

export type ReviewListRelationFilter = {
  every?: InputMaybe<ReviewWhereInput>;
  none?: InputMaybe<ReviewWhereInput>;
  some?: InputMaybe<ReviewWhereInput>;
};

export type ReviewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReviewOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  featuredReview?: InputMaybe<FeaturedReviewOrderByWithRelationInput>;
  finalist?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPublic?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  labels?: InputMaybe<SortOrder>;
  media?: InputMaybe<MediaOrderByWithRelationInput>;
  rating?: InputMaybe<SortOrder>;
  responseMediaId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type ReviewRelationFilter = {
  is?: InputMaybe<ReviewWhereInput>;
  isNot?: InputMaybe<ReviewWhereInput>;
};

export enum ReviewScalarFieldEnum {
  ApplicationId = 'applicationId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Finalist = 'finalist',
  Id = 'id',
  IsPublic = 'isPublic',
  Kind = 'kind',
  Labels = 'labels',
  Rating = 'rating',
  ResponseMediaId = 'responseMediaId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ReviewWhereInput = {
  AND?: InputMaybe<Array<ReviewWhereInput>>;
  NOT?: InputMaybe<Array<ReviewWhereInput>>;
  OR?: InputMaybe<Array<ReviewWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringNullableFilter>;
  featuredReview?: InputMaybe<FeaturedReviewRelationFilter>;
  finalist?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  isPublic?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<EnumReviewKindEnumFilter>;
  labels?: InputMaybe<JsonNullableFilter>;
  media?: InputMaybe<MediaRelationFilter>;
  rating?: InputMaybe<IntNullableFilter>;
  responseMediaId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ReviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename: 'Role';
  _count?: Maybe<RoleCount>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userCohorts: Array<UserCohort>;
};


export type RoleUserCohortsArgs = {
  cursor?: InputMaybe<UserCohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCohortScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCohortOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserCohortWhereInput>;
};

export type RoleCount = {
  __typename: 'RoleCount';
  userCohorts: Scalars['Int'];
};

export type RoleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userCohorts?: InputMaybe<UserCohortOrderByRelationAggregateInput>;
};

export type RoleRelationFilter = {
  is?: InputMaybe<RoleWhereInput>;
  isNot?: InputMaybe<RoleWhereInput>;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userCohorts?: InputMaybe<UserCohortListRelationFilter>;
};

export type RoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ScholarshipApplication = {
  __typename: 'ScholarshipApplication';
  _count?: Maybe<ScholarshipApplicationCount>;
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  shortCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ScholarshipApplicationCount = {
  __typename: 'ScholarshipApplicationCount';
  scholarshipApplicationReferrals: Scalars['Int'];
  upVotes: Scalars['Int'];
};

export type ScholarshipApplicationOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralOrderByRelationAggregateInput>;
  shortCode?: InputMaybe<SortOrder>;
  upVotes?: InputMaybe<ScholarshipApplicationUpvoteOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ScholarshipApplicationReferral = {
  __typename: 'ScholarshipApplicationReferral';
  createdAt: Scalars['DateTime'];
  demoMediaId?: Maybe<Scalars['String']>;
  expertRecommendationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  moderationComment?: Maybe<Scalars['String']>;
  referredUserId: Scalars['String'];
  scholarshipApplicationId: Scalars['String'];
  state: ScholarshipApplicationReferralStateEnum;
  updatedAt: Scalars['DateTime'];
};

export type ScholarshipApplicationReferralListRelationFilter = {
  every?: InputMaybe<ScholarshipApplicationReferralWhereInput>;
  none?: InputMaybe<ScholarshipApplicationReferralWhereInput>;
  some?: InputMaybe<ScholarshipApplicationReferralWhereInput>;
};

export type ScholarshipApplicationReferralOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ScholarshipApplicationReferralOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  demoMedia?: InputMaybe<MediaOrderByWithRelationInput>;
  demoMediaId?: InputMaybe<SortOrder>;
  expertRecommendation?: InputMaybe<UserOrderByWithRelationInput>;
  expertRecommendationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  moderationComment?: InputMaybe<SortOrder>;
  referredUser?: InputMaybe<UserOrderByWithRelationInput>;
  referredUserId?: InputMaybe<SortOrder>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationOrderByWithRelationInput>;
  scholarshipApplicationId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ScholarshipApplicationReferralScalarFieldEnum {
  CreatedAt = 'createdAt',
  DemoMediaId = 'demoMediaId',
  ExpertRecommendationId = 'expertRecommendationId',
  Id = 'id',
  ModerationComment = 'moderationComment',
  ReferredUserId = 'referredUserId',
  ScholarshipApplicationId = 'scholarshipApplicationId',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export enum ScholarshipApplicationReferralStateEnum {
  Approved = 'Approved',
  Created = 'Created',
  PendingModeration = 'PendingModeration',
  Refused = 'Refused'
}

export type ScholarshipApplicationReferralWhereInput = {
  AND?: InputMaybe<Array<ScholarshipApplicationReferralWhereInput>>;
  NOT?: InputMaybe<Array<ScholarshipApplicationReferralWhereInput>>;
  OR?: InputMaybe<Array<ScholarshipApplicationReferralWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  demoMedia?: InputMaybe<MediaRelationFilter>;
  demoMediaId?: InputMaybe<StringNullableFilter>;
  expertRecommendation?: InputMaybe<UserRelationFilter>;
  expertRecommendationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  moderationComment?: InputMaybe<StringNullableFilter>;
  referredUser?: InputMaybe<UserRelationFilter>;
  referredUserId?: InputMaybe<StringFilter>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationRelationFilter>;
  scholarshipApplicationId?: InputMaybe<StringFilter>;
  state?: InputMaybe<EnumScholarshipApplicationReferralStateEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ScholarshipApplicationReferralWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  referredUserId?: InputMaybe<Scalars['String']>;
};

export type ScholarshipApplicationRelationFilter = {
  is?: InputMaybe<ScholarshipApplicationWhereInput>;
  isNot?: InputMaybe<ScholarshipApplicationWhereInput>;
};

export type ScholarshipApplicationUpvote = {
  __typename: 'ScholarshipApplicationUpvote';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  scholarshipApplicationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  voterId: Scalars['String'];
};

export type ScholarshipApplicationUpvoteListRelationFilter = {
  every?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
  none?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
  some?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
};

export type ScholarshipApplicationUpvoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ScholarshipApplicationUpvoteOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationOrderByWithRelationInput>;
  scholarshipApplicationId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  voter?: InputMaybe<UserOrderByWithRelationInput>;
  voterId?: InputMaybe<SortOrder>;
};

export enum ScholarshipApplicationUpvoteScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ScholarshipApplicationId = 'scholarshipApplicationId',
  UpdatedAt = 'updatedAt',
  VoterId = 'voterId'
}

export type ScholarshipApplicationUpvoteWhereInput = {
  AND?: InputMaybe<Array<ScholarshipApplicationUpvoteWhereInput>>;
  NOT?: InputMaybe<Array<ScholarshipApplicationUpvoteWhereInput>>;
  OR?: InputMaybe<Array<ScholarshipApplicationUpvoteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  scholarshipApplication?: InputMaybe<ScholarshipApplicationRelationFilter>;
  scholarshipApplicationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  voter?: InputMaybe<UserRelationFilter>;
  voterId?: InputMaybe<StringFilter>;
};

export type ScholarshipApplicationUpvoteWhereUniqueInput = {
  ScholarshipApplicationUpvoteVoterIdUniqueIndex?: InputMaybe<Scholarship_Application_UpvoteScholarshipApplicationUpvoteVoterIdUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type ScholarshipApplicationWhereInput = {
  AND?: InputMaybe<Array<ScholarshipApplicationWhereInput>>;
  NOT?: InputMaybe<Array<ScholarshipApplicationWhereInput>>;
  OR?: InputMaybe<Array<ScholarshipApplicationWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralListRelationFilter>;
  shortCode?: InputMaybe<StringNullableFilter>;
  upVotes?: InputMaybe<ScholarshipApplicationUpvoteListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ScholarshipApplicationWhereUniqueInput = {
  applicationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  shortCode?: InputMaybe<Scalars['String']>;
};

/** An error that occurs when creating a paid application from a scholarship one */
export type ScholarshipToPaidApplicationErrorResponse = {
  __typename: 'ScholarshipToPaidApplicationErrorResponse';
  message: Scalars['String'];
  type: ScholarshipToPaidApplicationErrorType;
};

/** Errors related to creating a paid application from a scholarship one */
export enum ScholarshipToPaidApplicationErrorType {
  ApplicationIsNotScholarship = 'APPLICATION_IS_NOT_SCHOLARSHIP',
  ApplicationNotFound = 'APPLICATION_NOT_FOUND',
  CohortNoLongerAcceptingPaidApplications = 'COHORT_NO_LONGER_ACCEPTING_PAID_APPLICATIONS',
  CohortOnlyAcceptScholarships = 'COHORT_ONLY_ACCEPT_SCHOLARSHIPS',
  UserIsNotTheApplicationOwner = 'USER_IS_NOT_THE_APPLICATION_OWNER'
}

export type ScholarshipToPaidApplicationResponseUnion = PrivilegedApplication | ScholarshipToPaidApplicationErrorResponse;

/** An error that occurs when upvoting a scholarship application */
export type ScholarshipUpvoteErrorResponse = {
  __typename: 'ScholarshipUpvoteErrorResponse';
  type: ScholarshipUpvoteErrorType;
};

/** Errors related to upvoting a scholarship application */
export enum ScholarshipUpvoteErrorType {
  AlreadyVoted = 'ALREADY_VOTED',
  NotFound = 'NOT_FOUND'
}

export type ScholarshipUpvoteResponse = PrivilegedApplication | ScholarshipUpvoteErrorResponse;

export type ShareableAssetMediaUrl = {
  __typename: 'ShareableAssetMediaUrl';
  higQuality: Scalars['String'];
  lowQuality: Scalars['String'];
};

export type SignOutResponse = {
  __typename: 'SignOutResponse';
  error?: Maybe<AuthErrorResponse>;
  success: Scalars['Boolean'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StripePaymentIntent = {
  __typename: 'StripePaymentIntent';
  amount: Scalars['Float'];
  clientSecret: Scalars['String'];
  id: Scalars['ID'];
};

export type StripePaymentTransactionIntent = {
  __typename: 'StripePaymentTransactionIntent';
  paymentIntent: StripePaymentIntent;
  transaction: Transaction;
};

export type StripeRefund = {
  __typename: 'StripeRefund';
  amount: Scalars['Float'];
  brand: StripeStoredCardBrand;
  id: Scalars['ID'];
  last4: Scalars['String'];
};

export type StripeRefundIntent = {
  __typename: 'StripeRefundIntent';
  amount: Scalars['Int'];
  card: StripeWithdrawMethodCard;
  id: Scalars['ID'];
  paymentIntentId: Scalars['String'];
};

export type StripeRefundTransactionIntent = {
  __typename: 'StripeRefundTransactionIntent';
  refundIntent: StripeRefundIntent;
  transaction: Transaction;
};

export type StripeSetupIntent = {
  __typename: 'StripeSetupIntent';
  clientSecret: Scalars['String'];
};

/** Stripe stored card brand */
export enum StripeStoredCardBrand {
  Amex = 'Amex',
  Diners = 'Diners',
  Discover = 'Discover',
  Jcb = 'Jcb',
  Mastercard = 'Mastercard',
  Unionpay = 'Unionpay',
  Unknown = 'Unknown',
  Visa = 'Visa'
}

export type StripeStoredCardPaymentMethod = {
  __typename: 'StripeStoredCardPaymentMethod';
  brand: StripeStoredCardBrand;
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  id: Scalars['ID'];
  last4: Scalars['String'];
};

export type StripeWithdrawMethod = {
  __typename: 'StripeWithdrawMethod';
  availableAmount: Scalars['Int'];
  card: StripeWithdrawMethodCard;
  transactionIds: Array<Scalars['String']>;
};

export type StripeWithdrawMethodCard = {
  __typename: 'StripeWithdrawMethodCard';
  brand: Scalars['String'];
  last4: Scalars['String'];
};

export type SubmitScholarshipApplicationInput = {
  applicationId: Scalars['ID'];
  hasAcceptedContentTOS?: InputMaybe<Scalars['Boolean']>;
};

export type SyncEmailTemplateInput = {
  externalId: Scalars['ID'];
  name: Scalars['String'];
};

export type TagDetailContent = {
  __typename: 'TagDetailContent';
  definition: Scalars['String'];
  term?: Maybe<Scalars['String']>;
};

export type TagDetailContentInput = {
  definition: Scalars['String'];
  term: Scalars['String'];
};

export type TagOrderByWithRelationInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  entityTags?: InputMaybe<EntityTagOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  typeformRelations?: InputMaybe<TypeformRelationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TagRelationFilter = {
  is?: InputMaybe<TagWhereInput>;
  isNot?: InputMaybe<TagWhereInput>;
};

export enum TagScalarFieldEnum {
  Content = 'content',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum TagTypeEnum {
  ApplicationClonedFrom = 'ApplicationClonedFrom',
  ApplicationClonedTo = 'ApplicationClonedTo',
  CharityBadge = 'CharityBadge',
  Classification = 'Classification',
  CohortDetail = 'CohortDetail',
  CohortWhatToSend = 'CohortWhatToSend',
  CohortWhatYouReceive = 'CohortWhatYouReceive',
  ExpertCredential = 'ExpertCredential',
  PrizeDetail = 'PrizeDetail'
}

export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  content?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  entityTags?: InputMaybe<EntityTagListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumTagTypeEnumFilter>;
  typeformRelations?: InputMaybe<TypeformRelationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TagWhereUniqueInput = {
  TagTypeUniqueIndex?: InputMaybe<TagTagTypeUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type TaggedCohortPaginationInput = {
  /** values must be multiples of 3.  examples: 3, 6, ...., 30 */
  items: Scalars['Int'];
  page: Scalars['Int'];
};

export type TaggedEntityUnion = PublicApplication | PublicCohort | PublicInterstitialAd | PublicUser;

export type Task = {
  __typename: 'Task';
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  state: TaskStateEnum;
  type: TaskTypeEnum;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type TaskListRelationFilter = {
  every?: InputMaybe<TaskWhereInput>;
  none?: InputMaybe<TaskWhereInput>;
  some?: InputMaybe<TaskWhereInput>;
};

export type TaskOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TaskOrderByWithRelationInput = {
  application?: InputMaybe<ApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastViewedAt?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum TaskScalarFieldEnum {
  ApplicationId = 'applicationId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LastViewedAt = 'lastViewedAt',
  State = 'state',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum TaskStateEnum {
  Completed = 'Completed',
  Deleted = 'Deleted',
  Pending = 'Pending'
}

export enum TaskTypeEnum {
  Collab = 'Collab',
  Intro = 'Intro',
  Judge = 'Judge',
  Reaction = 'Reaction',
  Review = 'Review',
  Watch = 'Watch'
}

export type TaskWhereInput = {
  AND?: InputMaybe<Array<TaskWhereInput>>;
  NOT?: InputMaybe<Array<TaskWhereInput>>;
  OR?: InputMaybe<Array<TaskWhereInput>>;
  application?: InputMaybe<ApplicationRelationFilter>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastViewedAt?: InputMaybe<DateTimeNullableFilter>;
  state?: InputMaybe<EnumTaskStateEnumFilter>;
  type?: InputMaybe<EnumTaskTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type TaskWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  taskUserApplicationUniqueIndex?: InputMaybe<TaskTaskUserApplicationUniqueIndexCompoundUniqueInput>;
};

export type TemplateOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TemplateScalarFieldEnum {
  Body = 'body',
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  Id = 'id',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum TemplateTypeEnum {
  Email = 'Email'
}

export type TemplateWhereInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  body?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumTemplateTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TemplateWhereUniqueInput = {
  TemplateNameTypeUniqueIndex?: InputMaybe<TemplateTemplateNameTypeUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export enum ThreadEntityTypeEnum {
  Review = 'Review'
}

export type ThreadEntityUnion = PublicReview;

export type ThreadItem = {
  __typename: 'ThreadItem';
  _count?: Maybe<ThreadItemCount>;
  content: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['String']>;
  state: ThreadItemStateEnum;
  threadId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};


export type ThreadItemCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type ThreadItemUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type ThreadItemContent = {
  __typename: 'ThreadItemContent';
  body: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ThreadItemContentInput = {
  body: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type ThreadItemCount = {
  __typename: 'ThreadItemCount';
  children: Scalars['Int'];
};

export type ThreadItemListRelationFilter = {
  every?: InputMaybe<ThreadItemWhereInput>;
  none?: InputMaybe<ThreadItemWhereInput>;
  some?: InputMaybe<ThreadItemWhereInput>;
};

export type ThreadItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ThreadItemOrderByWithRelationInput = {
  children?: InputMaybe<ThreadItemOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parent?: InputMaybe<ThreadItemOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  thread?: InputMaybe<ThreadOrderByWithRelationInput>;
  threadId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type ThreadItemRelationFilter = {
  is?: InputMaybe<ThreadItemWhereInput>;
  isNot?: InputMaybe<ThreadItemWhereInput>;
};

export enum ThreadItemScalarFieldEnum {
  Content = 'content',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ParentId = 'parentId',
  State = 'state',
  ThreadId = 'threadId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum ThreadItemStateEnum {
  Active = 'Active',
  Blocked = 'Blocked',
  Deleted = 'Deleted'
}

export type ThreadItemWhereInput = {
  AND?: InputMaybe<Array<ThreadItemWhereInput>>;
  NOT?: InputMaybe<Array<ThreadItemWhereInput>>;
  OR?: InputMaybe<Array<ThreadItemWhereInput>>;
  children?: InputMaybe<ThreadItemListRelationFilter>;
  content?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  parent?: InputMaybe<ThreadItemRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<EnumThreadItemStateEnumFilter>;
  thread?: InputMaybe<ThreadRelationFilter>;
  threadId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ThreadItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ThreadOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  items?: InputMaybe<ThreadItemOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ThreadRelationFilter = {
  is?: InputMaybe<ThreadWhereInput>;
  isNot?: InputMaybe<ThreadWhereInput>;
};

export type ThreadWhereInput = {
  AND?: InputMaybe<Array<ThreadWhereInput>>;
  NOT?: InputMaybe<Array<ThreadWhereInput>>;
  OR?: InputMaybe<Array<ThreadWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumThreadEntityTypeEnumFilter>;
  id?: InputMaybe<StringFilter>;
  items?: InputMaybe<ThreadItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ThreadWhereUniqueInput = {
  ThreadEntityUniqueIndex?: InputMaybe<ThreadThreadEntityUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type Ticket = {
  __typename: 'Ticket';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type TicketOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type TicketRelationFilter = {
  is?: InputMaybe<TicketWhereInput>;
  isNot?: InputMaybe<TicketWhereInput>;
};

export type TicketWhereInput = {
  AND?: InputMaybe<Array<TicketWhereInput>>;
  NOT?: InputMaybe<Array<TicketWhereInput>>;
  OR?: InputMaybe<Array<TicketWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Transaction = {
  __typename: 'Transaction';
  amount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  productId?: Maybe<Scalars['String']>;
  productQty?: Maybe<Scalars['Int']>;
  provider: PaymentProviderEnum;
  providerTransactionId?: Maybe<Scalars['String']>;
  providerTransactionStatus?: Maybe<Scalars['String']>;
  type: TransactionTypeEnum;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type TransactionListRelationFilter = {
  every?: InputMaybe<TransactionWhereInput>;
  none?: InputMaybe<TransactionWhereInput>;
  some?: InputMaybe<TransactionWhereInput>;
};

export type TransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransactionOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credit?: InputMaybe<CreditOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productQty?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerProduct?: InputMaybe<PaymentProviderProductOrderByWithRelationInput>;
  providerTransactionId?: InputMaybe<SortOrder>;
  providerTransactionStatus?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type TransactionRelationFilter = {
  is?: InputMaybe<TransactionWhereInput>;
  isNot?: InputMaybe<TransactionWhereInput>;
};

export enum TransactionScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Id = 'id',
  ProductId = 'productId',
  ProductQty = 'productQty',
  Provider = 'provider',
  ProviderTransactionId = 'providerTransactionId',
  ProviderTransactionStatus = 'providerTransactionStatus',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum TransactionTypeEnum {
  Payment = 'Payment',
  Withdrawal = 'Withdrawal'
}

export type TransactionWhereInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credit?: InputMaybe<CreditRelationFilter>;
  id?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  productQty?: InputMaybe<IntNullableFilter>;
  provider?: InputMaybe<EnumPaymentProviderEnumFilter>;
  providerProduct?: InputMaybe<PaymentProviderProductRelationFilter>;
  providerTransactionId?: InputMaybe<StringNullableFilter>;
  providerTransactionStatus?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type TransactionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type TypeformRelationListRelationFilter = {
  every?: InputMaybe<TypeformRelationWhereInput>;
  none?: InputMaybe<TypeformRelationWhereInput>;
  some?: InputMaybe<TypeformRelationWhereInput>;
};

export type TypeformRelationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TypeformRelationWhereInput = {
  AND?: InputMaybe<Array<TypeformRelationWhereInput>>;
  NOT?: InputMaybe<Array<TypeformRelationWhereInput>>;
  OR?: InputMaybe<Array<TypeformRelationWhereInput>>;
  id?: InputMaybe<StringFilter>;
  tag?: InputMaybe<TagRelationFilter>;
  tagId?: InputMaybe<StringFilter>;
  typeFormId?: InputMaybe<StringFilter>;
};

export type UpdateApplicationStateInput = {
  action: ApplicationAction;
  applicationId: Scalars['ID'];
};

export type UpdateCategoryInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type UpdateCohortCategoryInput = {
  categoryClassificationTagIds: Array<Scalars['ID']>;
  categoryId: Scalars['ID'];
};

export type UpdateCohortInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  charity?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Featured cohort position index */
  featuredIndex?: InputMaybe<Scalars['Int']>;
  /** Limit of the cohort paid applications */
  paidApplicationLimit?: InputMaybe<Scalars['Int']>;
  /** Price in USD cents ($10.00 = 1000 cents) */
  price?: InputMaybe<Scalars['Int']>;
  prize?: InputMaybe<Scalars['String']>;
  responseDetail?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['String']>;
  scholarship?: InputMaybe<CohortScholarshipInput>;
  state?: InputMaybe<CohortStateEnum>;
  symbol?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateCohortVideoInput = {
  bytes: Scalars['Int'];
  cloudinaryPublicId: Scalars['String'];
  duration: Scalars['Float'];
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type UpdateExpertOnboardingInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  applications?: InputMaybe<Array<ExpertOnboardingApplicationInput>>;
  cohortSettings?: InputMaybe<ExpertOnboardingCohortSettingsInput>;
};

export type UpdateFeaturedApplicationInput = {
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type UpdateFeaturedExpertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cohortId?: InputMaybe<Scalars['ID']>;
  customVideoId?: InputMaybe<Scalars['ID']>;
  headline?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  subHeadline?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FeaturedExpertTypeEnum>;
  updateStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateFeaturedFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['JSON']>;
  users?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateNotificationsByResourceResult = {
  __typename: 'UpdateNotificationsByResourceResult';
  notificationsAffected: Scalars['Int'];
};

export type UpdateProfileForApplicationInput = {
  applicationId: Scalars['ID'];
};

export type UpdateProfileImageInput = {
  bytes: Scalars['Int'];
  cloudinaryPublicId: Scalars['String'];
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type UpdateProfileVideoInput = {
  bytes?: InputMaybe<Scalars['Int']>;
  cloudinaryPublicId: Scalars['String'];
  duration?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UpdateReviewRatingInput = {
  rating: Scalars['Int'];
  reviewId: Scalars['ID'];
};

/** An error that occurs when update the user */
export type UpdateUserErrorResponse = {
  __typename: 'UpdateUserErrorResponse';
  message?: Maybe<Scalars['String']>;
  type: UpdateUserErrorType;
};

/** Errors related to user update */
export enum UpdateUserErrorType {
  InvalidPhone = 'INVALID_PHONE',
  InvalidSocialUsernames = 'INVALID_SOCIAL_USERNAMES',
  InvalidUsername = 'INVALID_USERNAME',
  NotFound = 'NOT_FOUND'
}

export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  facebookUsername?: InputMaybe<Scalars['String']>;
  hasAcceptedAgeVerification?: InputMaybe<Scalars['Boolean']>;
  hasAcceptedTOS?: InputMaybe<Scalars['Boolean']>;
  instagramUsername?: InputMaybe<Scalars['String']>;
  isExpert?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  linkedInUsername?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  profileVisibility?: InputMaybe<ProfileVisibilityEnum>;
  soundcloudUsername?: InputMaybe<Scalars['String']>;
  spotifyArtistId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tiktokUsername?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twitterUsername?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateUserResponse = CurrentUser | UpdateUserErrorResponse;

export type User = {
  __typename: 'User';
  _count?: Maybe<UserCount>;
  acceptedTOSAt?: Maybe<Scalars['DateTime']>;
  applicationTickets: Array<ApplicationTicket>;
  applications: Array<Application>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  conversations: Array<Conversation>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  expertOnboarding: Array<ExpertOnboarding>;
  expertRecommendations: Array<ScholarshipApplicationReferral>;
  expertRelationsUser?: Maybe<User>;
  expertRelationsUserId?: Maybe<Scalars['String']>;
  facebookLogin: Scalars['Boolean'];
  facebookUsername?: Maybe<Scalars['String']>;
  featuredExperts: Array<FeaturedExpert>;
  feed?: Maybe<Feed>;
  hasAcceptedAgeVerification?: Maybe<Scalars['Boolean']>;
  hasAcceptedTOS?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instagramUsername?: Maybe<Scalars['String']>;
  isAdmin: Scalars['Boolean'];
  isExpert: Scalars['Boolean'];
  isProfileComplete: Scalars['Boolean'];
  isStudent: Scalars['Boolean'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  linkedInUsername?: Maybe<Scalars['String']>;
  managedUsers: Array<User>;
  media: Array<Media>;
  messages: Array<Message>;
  metadata: Scalars['JSON'];
  name?: Maybe<Scalars['String']>;
  notifications: Array<Notification>;
  phone?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  profileVisibility: ProfileVisibilityEnum;
  referralCodes: Array<ReferralCode>;
  reviews: Array<Review>;
  scholarshipApplicationReferrals: Array<ScholarshipApplicationReferral>;
  scholarshipApplicationUpvotes: Array<ScholarshipApplicationUpvote>;
  settings?: Maybe<UserSetting>;
  soundcloudUsername?: Maybe<Scalars['String']>;
  spotifyArtistId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  tasks: Array<Task>;
  threadItems: Array<ThreadItem>;
  ticket?: Maybe<Ticket>;
  tiktokUsername?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transaction: Array<Transaction>;
  twitterUsername?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userCategories: Array<UserCategory>;
  userCohorts: Array<UserCohort>;
  userConversations: Array<UserConversation>;
  userFacts?: Maybe<Scalars['JSON']>;
  userProfileAlternateImage?: Maybe<Media>;
  userProfileAlternateImageId?: Maybe<Scalars['String']>;
  userProfileCoverImage?: Maybe<Media>;
  userProfileCoverImageId?: Maybe<Scalars['String']>;
  userProfileImage?: Maybe<Media>;
  userProfileImageId?: Maybe<Scalars['String']>;
  userProfileVideo?: Maybe<Media>;
  userProfileVideoId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  waitlistEnabled: Scalars['Boolean'];
};


export type UserApplicationTicketsArgs = {
  cursor?: InputMaybe<ApplicationTicketWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationTicketScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationTicketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationTicketWhereInput>;
};


export type UserApplicationsArgs = {
  cursor?: InputMaybe<ApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApplicationWhereInput>;
};


export type UserConversationsArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type UserCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type UserExpertOnboardingArgs = {
  cursor?: InputMaybe<ExpertOnboardingWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExpertOnboardingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExpertOnboardingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExpertOnboardingWhereInput>;
};


export type UserExpertRecommendationsArgs = {
  cursor?: InputMaybe<ScholarshipApplicationReferralWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScholarshipApplicationReferralScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScholarshipApplicationReferralOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScholarshipApplicationReferralWhereInput>;
};


export type UserFeaturedExpertsArgs = {
  cursor?: InputMaybe<FeaturedExpertWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeaturedExpertScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeaturedExpertOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeaturedExpertWhereInput>;
};


export type UserManagedUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type UserMediaArgs = {
  cursor?: InputMaybe<MediaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MediaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MediaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaWhereInput>;
};


export type UserMessagesArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<MessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageWhereInput>;
};


export type UserNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserReferralCodesArgs = {
  cursor?: InputMaybe<ReferralCodeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReferralCodeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReferralCodeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReferralCodeWhereInput>;
};


export type UserReviewsArgs = {
  cursor?: InputMaybe<ReviewWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReviewScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReviewOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewWhereInput>;
};


export type UserScholarshipApplicationReferralsArgs = {
  cursor?: InputMaybe<ScholarshipApplicationReferralWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScholarshipApplicationReferralScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScholarshipApplicationReferralOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScholarshipApplicationReferralWhereInput>;
};


export type UserScholarshipApplicationUpvotesArgs = {
  cursor?: InputMaybe<ScholarshipApplicationUpvoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScholarshipApplicationUpvoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScholarshipApplicationUpvoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScholarshipApplicationUpvoteWhereInput>;
};


export type UserTasksArgs = {
  cursor?: InputMaybe<TaskWhereUniqueInput>;
  distinct?: InputMaybe<Array<TaskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TaskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TaskWhereInput>;
};


export type UserThreadItemsArgs = {
  cursor?: InputMaybe<ThreadItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThreadItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThreadItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThreadItemWhereInput>;
};


export type UserTransactionArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type UserUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type UserUserCategoriesArgs = {
  cursor?: InputMaybe<UserCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserCategoryWhereInput>;
};


export type UserUserCohortsArgs = {
  cursor?: InputMaybe<UserCohortWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCohortScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCohortOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserCohortWhereInput>;
};


export type UserUserConversationsArgs = {
  cursor?: InputMaybe<UserConversationWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserConversationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserConversationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserConversationWhereInput>;
};

export type UserCategory = {
  __typename: 'UserCategory';
  categoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: UserCategoryTypeEnum;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserCategoryListRelationFilter = {
  every?: InputMaybe<UserCategoryWhereInput>;
  none?: InputMaybe<UserCategoryWhereInput>;
  some?: InputMaybe<UserCategoryWhereInput>;
};

export type UserCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserCategoryOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserCategoryScalarFieldEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum UserCategoryTypeEnum {
  Expertise = 'Expertise',
  Interest = 'Interest'
}

export type UserCategoryWhereInput = {
  AND?: InputMaybe<Array<UserCategoryWhereInput>>;
  NOT?: InputMaybe<Array<UserCategoryWhereInput>>;
  OR?: InputMaybe<Array<UserCategoryWhereInput>>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumUserCategoryTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserCategoryWhereUniqueInput = {
  userCategoryTypeUniqueIndex?: InputMaybe<User_CategoryUserCategoryTypeUniqueIndexCompoundUniqueInput>;
};

export type UserCohort = {
  __typename: 'UserCohort';
  allocation: Scalars['Decimal'];
  available: Scalars['Boolean'];
  cohort: Cohort;
  cohortId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  featured: Scalars['Boolean'];
  id: Scalars['ID'];
  public: Scalars['Boolean'];
  revenueSplit: Scalars['Decimal'];
  role: Role;
  roleId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type UserCohortListRelationFilter = {
  every?: InputMaybe<UserCohortWhereInput>;
  none?: InputMaybe<UserCohortWhereInput>;
  some?: InputMaybe<UserCohortWhereInput>;
};

export type UserCohortOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserCohortOrderByWithRelationInput = {
  allocation?: InputMaybe<SortOrder>;
  available?: InputMaybe<SortOrder>;
  cohort?: InputMaybe<CohortOrderByWithRelationInput>;
  cohortId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  revenueSplit?: InputMaybe<SortOrder>;
  role?: InputMaybe<RoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserCohortScalarFieldEnum {
  Allocation = 'allocation',
  Available = 'available',
  CohortId = 'cohortId',
  CreatedAt = 'createdAt',
  Featured = 'featured',
  Id = 'id',
  Public = 'public',
  RevenueSplit = 'revenueSplit',
  RoleId = 'roleId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserCohortWhereInput = {
  AND?: InputMaybe<Array<UserCohortWhereInput>>;
  NOT?: InputMaybe<Array<UserCohortWhereInput>>;
  OR?: InputMaybe<Array<UserCohortWhereInput>>;
  allocation?: InputMaybe<DecimalFilter>;
  available?: InputMaybe<BoolFilter>;
  cohort?: InputMaybe<CohortRelationFilter>;
  cohortId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  featured?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  public?: InputMaybe<BoolFilter>;
  revenueSplit?: InputMaybe<DecimalFilter>;
  role?: InputMaybe<RoleRelationFilter>;
  roleId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserCohortWhereUniqueInput = {
  cohortUserUniqueIndex?: InputMaybe<User_CohortCohortUserUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type UserConversation = {
  __typename: 'UserConversation';
  _count?: Maybe<UserConversationCount>;
  conversationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastAccessedAt: Scalars['DateTime'];
  role: UserConversationRoleEnum;
  state: UserConversationStateEnum;
  type: UserConversationTypeEnum;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};


export type UserConversationCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type UserConversationUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UserConversationCount = {
  __typename: 'UserConversationCount';
  messages: Scalars['Int'];
};

export type UserConversationListRelationFilter = {
  every?: InputMaybe<UserConversationWhereInput>;
  none?: InputMaybe<UserConversationWhereInput>;
  some?: InputMaybe<UserConversationWhereInput>;
};

export type UserConversationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserConversationOrderByWithRelationInput = {
  conversation?: InputMaybe<ConversationOrderByWithRelationInput>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastAccessedAt?: InputMaybe<SortOrder>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  role?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserConversationRelationFilter = {
  is?: InputMaybe<UserConversationWhereInput>;
  isNot?: InputMaybe<UserConversationWhereInput>;
};

export enum UserConversationRoleEnum {
  Manager = 'Manager',
  Moderator = 'Moderator',
  Owner = 'Owner',
  Participant = 'Participant'
}

export enum UserConversationScalarFieldEnum {
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LastAccessedAt = 'lastAccessedAt',
  Role = 'role',
  State = 'state',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum UserConversationStateEnum {
  Active = 'Active',
  Hide = 'Hide',
  Locked = 'Locked'
}

export enum UserConversationTypeEnum {
  Group = 'Group',
  Single = 'Single'
}

export type UserConversationWhereInput = {
  AND?: InputMaybe<Array<UserConversationWhereInput>>;
  NOT?: InputMaybe<Array<UserConversationWhereInput>>;
  OR?: InputMaybe<Array<UserConversationWhereInput>>;
  conversation?: InputMaybe<ConversationRelationFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastAccessedAt?: InputMaybe<DateTimeFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  role?: InputMaybe<EnumUserConversationRoleEnumFilter>;
  state?: InputMaybe<EnumUserConversationStateEnumFilter>;
  type?: InputMaybe<EnumUserConversationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserConversationWhereUniqueInput = {
  UserConversationConversationIdUserIdUniqueIndex?: InputMaybe<User_ConversationUserConversationConversationIdUserIdUniqueIndexCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type UserCount = {
  __typename: 'UserCount';
  applicationTickets: Scalars['Int'];
  applications: Scalars['Int'];
  conversations: Scalars['Int'];
  expertOnboarding: Scalars['Int'];
  expertRecommendations: Scalars['Int'];
  featuredExperts: Scalars['Int'];
  managedUsers: Scalars['Int'];
  media: Scalars['Int'];
  messages: Scalars['Int'];
  notifications: Scalars['Int'];
  referralCodes: Scalars['Int'];
  reviews: Scalars['Int'];
  scholarshipApplicationReferrals: Scalars['Int'];
  scholarshipApplicationUpvotes: Scalars['Int'];
  tasks: Scalars['Int'];
  threadItems: Scalars['Int'];
  transaction: Scalars['Int'];
  userCategories: Scalars['Int'];
  userCohorts: Scalars['Int'];
  userConversations: Scalars['Int'];
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  acceptedTOSAt?: InputMaybe<SortOrder>;
  applicationTickets?: InputMaybe<ApplicationTicketOrderByRelationAggregateInput>;
  applications?: InputMaybe<ApplicationOrderByRelationAggregateInput>;
  auth0Id?: InputMaybe<SortOrder>;
  bio?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  conversations?: InputMaybe<ConversationOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  expertOnboarding?: InputMaybe<ExpertOnboardingOrderByRelationAggregateInput>;
  expertRecommendations?: InputMaybe<ScholarshipApplicationReferralOrderByRelationAggregateInput>;
  expertRelationsUser?: InputMaybe<UserOrderByWithRelationInput>;
  expertRelationsUserId?: InputMaybe<SortOrder>;
  facebookLogin?: InputMaybe<SortOrder>;
  facebookUsername?: InputMaybe<SortOrder>;
  featuredExperts?: InputMaybe<FeaturedExpertOrderByRelationAggregateInput>;
  feed?: InputMaybe<FeedOrderByWithRelationInput>;
  hasAcceptedAgeVerification?: InputMaybe<SortOrder>;
  hasAcceptedTOS?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagramUsername?: InputMaybe<SortOrder>;
  isAdmin?: InputMaybe<SortOrder>;
  isExpert?: InputMaybe<SortOrder>;
  isProfileComplete?: InputMaybe<SortOrder>;
  isStudent?: InputMaybe<SortOrder>;
  linkedInUsername?: InputMaybe<SortOrder>;
  managedUsers?: InputMaybe<UserOrderByRelationAggregateInput>;
  media?: InputMaybe<MediaOrderByRelationAggregateInput>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrder>;
  profileImageUrl?: InputMaybe<SortOrder>;
  profileVisibility?: InputMaybe<SortOrder>;
  referralCodes?: InputMaybe<ReferralCodeOrderByRelationAggregateInput>;
  reviews?: InputMaybe<ReviewOrderByRelationAggregateInput>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralOrderByRelationAggregateInput>;
  scholarshipApplicationUpvotes?: InputMaybe<ScholarshipApplicationUpvoteOrderByRelationAggregateInput>;
  settings?: InputMaybe<UserSettingOrderByWithRelationInput>;
  soundcloudUsername?: InputMaybe<SortOrder>;
  spotifyArtistId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stripeId?: InputMaybe<SortOrder>;
  tasks?: InputMaybe<TaskOrderByRelationAggregateInput>;
  threadItems?: InputMaybe<ThreadItemOrderByRelationAggregateInput>;
  ticket?: InputMaybe<TicketOrderByWithRelationInput>;
  tiktokUsername?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  transaction?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  twitterUsername?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userCategories?: InputMaybe<UserCategoryOrderByRelationAggregateInput>;
  userCohorts?: InputMaybe<UserCohortOrderByRelationAggregateInput>;
  userConversations?: InputMaybe<UserConversationOrderByRelationAggregateInput>;
  userFacts?: InputMaybe<SortOrder>;
  userProfileAlternateImage?: InputMaybe<MediaOrderByWithRelationInput>;
  userProfileAlternateImageId?: InputMaybe<SortOrder>;
  userProfileCoverImage?: InputMaybe<MediaOrderByWithRelationInput>;
  userProfileCoverImageId?: InputMaybe<SortOrder>;
  userProfileImage?: InputMaybe<MediaOrderByWithRelationInput>;
  userProfileImageId?: InputMaybe<SortOrder>;
  userProfileVideo?: InputMaybe<MediaOrderByWithRelationInput>;
  userProfileVideoId?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  waitlistEnabled?: InputMaybe<SortOrder>;
};

export type UserReferred = {
  scholarshipApplicationId: Scalars['String'];
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

/** The basic Roles */
export enum UserRole {
  Admin = 'ADMIN',
  Expert = 'EXPERT',
  Student = 'STUDENT',
  User = 'USER'
}

export enum UserScalarFieldEnum {
  AcceptedTosAt = 'acceptedTOSAt',
  Auth0Id = 'auth0Id',
  Bio = 'bio',
  City = 'city',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpertRelationsUserId = 'expertRelationsUserId',
  FacebookLogin = 'facebookLogin',
  FacebookUsername = 'facebookUsername',
  HasAcceptedAgeVerification = 'hasAcceptedAgeVerification',
  HasAcceptedTos = 'hasAcceptedTOS',
  Id = 'id',
  InstagramUsername = 'instagramUsername',
  IsAdmin = 'isAdmin',
  IsExpert = 'isExpert',
  IsProfileComplete = 'isProfileComplete',
  IsStudent = 'isStudent',
  LinkedInUsername = 'linkedInUsername',
  Metadata = 'metadata',
  Name = 'name',
  Phone = 'phone',
  ProfileImageUrl = 'profileImageUrl',
  ProfileVisibility = 'profileVisibility',
  SoundcloudUsername = 'soundcloudUsername',
  SpotifyArtistId = 'spotifyArtistId',
  State = 'state',
  StripeId = 'stripeId',
  TiktokUsername = 'tiktokUsername',
  Title = 'title',
  TwitterUsername = 'twitterUsername',
  UpdatedAt = 'updatedAt',
  UserFacts = 'userFacts',
  UserProfileAlternateImageId = 'userProfileAlternateImageId',
  UserProfileCoverImageId = 'userProfileCoverImageId',
  UserProfileImageId = 'userProfileImageId',
  UserProfileVideoId = 'userProfileVideoId',
  Username = 'username',
  WaitlistEnabled = 'waitlistEnabled'
}

export type UserSetting = {
  __typename: 'UserSetting';
  appsCloseToExpireNotification: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isoCreatedAt: Scalars['DateTime'];
  isoUpdatedAt: Scalars['DateTime'];
  newApplicationNotification: Scalars['Boolean'];
  newMessageNotification: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};


export type UserSettingCreatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type UserSettingUpdatedAtArgs = {
  format?: InputMaybe<DateFormatEnum>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UserSettingInput = {
  applicationsCloseToExpireNotification?: InputMaybe<Scalars['Boolean']>;
  applicationsPendingReviewNotification?: InputMaybe<Scalars['Boolean']>;
  newApplicationNotification?: InputMaybe<Scalars['Boolean']>;
  newMessageNotification?: InputMaybe<Scalars['Boolean']>;
};

export type UserSettingOrderByWithRelationInput = {
  appsCloseToExpireNotification?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newApplicationNotification?: InputMaybe<SortOrder>;
  newMessageNotification?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserSettingRelationFilter = {
  is?: InputMaybe<UserSettingWhereInput>;
  isNot?: InputMaybe<UserSettingWhereInput>;
};

export type UserSettingWhereInput = {
  AND?: InputMaybe<Array<UserSettingWhereInput>>;
  NOT?: InputMaybe<Array<UserSettingWhereInput>>;
  OR?: InputMaybe<Array<UserSettingWhereInput>>;
  appsCloseToExpireNotification?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  newApplicationNotification?: InputMaybe<BoolFilter>;
  newMessageNotification?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  acceptedTOSAt?: InputMaybe<DateTimeNullableFilter>;
  applicationTickets?: InputMaybe<ApplicationTicketListRelationFilter>;
  applications?: InputMaybe<ApplicationListRelationFilter>;
  auth0Id?: InputMaybe<StringNullableFilter>;
  bio?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  conversations?: InputMaybe<ConversationListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  expertOnboarding?: InputMaybe<ExpertOnboardingListRelationFilter>;
  expertRecommendations?: InputMaybe<ScholarshipApplicationReferralListRelationFilter>;
  expertRelationsUser?: InputMaybe<UserRelationFilter>;
  expertRelationsUserId?: InputMaybe<StringNullableFilter>;
  facebookLogin?: InputMaybe<BoolFilter>;
  facebookUsername?: InputMaybe<StringNullableFilter>;
  featuredExperts?: InputMaybe<FeaturedExpertListRelationFilter>;
  feed?: InputMaybe<FeedRelationFilter>;
  hasAcceptedAgeVerification?: InputMaybe<BoolNullableFilter>;
  hasAcceptedTOS?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  instagramUsername?: InputMaybe<StringNullableFilter>;
  isAdmin?: InputMaybe<BoolFilter>;
  isExpert?: InputMaybe<BoolFilter>;
  isProfileComplete?: InputMaybe<BoolFilter>;
  isStudent?: InputMaybe<BoolFilter>;
  linkedInUsername?: InputMaybe<StringNullableFilter>;
  managedUsers?: InputMaybe<UserListRelationFilter>;
  media?: InputMaybe<MediaListRelationFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  metadata?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  profileImageUrl?: InputMaybe<StringNullableFilter>;
  profileVisibility?: InputMaybe<EnumProfileVisibilityEnumFilter>;
  referralCodes?: InputMaybe<ReferralCodeListRelationFilter>;
  reviews?: InputMaybe<ReviewListRelationFilter>;
  scholarshipApplicationReferrals?: InputMaybe<ScholarshipApplicationReferralListRelationFilter>;
  scholarshipApplicationUpvotes?: InputMaybe<ScholarshipApplicationUpvoteListRelationFilter>;
  settings?: InputMaybe<UserSettingRelationFilter>;
  soundcloudUsername?: InputMaybe<StringNullableFilter>;
  spotifyArtistId?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stripeId?: InputMaybe<StringNullableFilter>;
  tasks?: InputMaybe<TaskListRelationFilter>;
  threadItems?: InputMaybe<ThreadItemListRelationFilter>;
  ticket?: InputMaybe<TicketRelationFilter>;
  tiktokUsername?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  transaction?: InputMaybe<TransactionListRelationFilter>;
  twitterUsername?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userCategories?: InputMaybe<UserCategoryListRelationFilter>;
  userCohorts?: InputMaybe<UserCohortListRelationFilter>;
  userConversations?: InputMaybe<UserConversationListRelationFilter>;
  userFacts?: InputMaybe<JsonNullableFilter>;
  userProfileAlternateImage?: InputMaybe<MediaRelationFilter>;
  userProfileAlternateImageId?: InputMaybe<StringNullableFilter>;
  userProfileCoverImage?: InputMaybe<MediaRelationFilter>;
  userProfileCoverImageId?: InputMaybe<StringNullableFilter>;
  userProfileImage?: InputMaybe<MediaRelationFilter>;
  userProfileImageId?: InputMaybe<StringNullableFilter>;
  userProfileVideo?: InputMaybe<MediaRelationFilter>;
  userProfileVideoId?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  waitlistEnabled?: InputMaybe<BoolFilter>;
};

export type UserWhereUniqueInput = {
  auth0Id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  stripeId?: InputMaybe<Scalars['String']>;
  userProfileAlternateImageId?: InputMaybe<Scalars['String']>;
  userProfileCoverImageId?: InputMaybe<Scalars['String']>;
  userProfileImageId?: InputMaybe<Scalars['String']>;
  userProfileVideoId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type VerifyAuthInput = {
  otp: Scalars['String'];
  /** User email or phone number */
  username: Scalars['String'];
};

export type VerifyAuthResponse = {
  __typename: 'VerifyAuthResponse';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
};

export type VerifyAuthResponseUnion = AuthErrorResponse | VerifyAuthResponse;

export type VideoAnswerInput = {
  cloudinaryPublicId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['ID']>;
};

/** Media video configuration name */
export enum VideoConfigNameEnum {
  ApplicationShareableAssetVideo = 'APPLICATION_SHAREABLE_ASSET_VIDEO',
  ApplicationVideo_720p = 'APPLICATION_VIDEO_720p',
  ApplicationVideo_720pWithWatermark = 'APPLICATION_VIDEO_720p_WITH_WATERMARK',
  ApplicationVideo_720pWithWatermark_03292022 = 'APPLICATION_VIDEO_720p_WITH_WATERMARK_03292022',
  ReviewVideo_720p = 'REVIEW_VIDEO_720p',
  ReviewVideo_720pWithWatermark = 'REVIEW_VIDEO_720p_WITH_WATERMARK',
  ReviewVideo_720pWithWatermark_03082022 = 'REVIEW_VIDEO_720p_WITH_WATERMARK_03082022',
  ReviewVideo_720pWithWatermark_05022022 = 'REVIEW_VIDEO_720p_WITH_WATERMARK_05022022',
  StatusVideo_720p = 'STATUS_VIDEO_720p'
}

export type VideoQuestionInput = {
  maxDuration?: InputMaybe<Scalars['Float']>;
  prompt?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Errors related to subscribing to a waitlist */
export enum WaitlistSubscribeErrorType {
  AlreadySubscribed = 'ALREADY_SUBSCRIBED',
  NotFound = 'NOT_FOUND'
}

export type WaitlistSubscribeInput = {
  expertId: Scalars['String'];
  subscriberEmail: Scalars['String'];
  subscriberName?: InputMaybe<Scalars['String']>;
};

/** Response object when trying to subscribe to a user waiting list  */
export type WaitlistSubscribeResponse = {
  __typename: 'WaitlistSubscribeResponse';
  error?: Maybe<WaitlistSubscribeErrorType>;
  success: Scalars['Boolean'];
};

export type WithdrawInput = {
  amount: Scalars['Int'];
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type Credential_AssignmentCredentialAssignmentUniqueIndexCompoundUniqueInput = {
  credentialId: Scalars['String'];
  fromEntityId: Scalars['String'];
  fromEntityType: CredentialAssignmentEntityTypeEnum;
  toEntityId: Scalars['String'];
  toEntityType: CredentialAssignmentEntityTypeEnum;
};

export type Payment_Provider_ProductPaymentProviderPriceUniqueIndexCompoundUniqueInput = {
  price: Scalars['Int'];
  provider: PaymentProviderEnum;
};

export type Payment_Provider_ProductPaymentProviderProductUniqueIndexCompoundUniqueInput = {
  provider: PaymentProviderEnum;
  providerProductId: Scalars['String'];
};

export type Scholarship_Application_UpvoteScholarshipApplicationUpvoteVoterIdUniqueIndexCompoundUniqueInput = {
  scholarshipApplicationId: Scalars['String'];
  voterId: Scalars['String'];
};

export type TagTagTypeUniqueIndexCompoundUniqueInput = {
  content: Scalars['JSON'];
  type: TagTypeEnum;
};

export type TaskTaskUserApplicationUniqueIndexCompoundUniqueInput = {
  applicationId: Scalars['String'];
  userId: Scalars['String'];
};

export type TemplateTemplateNameTypeUniqueIndexCompoundUniqueInput = {
  name: Scalars['String'];
  type: TemplateTypeEnum;
};

export type ThreadThreadEntityUniqueIndexCompoundUniqueInput = {
  entityId: Scalars['String'];
  entityType: ThreadEntityTypeEnum;
};

export type User_CategoryUserCategoryTypeUniqueIndexCompoundUniqueInput = {
  categoryId: Scalars['String'];
  type: UserCategoryTypeEnum;
  userId: Scalars['String'];
};

export type User_CohortCohortUserUniqueIndexCompoundUniqueInput = {
  cohortId: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

export type User_ConversationUserConversationConversationIdUserIdUniqueIndexCompoundUniqueInput = {
  conversationId: Scalars['String'];
  userId: Scalars['String'];
};

export type AccessControlQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessControlQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, isExpert: boolean, isStudent: boolean } | null };

export type ApplicationAnswerFragment = { __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type ApplicationAnswerEssayAnswerFragment = { __typename: 'PrivilegedAnswer', id: string, data?: string | null };

export type ApplicationAnswerVideoAnswerFragment = { __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type ApplicationCardPrivilegedApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, publishDeadline?: string | null, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type ApplicationCardMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type AuditionFragment = { __typename: 'PublicFeaturedApplication', application?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', name?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null };

export type AuditionMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, STATUS_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type PublicFeaturedFlagFragment = { __typename: 'PublicFeaturedFlag', key: string, name: string, options: any };

export type PublicFeaturedFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicFeaturedFlagsQuery = { __typename: 'Query', publicFeaturedFlags: Array<{ __typename: 'PublicFeaturedFlag', key: string, name: string, options: any }> };

export type HeaderProfileUserFragment = { __typename: 'CurrentUser', id: string, name?: string | null, profileImageUrl?: string | null, isExpert: boolean, isStudent: boolean, userProfileImage?: { __typename: 'Media', url?: string | null } | null };

export type HeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, profileImageUrl?: string | null, isExpert: boolean, isStudent: boolean, userProfileImage?: { __typename: 'Media', url?: string | null } | null } | null };

export type MemoizedVideoPlayerMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type ProfileImageUploaderConfigQueryVariables = Exact<{
  uploadPreset?: InputMaybe<Scalars['String']>;
  notificationUrl?: InputMaybe<Scalars['String']>;
}>;


export type ProfileImageUploaderConfigQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', cloudinaryMediaSignature: { __typename: 'MediaSignature', publicId: string, signature: string, timestamp: number } } };

export type PublicApplicationFragment = { __typename: 'PublicApplication', id: string, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } };

export type GetRecentAuditionsQueryVariables = Exact<{
  cohortId: Scalars['String'];
}>;


export type GetRecentAuditionsQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } }, publicApplications: Array<{ __typename: 'PublicApplication', id: string, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }> };

export type VideoPlayerMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type SegmentIdentifyViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentIdentifyViewerQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, email?: string | null, username?: string | null } | null };

export type UpdateApplicationStateMutationVariables = Exact<{
  input: UpdateApplicationStateInput;
}>;


export type UpdateApplicationStateMutation = { __typename: 'Mutation', updateApplicationState: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } };

export type StudentCardViewerFragment = { __typename: 'CurrentUser', id: string, name?: string | null, email?: string | null, phone?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null };

export type ApplicationCardStudentFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, cohortId: string, isScholarship: boolean, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }> };

export type UserProfileFormUserFragment = { __typename: 'CurrentUser', id: string, email?: string | null, phone?: string | null, name?: string | null, username?: string | null, hasAcceptedTOS?: boolean | null, bio?: string | null, state?: string | null, city?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyArtistId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser: { __typename: 'CurrentUser', id: string, username?: string | null, phone?: string | null, hasAcceptedTOS?: boolean | null, profileImageUrl?: string | null } | { __typename: 'UpdateUserErrorResponse', type: UpdateUserErrorType, message?: string | null } };

export type UpdateUserProfileImageMutationVariables = Exact<{
  input: UpdateProfileImageInput;
}>;


export type UpdateUserProfileImageMutation = { __typename: 'Mutation', updateUserProfileImage: { __typename: 'CurrentUser', id: string, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null } };

export type VideoPlayerMediaConfigQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['String']>;
}>;


export type VideoPlayerMediaConfigQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, APPLICATION_SHAREABLE_ASSET_VIDEO?: { __typename: 'MediaVideoConfiguration', transformation?: any | null } | null } };

export type VideoUploaderMediaConfigTransformationsQueryVariables = Exact<{
  cohortId: Scalars['String'];
}>;


export type VideoUploaderMediaConfigTransformationsQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, APPLICATION_VIDEO_720p_WITH_WATERMARK_03292022: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, APPLICATION_SHAREABLE_ASSET_VIDEO?: { __typename: 'MediaVideoConfiguration', transformation?: any | null } | null } };

export type VideoUploaderConfigQueryVariables = Exact<{
  uploadPreset?: InputMaybe<Scalars['String']>;
  notificationUrl?: InputMaybe<Scalars['String']>;
  eager?: InputMaybe<Scalars['String']>;
  eagerAsync?: InputMaybe<Scalars['Boolean']>;
}>;


export type VideoUploaderConfigQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', cloudinaryMediaSignature: { __typename: 'MediaSignature', publicId: string, signature: string, timestamp: number } } };

export type VideoUploaderPollUploadStatusQueryVariables = Exact<{
  cloudinaryPublicId: Scalars['String'];
}>;


export type VideoUploaderPollUploadStatusQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, uniqueMedia?: { __typename: 'Media', id: string, cloudinaryPublicId: string, state: MediaStateEnum } | null } | null };

export type InitializeMediaMutationVariables = Exact<{
  cloudinaryPublicId: Scalars['String'];
  type: MediaTypeEnum;
}>;


export type InitializeMediaMutation = { __typename: 'Mutation', initializeMedia: { __typename: 'PrivilegedMedia', id: string, cloudinaryPublicId: string, state: MediaStateEnum } };

export type ApplicationVideoUploaderCohortFragment = { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null } };

export type ApplicationVideoUploaderViewerFragment = { __typename: 'CurrentUser', id: string, name?: string | null, email?: string | null, firstName?: string | null, phone?: string | null };

export type ApplicationCreatePageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApplicationCreatePageQuery = { __typename: 'Query', publicCohort?: { __typename: 'PublicCohort', id: string, state: CohortStateEnum, name: string, type: CohortTypeEnum, expert: { __typename: 'PublicUser', username?: string | null, profileImageUrl?: string | null, name?: string | null, id: string, userProfileImage?: { __typename: 'Media', url?: string | null, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', url?: string | null, cloudinaryPublicId: string } | null }, questions: Array<{ __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum, title?: string | null, prompt?: string | null, maxDuration?: number | null }>, category?: { __typename: 'PublicCategory', id: string, name: string } | null } | null, viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, email?: string | null, firstName?: string | null, phone?: string | null } | null };

export type ApplicationEditApplicationPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApplicationEditApplicationPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, email?: string | null, firstName?: string | null, phone?: string | null, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, bytes?: number | null, cloudinaryPublicId: string, duration?: number | null, height?: number | null, width?: number | null, url?: string | null, type: MediaTypeEnum } | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum } }> } | null } | null };

export type CreateApplicationMutationVariables = Exact<{
  input: CreateApplicationInput;
}>;


export type CreateApplicationMutation = { __typename: 'Mutation', createApplication: { __typename: 'CreateApplicationErrorResponse', type: CreateApplicationErrorType } | { __typename: 'ManagementReferralCodeErrorResponse' } | { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, price: number, userId: string } };

export type UpdateVideoAnswerMutationVariables = Exact<{
  input: VideoAnswerInput;
  answerId: Scalars['String'];
}>;


export type UpdateVideoAnswerMutation = { __typename: 'Mutation', updateVideoAnswer: { __typename: 'PrivilegedAnswer', id: string } };

export type ApplicationQuestionFragment = { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum, title?: string | null, prompt?: string | null, maxDuration?: number | null };

export type ApplicationQuestionCohortFragment = { __typename: 'PublicCohort', id: string, category?: { __typename: 'PublicCategory', id: string, name: string } | null };

export type ApplicationEssayQuestionFragment = { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum, prompt?: string | null, maxDuration?: number | null };

export type ApplicationVideoQuestionFragment = { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum, title?: string | null, prompt?: string | null, maxDuration?: number | null };

export type ApplicationDetailPageDetailApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, createdAt: string, user: { __typename: 'PublicUser', username?: string | null }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type ApplicationDetailPageQueryVariables = Exact<{
  cohortId: Scalars['String'];
  applicationId: Scalars['String'];
}>;


export type ApplicationDetailPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, isExpert: boolean, cohort?: { __typename: 'PrivilegedCohort', name: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, profileImageUrl?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null }, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, createdAt: string, isScholarship: boolean, user: { __typename: 'PublicUser', id: string, username?: string | null }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, media?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum } }>, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number } | null } | null } | null } | null };

export type ReviewVideoApplicationMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type ReviewVideoApplicationMutation = { __typename: 'Mutation', reviewApplication: { __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', username?: string | null }, application: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } } };

export type ReviewPrivilegedReviewFragment = { __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type ReviewCreateApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, media?: { __typename: 'Media', id: string, url?: string | null } | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum } }> };

export type ReviewApplicationMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type ReviewApplicationMutation = { __typename: 'Mutation', reviewApplication: { __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', username?: string | null }, application: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', username?: string | null }, reactionVideo: { __typename: 'ReactionVideoResponse', verticalReactionVideoUrl?: string | null, horizontalReactionVideoUrl?: string | null } }> }, reactionVideo: { __typename: 'ReactionVideoResponse', verticalReactionVideoUrl?: string | null, horizontalReactionVideoUrl?: string | null } } };

export type ApplicationSummaryAndPaymentPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApplicationSummaryAndPaymentPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, email?: string | null, firstName?: string | null, phone?: string | null, balance: number, hasAcceptedTOS?: boolean | null, name?: string | null, profileImageUrl?: string | null, storedCardPaymentMethodsForStripe: Array<{ __typename: 'StripeStoredCardPaymentMethod', id: string, brand: StripeStoredCardBrand, last4: string, expYear: number, expMonth: number }>, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, price: number, isScholarship: boolean, referralCodeApplicableDiscount: number, adjustedPrice: number, cohortId: string, referralCode?: { __typename: 'PrivilegedReferralCode', id: string, code: string } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, price: number, scholarshipVotesThreshold: number, scholarshipApplicationLimit?: number | null, scholarshipsAwarded: number, scholarshipReferralsThreshold: number, scholarshipDeadline?: string | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', profileImageUrl?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null } }, createTransactionIntentForStripe?: { __typename: 'StripePaymentTransactionIntent', transaction: { __typename: 'Transaction', id: string, userId: string, createdAt: any, updatedAt: any, amount: number, providerTransactionId?: string | null, providerTransactionStatus?: string | null }, paymentIntent: { __typename: 'StripePaymentIntent', id: string, clientSecret: string, amount: number } } | null, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }> } | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null } | null };

export type PurchaseApplicationMutationVariables = Exact<{
  input: PurchaseApplicationWithStripeInput;
}>;


export type PurchaseApplicationMutation = { __typename: 'Mutation', purchaseApplicationWithStripe: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } | { __typename: 'PurchaseApplicationErrorResponse', type: PurchaseApplicationErrorType, applicationId: string, reason?: string | null } };

export type CompleteAndPurchaseApplicationMutationVariables = Exact<{
  input: CompleteAndPurchaseApplicationInput;
}>;


export type CompleteAndPurchaseApplicationMutation = { __typename: 'Mutation', completeAndPurchaseApplicationWithStripe: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } | { __typename: 'PurchaseApplicationErrorResponse', type: PurchaseApplicationErrorType, applicationId: string, reason?: string | null } };

export type RedeemReferralCodeMutationVariables = Exact<{
  code: Scalars['String'];
  applicationId: Scalars['ID'];
}>;


export type RedeemReferralCodeMutation = { __typename: 'Mutation', redeemReferralCode: { __typename: 'ManagementReferralCodeErrorResponse', type: ManagementReferralCodeErrorType } | { __typename: 'PrivilegedApplication', id: string, referralCodeApplicableDiscount: number, referralCode?: { __typename: 'PrivilegedReferralCode', id: string, type: ReferralCodeTypeEnum, code: string } | null, createTransactionIntentForStripe?: { __typename: 'StripePaymentTransactionIntent', paymentIntent: { __typename: 'StripePaymentIntent', id: string, clientSecret: string, amount: number } } | null } };

export type SubmitScholarshipApplicationMutationVariables = Exact<{
  input: SubmitScholarshipApplicationInput;
}>;


export type SubmitScholarshipApplicationMutation = { __typename: 'Mutation', submitScholarshipApplication: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } };

export type ApplicationUpdateProfilePageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApplicationUpdateProfilePageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, email?: string | null, phone?: string | null, name?: string | null, username?: string | null, hasAcceptedTOS?: boolean | null, bio?: string | null, state?: string | null, city?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyArtistId?: string | null, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isScholarship: boolean, cohort: { __typename: 'PrivilegedCohort', id: string, type: CohortTypeEnum, expert: { __typename: 'PublicUser', profileImageUrl?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null } } } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null };

export type UpdateProfileForApplicationMutationVariables = Exact<{
  input: UpdateProfileForApplicationInput;
}>;


export type UpdateProfileForApplicationMutation = { __typename: 'Mutation', updateProfileForApplication: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } };

export type AuthProviderPostLoginUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthProviderPostLoginUserQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null } | null };

export type AuthProviderGenerateAuthCodeMutationVariables = Exact<{
  input: AuthUserInput;
}>;


export type AuthProviderGenerateAuthCodeMutation = { __typename: 'Mutation', authUser: boolean };

export type AuthProviderCreateUserFromSocialMutationVariables = Exact<{
  input: AuthUserInput;
}>;


export type AuthProviderCreateUserFromSocialMutation = { __typename: 'Mutation', authUserFromSocial?: string | null };

export type InitAuthMutationVariables = Exact<{
  input: InitAuthInput;
}>;


export type InitAuthMutation = { __typename: 'Mutation', initAuth: { __typename: 'InitAuthResponse', success: boolean, error?: { __typename: 'AuthErrorResponse', type: AuthErrorType, message?: string | null } | null } };

export type VerifyOtpMutationVariables = Exact<{
  input: VerifyAuthInput;
}>;


export type VerifyOtpMutation = { __typename: 'Mutation', verifyOtp: { __typename: 'AuthErrorResponse', message?: string | null, type: AuthErrorType } | { __typename: 'VerifyAuthResponse', accessToken: string, expiresIn: number, refreshToken: string } };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename: 'Mutation', refreshToken: { __typename: 'AuthErrorResponse', message?: string | null, type: AuthErrorType } | { __typename: 'RefreshTokenResponse', accessToken: string, expiresIn: number } };

export type AllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCategoriesQuery = { __typename: 'Query', publicTags: Array<{ __typename: 'PublicTag', id: string, content: { __typename: 'CommonTagContent', title: string, subtitle?: string | null, slug?: string | null, iconCloudinaryPublicId?: string | null } }> };

export type CategoryPageQueryVariables = Exact<{
  slug: Scalars['JSON'];
}>;


export type CategoryPageQuery = { __typename: 'Query', publicTags: Array<{ __typename: 'PublicTag', id: string, content: { __typename: 'CommonTagContent', title: string, subtitle?: string | null, slug?: string | null, iconCloudinaryPublicId?: string | null } }>, publicTag?: { __typename: 'PublicTag', id: string, content: { __typename: 'CommonTagContent', title: string, subtitle?: string | null, slug?: string | null, iconCloudinaryPublicId?: string | null }, taggedCohorts: Array<{ __typename: 'PublicApplication' } | { __typename: 'PublicCohort', id: string, updateStatus?: string | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, title?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | { __typename: 'PublicInterstitialAd', id: string, headline: string, subHeadline: string, buttonPath: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | { __typename: 'PublicUser' }> } | null };

export type CollabReviewFragment = { __typename: 'PublicReview', id: string, mediaUrlWithTransformations?: string | null, application?: { __typename: 'Application', id: string, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } };

export type CollabRatedApplicationFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } };

export type CollabHeaderUserFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, waitlistEnabled?: boolean | null, bio?: string | null, numberOfCredentialsGranted: number, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, state: CohortStateEnum, price: number, prize?: string | null, name: string, type: CohortTypeEnum, description?: string | null, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, updateStatus?: string | null }> };

export type CollabCohortFragment = { __typename: 'PublicCohort', id: string, type: CohortTypeEnum, description?: string | null, updateStatus?: string | null, state: CohortStateEnum, symbol?: string | null, isActive: boolean, price: number, prize?: string | null };

export type CollabPageUserFragment = { __typename: 'PublicUser', title?: string | null, waitlistEnabled?: boolean | null, id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, bio?: string | null, numberOfCredentialsGranted: number, expertCredentials: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, state: CohortStateEnum, price: number, prize?: string | null, name: string, type: CohortTypeEnum, description?: string | null, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, updateStatus?: string | null, symbol?: string | null, isActive: boolean }>, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }> };

export type CollabPageMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type GetCollabProfileByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetCollabProfileByUsernameQuery = { __typename: 'Query', userByUsername?: { __typename: 'PublicUser', id: string, isExpert: boolean, title?: string | null, waitlistEnabled?: boolean | null, name?: string | null, username?: string | null, profileImageUrl?: string | null, bio?: string | null, numberOfCredentialsGranted: number, reviews?: Array<{ __typename: 'PublicReview', id: string, mediaUrlWithTransformations?: string | null, application?: { __typename: 'Application', id: string, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }> | null, expertCredentials: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, state: CohortStateEnum, price: number, prize?: string | null, name: string, type: CohortTypeEnum, description?: string | null, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, updateStatus?: string | null, symbol?: string | null, isActive: boolean }>, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }> } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type CollabGalleryPublicApplicationFragment = { __typename: 'PublicApplication', id: string, isScholarship: boolean, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type GetCollabUserPublicApplicationsQueryVariables = Exact<{
  userById: Scalars['String'];
}>;


export type GetCollabUserPublicApplicationsQuery = { __typename: 'Query', userById?: { __typename: 'PublicUser', id: string, publicApplications: Array<{ __typename: 'PublicApplication', id: string, isScholarship: boolean, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> }> } | null };

export type StudentConversationMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type ConversationQueryVariables = Exact<{
  where?: InputMaybe<ConversationWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput> | MessageOrderByWithRelationInput>;
  timezone: Scalars['String'];
}>;


export type ConversationQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, conversation?: { __typename: 'PrivilegedConversation', id: string, freeMessagesEnabled: boolean, entity?: { __typename: 'PrivilegedCohort', id: string, publishDeadline?: string | null, isScholarshipOnly: boolean, isPaidOnly: boolean, arePaidApplicationsAvailable: boolean, areScholarshipsAvailable: boolean, price: number, hasPublishDeadlineExpired: boolean, publishDeadlineTimeLeft: any, publishWindow?: number | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, waitlistEnabled?: boolean | null, bio?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, experts: Array<{ __typename: 'PublicUser', id: string, title?: string | null, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | null, participants: Array<{ __typename: 'PrivilegedUserConversation', user: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }>, messages: { __typename: 'PaginatedPrivilegedMessageResponse', pageInfo: { __typename: 'PageInfo', activePage: number, perPage: number, totalPages: number, totalCount: number, hasPrevious: boolean, hasNext: boolean }, data: Array<{ __typename: 'PrivilegedMessage', id: string, parentId?: string | null, type: MessageTypeEnum, content?: string | null, sentAt: string, sender: { __typename: 'PublicUser', id: string, name?: string | null, isExpert: boolean, isStudent: boolean, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, entity?: { __typename: 'Media', cloudinaryPublicId: string, mediaId: string } | { __typename: 'PrivilegedApplication', isPublic: boolean, state: ApplicationStateEnum, isScholarship: boolean, isExpired: boolean, privilegedApplicationId: string, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, comment?: string | null, privilegedAnswerId: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | { __typename: 'PrivilegedReview', id: string, rating?: number | null, applicationId: string, isPublicReview?: boolean | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, application: { __typename: 'PrivilegedApplication', id: string, isScholarship: boolean } } | null }> } } | null } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type ConversationAuditionPrivilegedAnswerFragment = { __typename: 'PrivilegedAnswer', comment?: string | null, privilegedAnswerId: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type ConversationPrivilegedApplicationFragment = { __typename: 'PrivilegedApplication', isPublic: boolean, state: ApplicationStateEnum, isScholarship: boolean, isExpired: boolean, privilegedApplicationId: string, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, comment?: string | null, privilegedAnswerId: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type ConversationPrivilegedReviewFragment = { __typename: 'PrivilegedReview', id: string, rating?: number | null, applicationId: string, isPublicReview?: boolean | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, application: { __typename: 'PrivilegedApplication', id: string, isScholarship: boolean } };

export type ConversationDataFragment = { __typename: 'PrivilegedMessage', id: string, parentId?: string | null, type: MessageTypeEnum, content?: string | null, sentAt: string, sender: { __typename: 'PublicUser', id: string, name?: string | null, isExpert: boolean, isStudent: boolean, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, entity?: { __typename: 'Media', cloudinaryPublicId: string, mediaId: string } | { __typename: 'PrivilegedApplication', isPublic: boolean, state: ApplicationStateEnum, isScholarship: boolean, isExpired: boolean, privilegedApplicationId: string, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, comment?: string | null, privilegedAnswerId: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | { __typename: 'PrivilegedReview', id: string, rating?: number | null, applicationId: string, isPublicReview?: boolean | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, application: { __typename: 'PrivilegedApplication', id: string, isScholarship: boolean } } | null };

export type ConversationMessageCohortFragment = { __typename: 'PrivilegedCohort', id: string, publishDeadline?: string | null, isScholarshipOnly: boolean, isPaidOnly: boolean, arePaidApplicationsAvailable: boolean, areScholarshipsAvailable: boolean, price: number, hasPublishDeadlineExpired: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, waitlistEnabled?: boolean | null } };

export type UpdateMessagesReadMutationVariables = Exact<{
  conversationId: Scalars['ID'];
}>;


export type UpdateMessagesReadMutation = { __typename: 'Mutation', messagesRead: Array<{ __typename: 'PrivilegedMessage', id: string }> };

export type ConversationListQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ConversationListQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, conversations: Array<{ __typename: 'PrivilegedConversation', id: string, totalUnreadMessages: number, participants: Array<{ __typename: 'PrivilegedUserConversation', user: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }>, messages: { __typename: 'PaginatedPrivilegedMessageResponse', data: Array<{ __typename: 'PrivilegedMessage', id: string, content?: string | null, sentAt: string, type: MessageTypeEnum, sender: { __typename: 'PublicUser', name?: string | null, id: string, username?: string | null } }> } }> } | null };

export type DiscoverPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoverPageQuery = { __typename: 'Query', publicCategories: Array<{ __typename: 'PublicCategory', id: string, name: string, fontColor?: string | null, backgroundColor?: string | null }>, publicCohorts: Array<{ __typename: 'PublicCohort', id: string, comingSoon: boolean, name: string, prize?: string | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, profileImageUrl?: string | null, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, category?: { __typename: 'PublicCategory', id: string, name: string, backgroundColor?: string | null, fontColor?: string | null } | null }> };

export type CategoryFilterPublicCategoryFragment = { __typename: 'PublicCategory', id: string, name: string, fontColor?: string | null, backgroundColor?: string | null };

export type FeaturedCohortsListPublicCohortFragment = { __typename: 'PublicCohort', id: string, name: string, prize?: string | null, comingSoon: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, profileImageUrl?: string | null, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, category?: { __typename: 'PublicCategory', id: string, name: string, backgroundColor?: string | null, fontColor?: string | null } | null };

export type CohortTagsPublicCohortFragment = { __typename: 'PublicCohort', id: string, comingSoon: boolean, category?: { __typename: 'PublicCategory', id: string, name: string, backgroundColor?: string | null, fontColor?: string | null } | null };

export type UpdateUserProfileCoverImageMutationVariables = Exact<{
  input: UpdateProfileImageInput;
}>;


export type UpdateUserProfileCoverImageMutation = { __typename: 'Mutation', updateUserProfileCoverImage: { __typename: 'CurrentUser', id: string, userProfileCoverImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null } };

export type ProfileCoverUploaderConfigQueryVariables = Exact<{
  uploadPreset?: InputMaybe<Scalars['String']>;
  notificationUrl?: InputMaybe<Scalars['String']>;
}>;


export type ProfileCoverUploaderConfigQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', cloudinaryMediaSignature: { __typename: 'MediaSignature', publicId: string, signature: string, timestamp: number } } };

export type FeedHomePageBaseFeaturedApplicationFragment = { __typename: 'BaseFeaturedApplication', id: string, sortOrder?: number | null, application?: { __typename: 'PublicApplication', id: string, createdAt: string, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null };

export type FeedHomePageFeaturedExpertFragment = { __typename: 'PublicFeaturedExpert', id: string, hoursToReview?: number | null, status?: string | null, type: FeaturedExpertTypeEnum, headline: string, subHeadline: string, customVideo?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, cohort?: { __typename: 'PublicCohort', id: string, updateStatus?: string | null, expert: { __typename: 'PublicUser', id: string, waitlistEnabled?: boolean | null } } | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, profileImageUrl?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, featuredApplications: Array<{ __typename: 'PublicFeaturedApplication', application?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', name?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null }> };

export type FeedHomePageQueryVariables = Exact<{
  maxPublicExperts: Scalars['Int'];
}>;


export type FeedHomePageQuery = { __typename: 'Query', publicFeaturedExperts: Array<{ __typename: 'PublicFeaturedExpert', id: string, hoursToReview?: number | null, status?: string | null, type: FeaturedExpertTypeEnum, headline: string, subHeadline: string, customVideo?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, cohort?: { __typename: 'PublicCohort', id: string, updateStatus?: string | null, expert: { __typename: 'PublicUser', id: string, waitlistEnabled?: boolean | null } } | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, profileImageUrl?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, featuredApplications: Array<{ __typename: 'PublicFeaturedApplication', application?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', name?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null }> }>, expertList: Array<{ __typename: 'PublicFeaturedExpert', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }>, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, STATUS_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type FeedExpertAvatarFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type FeedExpertListContentFragment = { __typename: 'PublicFeaturedExpert', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } };

export type FeedExpertListFragment = { __typename: 'PublicFeaturedExpert', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } };

export type FeedQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedQuery = { __typename: 'Query', feed: Array<{ __typename: 'FeaturedReview', review: { __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } }> };

export type LoginAsUserPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginAsUserPageQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, name?: string | null, username?: string | null, isExpert: boolean, isAdmin: boolean, isStudent: boolean, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null, userCohorts: Array<{ __typename: 'UserCohort', id: string, cohortId: string, role: { __typename: 'Role', name: string }, cohort: { __typename: 'Cohort', description?: string | null, state: CohortStateEnum } }> }> };

export type LoginAsUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type LoginAsUserMutation = { __typename: 'Mutation', loginAsUser?: { __typename: 'CurrentUser', id: string, username?: string | null, profileImageUrl?: string | null } | null };

export type MusicianOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type MusicianOnboardingQuery = { __typename: 'Query', myScholarshipApplicationReferral?: { __typename: 'PrivilegedScholarshipApplicationReferral', id: string, publicScholarshipApplication: { __typename: 'PublicScholarshipApplication', id: string, shortCode?: string | null, application: { __typename: 'PublicApplication', id: string, user: { __typename: 'PublicUser', id: string, name?: string | null }, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null } } } }, referredUser: { __typename: 'PublicUser', id: string, name?: string | null } } | null, viewer?: { __typename: 'CurrentUser', id: string, name?: string | null } | null };

export type CompleteApplicationScholarshipReferralMutationVariables = Exact<{
  input: CompleteApplicationScholarshipReferralInput;
}>;


export type CompleteApplicationScholarshipReferralMutation = { __typename: 'Mutation', completeApplicationScholarshipReferral: { __typename: 'CompleteScholarshipApplicationReferralErrorResponse', type: CompleteScholarshipApplicationReferralErrorType, message?: string | null } | { __typename: 'PrivilegedScholarshipApplicationReferral', id: string } };

export type ProfileEditStudentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileEditStudentPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, hasAcceptedTOS?: boolean | null, email?: string | null, phone?: string | null, name?: string | null, username?: string | null, bio?: string | null, state?: string | null, city?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyArtistId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null };

export type ProfileExpertPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileExpertPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, email?: string | null, isExpert: boolean, isStudent: boolean, bio?: string | null, cohorts: Array<{ __typename: 'PrivilegedCohort', id: string, state: CohortStateEnum, name: string }>, applications: Array<{ __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, cohort: { __typename: 'PrivilegedCohort', id: string, name: string } }> } | null };

export type UserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, email?: string | null, createdAt: string } | null };

export type ProfileStudentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileStudentPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, email?: string | null, isExpert: boolean, isStudent: boolean, bio?: string | null, balance: number, cohorts: Array<{ __typename: 'PrivilegedCohort', id: string, state: CohortStateEnum, name: string }>, applications: Array<{ __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, createdAt: string, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, expert: { __typename: 'PublicUser', username?: string | null, profileImageUrl?: string | null } } }> } | null };

export type RaiseExpertPageUserFragment = { __typename: 'PublicUser', title?: string | null, waitlistEnabled?: boolean | null, id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, bio?: string | null, numberOfCredentialsGranted: number, expertCredentials: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, timeline?: any | null, type: CohortTypeEnum, description?: string | null, updateStatus?: string | null, state: CohortStateEnum, price: number, prize?: string | null, name: string, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, isActive: boolean, comingSoon: boolean, responseDetail?: string | null, applicationExpirationDeadline?: string | null, publishDeadlineTimeLeft: any, hasPublishDeadlineExpired: boolean, hasScholarshipDeadlineExpired: boolean, areScholarshipsAvailable: boolean, areApplicationsAvailable: boolean, arePaidApplicationsAvailable: boolean, isScholarshipOnly: boolean, isPaidOnly: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, scholarshipWindow?: number | null, publishDeadline?: string | null, scholarshipDeadline?: string | null, scholarshipApplicationLimit?: number | null, scholarshipsAwarded: number, totalApplicationsRemaining?: number | null, aggregateApplicationLimit?: number | null, numberOfCredentialsGranted: number, rules?: string | null, experts: Array<{ __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, sampleAuditionVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, sampleReviewVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, charityBadge?: { __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }>, category?: { __typename: 'PublicCategory', id: string, name: string } | null, whatToSend: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, whatYouReceive: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, details: Array<{ __typename: 'DetailTagContent', title: string, active?: boolean | null, content: Array<{ __typename: 'TagDetailContent', term?: string | null, definition: string }> }> }>, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }> };

export type RaiseExpertPageMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type GetProfileByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetProfileByUsernameQuery = { __typename: 'Query', userByUsername?: { __typename: 'PublicUser', id: string, isExpert: boolean, title?: string | null, waitlistEnabled?: boolean | null, name?: string | null, username?: string | null, profileImageUrl?: string | null, bio?: string | null, numberOfCredentialsGranted: number, expertCredentials: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, timeline?: any | null, type: CohortTypeEnum, description?: string | null, updateStatus?: string | null, state: CohortStateEnum, price: number, prize?: string | null, name: string, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, isActive: boolean, comingSoon: boolean, responseDetail?: string | null, applicationExpirationDeadline?: string | null, publishDeadlineTimeLeft: any, hasPublishDeadlineExpired: boolean, hasScholarshipDeadlineExpired: boolean, areScholarshipsAvailable: boolean, areApplicationsAvailable: boolean, arePaidApplicationsAvailable: boolean, isScholarshipOnly: boolean, isPaidOnly: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, scholarshipWindow?: number | null, publishDeadline?: string | null, scholarshipDeadline?: string | null, scholarshipApplicationLimit?: number | null, scholarshipsAwarded: number, totalApplicationsRemaining?: number | null, aggregateApplicationLimit?: number | null, numberOfCredentialsGranted: number, rules?: string | null, experts: Array<{ __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, sampleAuditionVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, sampleReviewVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, charityBadge?: { __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }>, category?: { __typename: 'PublicCategory', id: string, name: string } | null, whatToSend: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, whatYouReceive: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, details: Array<{ __typename: 'DetailTagContent', title: string, active?: boolean | null, content: Array<{ __typename: 'TagDetailContent', term?: string | null, definition: string }> }> }>, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }> } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type CharityBannerFragment = { __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, url?: string | null };

export type RatedApplicationFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } };

export type HeaderUserFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, waitlistEnabled?: boolean | null, bio?: string | null, numberOfCredentialsGranted: number, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileVideo?: { __typename: 'Media', cloudinaryPublicId: string } | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }>, cohorts: Array<{ __typename: 'PublicCohort', id: string, state: CohortStateEnum, price: number, prize?: string | null, name: string, type: CohortTypeEnum, description?: string | null, paidApplicationLimit?: number | null, totalPaidApplications: number, publishWindow?: number | null, updateStatus?: string | null }> };

export type HeaderCohortFragment = { __typename: 'PublicCohort', id: string, isActive: boolean, state: CohortStateEnum, comingSoon: boolean, price: number, prize?: string | null, responseDetail?: string | null, name: string, type: CohortTypeEnum, applicationExpirationDeadline?: string | null, description?: string | null, publishDeadlineTimeLeft: any, hasPublishDeadlineExpired: boolean, hasScholarshipDeadlineExpired: boolean, paidApplicationLimit?: number | null, totalPaidApplications: number, areScholarshipsAvailable: boolean, areApplicationsAvailable: boolean, arePaidApplicationsAvailable: boolean, isScholarshipOnly: boolean, isPaidOnly: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, scholarshipWindow?: number | null, publishWindow?: number | null, publishDeadline?: string | null, scholarshipDeadline?: string | null, scholarshipApplicationLimit?: number | null, scholarshipsAwarded: number, totalApplicationsRemaining?: number | null, aggregateApplicationLimit?: number | null, numberOfCredentialsGranted: number, updateStatus?: string | null, rules?: string | null, credentialAssignmentGranted: Array<{ __typename: 'PublicCredentialAssignment', id: string, createdAt: string, ratedApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null, to: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, isStudent: boolean, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }>, charityBadge?: { __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null } | null, category?: { __typename: 'PublicCategory', id: string, name: string } | null, experts: Array<{ __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, whatToSend: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, whatYouReceive: Array<{ __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, subtitle?: string | null, url?: string | null }>, details: Array<{ __typename: 'DetailTagContent', title: string, active?: boolean | null, content: Array<{ __typename: 'TagDetailContent', term?: string | null, definition: string }> }> };

export type PanelistsPublicUserFragment = { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type TypeSelectorPublicCohortFragment = { __typename: 'PublicCohort', id: string, state: CohortStateEnum, type: CohortTypeEnum, isPaidOnly: boolean, isScholarshipOnly: boolean, areApplicationsAvailable: boolean, arePaidApplicationsAvailable: boolean, areScholarshipsAvailable: boolean, publishDeadline?: string | null, hasPublishDeadlineExpired: boolean, scholarshipDeadline?: string | null, hasScholarshipDeadlineExpired: boolean, scholarshipWindow?: number | null, publishWindow?: number | null, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, price: number, aggregateApplicationLimit?: number | null, totalApplicationsRemaining?: number | null, rules?: string | null, charityBadge?: { __typename: 'CommonTagContent', title: string, iconCloudinaryPublicId?: string | null, url?: string | null } | null, category?: { __typename: 'PublicCategory', name: string } | null };

export type ApplicationStartButtonLabelPublicCohortFragment = { __typename: 'PublicCohort', id: string, state: CohortStateEnum, type: CohortTypeEnum, isPaidOnly: boolean, isScholarshipOnly: boolean, price: number, scholarshipVotesThreshold: number };

export type TypeSelectorCharityBannerFragment = { __typename: 'CommonTagContent', iconCloudinaryPublicId?: string | null, title: string, url?: string | null };

export type ExpertWaitlistSubcribeMutationVariables = Exact<{
  input: WaitlistSubscribeInput;
}>;


export type ExpertWaitlistSubcribeMutation = { __typename: 'Mutation', expertWaitlistSubcribe: { __typename: 'WaitlistSubscribeResponse', success: boolean, error?: WaitlistSubscribeErrorType | null } };

export type GetViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, email?: string | null } | null };

export type GetCohortRecommendationsQueryVariables = Exact<{
  input: CohortsRecommendationInput;
}>;


export type GetCohortRecommendationsQuery = { __typename: 'Query', getCohortRecommendations: Array<{ __typename: 'PublicCohort', id: string, name: string, prize?: string | null, comingSoon: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, profileImageUrl?: string | null, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, category?: { __typename: 'PublicCategory', id: string, name: string, backgroundColor?: string | null, fontColor?: string | null } | null }> };

export type SampleVideosMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type RaiseHomePageBaseFeaturedApplicationFragment = { __typename: 'BaseFeaturedApplication', id: string, sortOrder?: number | null, application?: { __typename: 'PublicApplication', id: string, createdAt: string, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null };

export type RaiseHomePageFeaturedExpertFragment = { __typename: 'PublicFeaturedExpert', id: string, headline: string, subHeadline: string, type: FeaturedExpertTypeEnum, updateStatus?: string | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, featuredApplications: Array<{ __typename: 'PublicFeaturedApplication', application?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', name?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null }> };

export type GetFeaturedExpertsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedExpertsQuery = { __typename: 'Query', publicFeaturedExperts: Array<{ __typename: 'PublicFeaturedExpert', id: string, headline: string, subHeadline: string, type: FeaturedExpertTypeEnum, updateStatus?: string | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, featuredApplications: Array<{ __typename: 'PublicFeaturedApplication', application?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', name?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null, review?: { __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } | null }> }>, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, STATUS_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } }, featuredApplications: Array<{ __typename: 'BaseFeaturedApplication', id: string, sortOrder?: number | null, application?: { __typename: 'PublicApplication', id: string, createdAt: string, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null }> };

export type ExpertsSectionPublicFeaturedExpertFragment = { __typename: 'PublicFeaturedExpert', id: string, headline: string, subHeadline: string, expert: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } };

export type FeaturedExpertImagePublicUserFragment = { __typename: 'PublicUser', id: string, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type FeaturedApplicationsBaseFeaturedApplicationFragment = { __typename: 'BaseFeaturedApplication', id: string, application?: { __typename: 'PublicApplication', id: string, createdAt: string, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } | null };

export type MatchedCohortsListPublicCohortFragment = { __typename: 'PublicCohort', id: string, name: string, description?: string | null, prize?: string | null, arePaidApplicationsAvailable: boolean, price: number, type: CohortTypeEnum, areScholarshipsAvailable: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, prizeDetails?: { __typename: 'PrizeDetailTagContent', title: string, textMapping: string } | null };

export type GetCohortRecommendationsForTypeFormQueryVariables = Exact<{
  responseId: Scalars['String'];
}>;


export type GetCohortRecommendationsForTypeFormQuery = { __typename: 'Query', getCohortRecommendationsForTypeForm: Array<{ __typename: 'PublicCohort', id: string, name: string, description?: string | null, prize?: string | null, arePaidApplicationsAvailable: boolean, price: number, type: CohortTypeEnum, areScholarshipsAvailable: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, prizeDetails?: { __typename: 'PrizeDetailTagContent', title: string, textMapping: string } | null }> };

export type ReferralOnboardingPageQueryVariables = Exact<{
  shortCode: Scalars['String'];
}>;


export type ReferralOnboardingPageQuery = { __typename: 'Query', publicScholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, application: { __typename: 'PublicApplication', id: string, cohort: { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, name?: string | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null } } } | null, publicCohorts: Array<{ __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', id: string, username?: string | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }> };

export type GetConversationQueryVariables = Exact<{
  cohortId: Scalars['String'];
}>;


export type GetConversationQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', conversation?: { __typename: 'PrivilegedConversation', id: string } | null } | null };

export type ScholarshipPageQueryVariables = Exact<{
  applicationId: Scalars['String'];
}>;


export type ScholarshipPageQuery = { __typename: 'Query', publicApplication?: { __typename: 'PublicApplication', id: string, isScholarship: boolean, user: { __typename: 'PublicUser', id: string, username?: string | null } } | null };

export type SitemapPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapPageQuery = { __typename: 'Query', publicCohorts: Array<{ __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null } }> };

export type StudentPublicFeedbackFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, reviews: Array<{ __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null };

export type StudentPublicUserFeedbackFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, publicApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, reviews: Array<{ __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null } | null };

export type GetStudentFeedbackQueryVariables = Exact<{
  username: Scalars['String'];
  applicationId: Scalars['String'];
}>;


export type GetStudentFeedbackQuery = { __typename: 'Query', userByUsername?: { __typename: 'PublicUser', name?: string | null, username?: string | null, bio?: string | null, id: string, publicApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, reviews: Array<{ __typename: 'PublicReview', id: string, createdAt: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null } | null } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type ScholarshipUpvoteMutationVariables = Exact<{
  applicationId: Scalars['ID'];
}>;


export type ScholarshipUpvoteMutation = { __typename: 'Mutation', scholarshipUpvote: { __typename: 'PrivilegedApplication', id: string, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number } | null } | { __typename: 'ScholarshipUpvoteErrorResponse', type: ScholarshipUpvoteErrorType } };

export type StudentPublicApplicationFeedbackDetailFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, isScholarship: boolean, createdAt: string, cohort: { __typename: 'PublicCohort', id: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null };

export type StudentPublicApplicationVideoMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type StudentFeedbackVideoFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, user: { __typename: 'PublicUser', id: string, name?: string | null }, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, reviews: Array<{ __typename: 'PublicReview', id: string, isPublic?: boolean | null, createdAt: string, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }> };

export type StudentPublicApplicationFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, scholarshipVotesThreshold: number, hasPublishDeadlineExpired: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } };

export type StudentPublicUserFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, publicApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, scholarshipVotesThreshold: number, hasPublishDeadlineExpired: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null };

export type GetStudentApplicationQueryVariables = Exact<{
  username: Scalars['String'];
  applicationId: Scalars['String'];
}>;


export type GetStudentApplicationQuery = { __typename: 'Query', userByUsername?: { __typename: 'PublicUser', name?: string | null, username?: string | null, id: string, publicApplication?: { __typename: 'PublicApplication', id: string, isPublic: boolean, createdAt: string, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', id: string, scholarshipVotesThreshold: number, hasPublishDeadlineExpired: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type StudentPublicApplicationDetailFragment = { __typename: 'PublicApplication', id: string, isPublic: boolean, isScholarship: boolean, createdAt: string, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null, cohort: { __typename: 'PublicCohort', id: string, scholarshipVotesThreshold: number, hasPublishDeadlineExpired: boolean, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null } }, user: { __typename: 'PublicUser', id: string, name?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } };

export type StudentPublicApplicationScholarshipFragment = { __typename: 'PublicApplication', id: string, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, canVote: boolean, hasVoted?: boolean | null, totalApprovedReferrals: number } | null, cohort: { __typename: 'PublicCohort', scholarshipVotesThreshold: number, hasPublishDeadlineExpired: boolean }, user: { __typename: 'PublicUser', id: string, name?: string | null } };

export type StudentPublicApplicationVideoFragment = { __typename: 'PublicApplication', id: string, cohort: { __typename: 'PublicCohort', expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImageId?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PublicAnswer', id: string, title?: string | null, comment?: string | null, media?: { __typename: 'Media', id: string, type: MediaTypeEnum, cloudinaryPublicId: string } | null }> };

export type StudentConversationQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  cohortId: Scalars['String'];
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput> | MessageOrderByWithRelationInput>;
  timezone: Scalars['String'];
}>;


export type StudentConversationQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, isStudent: boolean, bio?: string | null, freeMessagesEnabled: boolean, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, userProfileCoverImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, conversation?: { __typename: 'PrivilegedConversation', id: string, messages: { __typename: 'PaginatedPrivilegedMessageResponse', pageInfo: { __typename: 'PageInfo', activePage: number, perPage: number, totalPages: number, totalCount: number, hasPrevious: boolean, hasNext: boolean }, data: Array<{ __typename: 'PrivilegedMessage', id: string, parentId?: string | null, type: MessageTypeEnum, content?: string | null, sentAt: string, sender: { __typename: 'PublicUser', id: string, name?: string | null, isExpert: boolean, isStudent: boolean, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, entity?: { __typename: 'Media', cloudinaryPublicId: string, mediaId: string } | { __typename: 'PrivilegedApplication', isPublic: boolean, state: ApplicationStateEnum, isScholarship: boolean, isExpired: boolean, privilegedApplicationId: string, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, comment?: string | null, privilegedAnswerId: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | { __typename: 'PrivilegedReview', id: string, rating?: number | null, applicationId: string, isPublicReview?: boolean | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, application: { __typename: 'PrivilegedApplication', id: string, isScholarship: boolean } } | null }> } } | null, cohort?: { __typename: 'PrivilegedCohort', id: string, publishDeadline?: string | null, isScholarshipOnly: boolean, isPaidOnly: boolean, arePaidApplicationsAvailable: boolean, areScholarshipsAvailable: boolean, price: number, hasPublishDeadlineExpired: boolean, publishDeadlineTimeLeft: any, publishWindow?: number | null, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, waitlistEnabled?: boolean | null, bio?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, experts: Array<{ __typename: 'PublicUser', id: string, title?: string | null, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | null } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type ConversationApplicationDetailsFragment = { __typename: 'PrivilegedCohort', id: string, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, expert: { __typename: 'PublicUser', id: string, bio?: string | null, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, experts: Array<{ __typename: 'PublicUser', id: string, title?: string | null, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename: 'Mutation', createMessage: { __typename: 'PrivilegedMessage', id: string, conversation?: { __typename: 'PrivilegedConversation', id: string } | null, entity?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | { __typename: 'PrivilegedApplication' } | { __typename: 'PrivilegedReview' } | null } };

export type SocialLinkFragment = { __typename: 'PublicUser', id: string, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null };

export type StudentUserProfileFragment = { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, isStudent: boolean, bio?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', cloudinaryPublicId: string } | null };

export type GetStudentProfileByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetStudentProfileByUsernameQuery = { __typename: 'Query', userByUsername?: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, isStudent: boolean, bio?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } | null };

export type GetUserPublicApplicationsQueryVariables = Exact<{
  userById: Scalars['String'];
}>;


export type GetUserPublicApplicationsQuery = { __typename: 'Query', userById?: { __typename: 'PublicUser', id: string, publicApplications: Array<{ __typename: 'PublicApplication', id: string, isScholarship: boolean, isPublic: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', totalUpvote: number, canVote: boolean } | null, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', profileImageUrl?: string | null, id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } }> } | null };

export type GetUserCredentialAssignmentReceivedQueryVariables = Exact<{
  userById: Scalars['String'];
}>;


export type GetUserCredentialAssignmentReceivedQuery = { __typename: 'Query', userById?: { __typename: 'PublicUser', id: string, credentialAssignmentReceived: Array<{ __typename: 'PublicCredentialAssignment', createdAt: string, from: { __typename: 'HouseCredentialAssignmentEntityType' } | { __typename: 'PublicCohort', id: string, expert: { __typename: 'PublicUser', username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, credential: { __typename: 'Credential', id: string, name: string, description: string, iconUrl?: string | null } }> } | null };

export type GetPopularStudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularStudentsQuery = { __typename: 'Query', experts: Array<{ __typename: 'PublicUser', username?: string | null }> };

export type VideoGalleryPublicApplicationFragment = { __typename: 'PublicApplication', id: string, isScholarship: boolean, isPublic: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', totalUpvote: number, canVote: boolean } | null, answers: Array<{ __typename: 'PublicAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, cohort: { __typename: 'PublicCohort', scholarshipVotesThreshold: number, expert: { __typename: 'PublicUser', profileImageUrl?: string | null, id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } } };

export type StudentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentProfileQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, isStudent: boolean, bio?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, userProfileCoverImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, applications: Array<{ __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, cohort: { __typename: 'PrivilegedCohort', expert: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> }> } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type StudentProfileApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, cohort: { __typename: 'PrivilegedCohort', expert: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type StudentPrivilegedCohortFragment = { __typename: 'PrivilegedCohort', id: string, name: string, description?: string | null, price: number, state: CohortStateEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, myApplications: Array<{ __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum }> };

export type StudentPrivilegedConversationFragment = { __typename: 'PrivilegedConversation', id: string, totalUnreadMessages: number };

export type StudentProfileApplicationMediaConfigFragment = { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } };

export type StudentProfileApplicationQueryVariables = Exact<{
  applicationId: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type StudentProfileApplicationQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, isStudent: boolean, bio?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, userProfileCoverImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isExpirationExtended: boolean, isPublic: boolean, isScholarship: boolean, shareableAssetMediaUrl?: { __typename: 'ShareableAssetMediaUrl', lowQuality: string, higQuality: string } | null, cohort: { __typename: 'PrivilegedCohort', id: string, scholarshipVotesThreshold: number, name: string, hasPublishDeadlineExpired: boolean, scholarshipReferralsThreshold: number, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, state: CohortStateEnum, category?: { __typename: 'PublicCategory', id: string, name: string } | null, expert: { __typename: 'PublicUser', id: string, bio?: string | null, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string, id: string } | null, userProfileImage?: { __typename: 'Media', url?: string | null, id: string, cloudinaryPublicId: string } | null } }, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, shortCode?: string | null, totalApprovedReferrals: number } | null, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, rating?: number | null, updatedAt: string, watched: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | null } | null, MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null } } };

export type ToggleApplicationVisibilityMutationVariables = Exact<{
  applicationId: Scalars['ID'];
}>;


export type ToggleApplicationVisibilityMutation = { __typename: 'Mutation', toggleApplicationVisibility: { __typename: 'PrivilegedApplication', id: string, isPublic: boolean, isScholarship: boolean } };

export type StudentProfilePrivilegedCoachingApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isPublic: boolean, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, totalApprovedReferrals: number, shortCode?: string | null } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type StudentProfileCoachingUserFragment = { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, isStudent: boolean, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isPublic: boolean, isScholarship: boolean, isExpirationExtended: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, totalApprovedReferrals: number, shortCode?: string | null } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null }, category?: { __typename: 'PublicCategory', id: string, name: string } | null }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, rating?: number | null, updatedAt: string, watched: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | null };

export type FeedBackStudentProfilePrivilegedApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isExpirationExtended: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, shortCode?: string | null } | null, cohort: { __typename: 'PrivilegedCohort', id: string, scholarshipVotesThreshold: number, category?: { __typename: 'PublicCategory', id: string, name: string } | null, expert: { __typename: 'PublicUser', id: string, bio?: string | null, name?: string | null, username?: string | null, profileImageUrl?: string | null, userProfileAlternateImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, rating?: number | null, createdAt: string, updatedAt: string, watched: string, user: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type FeedbackAuditionPrivilegedAnswerFragment = { __typename: 'PrivilegedAnswer', id: string, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type FeedbackReviewPrivilegedReviewFragment = { __typename: 'PrivilegedReview', id: string, data?: string | null, rating?: number | null, createdAt: string, updatedAt: string, watched: string, user: { __typename: 'PublicUser', id: string, username?: string | null, name?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type StudentProfilePrivilegedOpportunityApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isPublic: boolean, isScholarship: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, totalApprovedReferrals: number, shortCode?: string | null } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, state: CohortStateEnum, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null } }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> };

export type StudentProfileOpportunityUserFragment = { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, isStudent: boolean, bio?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null, application?: { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isPublic: boolean, isScholarship: boolean, isExpirationExtended: boolean, scholarshipApplication?: { __typename: 'PublicScholarshipApplication', id: string, totalUpvote: number, totalApprovedReferrals: number, shortCode?: string | null } | null, cohort: { __typename: 'PrivilegedCohort', id: string, name: string, state: CohortStateEnum, hasPublishDeadlineExpired: boolean, scholarshipVotesThreshold: number, scholarshipReferralsThreshold: number, publishDeadline?: string | null, publishDeadlineTimeLeft: any, publishWindow?: number | null, type: CohortTypeEnum, expert: { __typename: 'PublicUser', id: string, name?: string | null, profileImageUrl?: string | null, bio?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', id: string, url?: string | null, cloudinaryPublicId: string } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }, category?: { __typename: 'PublicCategory', id: string, name: string } | null }, reviews: Array<{ __typename: 'PrivilegedReview', id: string, data?: string | null, createdAt: string, rating?: number | null, updatedAt: string, watched: string, user: { __typename: 'PublicUser', id: string, username?: string | null, profileImageUrl?: string | null, title?: string | null, name?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null, userProfileAlternateImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string, url?: string | null } | null }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }>, answers: Array<{ __typename: 'PrivilegedAnswer', id: string, data?: string | null, question: { __typename: 'PublicQuestion', id: string, type: QuestionTypeEnum }, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null }> } | null };

export type StudentProfileOpportunityResultPrivilegedApplicationFragment = { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum, isPublic: boolean, isScholarship: boolean };

export type ApplicationRefundMutationVariables = Exact<{
  applicationId: Scalars['String'];
}>;


export type ApplicationRefundMutation = { __typename: 'Mutation', applicationRefund: { __typename: 'ApplicationRefundErrorResponse', message?: string | null, type: ApplicationRefundErrorType } | { __typename: 'PrivilegedApplication', id: string, state: ApplicationStateEnum } };

export type ScholarshipToPaidApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID'];
}>;


export type ScholarshipToPaidApplicationMutation = { __typename: 'Mutation', scholarshipToPaidApplication: { __typename: 'PrivilegedApplication', id: string } | { __typename: 'ScholarshipToPaidApplicationErrorResponse', type: ScholarshipToPaidApplicationErrorType, message: string } };

export type StudentLayoutProfileSocialFragment = { __typename: 'CurrentUser', id: string, name?: string | null, username?: string | null, profileImageUrl?: string | null, isStudent: boolean, bio?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, soundcloudUrl?: string | null, tiktokUrl?: string | null, facebookUrl?: string | null, twitterUsername?: string | null, instagramUsername?: string | null, linkedInUsername?: string | null, soundcloudUsername?: string | null, tiktokUsername?: string | null, facebookUsername?: string | null, spotifyUrl?: string | null, userProfileImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, userProfileCoverImage?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null };

export type ReviewsFromUserQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type ReviewsFromUserQuery = { __typename: 'Query', MediaConfig: { __typename: 'MediaConfig', APPLICATION_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p: { __typename: 'MediaVideoConfiguration', transformation?: any | null }, REVIEW_VIDEO_720p_WITH_WATERMARK_05022022: { __typename: 'MediaVideoConfiguration', transformation?: any | null } }, userByUsername?: { __typename: 'PublicUser', reviews?: Array<{ __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }> | null } | null };

export type FeedReviewsQueryVariables = Exact<{
  loadPrependedReviewId: Scalars['Boolean'];
  prependedReviewId: Scalars['ID'];
}>;


export type FeedReviewsQuery = { __typename: 'Query', featuredReviews: Array<{ __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } }>, publicReview?: { __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null };

export type ReviewByIdQueryVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type ReviewByIdQuery = { __typename: 'Query', publicReview?: { __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null };

export type LikeReviewMutationVariables = Exact<{
  reviewId: Scalars['ID'];
}>;


export type LikeReviewMutation = { __typename: 'Mutation', likeReview: { __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } };

export type ReviewFragmentFragment = { __typename: 'PublicReview', id: string, likeCount?: number | null, likedByMe?: boolean | null, mediaUrlWithTransformations?: string | null, thread?: { __typename: 'PublicThread', items: { __typename: 'PaginatedPublicThreadItemResponse', pageInfo: { __typename: 'PageInfo', totalCount: number } } } | null, application?: { __typename: 'Application', id: string, cohort: { __typename: 'Cohort', id: string, prize?: string | null, price: number, symbol?: string | null, category?: { __typename: 'Category', name: string } | null }, user: { __typename: 'User', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } } | null, media?: { __typename: 'Media', id: string, cloudinaryPublicId: string } | null, user: { __typename: 'PublicUser', id: string, name?: string | null, username?: string | null, userProfileImage?: { __typename: 'Media', cloudinaryPublicId: string } | null } };

export type WalletPageQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletPageQuery = { __typename: 'Query', viewer?: { __typename: 'CurrentUser', id: string, balance: number, createSetupIntentForStripe?: { __typename: 'StripeSetupIntent', clientSecret: string } | null, storedCardPaymentMethodsForStripe: Array<{ __typename: 'StripeStoredCardPaymentMethod', id: string, brand: StripeStoredCardBrand, last4: string }>, refundsForStripe: Array<{ __typename: 'StripeRefund', id: string, amount: number, brand: StripeStoredCardBrand, last4: string }> } | null };

export type StudentWithdrawMutationVariables = Exact<{
  input: WithdrawInput;
}>;


export type StudentWithdrawMutation = { __typename: 'Mutation', withdraw: Array<{ __typename: 'StripeRefundTransactionIntent', refundIntent: { __typename: 'StripeRefundIntent', id: string } }> };

export type RemoveStudentCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type RemoveStudentCardMutation = { __typename: 'Mutation', removeCard: { __typename: 'StripeStoredCardPaymentMethod', id: string } };

export type SyncUserMutationVariables = Exact<{
  auth0Key: Scalars['String'];
}>;


export type SyncUserMutation = { __typename: 'Mutation', syncUser: boolean };

export const ApplicationCardPrivilegedApplicationFragmentDoc = gql`
    fragment ApplicationCardPrivilegedApplication on PrivilegedApplication {
  id
  state
  isScholarship
  scholarshipApplication {
    id
    totalUpvote
  }
  cohort {
    id
    name
    hasPublishDeadlineExpired
    scholarshipVotesThreshold
    publishDeadline(format: RELATIVE)
    publishWindow
    type
    expert {
      id
      name
      profileImageUrl
      userProfileImage {
        url
      }
      userProfileAlternateImage {
        cloudinaryPublicId
      }
    }
  }
  answers {
    id
    media {
      id
      cloudinaryPublicId
    }
  }
}
    `;
export const ApplicationCardMediaConfigFragmentDoc = gql`
    fragment ApplicationCardMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
}
    `;
export const AuditionFragmentDoc = gql`
    fragment Audition on PublicFeaturedApplication {
  application {
    id
    isPublic
    cohort {
      expert {
        name
        profileImageUrl
        userProfileAlternateImage {
          cloudinaryPublicId
        }
      }
    }
    createdAt(format: RELATIVE)
    answers {
      media {
        id
        cloudinaryPublicId
      }
    }
    user {
      id
      name
      username
      userProfileImage {
        id
        cloudinaryPublicId
      }
    }
  }
  review {
    id
    media {
      id
      cloudinaryPublicId
    }
    createdAt(format: RELATIVE)
  }
}
    `;
export const AuditionMediaConfigFragmentDoc = gql`
    fragment AuditionMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p_WITH_WATERMARK_05022022 {
    transformation
  }
  STATUS_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p {
    transformation
  }
}
    `;
export const PublicFeaturedFlagFragmentDoc = gql`
    fragment PublicFeaturedFlag on PublicFeaturedFlag {
  key
  name
  options
}
    `;
export const HeaderProfileUserFragmentDoc = gql`
    fragment HeaderProfileUser on CurrentUser {
  id
  name
  profileImageUrl
  isExpert
  isStudent
  userProfileImage {
    url
  }
}
    `;
export const VideoPlayerMediaConfigFragmentDoc = gql`
    fragment VideoPlayerMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p_WITH_WATERMARK_05022022 {
    transformation
  }
}
    `;
export const StudentCardViewerFragmentDoc = gql`
    fragment StudentCardViewer on CurrentUser {
  id
  name
  email
  phone
  profileImageUrl
  userProfileImage {
    url
  }
}
    `;
export const ApplicationCardStudentFragmentDoc = gql`
    fragment ApplicationCardStudent on PrivilegedApplication {
  id
  state
  cohortId
  isScholarship
  answers {
    id
    media {
      id
      cloudinaryPublicId
      url
    }
  }
}
    `;
export const UserProfileFormUserFragmentDoc = gql`
    fragment UserProfileFormUser on CurrentUser {
  id
  email
  phone
  name
  username
  hasAcceptedTOS
  userProfileImage {
    id
    cloudinaryPublicId
  }
  userProfileCoverImage {
    id
    cloudinaryPublicId
  }
  bio
  state
  city
  twitterUsername
  instagramUsername
  linkedInUsername
  soundcloudUsername
  tiktokUsername
  facebookUsername
  spotifyArtistId
}
    `;
export const ApplicationVideoUploaderCohortFragmentDoc = gql`
    fragment ApplicationVideoUploaderCohort on PublicCohort {
  id
  expert {
    id
    name
    username
  }
}
    `;
export const ApplicationVideoUploaderViewerFragmentDoc = gql`
    fragment ApplicationVideoUploaderViewer on CurrentUser {
  id
  name
  email
  firstName
  phone
}
    `;
export const ApplicationVideoQuestionFragmentDoc = gql`
    fragment ApplicationVideoQuestion on PublicQuestion {
  id
  type
  title
  prompt
  maxDuration
}
    `;
export const ApplicationEssayQuestionFragmentDoc = gql`
    fragment ApplicationEssayQuestion on PublicQuestion {
  id
  type
  prompt
  maxDuration
}
    `;
export const ApplicationQuestionFragmentDoc = gql`
    fragment ApplicationQuestion on PublicQuestion {
  id
  ...ApplicationVideoQuestion
  ...ApplicationEssayQuestion
}
    ${ApplicationVideoQuestionFragmentDoc}
${ApplicationEssayQuestionFragmentDoc}`;
export const ApplicationQuestionCohortFragmentDoc = gql`
    fragment ApplicationQuestionCohort on PublicCohort {
  id
  category {
    id
    name
  }
}
    `;
export const ReviewPrivilegedReviewFragmentDoc = gql`
    fragment ReviewPrivilegedReview on PrivilegedReview {
  id
  data
  createdAt
  user {
    id
    username
    profileImageUrl
    title
    userProfileImage {
      id
      cloudinaryPublicId
      url
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
      url
    }
  }
  media {
    id
    cloudinaryPublicId
  }
}
    `;
export const ApplicationAnswerEssayAnswerFragmentDoc = gql`
    fragment ApplicationAnswerEssayAnswer on PrivilegedAnswer {
  id
  data
}
    `;
export const ApplicationAnswerVideoAnswerFragmentDoc = gql`
    fragment ApplicationAnswerVideoAnswer on PrivilegedAnswer {
  id
  media {
    id
    cloudinaryPublicId
  }
}
    `;
export const ApplicationAnswerFragmentDoc = gql`
    fragment ApplicationAnswer on PrivilegedAnswer {
  id
  question {
    id
    type
  }
  ...ApplicationAnswerEssayAnswer
  ...ApplicationAnswerVideoAnswer
}
    ${ApplicationAnswerEssayAnswerFragmentDoc}
${ApplicationAnswerVideoAnswerFragmentDoc}`;
export const ApplicationDetailPageDetailApplicationFragmentDoc = gql`
    fragment ApplicationDetailPageDetailApplication on PrivilegedApplication {
  id
  state
  createdAt
  user {
    username
  }
  reviews(onlyPublicExperts: true) {
    id
    ...ReviewPrivilegedReview
  }
  answers {
    id
    ...ApplicationAnswer
  }
}
    ${ReviewPrivilegedReviewFragmentDoc}
${ApplicationAnswerFragmentDoc}`;
export const ReviewCreateApplicationFragmentDoc = gql`
    fragment ReviewCreateApplication on PrivilegedApplication {
  id
  state
  answers {
    id
    media {
      id
      url
    }
    data
    question {
      id
      type
    }
  }
}
    `;
export const CollabReviewFragmentDoc = gql`
    fragment CollabReview on PublicReview {
  id
  application {
    id
    user {
      id
      name
      username
      userProfileImage {
        cloudinaryPublicId
      }
    }
  }
  mediaUrlWithTransformations
  media {
    id
    cloudinaryPublicId
  }
  user {
    id
    name
    username
    userProfileImage {
      cloudinaryPublicId
    }
  }
}
    `;
export const CollabRatedApplicationFragmentDoc = gql`
    fragment CollabRatedApplication on PublicApplication {
  id
  isPublic
  answers {
    id
    media {
      cloudinaryPublicId
    }
  }
  user {
    id
    username
  }
}
    `;
export const CollabHeaderUserFragmentDoc = gql`
    fragment CollabHeaderUser on PublicUser {
  id
  name
  username
  profileImageUrl
  waitlistEnabled
  userProfileImage {
    cloudinaryPublicId
  }
  userProfileVideo {
    cloudinaryPublicId
  }
  bio
  numberOfCredentialsGranted
  credentialAssignmentGranted(credentialNames: [Protege, TopProspect]) {
    id
    ratedApplication {
      ...CollabRatedApplication
    }
    to {
      __typename
      ... on PublicUser {
        id
        username
        name
        isStudent
        userProfileImage {
          cloudinaryPublicId
        }
      }
      ... on PublicCohort {
        id
        expert {
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
      }
    }
    credential {
      id
      name
      description
      iconUrl
    }
    createdAt(format: NUMERIC)
  }
  cohorts(role: EXPERT) {
    id
    state
    price
    prize
    name
    type
    description
    paidApplicationLimit
    totalPaidApplications
    publishWindow
    updateStatus
  }
  bio
}
    ${CollabRatedApplicationFragmentDoc}`;
export const CollabCohortFragmentDoc = gql`
    fragment CollabCohort on PublicCohort {
  id
  type
  description
  updateStatus
  state
  symbol
  isActive
  price
  prize
}
    `;
export const CollabPageUserFragmentDoc = gql`
    fragment CollabPageUser on PublicUser {
  ...CollabHeaderUser
  title
  waitlistEnabled
  expertCredentials {
    iconCloudinaryPublicId
    title
    subtitle
    url
  }
  cohorts(role: EXPERT) {
    id
    state
    ...CollabCohort
  }
}
    ${CollabHeaderUserFragmentDoc}
${CollabCohortFragmentDoc}`;
export const MemoizedVideoPlayerMediaConfigFragmentDoc = gql`
    fragment MemoizedVideoPlayerMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
}
    `;
export const CollabPageMediaConfigFragmentDoc = gql`
    fragment CollabPageMediaConfig on MediaConfig {
  ...MemoizedVideoPlayerMediaConfig
}
    ${MemoizedVideoPlayerMediaConfigFragmentDoc}`;
export const CollabGalleryPublicApplicationFragmentDoc = gql`
    fragment CollabGalleryPublicApplication on PublicApplication {
  id
  isScholarship
  isPublic
  answers {
    id
    media {
      id
      cloudinaryPublicId
    }
  }
}
    `;
export const StudentConversationMediaConfigFragmentDoc = gql`
    fragment StudentConversationMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p {
    transformation
  }
  REVIEW_VIDEO_720p_WITH_WATERMARK_05022022 {
    transformation
  }
}
    `;
export const ConversationAuditionPrivilegedAnswerFragmentDoc = gql`
    fragment ConversationAuditionPrivilegedAnswer on PrivilegedAnswer {
  __typename
  privilegedAnswerId: id
  comment
  media {
    id
    cloudinaryPublicId
  }
}
    `;
export const ConversationPrivilegedApplicationFragmentDoc = gql`
    fragment ConversationPrivilegedApplication on PrivilegedApplication {
  __typename
  privilegedApplicationId: id
  isPublic
  state
  isScholarship
  isExpired
  answers {
    id
    ...ConversationAuditionPrivilegedAnswer
  }
}
    ${ConversationAuditionPrivilegedAnswerFragmentDoc}`;
export const ConversationPrivilegedReviewFragmentDoc = gql`
    fragment ConversationPrivilegedReview on PrivilegedReview {
  __typename
  id
  rating
  isPublicReview: isPublic
  applicationId
  media {
    id
    cloudinaryPublicId
  }
  user {
    id
    name
    profileImageUrl
    userProfileImage {
      id
      cloudinaryPublicId
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
  }
  application {
    id
    isScholarship
  }
}
    `;
export const ConversationDataFragmentDoc = gql`
    fragment ConversationData on PrivilegedMessage {
  __typename
  id
  parentId
  type
  content
  sender {
    id
    name
    isExpert
    isStudent
    profileImageUrl
    userProfileImage {
      id
      cloudinaryPublicId
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
  }
  sentAt(format: TWELVE_HOURS, timezone: $timezone)
  entity {
    ... on PrivilegedApplication {
      ...ConversationPrivilegedApplication
    }
    ... on PrivilegedReview {
      ...ConversationPrivilegedReview
    }
    ... on Media {
      mediaId: id
      __typename
      cloudinaryPublicId
    }
  }
}
    ${ConversationPrivilegedApplicationFragmentDoc}
${ConversationPrivilegedReviewFragmentDoc}`;
export const ConversationMessageCohortFragmentDoc = gql`
    fragment ConversationMessageCohort on PrivilegedCohort {
  __typename
  id
  publishDeadline(format: RELATIVE)
  isScholarshipOnly
  isPaidOnly
  arePaidApplicationsAvailable
  areScholarshipsAvailable
  price
  hasPublishDeadlineExpired
  expert {
    id
    name
    username
    waitlistEnabled
  }
}
    `;
export const CategoryFilterPublicCategoryFragmentDoc = gql`
    fragment CategoryFilterPublicCategory on PublicCategory {
  id
  name
  fontColor
  backgroundColor
}
    `;
export const CohortTagsPublicCohortFragmentDoc = gql`
    fragment CohortTagsPublicCohort on PublicCohort {
  id
  category {
    id
    name
    backgroundColor
    fontColor
  }
  comingSoon
}
    `;
export const FeaturedCohortsListPublicCohortFragmentDoc = gql`
    fragment FeaturedCohortsListPublicCohort on PublicCohort {
  id
  name
  prize
  expert {
    id
    name
    bio
    profileImageUrl
    username
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
    userProfileImage {
      id
      cloudinaryPublicId
    }
  }
  ...CohortTagsPublicCohort
}
    ${CohortTagsPublicCohortFragmentDoc}`;
export const PublicApplicationFragmentDoc = gql`
    fragment PublicApplication on PublicApplication {
  id
  answers {
    id
    media {
      id
      type
      cloudinaryPublicId
    }
  }
  user {
    id
    name
    username
    userProfileImage {
      id
      cloudinaryPublicId
    }
  }
}
    `;
export const FeedHomePageBaseFeaturedApplicationFragmentDoc = gql`
    fragment FeedHomePageBaseFeaturedApplication on BaseFeaturedApplication {
  id
  sortOrder
  application {
    id
    createdAt(format: RELATIVE)
    cohort {
      id
      expert {
        id
        name
        username
        profileImageUrl
        userProfileAlternateImage {
          cloudinaryPublicId
        }
      }
    }
    ...PublicApplication
  }
  review {
    id
    createdAt(format: RELATIVE)
    media {
      id
      cloudinaryPublicId
    }
  }
}
    ${PublicApplicationFragmentDoc}`;
export const FeedExpertAvatarFragmentDoc = gql`
    fragment FeedExpertAvatar on PublicUser {
  id
  name
  username
  userProfileAlternateImage {
    id
    cloudinaryPublicId
  }
  userProfileImage {
    id
    cloudinaryPublicId
  }
  profileImageUrl
}
    `;
export const FeedExpertListFragmentDoc = gql`
    fragment FeedExpertList on PublicFeaturedExpert {
  id
  expert {
    id
    name
    bio
    ...FeedExpertAvatar
  }
}
    ${FeedExpertAvatarFragmentDoc}`;
export const FeedExpertListContentFragmentDoc = gql`
    fragment FeedExpertListContent on PublicFeaturedExpert {
  id
  expert {
    ...FeedExpertAvatar
  }
  ...FeedExpertList
}
    ${FeedExpertAvatarFragmentDoc}
${FeedExpertListFragmentDoc}`;
export const FeedHomePageFeaturedExpertFragmentDoc = gql`
    fragment FeedHomePageFeaturedExpert on PublicFeaturedExpert {
  id
  hoursToReview
  status
  type
  customVideo {
    id
    cloudinaryPublicId
  }
  cohort {
    id
    updateStatus
    expert {
      id
      waitlistEnabled
    }
  }
  expert {
    id
    name
    userProfileImage {
      id
      cloudinaryPublicId
    }
    bio
    profileImageUrl
    userProfileVideo {
      id
      cloudinaryPublicId
    }
    ...FeedExpertAvatar
  }
  id
  expert {
    id
    username
    name
    userProfileImage {
      id
      cloudinaryPublicId
    }
  }
  headline
  subHeadline
  featuredApplications {
    application {
      id
      isPublic
      createdAt(format: RELATIVE)
      cohort {
        expert {
          name
          profileImageUrl
          userProfileAlternateImage {
            cloudinaryPublicId
          }
        }
      }
      answers {
        media {
          id
          cloudinaryPublicId
        }
      }
      user {
        id
        name
        username
        userProfileImage {
          id
          cloudinaryPublicId
        }
      }
    }
    review {
      id
      createdAt(format: RELATIVE)
      media {
        id
        cloudinaryPublicId
      }
    }
  }
  ...FeedExpertListContent
}
    ${FeedExpertAvatarFragmentDoc}
${FeedExpertListContentFragmentDoc}`;
export const RatedApplicationFragmentDoc = gql`
    fragment RatedApplication on PublicApplication {
  id
  isPublic
  answers {
    id
    media {
      cloudinaryPublicId
    }
  }
  user {
    id
    username
  }
}
    `;
export const HeaderUserFragmentDoc = gql`
    fragment HeaderUser on PublicUser {
  id
  name
  username
  profileImageUrl
  waitlistEnabled
  userProfileImage {
    cloudinaryPublicId
  }
  userProfileVideo {
    cloudinaryPublicId
  }
  bio
  numberOfCredentialsGranted
  credentialAssignmentGranted(credentialNames: [Protege, TopProspect]) {
    id
    ratedApplication {
      ...RatedApplication
    }
    to {
      __typename
      ... on PublicUser {
        id
        username
        name
        isStudent
        userProfileImage {
          cloudinaryPublicId
        }
      }
      ... on PublicCohort {
        id
        expert {
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
      }
    }
    credential {
      id
      name
      description
      iconUrl
    }
    createdAt(format: NUMERIC)
  }
  cohorts(role: EXPERT) {
    id
    state
    price
    prize
    name
    type
    description
    paidApplicationLimit
    totalPaidApplications
    publishWindow
    updateStatus
  }
  bio
}
    ${RatedApplicationFragmentDoc}`;
export const PanelistsPublicUserFragmentDoc = gql`
    fragment PanelistsPublicUser on PublicUser {
  id
  name
  profileImageUrl
  title
  userProfileAlternateImage {
    id
    cloudinaryPublicId
  }
}
    `;
export const TypeSelectorCharityBannerFragmentDoc = gql`
    fragment TypeSelectorCharityBanner on CommonTagContent {
  iconCloudinaryPublicId
  title
  url
}
    `;
export const ApplicationStartButtonLabelPublicCohortFragmentDoc = gql`
    fragment ApplicationStartButtonLabelPublicCohort on PublicCohort {
  id
  state
  type
  isPaidOnly
  isScholarshipOnly
  price
  scholarshipVotesThreshold
}
    `;
export const TypeSelectorPublicCohortFragmentDoc = gql`
    fragment TypeSelectorPublicCohort on PublicCohort {
  id
  state
  type
  isPaidOnly
  isScholarshipOnly
  areApplicationsAvailable
  arePaidApplicationsAvailable
  areScholarshipsAvailable
  publishDeadline(format: RELATIVE)
  hasPublishDeadlineExpired
  scholarshipDeadline(format: RELATIVE)
  hasScholarshipDeadlineExpired
  scholarshipWindow
  publishWindow
  charityBadge {
    title
    ...TypeSelectorCharityBanner
  }
  scholarshipVotesThreshold
  scholarshipReferralsThreshold
  price
  aggregateApplicationLimit
  totalApplicationsRemaining
  category {
    name
  }
  rules
  ...ApplicationStartButtonLabelPublicCohort
}
    ${TypeSelectorCharityBannerFragmentDoc}
${ApplicationStartButtonLabelPublicCohortFragmentDoc}`;
export const HeaderCohortFragmentDoc = gql`
    fragment HeaderCohort on PublicCohort {
  id
  isActive
  state
  comingSoon
  price
  prize
  responseDetail
  name
  type
  applicationExpirationDeadline(format: RELATIVE)
  description
  publishDeadlineTimeLeft
  hasPublishDeadlineExpired
  hasScholarshipDeadlineExpired
  paidApplicationLimit
  totalPaidApplications
  areScholarshipsAvailable
  areApplicationsAvailable
  arePaidApplicationsAvailable
  isScholarshipOnly
  isPaidOnly
  scholarshipVotesThreshold
  scholarshipReferralsThreshold
  scholarshipWindow
  publishWindow
  publishDeadline(format: RELATIVE)
  scholarshipDeadline(format: RELATIVE)
  scholarshipApplicationLimit
  scholarshipsAwarded
  totalApplicationsRemaining
  aggregateApplicationLimit
  numberOfCredentialsGranted
  credentialAssignmentGranted(credentialNames: [Protege, TopProspect]) {
    id
    ratedApplication {
      ...RatedApplication
    }
    to {
      __typename
      ... on PublicUser {
        id
        username
        name
        isStudent
        userProfileImage {
          cloudinaryPublicId
        }
      }
      ... on PublicCohort {
        id
        expert {
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
      }
    }
    credential {
      id
      name
      description
      iconUrl
    }
    createdAt(format: NUMERIC)
  }
  updateStatus
  charityBadge {
    iconCloudinaryPublicId
    title
    subtitle
  }
  category {
    id
    name
  }
  experts(roles: [Expert]) {
    id
    ...PanelistsPublicUser
  }
  whatToSend {
    iconCloudinaryPublicId
    title
    subtitle
    url
  }
  whatYouReceive {
    iconCloudinaryPublicId
    title
    subtitle
    url
  }
  details {
    title
    active
    content {
      term
      definition
    }
  }
  ...TypeSelectorPublicCohort
}
    ${RatedApplicationFragmentDoc}
${PanelistsPublicUserFragmentDoc}
${TypeSelectorPublicCohortFragmentDoc}`;
export const CharityBannerFragmentDoc = gql`
    fragment CharityBanner on CommonTagContent {
  iconCloudinaryPublicId
  title
  url
}
    `;
export const RaiseExpertPageUserFragmentDoc = gql`
    fragment RaiseExpertPageUser on PublicUser {
  ...HeaderUser
  title
  waitlistEnabled
  expertCredentials {
    iconCloudinaryPublicId
    title
    subtitle
    url
  }
  cohorts(role: EXPERT) {
    id
    timeline
    type
    description
    updateStatus
    experts(roles: [Expert]) {
      id
      ...PanelistsPublicUser
    }
    sampleAuditionVideo {
      cloudinaryPublicId
    }
    sampleReviewVideo {
      cloudinaryPublicId
    }
    ...HeaderCohort
    charityBadge {
      ...CharityBanner
    }
  }
}
    ${HeaderUserFragmentDoc}
${PanelistsPublicUserFragmentDoc}
${HeaderCohortFragmentDoc}
${CharityBannerFragmentDoc}`;
export const SampleVideosMediaConfigFragmentDoc = gql`
    fragment SampleVideosMediaConfig on MediaConfig {
  ...MemoizedVideoPlayerMediaConfig
}
    ${MemoizedVideoPlayerMediaConfigFragmentDoc}`;
export const RaiseExpertPageMediaConfigFragmentDoc = gql`
    fragment RaiseExpertPageMediaConfig on MediaConfig {
  ...SampleVideosMediaConfig
}
    ${SampleVideosMediaConfigFragmentDoc}`;
export const FeaturedApplicationsBaseFeaturedApplicationFragmentDoc = gql`
    fragment FeaturedApplicationsBaseFeaturedApplication on BaseFeaturedApplication {
  id
  application {
    id
    createdAt(format: RELATIVE)
    cohort {
      id
      expert {
        id
        name
        username
        profileImageUrl
        userProfileAlternateImage {
          cloudinaryPublicId
        }
      }
    }
    ...PublicApplication
  }
}
    ${PublicApplicationFragmentDoc}`;
export const RaiseHomePageBaseFeaturedApplicationFragmentDoc = gql`
    fragment RaiseHomePageBaseFeaturedApplication on BaseFeaturedApplication {
  id
  sortOrder
  ...FeaturedApplicationsBaseFeaturedApplication
}
    ${FeaturedApplicationsBaseFeaturedApplicationFragmentDoc}`;
export const FeaturedExpertImagePublicUserFragmentDoc = gql`
    fragment FeaturedExpertImagePublicUser on PublicUser {
  id
  name
  userProfileImage {
    id
    cloudinaryPublicId
  }
}
    `;
export const RaiseHomePageFeaturedExpertFragmentDoc = gql`
    fragment RaiseHomePageFeaturedExpert on PublicFeaturedExpert {
  id
  expert {
    id
    name
    username
    userProfileImage {
      id
      cloudinaryPublicId
    }
    ...FeaturedExpertImagePublicUser
  }
  headline
  subHeadline
  type
  updateStatus
  featuredApplications {
    application {
      id
      isPublic
      createdAt(format: RELATIVE)
      cohort {
        expert {
          name
          profileImageUrl
          userProfileAlternateImage {
            cloudinaryPublicId
          }
        }
      }
      answers {
        media {
          id
          cloudinaryPublicId
        }
      }
      user {
        id
        name
        username
        userProfileImage {
          id
          cloudinaryPublicId
        }
      }
    }
    review {
      id
      createdAt(format: RELATIVE)
      media {
        id
        cloudinaryPublicId
      }
    }
  }
}
    ${FeaturedExpertImagePublicUserFragmentDoc}`;
export const ExpertsSectionPublicFeaturedExpertFragmentDoc = gql`
    fragment ExpertsSectionPublicFeaturedExpert on PublicFeaturedExpert {
  id
  expert {
    id
    username
    ...FeaturedExpertImagePublicUser
  }
  headline
  subHeadline
}
    ${FeaturedExpertImagePublicUserFragmentDoc}`;
export const MatchedCohortsListPublicCohortFragmentDoc = gql`
    fragment MatchedCohortsListPublicCohort on PublicCohort {
  id
  name
  description
  prize
  arePaidApplicationsAvailable
  price
  type
  areScholarshipsAvailable
  scholarshipVotesThreshold
  expert {
    id
    name
    bio
    username
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
    userProfileImage {
      id
      cloudinaryPublicId
    }
  }
  prizeDetails {
    title
    textMapping
  }
}
    `;
export const StudentPublicApplicationScholarshipFragmentDoc = gql`
    fragment StudentPublicApplicationScholarship on PublicApplication {
  id
  scholarshipApplication {
    id
    totalUpvote
    canVote
    hasVoted
    totalApprovedReferrals
  }
  cohort {
    scholarshipVotesThreshold
    hasPublishDeadlineExpired
  }
  user {
    id
    name
  }
}
    `;
export const StudentPublicApplicationFeedbackDetailFragmentDoc = gql`
    fragment StudentPublicApplicationFeedbackDetail on PublicApplication {
  id
  isPublic
  isScholarship
  cohort {
    id
    hasPublishDeadlineExpired
    expert {
      id
      name
      username
      bio
      userProfileImage {
        id
        cloudinaryPublicId
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
      }
    }
  }
  createdAt(format: SHORT)
  user {
    id
    name
    username
    bio
    userProfileImage {
      cloudinaryPublicId
    }
  }
  ...StudentPublicApplicationScholarship
}
    ${StudentPublicApplicationScholarshipFragmentDoc}`;
export const StudentPublicApplicationVideoFragmentDoc = gql`
    fragment StudentPublicApplicationVideo on PublicApplication {
  id
  cohort {
    expert {
      id
      name
      username
      profileImageUrl
      userProfileAlternateImageId
      userProfileImage {
        id
        cloudinaryPublicId
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
      }
    }
  }
  answers {
    id
    title
    comment
    media {
      id
      type
      cloudinaryPublicId
    }
  }
}
    `;
export const StudentPublicFeedbackFragmentDoc = gql`
    fragment StudentPublicFeedback on PublicApplication {
  id
  isPublic
  createdAt(format: SHORT)
  reviews {
    id
    createdAt(format: RELATIVE)
    media {
      id
      type
      cloudinaryPublicId
    }
  }
  ...StudentPublicApplicationFeedbackDetail
  ...StudentPublicApplicationVideo
}
    ${StudentPublicApplicationFeedbackDetailFragmentDoc}
${StudentPublicApplicationVideoFragmentDoc}`;
export const StudentPublicUserFeedbackFragmentDoc = gql`
    fragment StudentPublicUserFeedback on PublicUser {
  id
  name
  username
  publicApplication(where: {id: $applicationId}) {
    ...StudentPublicFeedback
  }
}
    ${StudentPublicFeedbackFragmentDoc}`;
export const StudentPublicApplicationVideoMediaConfigFragmentDoc = gql`
    fragment StudentPublicApplicationVideoMediaConfig on MediaConfig {
  ...MemoizedVideoPlayerMediaConfig
}
    ${MemoizedVideoPlayerMediaConfigFragmentDoc}`;
export const StudentFeedbackVideoFragmentDoc = gql`
    fragment StudentFeedbackVideo on PublicApplication {
  id
  isPublic
  user {
    id
    name
  }
  cohort {
    expert {
      id
      name
      username
      profileImageUrl
      userProfileAlternateImageId
      userProfileImage {
        id
        cloudinaryPublicId
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
      }
    }
  }
  reviews {
    id
    isPublic
    createdAt(format: RELATIVE)
    media {
      id
      type
      cloudinaryPublicId
    }
  }
}
    `;
export const StudentPublicApplicationDetailFragmentDoc = gql`
    fragment StudentPublicApplicationDetail on PublicApplication {
  id
  isPublic
  isScholarship
  scholarshipApplication {
    id
    totalUpvote
    canVote
    hasVoted
  }
  cohort {
    id
    scholarshipVotesThreshold
    hasPublishDeadlineExpired
    expert {
      id
      name
      username
    }
  }
  createdAt(format: SHORT)
  user {
    id
    name
    bio
    username
    userProfileImage {
      cloudinaryPublicId
    }
  }
  ...StudentPublicApplicationScholarship
}
    ${StudentPublicApplicationScholarshipFragmentDoc}`;
export const StudentPublicApplicationFragmentDoc = gql`
    fragment StudentPublicApplication on PublicApplication {
  id
  isPublic
  createdAt(format: SHORT)
  scholarshipApplication {
    id
    totalUpvote
    canVote
    hasVoted
  }
  answers {
    id
    title
    comment
    media {
      id
      type
      cloudinaryPublicId
    }
  }
  ...StudentPublicApplicationDetail
  ...StudentPublicApplicationVideo
}
    ${StudentPublicApplicationDetailFragmentDoc}
${StudentPublicApplicationVideoFragmentDoc}`;
export const StudentPublicUserFragmentDoc = gql`
    fragment StudentPublicUser on PublicUser {
  id
  name
  username
  publicApplication(where: {id: $applicationId}) {
    ...StudentPublicApplication
  }
}
    ${StudentPublicApplicationFragmentDoc}`;
export const ConversationApplicationDetailsFragmentDoc = gql`
    fragment ConversationApplicationDetails on PrivilegedCohort {
  id
  publishDeadline(format: RELATIVE)
  publishDeadlineTimeLeft
  publishWindow
  expert {
    id
    bio
    name
    profileImageUrl
    userProfileImage {
      id
      url
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
  }
  experts(roles: [Expert, Judge]) {
    id
    title
    name
    profileImageUrl
    userProfileImage {
      id
      url
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
    }
  }
}
    `;
export const SocialLinkFragmentDoc = gql`
    fragment SocialLink on PublicUser {
  id
  twitterUrl
  instagramUrl
  linkedInUrl
  soundcloudUrl
  tiktokUrl
  facebookUrl
  twitterUsername
  instagramUsername
  linkedInUsername
  soundcloudUsername
  tiktokUsername
  facebookUsername
  spotifyUrl
}
    `;
export const StudentUserProfileFragmentDoc = gql`
    fragment StudentUserProfile on PublicUser {
  id
  name
  username
  profileImageUrl
  twitterUrl
  instagramUrl
  linkedInUrl
  soundcloudUrl
  twitterUsername
  instagramUsername
  linkedInUsername
  soundcloudUsername
  isStudent
  userProfileImage {
    cloudinaryPublicId
  }
  userProfileCoverImage {
    cloudinaryPublicId
  }
  bio
  ...SocialLink
}
    ${SocialLinkFragmentDoc}`;
export const VideoGalleryPublicApplicationFragmentDoc = gql`
    fragment VideoGalleryPublicApplication on PublicApplication {
  id
  isScholarship
  isPublic
  scholarshipApplication {
    totalUpvote
    canVote
  }
  answers {
    id
    media {
      id
      cloudinaryPublicId
    }
  }
  cohort {
    scholarshipVotesThreshold
    expert {
      profileImageUrl
      id
      name
      username
      userProfileImage {
        id
        cloudinaryPublicId
      }
    }
  }
}
    `;
export const StudentProfileApplicationFragmentDoc = gql`
    fragment StudentProfileApplication on PrivilegedApplication {
  id
  state
  cohort {
    expert {
      id
      username
      name
      userProfileImage {
        cloudinaryPublicId
      }
    }
  }
  answers {
    id
    media {
      id
      cloudinaryPublicId
    }
  }
}
    `;
export const StudentPrivilegedCohortFragmentDoc = gql`
    fragment StudentPrivilegedCohort on PrivilegedCohort {
  id
  name
  description
  price
  state
  expert {
    id
    name
    username
    userProfileImage {
      id
      cloudinaryPublicId
    }
  }
  myApplications {
    id
    state
  }
}
    `;
export const StudentPrivilegedConversationFragmentDoc = gql`
    fragment StudentPrivilegedConversation on PrivilegedConversation {
  id
  totalUnreadMessages
}
    `;
export const StudentProfileApplicationMediaConfigFragmentDoc = gql`
    fragment StudentProfileApplicationMediaConfig on MediaConfig {
  APPLICATION_VIDEO_720p {
    transformation
  }
}
    `;
export const StudentProfilePrivilegedCoachingApplicationFragmentDoc = gql`
    fragment StudentProfilePrivilegedCoachingApplication on PrivilegedApplication {
  id
  state
  isPublic
  isScholarship
  scholarshipApplication {
    id
    totalUpvote
    totalApprovedReferrals
    shortCode
  }
  cohort {
    id
    name
    hasPublishDeadlineExpired
    scholarshipVotesThreshold
    scholarshipReferralsThreshold
    publishDeadline(format: RELATIVE)
    publishDeadlineTimeLeft
    publishWindow
    type
    expert {
      id
      name
      profileImageUrl
      userProfileImage {
        url
      }
      userProfileAlternateImage {
        cloudinaryPublicId
      }
    }
  }
  reviews(onlyPublicExperts: true) {
    id
    data
    createdAt
    user {
      id
      username
      profileImageUrl
      title
      userProfileImage {
        id
        cloudinaryPublicId
        url
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
        url
      }
    }
    media {
      id
      cloudinaryPublicId
    }
  }
  answers {
    id
    data
    question {
      id
      type
    }
    media {
      id
      cloudinaryPublicId
    }
    ...ApplicationAnswer
  }
}
    ${ApplicationAnswerFragmentDoc}`;
export const FeedbackReviewPrivilegedReviewFragmentDoc = gql`
    fragment FeedbackReviewPrivilegedReview on PrivilegedReview {
  id
  data
  rating
  createdAt
  updatedAt
  watched: updatedAt(format: TWELVE_HOURS, timezone: $timezone)
  user {
    id
    username
    name
    profileImageUrl
    title
    userProfileImage {
      id
      cloudinaryPublicId
      url
    }
    userProfileAlternateImage {
      id
      cloudinaryPublicId
      url
    }
  }
  media {
    id
    cloudinaryPublicId
  }
}
    `;
export const FeedbackAuditionPrivilegedAnswerFragmentDoc = gql`
    fragment FeedbackAuditionPrivilegedAnswer on PrivilegedAnswer {
  id
  media {
    id
    cloudinaryPublicId
  }
}
    `;
export const FeedBackStudentProfilePrivilegedApplicationFragmentDoc = gql`
    fragment FeedBackStudentProfilePrivilegedApplication on PrivilegedApplication {
  id
  state
  isExpirationExtended
  scholarshipApplication {
    id
    totalUpvote
    shortCode
  }
  cohort {
    id
    category {
      id
      name
    }
    scholarshipVotesThreshold
    expert {
      id
      bio
      name
      username
      profileImageUrl
      userProfileAlternateImage {
        cloudinaryPublicId
      }
    }
  }
  reviews(onlyPublicExperts: true) {
    id
    ...FeedbackReviewPrivilegedReview
  }
  answers {
    id
    ...FeedbackAuditionPrivilegedAnswer
  }
}
    ${FeedbackReviewPrivilegedReviewFragmentDoc}
${FeedbackAuditionPrivilegedAnswerFragmentDoc}`;
export const StudentProfileCoachingUserFragmentDoc = gql`
    fragment StudentProfileCoachingUser on CurrentUser {
  id
  name
  username
  profileImageUrl
  isStudent
  userProfileImage {
    cloudinaryPublicId
  }
  bio
  application(id: $applicationId) {
    id
    ...StudentProfilePrivilegedCoachingApplication
    ...FeedBackStudentProfilePrivilegedApplication
  }
}
    ${StudentProfilePrivilegedCoachingApplicationFragmentDoc}
${FeedBackStudentProfilePrivilegedApplicationFragmentDoc}`;
export const StudentProfileOpportunityResultPrivilegedApplicationFragmentDoc = gql`
    fragment StudentProfileOpportunityResultPrivilegedApplication on PrivilegedApplication {
  id
  state
  isPublic
  isScholarship
}
    `;
export const StudentProfilePrivilegedOpportunityApplicationFragmentDoc = gql`
    fragment StudentProfilePrivilegedOpportunityApplication on PrivilegedApplication {
  id
  state
  isPublic
  isScholarship
  scholarshipApplication {
    id
    totalUpvote
    totalApprovedReferrals
    shortCode
  }
  cohort {
    id
    name
    state
    hasPublishDeadlineExpired
    scholarshipVotesThreshold
    scholarshipReferralsThreshold
    publishDeadline(format: RELATIVE)
    publishDeadlineTimeLeft
    publishWindow
    type
    expert {
      id
      name
      profileImageUrl
      userProfileImage {
        id
        url
        cloudinaryPublicId
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
      }
    }
  }
  reviews(onlyPublicExperts: true) {
    id
    data
    createdAt
    user {
      id
      username
      profileImageUrl
      title
      userProfileImage {
        id
        cloudinaryPublicId
        url
      }
      userProfileAlternateImage {
        id
        cloudinaryPublicId
        url
      }
    }
    media {
      id
      cloudinaryPublicId
    }
  }
  answers {
    id
    data
    question {
      id
      type
    }
    media {
      id
      cloudinaryPublicId
    }
    ...ApplicationAnswer
  }
  ...StudentProfileOpportunityResultPrivilegedApplication
}
    ${ApplicationAnswerFragmentDoc}
${StudentProfileOpportunityResultPrivilegedApplicationFragmentDoc}`;
export const StudentProfileOpportunityUserFragmentDoc = gql`
    fragment StudentProfileOpportunityUser on CurrentUser {
  id
  name
  username
  profileImageUrl
  isStudent
  userProfileImage {
    cloudinaryPublicId
  }
  bio
  application(id: $applicationId) {
    id
    ...StudentProfilePrivilegedOpportunityApplication
    ...FeedBackStudentProfilePrivilegedApplication
  }
}
    ${StudentProfilePrivilegedOpportunityApplicationFragmentDoc}
${FeedBackStudentProfilePrivilegedApplicationFragmentDoc}`;
export const StudentLayoutProfileSocialFragmentDoc = gql`
    fragment StudentLayoutProfileSocial on CurrentUser {
  id
  name
  username
  profileImageUrl
  isStudent
  userProfileImage {
    id
    cloudinaryPublicId
  }
  userProfileCoverImage {
    id
    cloudinaryPublicId
  }
  bio
  twitterUrl
  instagramUrl
  linkedInUrl
  soundcloudUrl
  tiktokUrl
  facebookUrl
  twitterUsername
  instagramUsername
  linkedInUsername
  soundcloudUsername
  tiktokUsername
  facebookUsername
  spotifyUrl
}
    `;
export const ReviewFragmentFragmentDoc = gql`
    fragment ReviewFragment on PublicReview {
  id
  likeCount
  likedByMe
  thread {
    items {
      pageInfo {
        totalCount
      }
    }
  }
  mediaUrlWithTransformations
  application {
    id
    cohort {
      id
      prize
      price
      symbol
      category {
        name
      }
    }
    user {
      id
      name
      username
      userProfileImage {
        cloudinaryPublicId
      }
    }
  }
  mediaUrlWithTransformations
  media {
    id
    cloudinaryPublicId
  }
  user {
    id
    name
    username
    userProfileImage {
      cloudinaryPublicId
    }
  }
}
    `;
export const AccessControlDocument = gql`
    query AccessControl {
  viewer {
    id
    isExpert
    isStudent
  }
}
    `;

/**
 * __useAccessControlQuery__
 *
 * To run a query within a React component, call `useAccessControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessControlQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessControlQuery(baseOptions?: Apollo.QueryHookOptions<AccessControlQuery, AccessControlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessControlQuery, AccessControlQueryVariables>(AccessControlDocument, options);
      }
export function useAccessControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessControlQuery, AccessControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessControlQuery, AccessControlQueryVariables>(AccessControlDocument, options);
        }
export type AccessControlQueryHookResult = ReturnType<typeof useAccessControlQuery>;
export type AccessControlLazyQueryHookResult = ReturnType<typeof useAccessControlLazyQuery>;
export type AccessControlQueryResult = Apollo.QueryResult<AccessControlQuery, AccessControlQueryVariables>;
export const PublicFeaturedFlagsDocument = gql`
    query PublicFeaturedFlags {
  publicFeaturedFlags {
    ...PublicFeaturedFlag
  }
}
    ${PublicFeaturedFlagFragmentDoc}`;

/**
 * __usePublicFeaturedFlagsQuery__
 *
 * To run a query within a React component, call `usePublicFeaturedFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFeaturedFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFeaturedFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicFeaturedFlagsQuery(baseOptions?: Apollo.QueryHookOptions<PublicFeaturedFlagsQuery, PublicFeaturedFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicFeaturedFlagsQuery, PublicFeaturedFlagsQueryVariables>(PublicFeaturedFlagsDocument, options);
      }
export function usePublicFeaturedFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicFeaturedFlagsQuery, PublicFeaturedFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicFeaturedFlagsQuery, PublicFeaturedFlagsQueryVariables>(PublicFeaturedFlagsDocument, options);
        }
export type PublicFeaturedFlagsQueryHookResult = ReturnType<typeof usePublicFeaturedFlagsQuery>;
export type PublicFeaturedFlagsLazyQueryHookResult = ReturnType<typeof usePublicFeaturedFlagsLazyQuery>;
export type PublicFeaturedFlagsQueryResult = Apollo.QueryResult<PublicFeaturedFlagsQuery, PublicFeaturedFlagsQueryVariables>;
export const HeaderDocument = gql`
    query Header {
  viewer {
    id
    ...HeaderProfileUser
  }
}
    ${HeaderProfileUserFragmentDoc}`;

/**
 * __useHeaderQuery__
 *
 * To run a query within a React component, call `useHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderQuery(baseOptions?: Apollo.QueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
      }
export function useHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export type HeaderQueryHookResult = ReturnType<typeof useHeaderQuery>;
export type HeaderLazyQueryHookResult = ReturnType<typeof useHeaderLazyQuery>;
export type HeaderQueryResult = Apollo.QueryResult<HeaderQuery, HeaderQueryVariables>;
export const ProfileImageUploaderConfigDocument = gql`
    query ProfileImageUploaderConfig($uploadPreset: String, $notificationUrl: String) {
  MediaConfig {
    cloudinaryMediaSignature(
      uploadPreset: $uploadPreset
      notificationUrl: $notificationUrl
    ) {
      publicId
      signature
      timestamp
    }
  }
}
    `;

/**
 * __useProfileImageUploaderConfigQuery__
 *
 * To run a query within a React component, call `useProfileImageUploaderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileImageUploaderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileImageUploaderConfigQuery({
 *   variables: {
 *      uploadPreset: // value for 'uploadPreset'
 *      notificationUrl: // value for 'notificationUrl'
 *   },
 * });
 */
export function useProfileImageUploaderConfigQuery(baseOptions?: Apollo.QueryHookOptions<ProfileImageUploaderConfigQuery, ProfileImageUploaderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileImageUploaderConfigQuery, ProfileImageUploaderConfigQueryVariables>(ProfileImageUploaderConfigDocument, options);
      }
export function useProfileImageUploaderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileImageUploaderConfigQuery, ProfileImageUploaderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileImageUploaderConfigQuery, ProfileImageUploaderConfigQueryVariables>(ProfileImageUploaderConfigDocument, options);
        }
export type ProfileImageUploaderConfigQueryHookResult = ReturnType<typeof useProfileImageUploaderConfigQuery>;
export type ProfileImageUploaderConfigLazyQueryHookResult = ReturnType<typeof useProfileImageUploaderConfigLazyQuery>;
export type ProfileImageUploaderConfigQueryResult = Apollo.QueryResult<ProfileImageUploaderConfigQuery, ProfileImageUploaderConfigQueryVariables>;
export const GetRecentAuditionsDocument = gql`
    query GetRecentAuditions($cohortId: String!) {
  MediaConfig {
    ...VideoPlayerMediaConfig
  }
  publicApplications(
    where: {cohortId: {equals: $cohortId}, state: {in: [PublishedPendingExpert, Reviewed, Accepted, Rejected, Unprocessed]}, rating: {in: [3, 4, 5]}}
    take: 50
  ) {
    ...PublicApplication
  }
}
    ${VideoPlayerMediaConfigFragmentDoc}
${PublicApplicationFragmentDoc}`;

/**
 * __useGetRecentAuditionsQuery__
 *
 * To run a query within a React component, call `useGetRecentAuditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentAuditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentAuditionsQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useGetRecentAuditionsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentAuditionsQuery, GetRecentAuditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentAuditionsQuery, GetRecentAuditionsQueryVariables>(GetRecentAuditionsDocument, options);
      }
export function useGetRecentAuditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentAuditionsQuery, GetRecentAuditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentAuditionsQuery, GetRecentAuditionsQueryVariables>(GetRecentAuditionsDocument, options);
        }
export type GetRecentAuditionsQueryHookResult = ReturnType<typeof useGetRecentAuditionsQuery>;
export type GetRecentAuditionsLazyQueryHookResult = ReturnType<typeof useGetRecentAuditionsLazyQuery>;
export type GetRecentAuditionsQueryResult = Apollo.QueryResult<GetRecentAuditionsQuery, GetRecentAuditionsQueryVariables>;
export const SegmentIdentifyViewerDocument = gql`
    query SegmentIdentifyViewer {
  viewer {
    id
    name
    email
    username
  }
}
    `;

/**
 * __useSegmentIdentifyViewerQuery__
 *
 * To run a query within a React component, call `useSegmentIdentifyViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentIdentifyViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentIdentifyViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentIdentifyViewerQuery(baseOptions?: Apollo.QueryHookOptions<SegmentIdentifyViewerQuery, SegmentIdentifyViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentIdentifyViewerQuery, SegmentIdentifyViewerQueryVariables>(SegmentIdentifyViewerDocument, options);
      }
export function useSegmentIdentifyViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentIdentifyViewerQuery, SegmentIdentifyViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentIdentifyViewerQuery, SegmentIdentifyViewerQueryVariables>(SegmentIdentifyViewerDocument, options);
        }
export type SegmentIdentifyViewerQueryHookResult = ReturnType<typeof useSegmentIdentifyViewerQuery>;
export type SegmentIdentifyViewerLazyQueryHookResult = ReturnType<typeof useSegmentIdentifyViewerLazyQuery>;
export type SegmentIdentifyViewerQueryResult = Apollo.QueryResult<SegmentIdentifyViewerQuery, SegmentIdentifyViewerQueryVariables>;
export const UpdateApplicationStateDocument = gql`
    mutation UpdateApplicationState($input: UpdateApplicationStateInput!) {
  updateApplicationState(input: $input) {
    id
    state
  }
}
    `;
export type UpdateApplicationStateMutationFn = Apollo.MutationFunction<UpdateApplicationStateMutation, UpdateApplicationStateMutationVariables>;

/**
 * __useUpdateApplicationStateMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationStateMutation, { data, loading, error }] = useUpdateApplicationStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationStateMutation, UpdateApplicationStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationStateMutation, UpdateApplicationStateMutationVariables>(UpdateApplicationStateDocument, options);
      }
export type UpdateApplicationStateMutationHookResult = ReturnType<typeof useUpdateApplicationStateMutation>;
export type UpdateApplicationStateMutationResult = Apollo.MutationResult<UpdateApplicationStateMutation>;
export type UpdateApplicationStateMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationStateMutation, UpdateApplicationStateMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ... on UpdateUserErrorResponse {
      type
      message
    }
    ... on CurrentUser {
      id
      username
      phone
      hasAcceptedTOS
      profileImageUrl
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserProfileImageDocument = gql`
    mutation UpdateUserProfileImage($input: UpdateProfileImageInput!) {
  updateUserProfileImage(input: $input) {
    id
    profileImageUrl
    userProfileImage {
      url
    }
  }
}
    `;
export type UpdateUserProfileImageMutationFn = Apollo.MutationFunction<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>;

/**
 * __useUpdateUserProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileImageMutation, { data, loading, error }] = useUpdateUserProfileImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>(UpdateUserProfileImageDocument, options);
      }
export type UpdateUserProfileImageMutationHookResult = ReturnType<typeof useUpdateUserProfileImageMutation>;
export type UpdateUserProfileImageMutationResult = Apollo.MutationResult<UpdateUserProfileImageMutation>;
export type UpdateUserProfileImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileImageMutation, UpdateUserProfileImageMutationVariables>;
export const VideoPlayerMediaConfigDocument = gql`
    query VideoPlayerMediaConfig($cohortId: String) {
  MediaConfig {
    APPLICATION_VIDEO_720p {
      transformation
    }
    REVIEW_VIDEO_720p_WITH_WATERMARK_05022022 {
      transformation
    }
    APPLICATION_SHAREABLE_ASSET_VIDEO(cohortId: $cohortId) {
      transformation
    }
  }
}
    `;

/**
 * __useVideoPlayerMediaConfigQuery__
 *
 * To run a query within a React component, call `useVideoPlayerMediaConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoPlayerMediaConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoPlayerMediaConfigQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useVideoPlayerMediaConfigQuery(baseOptions?: Apollo.QueryHookOptions<VideoPlayerMediaConfigQuery, VideoPlayerMediaConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoPlayerMediaConfigQuery, VideoPlayerMediaConfigQueryVariables>(VideoPlayerMediaConfigDocument, options);
      }
export function useVideoPlayerMediaConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoPlayerMediaConfigQuery, VideoPlayerMediaConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoPlayerMediaConfigQuery, VideoPlayerMediaConfigQueryVariables>(VideoPlayerMediaConfigDocument, options);
        }
export type VideoPlayerMediaConfigQueryHookResult = ReturnType<typeof useVideoPlayerMediaConfigQuery>;
export type VideoPlayerMediaConfigLazyQueryHookResult = ReturnType<typeof useVideoPlayerMediaConfigLazyQuery>;
export type VideoPlayerMediaConfigQueryResult = Apollo.QueryResult<VideoPlayerMediaConfigQuery, VideoPlayerMediaConfigQueryVariables>;
export const VideoUploaderMediaConfigTransformationsDocument = gql`
    query VideoUploaderMediaConfigTransformations($cohortId: String!) {
  MediaConfig {
    APPLICATION_VIDEO_720p {
      transformation
    }
    APPLICATION_VIDEO_720p_WITH_WATERMARK_03292022 {
      transformation
    }
    APPLICATION_SHAREABLE_ASSET_VIDEO(cohortId: $cohortId) {
      transformation
    }
  }
}
    `;

/**
 * __useVideoUploaderMediaConfigTransformationsQuery__
 *
 * To run a query within a React component, call `useVideoUploaderMediaConfigTransformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoUploaderMediaConfigTransformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoUploaderMediaConfigTransformationsQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useVideoUploaderMediaConfigTransformationsQuery(baseOptions: Apollo.QueryHookOptions<VideoUploaderMediaConfigTransformationsQuery, VideoUploaderMediaConfigTransformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoUploaderMediaConfigTransformationsQuery, VideoUploaderMediaConfigTransformationsQueryVariables>(VideoUploaderMediaConfigTransformationsDocument, options);
      }
export function useVideoUploaderMediaConfigTransformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoUploaderMediaConfigTransformationsQuery, VideoUploaderMediaConfigTransformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoUploaderMediaConfigTransformationsQuery, VideoUploaderMediaConfigTransformationsQueryVariables>(VideoUploaderMediaConfigTransformationsDocument, options);
        }
export type VideoUploaderMediaConfigTransformationsQueryHookResult = ReturnType<typeof useVideoUploaderMediaConfigTransformationsQuery>;
export type VideoUploaderMediaConfigTransformationsLazyQueryHookResult = ReturnType<typeof useVideoUploaderMediaConfigTransformationsLazyQuery>;
export type VideoUploaderMediaConfigTransformationsQueryResult = Apollo.QueryResult<VideoUploaderMediaConfigTransformationsQuery, VideoUploaderMediaConfigTransformationsQueryVariables>;
export const VideoUploaderConfigDocument = gql`
    query VideoUploaderConfig($uploadPreset: String, $notificationUrl: String, $eager: String, $eagerAsync: Boolean) {
  MediaConfig {
    cloudinaryMediaSignature(
      uploadPreset: $uploadPreset
      notificationUrl: $notificationUrl
      eager: $eager
      eagerAsync: $eagerAsync
      eagerNotificationUrl: $notificationUrl
    ) {
      publicId
      signature
      timestamp
    }
  }
}
    `;

/**
 * __useVideoUploaderConfigQuery__
 *
 * To run a query within a React component, call `useVideoUploaderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoUploaderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoUploaderConfigQuery({
 *   variables: {
 *      uploadPreset: // value for 'uploadPreset'
 *      notificationUrl: // value for 'notificationUrl'
 *      eager: // value for 'eager'
 *      eagerAsync: // value for 'eagerAsync'
 *   },
 * });
 */
export function useVideoUploaderConfigQuery(baseOptions?: Apollo.QueryHookOptions<VideoUploaderConfigQuery, VideoUploaderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoUploaderConfigQuery, VideoUploaderConfigQueryVariables>(VideoUploaderConfigDocument, options);
      }
export function useVideoUploaderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoUploaderConfigQuery, VideoUploaderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoUploaderConfigQuery, VideoUploaderConfigQueryVariables>(VideoUploaderConfigDocument, options);
        }
export type VideoUploaderConfigQueryHookResult = ReturnType<typeof useVideoUploaderConfigQuery>;
export type VideoUploaderConfigLazyQueryHookResult = ReturnType<typeof useVideoUploaderConfigLazyQuery>;
export type VideoUploaderConfigQueryResult = Apollo.QueryResult<VideoUploaderConfigQuery, VideoUploaderConfigQueryVariables>;
export const VideoUploaderPollUploadStatusDocument = gql`
    query VideoUploaderPollUploadStatus($cloudinaryPublicId: String!) {
  viewer {
    id
    uniqueMedia(cloudinaryPublicId: $cloudinaryPublicId) {
      id
      cloudinaryPublicId
      state
    }
  }
}
    `;

/**
 * __useVideoUploaderPollUploadStatusQuery__
 *
 * To run a query within a React component, call `useVideoUploaderPollUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoUploaderPollUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoUploaderPollUploadStatusQuery({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *   },
 * });
 */
export function useVideoUploaderPollUploadStatusQuery(baseOptions: Apollo.QueryHookOptions<VideoUploaderPollUploadStatusQuery, VideoUploaderPollUploadStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoUploaderPollUploadStatusQuery, VideoUploaderPollUploadStatusQueryVariables>(VideoUploaderPollUploadStatusDocument, options);
      }
export function useVideoUploaderPollUploadStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoUploaderPollUploadStatusQuery, VideoUploaderPollUploadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoUploaderPollUploadStatusQuery, VideoUploaderPollUploadStatusQueryVariables>(VideoUploaderPollUploadStatusDocument, options);
        }
export type VideoUploaderPollUploadStatusQueryHookResult = ReturnType<typeof useVideoUploaderPollUploadStatusQuery>;
export type VideoUploaderPollUploadStatusLazyQueryHookResult = ReturnType<typeof useVideoUploaderPollUploadStatusLazyQuery>;
export type VideoUploaderPollUploadStatusQueryResult = Apollo.QueryResult<VideoUploaderPollUploadStatusQuery, VideoUploaderPollUploadStatusQueryVariables>;
export const InitializeMediaDocument = gql`
    mutation InitializeMedia($cloudinaryPublicId: String!, $type: MediaTypeEnum!) {
  initializeMedia(cloudinaryPublicId: $cloudinaryPublicId, type: $type) {
    id
    cloudinaryPublicId
    state
  }
}
    `;
export type InitializeMediaMutationFn = Apollo.MutationFunction<InitializeMediaMutation, InitializeMediaMutationVariables>;

/**
 * __useInitializeMediaMutation__
 *
 * To run a mutation, you first call `useInitializeMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeMediaMutation, { data, loading, error }] = useInitializeMediaMutation({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useInitializeMediaMutation(baseOptions?: Apollo.MutationHookOptions<InitializeMediaMutation, InitializeMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeMediaMutation, InitializeMediaMutationVariables>(InitializeMediaDocument, options);
      }
export type InitializeMediaMutationHookResult = ReturnType<typeof useInitializeMediaMutation>;
export type InitializeMediaMutationResult = Apollo.MutationResult<InitializeMediaMutation>;
export type InitializeMediaMutationOptions = Apollo.BaseMutationOptions<InitializeMediaMutation, InitializeMediaMutationVariables>;
export const ApplicationCreatePageDocument = gql`
    query ApplicationCreatePage($id: String!) {
  publicCohort(where: {id: $id}) {
    id
    state
    name
    type
    expert {
      username
      profileImageUrl
      name
      userProfileImage {
        url
        cloudinaryPublicId
      }
      userProfileAlternateImage {
        url
        cloudinaryPublicId
      }
    }
    questions {
      ...ApplicationQuestion
    }
    ...ApplicationQuestionCohort
    ...ApplicationVideoUploaderCohort
  }
  viewer {
    ...ApplicationVideoUploaderViewer
  }
}
    ${ApplicationQuestionFragmentDoc}
${ApplicationQuestionCohortFragmentDoc}
${ApplicationVideoUploaderCohortFragmentDoc}
${ApplicationVideoUploaderViewerFragmentDoc}`;

/**
 * __useApplicationCreatePageQuery__
 *
 * To run a query within a React component, call `useApplicationCreatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationCreatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationCreatePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationCreatePageQuery(baseOptions: Apollo.QueryHookOptions<ApplicationCreatePageQuery, ApplicationCreatePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationCreatePageQuery, ApplicationCreatePageQueryVariables>(ApplicationCreatePageDocument, options);
      }
export function useApplicationCreatePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationCreatePageQuery, ApplicationCreatePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationCreatePageQuery, ApplicationCreatePageQueryVariables>(ApplicationCreatePageDocument, options);
        }
export type ApplicationCreatePageQueryHookResult = ReturnType<typeof useApplicationCreatePageQuery>;
export type ApplicationCreatePageLazyQueryHookResult = ReturnType<typeof useApplicationCreatePageLazyQuery>;
export type ApplicationCreatePageQueryResult = Apollo.QueryResult<ApplicationCreatePageQuery, ApplicationCreatePageQueryVariables>;
export const ApplicationEditApplicationPageDocument = gql`
    query ApplicationEditApplicationPage($id: String!) {
  viewer {
    id
    email
    firstName
    phone
    application(id: $id) {
      id
      state
      answers {
        id
        media {
          id
          bytes
          cloudinaryPublicId
          duration
          height
          width
          url
          type
        }
        question {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useApplicationEditApplicationPageQuery__
 *
 * To run a query within a React component, call `useApplicationEditApplicationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationEditApplicationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationEditApplicationPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationEditApplicationPageQuery(baseOptions: Apollo.QueryHookOptions<ApplicationEditApplicationPageQuery, ApplicationEditApplicationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationEditApplicationPageQuery, ApplicationEditApplicationPageQueryVariables>(ApplicationEditApplicationPageDocument, options);
      }
export function useApplicationEditApplicationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationEditApplicationPageQuery, ApplicationEditApplicationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationEditApplicationPageQuery, ApplicationEditApplicationPageQueryVariables>(ApplicationEditApplicationPageDocument, options);
        }
export type ApplicationEditApplicationPageQueryHookResult = ReturnType<typeof useApplicationEditApplicationPageQuery>;
export type ApplicationEditApplicationPageLazyQueryHookResult = ReturnType<typeof useApplicationEditApplicationPageLazyQuery>;
export type ApplicationEditApplicationPageQueryResult = Apollo.QueryResult<ApplicationEditApplicationPageQuery, ApplicationEditApplicationPageQueryVariables>;
export const CreateApplicationDocument = gql`
    mutation CreateApplication($input: CreateApplicationInput!) {
  createApplication(input: $input) {
    ... on PrivilegedApplication {
      id
      state
      price
      userId
    }
    ... on CreateApplicationErrorResponse {
      type
    }
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const UpdateVideoAnswerDocument = gql`
    mutation UpdateVideoAnswer($input: VideoAnswerInput!, $answerId: String!) {
  updateVideoAnswer(input: $input, answerId: $answerId) {
    id
  }
}
    `;
export type UpdateVideoAnswerMutationFn = Apollo.MutationFunction<UpdateVideoAnswerMutation, UpdateVideoAnswerMutationVariables>;

/**
 * __useUpdateVideoAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateVideoAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoAnswerMutation, { data, loading, error }] = useUpdateVideoAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useUpdateVideoAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoAnswerMutation, UpdateVideoAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoAnswerMutation, UpdateVideoAnswerMutationVariables>(UpdateVideoAnswerDocument, options);
      }
export type UpdateVideoAnswerMutationHookResult = ReturnType<typeof useUpdateVideoAnswerMutation>;
export type UpdateVideoAnswerMutationResult = Apollo.MutationResult<UpdateVideoAnswerMutation>;
export type UpdateVideoAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateVideoAnswerMutation, UpdateVideoAnswerMutationVariables>;
export const ApplicationDetailPageDocument = gql`
    query ApplicationDetailPage($cohortId: String!, $applicationId: String!) {
  viewer {
    id
    isExpert
    cohort(id: $cohortId) {
      name
      hasPublishDeadlineExpired
      scholarshipVotesThreshold
      publishDeadlineTimeLeft
      publishWindow
      type
      expert {
        id
        profileImageUrl
        userProfileImage {
          id
          url
        }
        userProfileAlternateImage {
          id
          url
          cloudinaryPublicId
        }
        name
      }
      application(id: $applicationId) {
        __typename
        id
        state
        createdAt
        user {
          id
          username
        }
        reviews(onlyPublicExperts: true) {
          id
          ...ReviewPrivilegedReview
        }
        answers {
          id
          ...ApplicationAnswer
        }
        isScholarship
        scholarshipApplication {
          id
          totalUpvote
        }
        ...ApplicationDetailPageDetailApplication
        ...ReviewCreateApplication
      }
    }
  }
}
    ${ReviewPrivilegedReviewFragmentDoc}
${ApplicationAnswerFragmentDoc}
${ApplicationDetailPageDetailApplicationFragmentDoc}
${ReviewCreateApplicationFragmentDoc}`;

/**
 * __useApplicationDetailPageQuery__
 *
 * To run a query within a React component, call `useApplicationDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailPageQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationDetailPageQuery(baseOptions: Apollo.QueryHookOptions<ApplicationDetailPageQuery, ApplicationDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailPageQuery, ApplicationDetailPageQueryVariables>(ApplicationDetailPageDocument, options);
      }
export function useApplicationDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailPageQuery, ApplicationDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailPageQuery, ApplicationDetailPageQueryVariables>(ApplicationDetailPageDocument, options);
        }
export type ApplicationDetailPageQueryHookResult = ReturnType<typeof useApplicationDetailPageQuery>;
export type ApplicationDetailPageLazyQueryHookResult = ReturnType<typeof useApplicationDetailPageLazyQuery>;
export type ApplicationDetailPageQueryResult = Apollo.QueryResult<ApplicationDetailPageQuery, ApplicationDetailPageQueryVariables>;
export const ReviewVideoApplicationDocument = gql`
    mutation ReviewVideoApplication($input: CreateReviewInput!) {
  reviewApplication(input: $input) {
    id
    data
    createdAt
    user {
      username
    }
    application {
      id
      state
    }
  }
}
    `;
export type ReviewVideoApplicationMutationFn = Apollo.MutationFunction<ReviewVideoApplicationMutation, ReviewVideoApplicationMutationVariables>;

/**
 * __useReviewVideoApplicationMutation__
 *
 * To run a mutation, you first call `useReviewVideoApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewVideoApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewVideoApplicationMutation, { data, loading, error }] = useReviewVideoApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewVideoApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ReviewVideoApplicationMutation, ReviewVideoApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewVideoApplicationMutation, ReviewVideoApplicationMutationVariables>(ReviewVideoApplicationDocument, options);
      }
export type ReviewVideoApplicationMutationHookResult = ReturnType<typeof useReviewVideoApplicationMutation>;
export type ReviewVideoApplicationMutationResult = Apollo.MutationResult<ReviewVideoApplicationMutation>;
export type ReviewVideoApplicationMutationOptions = Apollo.BaseMutationOptions<ReviewVideoApplicationMutation, ReviewVideoApplicationMutationVariables>;
export const ReviewApplicationDocument = gql`
    mutation ReviewApplication($input: CreateReviewInput!) {
  reviewApplication(input: $input) {
    id
    data
    createdAt
    user {
      username
    }
    application {
      id
      state
      reviews {
        id
        data
        createdAt
        user {
          username
        }
        reactionVideo {
          verticalReactionVideoUrl
          horizontalReactionVideoUrl
        }
      }
    }
    reactionVideo {
      verticalReactionVideoUrl
      horizontalReactionVideoUrl
    }
  }
}
    `;
export type ReviewApplicationMutationFn = Apollo.MutationFunction<ReviewApplicationMutation, ReviewApplicationMutationVariables>;

/**
 * __useReviewApplicationMutation__
 *
 * To run a mutation, you first call `useReviewApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewApplicationMutation, { data, loading, error }] = useReviewApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ReviewApplicationMutation, ReviewApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewApplicationMutation, ReviewApplicationMutationVariables>(ReviewApplicationDocument, options);
      }
export type ReviewApplicationMutationHookResult = ReturnType<typeof useReviewApplicationMutation>;
export type ReviewApplicationMutationResult = Apollo.MutationResult<ReviewApplicationMutation>;
export type ReviewApplicationMutationOptions = Apollo.BaseMutationOptions<ReviewApplicationMutation, ReviewApplicationMutationVariables>;
export const ApplicationSummaryAndPaymentPageDocument = gql`
    query ApplicationSummaryAndPaymentPage($id: String!) {
  viewer {
    id
    email
    firstName
    phone
    balance
    hasAcceptedTOS
    storedCardPaymentMethodsForStripe {
      id
      brand
      last4
      expYear
      expMonth
    }
    application(id: $id) {
      id
      state
      price
      isScholarship
      referralCodeApplicableDiscount
      adjustedPrice
      referralCode {
        id
        code
      }
      cohort {
        id
        name
        price
        scholarshipVotesThreshold
        scholarshipApplicationLimit
        scholarshipsAwarded
        scholarshipReferralsThreshold
        scholarshipDeadline(format: NO_YEAR)
        type
        expert {
          profileImageUrl
          name
          userProfileImage {
            id
            url
            cloudinaryPublicId
          }
          userProfileAlternateImage {
            id
            url
            cloudinaryPublicId
          }
        }
      }
      createTransactionIntentForStripe {
        transaction {
          id
          userId
          createdAt
          updatedAt
          amount
          providerTransactionId
          providerTransactionStatus
        }
        paymentIntent {
          id
          clientSecret
          amount
        }
      }
      ...ApplicationCardStudent
    }
    ...StudentCardViewer
  }
}
    ${ApplicationCardStudentFragmentDoc}
${StudentCardViewerFragmentDoc}`;

/**
 * __useApplicationSummaryAndPaymentPageQuery__
 *
 * To run a query within a React component, call `useApplicationSummaryAndPaymentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationSummaryAndPaymentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationSummaryAndPaymentPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationSummaryAndPaymentPageQuery(baseOptions: Apollo.QueryHookOptions<ApplicationSummaryAndPaymentPageQuery, ApplicationSummaryAndPaymentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationSummaryAndPaymentPageQuery, ApplicationSummaryAndPaymentPageQueryVariables>(ApplicationSummaryAndPaymentPageDocument, options);
      }
export function useApplicationSummaryAndPaymentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationSummaryAndPaymentPageQuery, ApplicationSummaryAndPaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationSummaryAndPaymentPageQuery, ApplicationSummaryAndPaymentPageQueryVariables>(ApplicationSummaryAndPaymentPageDocument, options);
        }
export type ApplicationSummaryAndPaymentPageQueryHookResult = ReturnType<typeof useApplicationSummaryAndPaymentPageQuery>;
export type ApplicationSummaryAndPaymentPageLazyQueryHookResult = ReturnType<typeof useApplicationSummaryAndPaymentPageLazyQuery>;
export type ApplicationSummaryAndPaymentPageQueryResult = Apollo.QueryResult<ApplicationSummaryAndPaymentPageQuery, ApplicationSummaryAndPaymentPageQueryVariables>;
export const PurchaseApplicationDocument = gql`
    mutation PurchaseApplication($input: PurchaseApplicationWithStripeInput!) {
  purchaseApplicationWithStripe(input: $input) {
    ... on PurchaseApplicationErrorResponse {
      type
      applicationId
      reason
    }
    ... on PrivilegedApplication {
      id
      state
    }
  }
}
    `;
export type PurchaseApplicationMutationFn = Apollo.MutationFunction<PurchaseApplicationMutation, PurchaseApplicationMutationVariables>;

/**
 * __usePurchaseApplicationMutation__
 *
 * To run a mutation, you first call `usePurchaseApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseApplicationMutation, { data, loading, error }] = usePurchaseApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseApplicationMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseApplicationMutation, PurchaseApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseApplicationMutation, PurchaseApplicationMutationVariables>(PurchaseApplicationDocument, options);
      }
export type PurchaseApplicationMutationHookResult = ReturnType<typeof usePurchaseApplicationMutation>;
export type PurchaseApplicationMutationResult = Apollo.MutationResult<PurchaseApplicationMutation>;
export type PurchaseApplicationMutationOptions = Apollo.BaseMutationOptions<PurchaseApplicationMutation, PurchaseApplicationMutationVariables>;
export const CompleteAndPurchaseApplicationDocument = gql`
    mutation CompleteAndPurchaseApplication($input: CompleteAndPurchaseApplicationInput!) {
  completeAndPurchaseApplicationWithStripe(input: $input) {
    ... on PurchaseApplicationErrorResponse {
      type
      applicationId
      reason
    }
    ... on PrivilegedApplication {
      id
      state
    }
  }
}
    `;
export type CompleteAndPurchaseApplicationMutationFn = Apollo.MutationFunction<CompleteAndPurchaseApplicationMutation, CompleteAndPurchaseApplicationMutationVariables>;

/**
 * __useCompleteAndPurchaseApplicationMutation__
 *
 * To run a mutation, you first call `useCompleteAndPurchaseApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAndPurchaseApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAndPurchaseApplicationMutation, { data, loading, error }] = useCompleteAndPurchaseApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAndPurchaseApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAndPurchaseApplicationMutation, CompleteAndPurchaseApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAndPurchaseApplicationMutation, CompleteAndPurchaseApplicationMutationVariables>(CompleteAndPurchaseApplicationDocument, options);
      }
export type CompleteAndPurchaseApplicationMutationHookResult = ReturnType<typeof useCompleteAndPurchaseApplicationMutation>;
export type CompleteAndPurchaseApplicationMutationResult = Apollo.MutationResult<CompleteAndPurchaseApplicationMutation>;
export type CompleteAndPurchaseApplicationMutationOptions = Apollo.BaseMutationOptions<CompleteAndPurchaseApplicationMutation, CompleteAndPurchaseApplicationMutationVariables>;
export const RedeemReferralCodeDocument = gql`
    mutation RedeemReferralCode($code: String!, $applicationId: ID!) {
  redeemReferralCode(code: $code, applicationId: $applicationId) {
    ... on PrivilegedApplication {
      id
      referralCodeApplicableDiscount
      referralCode {
        id
        type
        code
      }
      createTransactionIntentForStripe {
        paymentIntent {
          id
          clientSecret
          amount
        }
      }
    }
    ... on ManagementReferralCodeErrorResponse {
      type
    }
  }
}
    `;
export type RedeemReferralCodeMutationFn = Apollo.MutationFunction<RedeemReferralCodeMutation, RedeemReferralCodeMutationVariables>;

/**
 * __useRedeemReferralCodeMutation__
 *
 * To run a mutation, you first call `useRedeemReferralCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemReferralCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemReferralCodeMutation, { data, loading, error }] = useRedeemReferralCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useRedeemReferralCodeMutation(baseOptions?: Apollo.MutationHookOptions<RedeemReferralCodeMutation, RedeemReferralCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemReferralCodeMutation, RedeemReferralCodeMutationVariables>(RedeemReferralCodeDocument, options);
      }
export type RedeemReferralCodeMutationHookResult = ReturnType<typeof useRedeemReferralCodeMutation>;
export type RedeemReferralCodeMutationResult = Apollo.MutationResult<RedeemReferralCodeMutation>;
export type RedeemReferralCodeMutationOptions = Apollo.BaseMutationOptions<RedeemReferralCodeMutation, RedeemReferralCodeMutationVariables>;
export const SubmitScholarshipApplicationDocument = gql`
    mutation SubmitScholarshipApplication($input: SubmitScholarshipApplicationInput!) {
  submitScholarshipApplication(input: $input) {
    id
    state
  }
}
    `;
export type SubmitScholarshipApplicationMutationFn = Apollo.MutationFunction<SubmitScholarshipApplicationMutation, SubmitScholarshipApplicationMutationVariables>;

/**
 * __useSubmitScholarshipApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitScholarshipApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitScholarshipApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitScholarshipApplicationMutation, { data, loading, error }] = useSubmitScholarshipApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitScholarshipApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitScholarshipApplicationMutation, SubmitScholarshipApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitScholarshipApplicationMutation, SubmitScholarshipApplicationMutationVariables>(SubmitScholarshipApplicationDocument, options);
      }
export type SubmitScholarshipApplicationMutationHookResult = ReturnType<typeof useSubmitScholarshipApplicationMutation>;
export type SubmitScholarshipApplicationMutationResult = Apollo.MutationResult<SubmitScholarshipApplicationMutation>;
export type SubmitScholarshipApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitScholarshipApplicationMutation, SubmitScholarshipApplicationMutationVariables>;
export const ApplicationUpdateProfilePageDocument = gql`
    query ApplicationUpdateProfilePage($id: String!) {
  viewer {
    id
    application(id: $id) {
      __typename
      id
      state
      isScholarship
      cohort {
        id
        type
        expert {
          profileImageUrl
          name
          userProfileImage {
            id
            url
            cloudinaryPublicId
          }
          userProfileAlternateImage {
            id
            url
            cloudinaryPublicId
          }
        }
      }
    }
    ...UserProfileFormUser
  }
}
    ${UserProfileFormUserFragmentDoc}`;

/**
 * __useApplicationUpdateProfilePageQuery__
 *
 * To run a query within a React component, call `useApplicationUpdateProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationUpdateProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationUpdateProfilePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationUpdateProfilePageQuery(baseOptions: Apollo.QueryHookOptions<ApplicationUpdateProfilePageQuery, ApplicationUpdateProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationUpdateProfilePageQuery, ApplicationUpdateProfilePageQueryVariables>(ApplicationUpdateProfilePageDocument, options);
      }
export function useApplicationUpdateProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationUpdateProfilePageQuery, ApplicationUpdateProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationUpdateProfilePageQuery, ApplicationUpdateProfilePageQueryVariables>(ApplicationUpdateProfilePageDocument, options);
        }
export type ApplicationUpdateProfilePageQueryHookResult = ReturnType<typeof useApplicationUpdateProfilePageQuery>;
export type ApplicationUpdateProfilePageLazyQueryHookResult = ReturnType<typeof useApplicationUpdateProfilePageLazyQuery>;
export type ApplicationUpdateProfilePageQueryResult = Apollo.QueryResult<ApplicationUpdateProfilePageQuery, ApplicationUpdateProfilePageQueryVariables>;
export const UpdateProfileForApplicationDocument = gql`
    mutation UpdateProfileForApplication($input: UpdateProfileForApplicationInput!) {
  updateProfileForApplication(input: $input) {
    id
    state
  }
}
    `;
export type UpdateProfileForApplicationMutationFn = Apollo.MutationFunction<UpdateProfileForApplicationMutation, UpdateProfileForApplicationMutationVariables>;

/**
 * __useUpdateProfileForApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateProfileForApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileForApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileForApplicationMutation, { data, loading, error }] = useUpdateProfileForApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileForApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileForApplicationMutation, UpdateProfileForApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileForApplicationMutation, UpdateProfileForApplicationMutationVariables>(UpdateProfileForApplicationDocument, options);
      }
export type UpdateProfileForApplicationMutationHookResult = ReturnType<typeof useUpdateProfileForApplicationMutation>;
export type UpdateProfileForApplicationMutationResult = Apollo.MutationResult<UpdateProfileForApplicationMutation>;
export type UpdateProfileForApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateProfileForApplicationMutation, UpdateProfileForApplicationMutationVariables>;
export const AuthProviderPostLoginUserDocument = gql`
    query AuthProviderPostLoginUser {
  viewer {
    id
    name
    username
  }
}
    `;

/**
 * __useAuthProviderPostLoginUserQuery__
 *
 * To run a query within a React component, call `useAuthProviderPostLoginUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthProviderPostLoginUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthProviderPostLoginUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthProviderPostLoginUserQuery(baseOptions?: Apollo.QueryHookOptions<AuthProviderPostLoginUserQuery, AuthProviderPostLoginUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthProviderPostLoginUserQuery, AuthProviderPostLoginUserQueryVariables>(AuthProviderPostLoginUserDocument, options);
      }
export function useAuthProviderPostLoginUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthProviderPostLoginUserQuery, AuthProviderPostLoginUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthProviderPostLoginUserQuery, AuthProviderPostLoginUserQueryVariables>(AuthProviderPostLoginUserDocument, options);
        }
export type AuthProviderPostLoginUserQueryHookResult = ReturnType<typeof useAuthProviderPostLoginUserQuery>;
export type AuthProviderPostLoginUserLazyQueryHookResult = ReturnType<typeof useAuthProviderPostLoginUserLazyQuery>;
export type AuthProviderPostLoginUserQueryResult = Apollo.QueryResult<AuthProviderPostLoginUserQuery, AuthProviderPostLoginUserQueryVariables>;
export const AuthProviderGenerateAuthCodeDocument = gql`
    mutation AuthProviderGenerateAuthCode($input: AuthUserInput!) {
  authUser(input: $input)
}
    `;
export type AuthProviderGenerateAuthCodeMutationFn = Apollo.MutationFunction<AuthProviderGenerateAuthCodeMutation, AuthProviderGenerateAuthCodeMutationVariables>;

/**
 * __useAuthProviderGenerateAuthCodeMutation__
 *
 * To run a mutation, you first call `useAuthProviderGenerateAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthProviderGenerateAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authProviderGenerateAuthCodeMutation, { data, loading, error }] = useAuthProviderGenerateAuthCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthProviderGenerateAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthProviderGenerateAuthCodeMutation, AuthProviderGenerateAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthProviderGenerateAuthCodeMutation, AuthProviderGenerateAuthCodeMutationVariables>(AuthProviderGenerateAuthCodeDocument, options);
      }
export type AuthProviderGenerateAuthCodeMutationHookResult = ReturnType<typeof useAuthProviderGenerateAuthCodeMutation>;
export type AuthProviderGenerateAuthCodeMutationResult = Apollo.MutationResult<AuthProviderGenerateAuthCodeMutation>;
export type AuthProviderGenerateAuthCodeMutationOptions = Apollo.BaseMutationOptions<AuthProviderGenerateAuthCodeMutation, AuthProviderGenerateAuthCodeMutationVariables>;
export const AuthProviderCreateUserFromSocialDocument = gql`
    mutation AuthProviderCreateUserFromSocial($input: AuthUserInput!) {
  authUserFromSocial(input: $input)
}
    `;
export type AuthProviderCreateUserFromSocialMutationFn = Apollo.MutationFunction<AuthProviderCreateUserFromSocialMutation, AuthProviderCreateUserFromSocialMutationVariables>;

/**
 * __useAuthProviderCreateUserFromSocialMutation__
 *
 * To run a mutation, you first call `useAuthProviderCreateUserFromSocialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthProviderCreateUserFromSocialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authProviderCreateUserFromSocialMutation, { data, loading, error }] = useAuthProviderCreateUserFromSocialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthProviderCreateUserFromSocialMutation(baseOptions?: Apollo.MutationHookOptions<AuthProviderCreateUserFromSocialMutation, AuthProviderCreateUserFromSocialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthProviderCreateUserFromSocialMutation, AuthProviderCreateUserFromSocialMutationVariables>(AuthProviderCreateUserFromSocialDocument, options);
      }
export type AuthProviderCreateUserFromSocialMutationHookResult = ReturnType<typeof useAuthProviderCreateUserFromSocialMutation>;
export type AuthProviderCreateUserFromSocialMutationResult = Apollo.MutationResult<AuthProviderCreateUserFromSocialMutation>;
export type AuthProviderCreateUserFromSocialMutationOptions = Apollo.BaseMutationOptions<AuthProviderCreateUserFromSocialMutation, AuthProviderCreateUserFromSocialMutationVariables>;
export const InitAuthDocument = gql`
    mutation InitAuth($input: InitAuthInput!) {
  initAuth(input: $input) {
    success
    error {
      type
      message
    }
  }
}
    `;
export type InitAuthMutationFn = Apollo.MutationFunction<InitAuthMutation, InitAuthMutationVariables>;

/**
 * __useInitAuthMutation__
 *
 * To run a mutation, you first call `useInitAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initAuthMutation, { data, loading, error }] = useInitAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitAuthMutation(baseOptions?: Apollo.MutationHookOptions<InitAuthMutation, InitAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitAuthMutation, InitAuthMutationVariables>(InitAuthDocument, options);
      }
export type InitAuthMutationHookResult = ReturnType<typeof useInitAuthMutation>;
export type InitAuthMutationResult = Apollo.MutationResult<InitAuthMutation>;
export type InitAuthMutationOptions = Apollo.BaseMutationOptions<InitAuthMutation, InitAuthMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation VerifyOtp($input: VerifyAuthInput!) {
  verifyOtp(input: $input) {
    ... on VerifyAuthResponse {
      accessToken
      expiresIn
      refreshToken
    }
    ... on AuthErrorResponse {
      message
      type
    }
  }
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    ... on RefreshTokenResponse {
      accessToken
      expiresIn
    }
    ... on AuthErrorResponse {
      message
      type
    }
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const AllCategoriesDocument = gql`
    query AllCategories {
  publicTags(
    where: {type: {equals: Classification}, content: {path: ["featured"], equals: true}}
  ) {
    id
    content {
      title
      subtitle
      slug
      iconCloudinaryPublicId
    }
  }
}
    `;

/**
 * __useAllCategoriesQuery__
 *
 * To run a query within a React component, call `useAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCategoriesQuery, AllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCategoriesQuery, AllCategoriesQueryVariables>(AllCategoriesDocument, options);
      }
export function useAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCategoriesQuery, AllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCategoriesQuery, AllCategoriesQueryVariables>(AllCategoriesDocument, options);
        }
export type AllCategoriesQueryHookResult = ReturnType<typeof useAllCategoriesQuery>;
export type AllCategoriesLazyQueryHookResult = ReturnType<typeof useAllCategoriesLazyQuery>;
export type AllCategoriesQueryResult = Apollo.QueryResult<AllCategoriesQuery, AllCategoriesQueryVariables>;
export const CategoryPageDocument = gql`
    query CategoryPage($slug: JSON!) {
  publicTags(
    where: {type: {equals: Classification}, content: {path: ["featured"], equals: true}}
  ) {
    id
    content {
      title
      subtitle
      slug
      iconCloudinaryPublicId
    }
  }
  publicTag(
    where: {type: {equals: Classification}, content: {path: "slug", equals: $slug}}
  ) {
    id
    content {
      title
      subtitle
      slug
      iconCloudinaryPublicId
    }
    taggedCohorts {
      __typename
      ... on PublicCohort {
        id
        updateStatus
        expert {
          id
          name
          username
          title
          profileImageUrl
          userProfileImage {
            id
            cloudinaryPublicId
          }
        }
      }
      ... on PublicInterstitialAd {
        id
        headline
        subHeadline
        buttonPath
        media {
          id
          cloudinaryPublicId
        }
      }
    }
  }
}
    `;

/**
 * __useCategoryPageQuery__
 *
 * To run a query within a React component, call `useCategoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoryPageQuery(baseOptions: Apollo.QueryHookOptions<CategoryPageQuery, CategoryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryPageQuery, CategoryPageQueryVariables>(CategoryPageDocument, options);
      }
export function useCategoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryPageQuery, CategoryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryPageQuery, CategoryPageQueryVariables>(CategoryPageDocument, options);
        }
export type CategoryPageQueryHookResult = ReturnType<typeof useCategoryPageQuery>;
export type CategoryPageLazyQueryHookResult = ReturnType<typeof useCategoryPageLazyQuery>;
export type CategoryPageQueryResult = Apollo.QueryResult<CategoryPageQuery, CategoryPageQueryVariables>;
export const GetCollabProfileByUsernameDocument = gql`
    query GetCollabProfileByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    isExpert
    ...CollabPageUser
    reviews {
      ...CollabReview
    }
  }
  MediaConfig {
    ...CollabPageMediaConfig
  }
}
    ${CollabPageUserFragmentDoc}
${CollabReviewFragmentDoc}
${CollabPageMediaConfigFragmentDoc}`;

/**
 * __useGetCollabProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetCollabProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollabProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollabProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetCollabProfileByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetCollabProfileByUsernameQuery, GetCollabProfileByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollabProfileByUsernameQuery, GetCollabProfileByUsernameQueryVariables>(GetCollabProfileByUsernameDocument, options);
      }
export function useGetCollabProfileByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollabProfileByUsernameQuery, GetCollabProfileByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollabProfileByUsernameQuery, GetCollabProfileByUsernameQueryVariables>(GetCollabProfileByUsernameDocument, options);
        }
export type GetCollabProfileByUsernameQueryHookResult = ReturnType<typeof useGetCollabProfileByUsernameQuery>;
export type GetCollabProfileByUsernameLazyQueryHookResult = ReturnType<typeof useGetCollabProfileByUsernameLazyQuery>;
export type GetCollabProfileByUsernameQueryResult = Apollo.QueryResult<GetCollabProfileByUsernameQuery, GetCollabProfileByUsernameQueryVariables>;
export const GetCollabUserPublicApplicationsDocument = gql`
    query GetCollabUserPublicApplications($userById: String!) {
  userById(id: $userById) {
    id
    publicApplications {
      ...CollabGalleryPublicApplication
    }
  }
}
    ${CollabGalleryPublicApplicationFragmentDoc}`;

/**
 * __useGetCollabUserPublicApplicationsQuery__
 *
 * To run a query within a React component, call `useGetCollabUserPublicApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollabUserPublicApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollabUserPublicApplicationsQuery({
 *   variables: {
 *      userById: // value for 'userById'
 *   },
 * });
 */
export function useGetCollabUserPublicApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetCollabUserPublicApplicationsQuery, GetCollabUserPublicApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollabUserPublicApplicationsQuery, GetCollabUserPublicApplicationsQueryVariables>(GetCollabUserPublicApplicationsDocument, options);
      }
export function useGetCollabUserPublicApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollabUserPublicApplicationsQuery, GetCollabUserPublicApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollabUserPublicApplicationsQuery, GetCollabUserPublicApplicationsQueryVariables>(GetCollabUserPublicApplicationsDocument, options);
        }
export type GetCollabUserPublicApplicationsQueryHookResult = ReturnType<typeof useGetCollabUserPublicApplicationsQuery>;
export type GetCollabUserPublicApplicationsLazyQueryHookResult = ReturnType<typeof useGetCollabUserPublicApplicationsLazyQuery>;
export type GetCollabUserPublicApplicationsQueryResult = Apollo.QueryResult<GetCollabUserPublicApplicationsQuery, GetCollabUserPublicApplicationsQueryVariables>;
export const ConversationDocument = gql`
    query Conversation($where: ConversationWhereInput, $take: Int, $skip: Int, $orderBy: [MessageOrderByWithRelationInput!], $timezone: String!) {
  viewer {
    id
    name
    username
    userProfileImage {
      cloudinaryPublicId
    }
    conversation(where: $where) {
      id
      freeMessagesEnabled
      entity(entityType: Cohort) {
        ...ConversationMessageCohort
        ...ConversationApplicationDetails
      }
      participants(where: {user: {is: {isExpert: {equals: true}}}}) {
        user {
          id
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
      }
      messages(take: $take, skip: $skip, orderBy: $orderBy) {
        pageInfo {
          activePage
          perPage
          totalPages
          totalCount
          hasPrevious
          hasNext
        }
        data {
          ...ConversationData
        }
      }
    }
  }
  MediaConfig {
    ...StudentConversationMediaConfig
  }
}
    ${ConversationMessageCohortFragmentDoc}
${ConversationApplicationDetailsFragmentDoc}
${ConversationDataFragmentDoc}
${StudentConversationMediaConfigFragmentDoc}`;

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useConversationQuery(baseOptions: Apollo.QueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, options);
      }
export function useConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, options);
        }
export type ConversationQueryHookResult = ReturnType<typeof useConversationQuery>;
export type ConversationLazyQueryHookResult = ReturnType<typeof useConversationLazyQuery>;
export type ConversationQueryResult = Apollo.QueryResult<ConversationQuery, ConversationQueryVariables>;
export const UpdateMessagesReadDocument = gql`
    mutation UpdateMessagesRead($conversationId: ID!) {
  messagesRead(conversationId: $conversationId) {
    id
  }
}
    `;
export type UpdateMessagesReadMutationFn = Apollo.MutationFunction<UpdateMessagesReadMutation, UpdateMessagesReadMutationVariables>;

/**
 * __useUpdateMessagesReadMutation__
 *
 * To run a mutation, you first call `useUpdateMessagesReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagesReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagesReadMutation, { data, loading, error }] = useUpdateMessagesReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useUpdateMessagesReadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessagesReadMutation, UpdateMessagesReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessagesReadMutation, UpdateMessagesReadMutationVariables>(UpdateMessagesReadDocument, options);
      }
export type UpdateMessagesReadMutationHookResult = ReturnType<typeof useUpdateMessagesReadMutation>;
export type UpdateMessagesReadMutationResult = Apollo.MutationResult<UpdateMessagesReadMutation>;
export type UpdateMessagesReadMutationOptions = Apollo.BaseMutationOptions<UpdateMessagesReadMutation, UpdateMessagesReadMutationVariables>;
export const ConversationListDocument = gql`
    query ConversationList($userId: String!) {
  viewer {
    id
    conversations(
      where: {userConversations: {some: {messages: {some: {OR: [{state: {in: [Complete, Delivered, Read]}}, {AND: [{userConversation: {is: {userId: {equals: $userId}}}}, {state: {in: [Pending, Draft]}}]}]}}}}}
      orderByMessage: {sentAt: desc}
    ) {
      id
      participants(where: {user: {is: {isExpert: {equals: true}}}}) {
        user {
          id
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
      }
      messages(
        where: {OR: [{state: {in: [Complete, Delivered, Read]}}, {AND: [{userConversation: {is: {userId: {equals: $userId}}}}, {state: {in: [Pending, Draft]}}]}]}
        orderBy: {sentAt: desc}
        take: 1
      ) {
        data {
          id
          content
          sentAt
          type
          sender {
            name
            id
            username
          }
        }
      }
      totalUnreadMessages
    }
  }
}
    `;

/**
 * __useConversationListQuery__
 *
 * To run a query within a React component, call `useConversationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useConversationListQuery(baseOptions: Apollo.QueryHookOptions<ConversationListQuery, ConversationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationListQuery, ConversationListQueryVariables>(ConversationListDocument, options);
      }
export function useConversationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationListQuery, ConversationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationListQuery, ConversationListQueryVariables>(ConversationListDocument, options);
        }
export type ConversationListQueryHookResult = ReturnType<typeof useConversationListQuery>;
export type ConversationListLazyQueryHookResult = ReturnType<typeof useConversationListLazyQuery>;
export type ConversationListQueryResult = Apollo.QueryResult<ConversationListQuery, ConversationListQueryVariables>;
export const DiscoverPageDocument = gql`
    query DiscoverPage {
  publicCategories(
    activeCohortsOnly: true
    featuredCohortsOnly: true
    comingSoonCohorts: true
  ) {
    id
    ...CategoryFilterPublicCategory
  }
  publicCohorts(where: {featured: {equals: true}}, isActive: true) {
    id
    expert {
      id
      name
    }
    comingSoon
    category {
      id
      name
    }
    ...FeaturedCohortsListPublicCohort
  }
}
    ${CategoryFilterPublicCategoryFragmentDoc}
${FeaturedCohortsListPublicCohortFragmentDoc}`;

/**
 * __useDiscoverPageQuery__
 *
 * To run a query within a React component, call `useDiscoverPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscoverPageQuery(baseOptions?: Apollo.QueryHookOptions<DiscoverPageQuery, DiscoverPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverPageQuery, DiscoverPageQueryVariables>(DiscoverPageDocument, options);
      }
export function useDiscoverPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverPageQuery, DiscoverPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverPageQuery, DiscoverPageQueryVariables>(DiscoverPageDocument, options);
        }
export type DiscoverPageQueryHookResult = ReturnType<typeof useDiscoverPageQuery>;
export type DiscoverPageLazyQueryHookResult = ReturnType<typeof useDiscoverPageLazyQuery>;
export type DiscoverPageQueryResult = Apollo.QueryResult<DiscoverPageQuery, DiscoverPageQueryVariables>;
export const UpdateUserProfileCoverImageDocument = gql`
    mutation UpdateUserProfileCoverImage($input: UpdateProfileImageInput!) {
  updateUserProfileCoverImage(input: $input) {
    id
    userProfileCoverImage {
      id
      cloudinaryPublicId
      url
    }
  }
}
    `;
export type UpdateUserProfileCoverImageMutationFn = Apollo.MutationFunction<UpdateUserProfileCoverImageMutation, UpdateUserProfileCoverImageMutationVariables>;

/**
 * __useUpdateUserProfileCoverImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileCoverImageMutation, { data, loading, error }] = useUpdateUserProfileCoverImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileCoverImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileCoverImageMutation, UpdateUserProfileCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileCoverImageMutation, UpdateUserProfileCoverImageMutationVariables>(UpdateUserProfileCoverImageDocument, options);
      }
export type UpdateUserProfileCoverImageMutationHookResult = ReturnType<typeof useUpdateUserProfileCoverImageMutation>;
export type UpdateUserProfileCoverImageMutationResult = Apollo.MutationResult<UpdateUserProfileCoverImageMutation>;
export type UpdateUserProfileCoverImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileCoverImageMutation, UpdateUserProfileCoverImageMutationVariables>;
export const ProfileCoverUploaderConfigDocument = gql`
    query ProfileCoverUploaderConfig($uploadPreset: String, $notificationUrl: String) {
  MediaConfig {
    cloudinaryMediaSignature(
      uploadPreset: $uploadPreset
      notificationUrl: $notificationUrl
    ) {
      publicId
      signature
      timestamp
    }
  }
}
    `;

/**
 * __useProfileCoverUploaderConfigQuery__
 *
 * To run a query within a React component, call `useProfileCoverUploaderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileCoverUploaderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileCoverUploaderConfigQuery({
 *   variables: {
 *      uploadPreset: // value for 'uploadPreset'
 *      notificationUrl: // value for 'notificationUrl'
 *   },
 * });
 */
export function useProfileCoverUploaderConfigQuery(baseOptions?: Apollo.QueryHookOptions<ProfileCoverUploaderConfigQuery, ProfileCoverUploaderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileCoverUploaderConfigQuery, ProfileCoverUploaderConfigQueryVariables>(ProfileCoverUploaderConfigDocument, options);
      }
export function useProfileCoverUploaderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileCoverUploaderConfigQuery, ProfileCoverUploaderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileCoverUploaderConfigQuery, ProfileCoverUploaderConfigQueryVariables>(ProfileCoverUploaderConfigDocument, options);
        }
export type ProfileCoverUploaderConfigQueryHookResult = ReturnType<typeof useProfileCoverUploaderConfigQuery>;
export type ProfileCoverUploaderConfigLazyQueryHookResult = ReturnType<typeof useProfileCoverUploaderConfigLazyQuery>;
export type ProfileCoverUploaderConfigQueryResult = Apollo.QueryResult<ProfileCoverUploaderConfigQuery, ProfileCoverUploaderConfigQueryVariables>;
export const FeedHomePageDocument = gql`
    query FeedHomePage($maxPublicExperts: Int!) {
  publicFeaturedExperts(
    take: $maxPublicExperts
    where: {active: {equals: true}}
    orderBy: {sortOrder: asc}
  ) {
    ...FeedHomePageFeaturedExpert
  }
  expertList: publicFeaturedExperts(
    where: {active: {equals: true}}
    orderBy: {sortOrder: asc}
  ) {
    ...FeedExpertListContent
  }
  MediaConfig {
    ...AuditionMediaConfig
  }
}
    ${FeedHomePageFeaturedExpertFragmentDoc}
${FeedExpertListContentFragmentDoc}
${AuditionMediaConfigFragmentDoc}`;

/**
 * __useFeedHomePageQuery__
 *
 * To run a query within a React component, call `useFeedHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedHomePageQuery({
 *   variables: {
 *      maxPublicExperts: // value for 'maxPublicExperts'
 *   },
 * });
 */
export function useFeedHomePageQuery(baseOptions: Apollo.QueryHookOptions<FeedHomePageQuery, FeedHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedHomePageQuery, FeedHomePageQueryVariables>(FeedHomePageDocument, options);
      }
export function useFeedHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedHomePageQuery, FeedHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedHomePageQuery, FeedHomePageQueryVariables>(FeedHomePageDocument, options);
        }
export type FeedHomePageQueryHookResult = ReturnType<typeof useFeedHomePageQuery>;
export type FeedHomePageLazyQueryHookResult = ReturnType<typeof useFeedHomePageLazyQuery>;
export type FeedHomePageQueryResult = Apollo.QueryResult<FeedHomePageQuery, FeedHomePageQueryVariables>;
export const FeedDocument = gql`
    query Feed {
  feed(take: 3) {
    review {
      ...ReviewFragment
    }
  }
}
    ${ReviewFragmentFragmentDoc}`;

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedQuery(baseOptions?: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
      }
export function useFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export type FeedQueryHookResult = ReturnType<typeof useFeedQuery>;
export type FeedLazyQueryHookResult = ReturnType<typeof useFeedLazyQuery>;
export type FeedQueryResult = Apollo.QueryResult<FeedQuery, FeedQueryVariables>;
export const LoginAsUserPageDocument = gql`
    query LoginAsUserPage {
  users(orderBy: {createdAt: asc}) {
    id
    name
    username
    isExpert
    isAdmin
    isStudent
    profileImageUrl
    userProfileImage {
      url
    }
    userCohorts {
      id
      cohortId
      role {
        name
      }
      cohort {
        description
        state
      }
    }
  }
}
    `;

/**
 * __useLoginAsUserPageQuery__
 *
 * To run a query within a React component, call `useLoginAsUserPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsUserPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsUserPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginAsUserPageQuery(baseOptions?: Apollo.QueryHookOptions<LoginAsUserPageQuery, LoginAsUserPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsUserPageQuery, LoginAsUserPageQueryVariables>(LoginAsUserPageDocument, options);
      }
export function useLoginAsUserPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsUserPageQuery, LoginAsUserPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsUserPageQuery, LoginAsUserPageQueryVariables>(LoginAsUserPageDocument, options);
        }
export type LoginAsUserPageQueryHookResult = ReturnType<typeof useLoginAsUserPageQuery>;
export type LoginAsUserPageLazyQueryHookResult = ReturnType<typeof useLoginAsUserPageLazyQuery>;
export type LoginAsUserPageQueryResult = Apollo.QueryResult<LoginAsUserPageQuery, LoginAsUserPageQueryVariables>;
export const LoginAsUserDocument = gql`
    mutation LoginAsUser($userId: String!) {
  loginAsUser(userId: $userId) {
    id
    username
    profileImageUrl
  }
}
    `;
export type LoginAsUserMutationFn = Apollo.MutationFunction<LoginAsUserMutation, LoginAsUserMutationVariables>;

/**
 * __useLoginAsUserMutation__
 *
 * To run a mutation, you first call `useLoginAsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsUserMutation, { data, loading, error }] = useLoginAsUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLoginAsUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginAsUserMutation, LoginAsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAsUserMutation, LoginAsUserMutationVariables>(LoginAsUserDocument, options);
      }
export type LoginAsUserMutationHookResult = ReturnType<typeof useLoginAsUserMutation>;
export type LoginAsUserMutationResult = Apollo.MutationResult<LoginAsUserMutation>;
export type LoginAsUserMutationOptions = Apollo.BaseMutationOptions<LoginAsUserMutation, LoginAsUserMutationVariables>;
export const MusicianOnboardingDocument = gql`
    query MusicianOnboarding {
  myScholarshipApplicationReferral {
    id
    publicScholarshipApplication {
      id
      shortCode
      application {
        id
        user {
          id
          name
        }
        cohort {
          ...ApplicationVideoUploaderCohort
        }
      }
    }
    referredUser {
      id
      name
    }
  }
  viewer {
    id
    name
  }
}
    ${ApplicationVideoUploaderCohortFragmentDoc}`;

/**
 * __useMusicianOnboardingQuery__
 *
 * To run a query within a React component, call `useMusicianOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMusicianOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMusicianOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useMusicianOnboardingQuery(baseOptions?: Apollo.QueryHookOptions<MusicianOnboardingQuery, MusicianOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MusicianOnboardingQuery, MusicianOnboardingQueryVariables>(MusicianOnboardingDocument, options);
      }
export function useMusicianOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MusicianOnboardingQuery, MusicianOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MusicianOnboardingQuery, MusicianOnboardingQueryVariables>(MusicianOnboardingDocument, options);
        }
export type MusicianOnboardingQueryHookResult = ReturnType<typeof useMusicianOnboardingQuery>;
export type MusicianOnboardingLazyQueryHookResult = ReturnType<typeof useMusicianOnboardingLazyQuery>;
export type MusicianOnboardingQueryResult = Apollo.QueryResult<MusicianOnboardingQuery, MusicianOnboardingQueryVariables>;
export const CompleteApplicationScholarshipReferralDocument = gql`
    mutation CompleteApplicationScholarshipReferral($input: CompleteApplicationScholarshipReferralInput!) {
  completeApplicationScholarshipReferral(input: $input) {
    ... on CompleteScholarshipApplicationReferralErrorResponse {
      type
      message
    }
    ... on PrivilegedScholarshipApplicationReferral {
      id
    }
  }
}
    `;
export type CompleteApplicationScholarshipReferralMutationFn = Apollo.MutationFunction<CompleteApplicationScholarshipReferralMutation, CompleteApplicationScholarshipReferralMutationVariables>;

/**
 * __useCompleteApplicationScholarshipReferralMutation__
 *
 * To run a mutation, you first call `useCompleteApplicationScholarshipReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteApplicationScholarshipReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeApplicationScholarshipReferralMutation, { data, loading, error }] = useCompleteApplicationScholarshipReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteApplicationScholarshipReferralMutation(baseOptions?: Apollo.MutationHookOptions<CompleteApplicationScholarshipReferralMutation, CompleteApplicationScholarshipReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteApplicationScholarshipReferralMutation, CompleteApplicationScholarshipReferralMutationVariables>(CompleteApplicationScholarshipReferralDocument, options);
      }
export type CompleteApplicationScholarshipReferralMutationHookResult = ReturnType<typeof useCompleteApplicationScholarshipReferralMutation>;
export type CompleteApplicationScholarshipReferralMutationResult = Apollo.MutationResult<CompleteApplicationScholarshipReferralMutation>;
export type CompleteApplicationScholarshipReferralMutationOptions = Apollo.BaseMutationOptions<CompleteApplicationScholarshipReferralMutation, CompleteApplicationScholarshipReferralMutationVariables>;
export const ProfileEditStudentPageDocument = gql`
    query ProfileEditStudentPage {
  viewer {
    id
    hasAcceptedTOS
    ...UserProfileFormUser
  }
}
    ${UserProfileFormUserFragmentDoc}`;

/**
 * __useProfileEditStudentPageQuery__
 *
 * To run a query within a React component, call `useProfileEditStudentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileEditStudentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileEditStudentPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileEditStudentPageQuery(baseOptions?: Apollo.QueryHookOptions<ProfileEditStudentPageQuery, ProfileEditStudentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileEditStudentPageQuery, ProfileEditStudentPageQueryVariables>(ProfileEditStudentPageDocument, options);
      }
export function useProfileEditStudentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileEditStudentPageQuery, ProfileEditStudentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileEditStudentPageQuery, ProfileEditStudentPageQueryVariables>(ProfileEditStudentPageDocument, options);
        }
export type ProfileEditStudentPageQueryHookResult = ReturnType<typeof useProfileEditStudentPageQuery>;
export type ProfileEditStudentPageLazyQueryHookResult = ReturnType<typeof useProfileEditStudentPageLazyQuery>;
export type ProfileEditStudentPageQueryResult = Apollo.QueryResult<ProfileEditStudentPageQuery, ProfileEditStudentPageQueryVariables>;
export const ProfileExpertPageDocument = gql`
    query ProfileExpertPage {
  viewer {
    id
    name
    username
    profileImageUrl
    email
    isExpert
    isStudent
    bio
    cohorts(role: EXPERT) {
      id
      state
      name
    }
    applications {
      id
      state
      cohort {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProfileExpertPageQuery__
 *
 * To run a query within a React component, call `useProfileExpertPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileExpertPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileExpertPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileExpertPageQuery(baseOptions?: Apollo.QueryHookOptions<ProfileExpertPageQuery, ProfileExpertPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileExpertPageQuery, ProfileExpertPageQueryVariables>(ProfileExpertPageDocument, options);
      }
export function useProfileExpertPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileExpertPageQuery, ProfileExpertPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileExpertPageQuery, ProfileExpertPageQueryVariables>(ProfileExpertPageDocument, options);
        }
export type ProfileExpertPageQueryHookResult = ReturnType<typeof useProfileExpertPageQuery>;
export type ProfileExpertPageLazyQueryHookResult = ReturnType<typeof useProfileExpertPageLazyQuery>;
export type ProfileExpertPageQueryResult = Apollo.QueryResult<ProfileExpertPageQuery, ProfileExpertPageQueryVariables>;
export const UserProfileDocument = gql`
    query UserProfile {
  viewer {
    id
    name
    username
    profileImageUrl
    email
    createdAt
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const ProfileStudentPageDocument = gql`
    query ProfileStudentPage {
  viewer {
    id
    name
    username
    profileImageUrl
    email
    isExpert
    isStudent
    bio
    balance
    cohorts(role: STUDENT) {
      id
      state
      name
    }
    applications {
      id
      state
      createdAt
      cohort {
        id
        name
        expert {
          username
          profileImageUrl
        }
      }
    }
  }
}
    `;

/**
 * __useProfileStudentPageQuery__
 *
 * To run a query within a React component, call `useProfileStudentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileStudentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileStudentPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileStudentPageQuery(baseOptions?: Apollo.QueryHookOptions<ProfileStudentPageQuery, ProfileStudentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileStudentPageQuery, ProfileStudentPageQueryVariables>(ProfileStudentPageDocument, options);
      }
export function useProfileStudentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileStudentPageQuery, ProfileStudentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileStudentPageQuery, ProfileStudentPageQueryVariables>(ProfileStudentPageDocument, options);
        }
export type ProfileStudentPageQueryHookResult = ReturnType<typeof useProfileStudentPageQuery>;
export type ProfileStudentPageLazyQueryHookResult = ReturnType<typeof useProfileStudentPageLazyQuery>;
export type ProfileStudentPageQueryResult = Apollo.QueryResult<ProfileStudentPageQuery, ProfileStudentPageQueryVariables>;
export const GetProfileByUsernameDocument = gql`
    query GetProfileByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    isExpert
    ...RaiseExpertPageUser
  }
  MediaConfig {
    ...RaiseExpertPageMediaConfig
  }
}
    ${RaiseExpertPageUserFragmentDoc}
${RaiseExpertPageMediaConfigFragmentDoc}`;

/**
 * __useGetProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetProfileByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetProfileByUsernameQuery, GetProfileByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileByUsernameQuery, GetProfileByUsernameQueryVariables>(GetProfileByUsernameDocument, options);
      }
export function useGetProfileByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileByUsernameQuery, GetProfileByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileByUsernameQuery, GetProfileByUsernameQueryVariables>(GetProfileByUsernameDocument, options);
        }
export type GetProfileByUsernameQueryHookResult = ReturnType<typeof useGetProfileByUsernameQuery>;
export type GetProfileByUsernameLazyQueryHookResult = ReturnType<typeof useGetProfileByUsernameLazyQuery>;
export type GetProfileByUsernameQueryResult = Apollo.QueryResult<GetProfileByUsernameQuery, GetProfileByUsernameQueryVariables>;
export const ExpertWaitlistSubcribeDocument = gql`
    mutation ExpertWaitlistSubcribe($input: WaitlistSubscribeInput!) {
  expertWaitlistSubcribe(input: $input) {
    success
    error
  }
}
    `;
export type ExpertWaitlistSubcribeMutationFn = Apollo.MutationFunction<ExpertWaitlistSubcribeMutation, ExpertWaitlistSubcribeMutationVariables>;

/**
 * __useExpertWaitlistSubcribeMutation__
 *
 * To run a mutation, you first call `useExpertWaitlistSubcribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpertWaitlistSubcribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expertWaitlistSubcribeMutation, { data, loading, error }] = useExpertWaitlistSubcribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExpertWaitlistSubcribeMutation(baseOptions?: Apollo.MutationHookOptions<ExpertWaitlistSubcribeMutation, ExpertWaitlistSubcribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpertWaitlistSubcribeMutation, ExpertWaitlistSubcribeMutationVariables>(ExpertWaitlistSubcribeDocument, options);
      }
export type ExpertWaitlistSubcribeMutationHookResult = ReturnType<typeof useExpertWaitlistSubcribeMutation>;
export type ExpertWaitlistSubcribeMutationResult = Apollo.MutationResult<ExpertWaitlistSubcribeMutation>;
export type ExpertWaitlistSubcribeMutationOptions = Apollo.BaseMutationOptions<ExpertWaitlistSubcribeMutation, ExpertWaitlistSubcribeMutationVariables>;
export const GetViewerDocument = gql`
    query GetViewer {
  viewer {
    id
    email
  }
}
    `;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
      }
export function useGetViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
        }
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<typeof useGetViewerLazyQuery>;
export type GetViewerQueryResult = Apollo.QueryResult<GetViewerQuery, GetViewerQueryVariables>;
export const GetCohortRecommendationsDocument = gql`
    query GetCohortRecommendations($input: CohortsRecommendationInput!) {
  getCohortRecommendations(input: $input) {
    id
    ...FeaturedCohortsListPublicCohort
  }
}
    ${FeaturedCohortsListPublicCohortFragmentDoc}`;

/**
 * __useGetCohortRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetCohortRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCohortRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetCohortRecommendationsQuery, GetCohortRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortRecommendationsQuery, GetCohortRecommendationsQueryVariables>(GetCohortRecommendationsDocument, options);
      }
export function useGetCohortRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortRecommendationsQuery, GetCohortRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortRecommendationsQuery, GetCohortRecommendationsQueryVariables>(GetCohortRecommendationsDocument, options);
        }
export type GetCohortRecommendationsQueryHookResult = ReturnType<typeof useGetCohortRecommendationsQuery>;
export type GetCohortRecommendationsLazyQueryHookResult = ReturnType<typeof useGetCohortRecommendationsLazyQuery>;
export type GetCohortRecommendationsQueryResult = Apollo.QueryResult<GetCohortRecommendationsQuery, GetCohortRecommendationsQueryVariables>;
export const GetFeaturedExpertsDocument = gql`
    query GetFeaturedExperts {
  publicFeaturedExperts(
    where: {active: {equals: true}}
    orderBy: {sortOrder: asc}
  ) {
    ...RaiseHomePageFeaturedExpert
  }
  MediaConfig {
    ...AuditionMediaConfig
  }
  featuredApplications(orderBy: {sortOrder: asc}) {
    ...RaiseHomePageBaseFeaturedApplication
  }
}
    ${RaiseHomePageFeaturedExpertFragmentDoc}
${AuditionMediaConfigFragmentDoc}
${RaiseHomePageBaseFeaturedApplicationFragmentDoc}`;

/**
 * __useGetFeaturedExpertsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedExpertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedExpertsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedExpertsQuery, GetFeaturedExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedExpertsQuery, GetFeaturedExpertsQueryVariables>(GetFeaturedExpertsDocument, options);
      }
export function useGetFeaturedExpertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedExpertsQuery, GetFeaturedExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedExpertsQuery, GetFeaturedExpertsQueryVariables>(GetFeaturedExpertsDocument, options);
        }
export type GetFeaturedExpertsQueryHookResult = ReturnType<typeof useGetFeaturedExpertsQuery>;
export type GetFeaturedExpertsLazyQueryHookResult = ReturnType<typeof useGetFeaturedExpertsLazyQuery>;
export type GetFeaturedExpertsQueryResult = Apollo.QueryResult<GetFeaturedExpertsQuery, GetFeaturedExpertsQueryVariables>;
export const GetCohortRecommendationsForTypeFormDocument = gql`
    query GetCohortRecommendationsForTypeForm($responseId: String!) {
  getCohortRecommendationsForTypeForm(responseId: $responseId) {
    id
    ...MatchedCohortsListPublicCohort
  }
}
    ${MatchedCohortsListPublicCohortFragmentDoc}`;

/**
 * __useGetCohortRecommendationsForTypeFormQuery__
 *
 * To run a query within a React component, call `useGetCohortRecommendationsForTypeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortRecommendationsForTypeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortRecommendationsForTypeFormQuery({
 *   variables: {
 *      responseId: // value for 'responseId'
 *   },
 * });
 */
export function useGetCohortRecommendationsForTypeFormQuery(baseOptions: Apollo.QueryHookOptions<GetCohortRecommendationsForTypeFormQuery, GetCohortRecommendationsForTypeFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortRecommendationsForTypeFormQuery, GetCohortRecommendationsForTypeFormQueryVariables>(GetCohortRecommendationsForTypeFormDocument, options);
      }
export function useGetCohortRecommendationsForTypeFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortRecommendationsForTypeFormQuery, GetCohortRecommendationsForTypeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortRecommendationsForTypeFormQuery, GetCohortRecommendationsForTypeFormQueryVariables>(GetCohortRecommendationsForTypeFormDocument, options);
        }
export type GetCohortRecommendationsForTypeFormQueryHookResult = ReturnType<typeof useGetCohortRecommendationsForTypeFormQuery>;
export type GetCohortRecommendationsForTypeFormLazyQueryHookResult = ReturnType<typeof useGetCohortRecommendationsForTypeFormLazyQuery>;
export type GetCohortRecommendationsForTypeFormQueryResult = Apollo.QueryResult<GetCohortRecommendationsForTypeFormQuery, GetCohortRecommendationsForTypeFormQueryVariables>;
export const ReferralOnboardingPageDocument = gql`
    query ReferralOnboardingPage($shortCode: String!) {
  publicScholarshipApplication(where: {shortCode: $shortCode}) {
    id
    application {
      id
      cohort {
        id
        expert {
          id
          name
        }
      }
      user {
        id
        name
      }
    }
  }
  publicCohorts(where: {featured: {equals: true}}, isActive: true) {
    id
    expert {
      id
      username
      userProfileAlternateImage {
        id
        cloudinaryPublicId
      }
      userProfileImage {
        id
        cloudinaryPublicId
      }
    }
  }
}
    `;

/**
 * __useReferralOnboardingPageQuery__
 *
 * To run a query within a React component, call `useReferralOnboardingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralOnboardingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralOnboardingPageQuery({
 *   variables: {
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useReferralOnboardingPageQuery(baseOptions: Apollo.QueryHookOptions<ReferralOnboardingPageQuery, ReferralOnboardingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralOnboardingPageQuery, ReferralOnboardingPageQueryVariables>(ReferralOnboardingPageDocument, options);
      }
export function useReferralOnboardingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralOnboardingPageQuery, ReferralOnboardingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralOnboardingPageQuery, ReferralOnboardingPageQueryVariables>(ReferralOnboardingPageDocument, options);
        }
export type ReferralOnboardingPageQueryHookResult = ReturnType<typeof useReferralOnboardingPageQuery>;
export type ReferralOnboardingPageLazyQueryHookResult = ReturnType<typeof useReferralOnboardingPageLazyQuery>;
export type ReferralOnboardingPageQueryResult = Apollo.QueryResult<ReferralOnboardingPageQuery, ReferralOnboardingPageQueryVariables>;
export const GetConversationDocument = gql`
    query GetConversation($cohortId: String!) {
  viewer {
    conversation: conversationByCohort(cohortId: $cohortId) {
      id
    }
  }
}
    `;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const ScholarshipPageDocument = gql`
    query ScholarshipPage($applicationId: String!) {
  publicApplication(where: {id: $applicationId}) {
    id
    isScholarship
    user {
      id
      username
    }
  }
}
    `;

/**
 * __useScholarshipPageQuery__
 *
 * To run a query within a React component, call `useScholarshipPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScholarshipPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScholarshipPageQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useScholarshipPageQuery(baseOptions: Apollo.QueryHookOptions<ScholarshipPageQuery, ScholarshipPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScholarshipPageQuery, ScholarshipPageQueryVariables>(ScholarshipPageDocument, options);
      }
export function useScholarshipPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScholarshipPageQuery, ScholarshipPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScholarshipPageQuery, ScholarshipPageQueryVariables>(ScholarshipPageDocument, options);
        }
export type ScholarshipPageQueryHookResult = ReturnType<typeof useScholarshipPageQuery>;
export type ScholarshipPageLazyQueryHookResult = ReturnType<typeof useScholarshipPageLazyQuery>;
export type ScholarshipPageQueryResult = Apollo.QueryResult<ScholarshipPageQuery, ScholarshipPageQueryVariables>;
export const SitemapPageDocument = gql`
    query SitemapPage {
  publicCohorts(where: {featured: {equals: true}}, isActive: true) {
    id
    expert {
      username
    }
  }
}
    `;

/**
 * __useSitemapPageQuery__
 *
 * To run a query within a React component, call `useSitemapPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitemapPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitemapPageQuery(baseOptions?: Apollo.QueryHookOptions<SitemapPageQuery, SitemapPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitemapPageQuery, SitemapPageQueryVariables>(SitemapPageDocument, options);
      }
export function useSitemapPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitemapPageQuery, SitemapPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitemapPageQuery, SitemapPageQueryVariables>(SitemapPageDocument, options);
        }
export type SitemapPageQueryHookResult = ReturnType<typeof useSitemapPageQuery>;
export type SitemapPageLazyQueryHookResult = ReturnType<typeof useSitemapPageLazyQuery>;
export type SitemapPageQueryResult = Apollo.QueryResult<SitemapPageQuery, SitemapPageQueryVariables>;
export const GetStudentFeedbackDocument = gql`
    query GetStudentFeedback($username: String!, $applicationId: String!) {
  userByUsername(username: $username) {
    name
    username
    bio
    ...StudentPublicUserFeedback
  }
  MediaConfig {
    ...StudentPublicApplicationVideoMediaConfig
  }
}
    ${StudentPublicUserFeedbackFragmentDoc}
${StudentPublicApplicationVideoMediaConfigFragmentDoc}`;

/**
 * __useGetStudentFeedbackQuery__
 *
 * To run a query within a React component, call `useGetStudentFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentFeedbackQuery({
 *   variables: {
 *      username: // value for 'username'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetStudentFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetStudentFeedbackQuery, GetStudentFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentFeedbackQuery, GetStudentFeedbackQueryVariables>(GetStudentFeedbackDocument, options);
      }
export function useGetStudentFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentFeedbackQuery, GetStudentFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentFeedbackQuery, GetStudentFeedbackQueryVariables>(GetStudentFeedbackDocument, options);
        }
export type GetStudentFeedbackQueryHookResult = ReturnType<typeof useGetStudentFeedbackQuery>;
export type GetStudentFeedbackLazyQueryHookResult = ReturnType<typeof useGetStudentFeedbackLazyQuery>;
export type GetStudentFeedbackQueryResult = Apollo.QueryResult<GetStudentFeedbackQuery, GetStudentFeedbackQueryVariables>;
export const ScholarshipUpvoteDocument = gql`
    mutation ScholarshipUpvote($applicationId: ID!) {
  scholarshipUpvote(applicationId: $applicationId) {
    ... on PrivilegedApplication {
      id
      scholarshipApplication {
        id
        totalUpvote
      }
    }
    ... on ScholarshipUpvoteErrorResponse {
      type
    }
  }
}
    `;
export type ScholarshipUpvoteMutationFn = Apollo.MutationFunction<ScholarshipUpvoteMutation, ScholarshipUpvoteMutationVariables>;

/**
 * __useScholarshipUpvoteMutation__
 *
 * To run a mutation, you first call `useScholarshipUpvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScholarshipUpvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scholarshipUpvoteMutation, { data, loading, error }] = useScholarshipUpvoteMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useScholarshipUpvoteMutation(baseOptions?: Apollo.MutationHookOptions<ScholarshipUpvoteMutation, ScholarshipUpvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScholarshipUpvoteMutation, ScholarshipUpvoteMutationVariables>(ScholarshipUpvoteDocument, options);
      }
export type ScholarshipUpvoteMutationHookResult = ReturnType<typeof useScholarshipUpvoteMutation>;
export type ScholarshipUpvoteMutationResult = Apollo.MutationResult<ScholarshipUpvoteMutation>;
export type ScholarshipUpvoteMutationOptions = Apollo.BaseMutationOptions<ScholarshipUpvoteMutation, ScholarshipUpvoteMutationVariables>;
export const GetStudentApplicationDocument = gql`
    query GetStudentApplication($username: String!, $applicationId: String!) {
  userByUsername(username: $username) {
    name
    username
    ...StudentPublicUser
  }
  MediaConfig {
    ...StudentPublicApplicationVideoMediaConfig
  }
}
    ${StudentPublicUserFragmentDoc}
${StudentPublicApplicationVideoMediaConfigFragmentDoc}`;

/**
 * __useGetStudentApplicationQuery__
 *
 * To run a query within a React component, call `useGetStudentApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentApplicationQuery({
 *   variables: {
 *      username: // value for 'username'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetStudentApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetStudentApplicationQuery, GetStudentApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentApplicationQuery, GetStudentApplicationQueryVariables>(GetStudentApplicationDocument, options);
      }
export function useGetStudentApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentApplicationQuery, GetStudentApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentApplicationQuery, GetStudentApplicationQueryVariables>(GetStudentApplicationDocument, options);
        }
export type GetStudentApplicationQueryHookResult = ReturnType<typeof useGetStudentApplicationQuery>;
export type GetStudentApplicationLazyQueryHookResult = ReturnType<typeof useGetStudentApplicationLazyQuery>;
export type GetStudentApplicationQueryResult = Apollo.QueryResult<GetStudentApplicationQuery, GetStudentApplicationQueryVariables>;
export const StudentConversationDocument = gql`
    query StudentConversation($take: Int, $skip: Int, $cohortId: String!, $orderBy: [MessageOrderByWithRelationInput!], $timezone: String!) {
  viewer {
    id
    name
    username
    profileImageUrl
    isStudent
    userProfileImage {
      cloudinaryPublicId
    }
    userProfileCoverImage {
      cloudinaryPublicId
    }
    bio
    ...StudentLayoutProfileSocial
    freeMessagesEnabled(entityId: $cohortId, entityType: Cohort)
    conversation: conversationByCohort(cohortId: $cohortId) {
      id
      messages(take: $take, skip: $skip, orderBy: $orderBy) {
        pageInfo {
          activePage
          perPage
          totalPages
          totalCount
          hasPrevious
          hasNext
        }
        data {
          ...ConversationData
        }
      }
    }
    cohort(id: $cohortId) {
      ...ConversationMessageCohort
      ...ConversationApplicationDetails
    }
  }
  MediaConfig {
    ...StudentConversationMediaConfig
  }
}
    ${StudentLayoutProfileSocialFragmentDoc}
${ConversationDataFragmentDoc}
${ConversationMessageCohortFragmentDoc}
${ConversationApplicationDetailsFragmentDoc}
${StudentConversationMediaConfigFragmentDoc}`;

/**
 * __useStudentConversationQuery__
 *
 * To run a query within a React component, call `useStudentConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentConversationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      cohortId: // value for 'cohortId'
 *      orderBy: // value for 'orderBy'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useStudentConversationQuery(baseOptions: Apollo.QueryHookOptions<StudentConversationQuery, StudentConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentConversationQuery, StudentConversationQueryVariables>(StudentConversationDocument, options);
      }
export function useStudentConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentConversationQuery, StudentConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentConversationQuery, StudentConversationQueryVariables>(StudentConversationDocument, options);
        }
export type StudentConversationQueryHookResult = ReturnType<typeof useStudentConversationQuery>;
export type StudentConversationLazyQueryHookResult = ReturnType<typeof useStudentConversationLazyQuery>;
export type StudentConversationQueryResult = Apollo.QueryResult<StudentConversationQuery, StudentConversationQueryVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    id
    conversation {
      id
    }
    entity {
      ... on Media {
        __typename
        id
        cloudinaryPublicId
      }
    }
  }
}
    `;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const GetStudentProfileByUsernameDocument = gql`
    query GetStudentProfileByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    ...StudentUserProfile
  }
}
    ${StudentUserProfileFragmentDoc}`;

/**
 * __useGetStudentProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetStudentProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetStudentProfileByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetStudentProfileByUsernameQuery, GetStudentProfileByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentProfileByUsernameQuery, GetStudentProfileByUsernameQueryVariables>(GetStudentProfileByUsernameDocument, options);
      }
export function useGetStudentProfileByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentProfileByUsernameQuery, GetStudentProfileByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentProfileByUsernameQuery, GetStudentProfileByUsernameQueryVariables>(GetStudentProfileByUsernameDocument, options);
        }
export type GetStudentProfileByUsernameQueryHookResult = ReturnType<typeof useGetStudentProfileByUsernameQuery>;
export type GetStudentProfileByUsernameLazyQueryHookResult = ReturnType<typeof useGetStudentProfileByUsernameLazyQuery>;
export type GetStudentProfileByUsernameQueryResult = Apollo.QueryResult<GetStudentProfileByUsernameQuery, GetStudentProfileByUsernameQueryVariables>;
export const GetUserPublicApplicationsDocument = gql`
    query GetUserPublicApplications($userById: String!) {
  userById(id: $userById) {
    id
    publicApplications {
      ...VideoGalleryPublicApplication
    }
  }
}
    ${VideoGalleryPublicApplicationFragmentDoc}`;

/**
 * __useGetUserPublicApplicationsQuery__
 *
 * To run a query within a React component, call `useGetUserPublicApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPublicApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPublicApplicationsQuery({
 *   variables: {
 *      userById: // value for 'userById'
 *   },
 * });
 */
export function useGetUserPublicApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPublicApplicationsQuery, GetUserPublicApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPublicApplicationsQuery, GetUserPublicApplicationsQueryVariables>(GetUserPublicApplicationsDocument, options);
      }
export function useGetUserPublicApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPublicApplicationsQuery, GetUserPublicApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPublicApplicationsQuery, GetUserPublicApplicationsQueryVariables>(GetUserPublicApplicationsDocument, options);
        }
export type GetUserPublicApplicationsQueryHookResult = ReturnType<typeof useGetUserPublicApplicationsQuery>;
export type GetUserPublicApplicationsLazyQueryHookResult = ReturnType<typeof useGetUserPublicApplicationsLazyQuery>;
export type GetUserPublicApplicationsQueryResult = Apollo.QueryResult<GetUserPublicApplicationsQuery, GetUserPublicApplicationsQueryVariables>;
export const GetUserCredentialAssignmentReceivedDocument = gql`
    query GetUserCredentialAssignmentReceived($userById: String!) {
  userById(id: $userById) {
    id
    credentialAssignmentReceived(credentialNames: [Protege, TopProspect]) {
      from {
        __typename
        ... on PublicUser {
          id
          username
          name
          userProfileImage {
            cloudinaryPublicId
          }
        }
        ... on PublicCohort {
          id
          expert {
            username
            name
            userProfileImage {
              cloudinaryPublicId
            }
          }
        }
      }
      credential {
        id
        name
        description
        iconUrl
      }
      createdAt(format: NUMERIC)
    }
  }
}
    `;

/**
 * __useGetUserCredentialAssignmentReceivedQuery__
 *
 * To run a query within a React component, call `useGetUserCredentialAssignmentReceivedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCredentialAssignmentReceivedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCredentialAssignmentReceivedQuery({
 *   variables: {
 *      userById: // value for 'userById'
 *   },
 * });
 */
export function useGetUserCredentialAssignmentReceivedQuery(baseOptions: Apollo.QueryHookOptions<GetUserCredentialAssignmentReceivedQuery, GetUserCredentialAssignmentReceivedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCredentialAssignmentReceivedQuery, GetUserCredentialAssignmentReceivedQueryVariables>(GetUserCredentialAssignmentReceivedDocument, options);
      }
export function useGetUserCredentialAssignmentReceivedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCredentialAssignmentReceivedQuery, GetUserCredentialAssignmentReceivedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCredentialAssignmentReceivedQuery, GetUserCredentialAssignmentReceivedQueryVariables>(GetUserCredentialAssignmentReceivedDocument, options);
        }
export type GetUserCredentialAssignmentReceivedQueryHookResult = ReturnType<typeof useGetUserCredentialAssignmentReceivedQuery>;
export type GetUserCredentialAssignmentReceivedLazyQueryHookResult = ReturnType<typeof useGetUserCredentialAssignmentReceivedLazyQuery>;
export type GetUserCredentialAssignmentReceivedQueryResult = Apollo.QueryResult<GetUserCredentialAssignmentReceivedQuery, GetUserCredentialAssignmentReceivedQueryVariables>;
export const GetPopularStudentsDocument = gql`
    query GetPopularStudents {
  experts {
    username
  }
}
    `;

/**
 * __useGetPopularStudentsQuery__
 *
 * To run a query within a React component, call `useGetPopularStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopularStudentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPopularStudentsQuery, GetPopularStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularStudentsQuery, GetPopularStudentsQueryVariables>(GetPopularStudentsDocument, options);
      }
export function useGetPopularStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularStudentsQuery, GetPopularStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularStudentsQuery, GetPopularStudentsQueryVariables>(GetPopularStudentsDocument, options);
        }
export type GetPopularStudentsQueryHookResult = ReturnType<typeof useGetPopularStudentsQuery>;
export type GetPopularStudentsLazyQueryHookResult = ReturnType<typeof useGetPopularStudentsLazyQuery>;
export type GetPopularStudentsQueryResult = Apollo.QueryResult<GetPopularStudentsQuery, GetPopularStudentsQueryVariables>;
export const StudentProfileDocument = gql`
    query StudentProfile {
  viewer {
    id
    name
    username
    profileImageUrl
    twitterUrl
    instagramUrl
    linkedInUrl
    soundcloudUrl
    twitterUsername
    instagramUsername
    linkedInUsername
    soundcloudUsername
    isStudent
    userProfileImage {
      cloudinaryPublicId
    }
    userProfileCoverImage {
      cloudinaryPublicId
    }
    bio
    ...StudentLayoutProfileSocial
    applications {
      ...StudentProfileApplication
    }
  }
  MediaConfig {
    APPLICATION_VIDEO_720p {
      transformation
    }
  }
}
    ${StudentLayoutProfileSocialFragmentDoc}
${StudentProfileApplicationFragmentDoc}`;

/**
 * __useStudentProfileQuery__
 *
 * To run a query within a React component, call `useStudentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentProfileQuery(baseOptions?: Apollo.QueryHookOptions<StudentProfileQuery, StudentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, options);
      }
export function useStudentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentProfileQuery, StudentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, options);
        }
export type StudentProfileQueryHookResult = ReturnType<typeof useStudentProfileQuery>;
export type StudentProfileLazyQueryHookResult = ReturnType<typeof useStudentProfileLazyQuery>;
export type StudentProfileQueryResult = Apollo.QueryResult<StudentProfileQuery, StudentProfileQueryVariables>;
export const StudentProfileApplicationDocument = gql`
    query StudentProfileApplication($applicationId: String!, $timezone: String!) {
  viewer {
    id
    name
    username
    profileImageUrl
    isStudent
    userProfileImage {
      cloudinaryPublicId
    }
    userProfileCoverImage {
      cloudinaryPublicId
    }
    bio
    ...StudentLayoutProfileSocial
    application(id: $applicationId) {
      id
      shareableAssetMediaUrl {
        lowQuality
        higQuality
      }
      ...FeedBackStudentProfilePrivilegedApplication
      cohort {
        id
      }
    }
    ...StudentProfileCoachingUser
    ...StudentProfileOpportunityUser
    ...StudentLayoutProfileSocial
  }
  MediaConfig {
    APPLICATION_VIDEO_720p {
      transformation
    }
  }
}
    ${StudentLayoutProfileSocialFragmentDoc}
${FeedBackStudentProfilePrivilegedApplicationFragmentDoc}
${StudentProfileCoachingUserFragmentDoc}
${StudentProfileOpportunityUserFragmentDoc}`;

/**
 * __useStudentProfileApplicationQuery__
 *
 * To run a query within a React component, call `useStudentProfileApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentProfileApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentProfileApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useStudentProfileApplicationQuery(baseOptions: Apollo.QueryHookOptions<StudentProfileApplicationQuery, StudentProfileApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentProfileApplicationQuery, StudentProfileApplicationQueryVariables>(StudentProfileApplicationDocument, options);
      }
export function useStudentProfileApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentProfileApplicationQuery, StudentProfileApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentProfileApplicationQuery, StudentProfileApplicationQueryVariables>(StudentProfileApplicationDocument, options);
        }
export type StudentProfileApplicationQueryHookResult = ReturnType<typeof useStudentProfileApplicationQuery>;
export type StudentProfileApplicationLazyQueryHookResult = ReturnType<typeof useStudentProfileApplicationLazyQuery>;
export type StudentProfileApplicationQueryResult = Apollo.QueryResult<StudentProfileApplicationQuery, StudentProfileApplicationQueryVariables>;
export const ToggleApplicationVisibilityDocument = gql`
    mutation ToggleApplicationVisibility($applicationId: ID!) {
  toggleApplicationVisibility(applicationId: $applicationId) {
    id
    isPublic
    isScholarship
  }
}
    `;
export type ToggleApplicationVisibilityMutationFn = Apollo.MutationFunction<ToggleApplicationVisibilityMutation, ToggleApplicationVisibilityMutationVariables>;

/**
 * __useToggleApplicationVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleApplicationVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleApplicationVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleApplicationVisibilityMutation, { data, loading, error }] = useToggleApplicationVisibilityMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useToggleApplicationVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleApplicationVisibilityMutation, ToggleApplicationVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleApplicationVisibilityMutation, ToggleApplicationVisibilityMutationVariables>(ToggleApplicationVisibilityDocument, options);
      }
export type ToggleApplicationVisibilityMutationHookResult = ReturnType<typeof useToggleApplicationVisibilityMutation>;
export type ToggleApplicationVisibilityMutationResult = Apollo.MutationResult<ToggleApplicationVisibilityMutation>;
export type ToggleApplicationVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleApplicationVisibilityMutation, ToggleApplicationVisibilityMutationVariables>;
export const ApplicationRefundDocument = gql`
    mutation ApplicationRefund($applicationId: String!) {
  applicationRefund(applicationId: $applicationId) {
    ... on PrivilegedApplication {
      id
      state
    }
    ... on ApplicationRefundErrorResponse {
      message
      type
    }
  }
}
    `;
export type ApplicationRefundMutationFn = Apollo.MutationFunction<ApplicationRefundMutation, ApplicationRefundMutationVariables>;

/**
 * __useApplicationRefundMutation__
 *
 * To run a mutation, you first call `useApplicationRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationRefundMutation, { data, loading, error }] = useApplicationRefundMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationRefundMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationRefundMutation, ApplicationRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationRefundMutation, ApplicationRefundMutationVariables>(ApplicationRefundDocument, options);
      }
export type ApplicationRefundMutationHookResult = ReturnType<typeof useApplicationRefundMutation>;
export type ApplicationRefundMutationResult = Apollo.MutationResult<ApplicationRefundMutation>;
export type ApplicationRefundMutationOptions = Apollo.BaseMutationOptions<ApplicationRefundMutation, ApplicationRefundMutationVariables>;
export const ScholarshipToPaidApplicationDocument = gql`
    mutation ScholarshipToPaidApplication($applicationId: ID!) {
  scholarshipToPaidApplication(applicationId: $applicationId) {
    ... on PrivilegedApplication {
      id
    }
    ... on ScholarshipToPaidApplicationErrorResponse {
      type
      message
    }
  }
}
    `;
export type ScholarshipToPaidApplicationMutationFn = Apollo.MutationFunction<ScholarshipToPaidApplicationMutation, ScholarshipToPaidApplicationMutationVariables>;

/**
 * __useScholarshipToPaidApplicationMutation__
 *
 * To run a mutation, you first call `useScholarshipToPaidApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScholarshipToPaidApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scholarshipToPaidApplicationMutation, { data, loading, error }] = useScholarshipToPaidApplicationMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useScholarshipToPaidApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ScholarshipToPaidApplicationMutation, ScholarshipToPaidApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScholarshipToPaidApplicationMutation, ScholarshipToPaidApplicationMutationVariables>(ScholarshipToPaidApplicationDocument, options);
      }
export type ScholarshipToPaidApplicationMutationHookResult = ReturnType<typeof useScholarshipToPaidApplicationMutation>;
export type ScholarshipToPaidApplicationMutationResult = Apollo.MutationResult<ScholarshipToPaidApplicationMutation>;
export type ScholarshipToPaidApplicationMutationOptions = Apollo.BaseMutationOptions<ScholarshipToPaidApplicationMutation, ScholarshipToPaidApplicationMutationVariables>;
export const ReviewsFromUserDocument = gql`
    query ReviewsFromUser($username: String!) {
  MediaConfig {
    ...VideoPlayerMediaConfig
  }
  userByUsername(username: $username) {
    reviews {
      ...ReviewFragment
    }
  }
}
    ${VideoPlayerMediaConfigFragmentDoc}
${ReviewFragmentFragmentDoc}`;

/**
 * __useReviewsFromUserQuery__
 *
 * To run a query within a React component, call `useReviewsFromUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsFromUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsFromUserQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useReviewsFromUserQuery(baseOptions: Apollo.QueryHookOptions<ReviewsFromUserQuery, ReviewsFromUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsFromUserQuery, ReviewsFromUserQueryVariables>(ReviewsFromUserDocument, options);
      }
export function useReviewsFromUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsFromUserQuery, ReviewsFromUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsFromUserQuery, ReviewsFromUserQueryVariables>(ReviewsFromUserDocument, options);
        }
export type ReviewsFromUserQueryHookResult = ReturnType<typeof useReviewsFromUserQuery>;
export type ReviewsFromUserLazyQueryHookResult = ReturnType<typeof useReviewsFromUserLazyQuery>;
export type ReviewsFromUserQueryResult = Apollo.QueryResult<ReviewsFromUserQuery, ReviewsFromUserQueryVariables>;
export const FeedReviewsDocument = gql`
    query FeedReviews($loadPrependedReviewId: Boolean!, $prependedReviewId: ID!) {
  featuredReviews {
    ...ReviewFragment
  }
  publicReview(id: $prependedReviewId) @include(if: $loadPrependedReviewId) {
    ...ReviewFragment
  }
}
    ${ReviewFragmentFragmentDoc}`;

/**
 * __useFeedReviewsQuery__
 *
 * To run a query within a React component, call `useFeedReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedReviewsQuery({
 *   variables: {
 *      loadPrependedReviewId: // value for 'loadPrependedReviewId'
 *      prependedReviewId: // value for 'prependedReviewId'
 *   },
 * });
 */
export function useFeedReviewsQuery(baseOptions: Apollo.QueryHookOptions<FeedReviewsQuery, FeedReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedReviewsQuery, FeedReviewsQueryVariables>(FeedReviewsDocument, options);
      }
export function useFeedReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedReviewsQuery, FeedReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedReviewsQuery, FeedReviewsQueryVariables>(FeedReviewsDocument, options);
        }
export type FeedReviewsQueryHookResult = ReturnType<typeof useFeedReviewsQuery>;
export type FeedReviewsLazyQueryHookResult = ReturnType<typeof useFeedReviewsLazyQuery>;
export type FeedReviewsQueryResult = Apollo.QueryResult<FeedReviewsQuery, FeedReviewsQueryVariables>;
export const ReviewByIdDocument = gql`
    query ReviewById($reviewId: ID!) {
  publicReview(id: $reviewId) {
    ...ReviewFragment
  }
}
    ${ReviewFragmentFragmentDoc}`;

/**
 * __useReviewByIdQuery__
 *
 * To run a query within a React component, call `useReviewByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewByIdQuery({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *   },
 * });
 */
export function useReviewByIdQuery(baseOptions: Apollo.QueryHookOptions<ReviewByIdQuery, ReviewByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewByIdQuery, ReviewByIdQueryVariables>(ReviewByIdDocument, options);
      }
export function useReviewByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewByIdQuery, ReviewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewByIdQuery, ReviewByIdQueryVariables>(ReviewByIdDocument, options);
        }
export type ReviewByIdQueryHookResult = ReturnType<typeof useReviewByIdQuery>;
export type ReviewByIdLazyQueryHookResult = ReturnType<typeof useReviewByIdLazyQuery>;
export type ReviewByIdQueryResult = Apollo.QueryResult<ReviewByIdQuery, ReviewByIdQueryVariables>;
export const LikeReviewDocument = gql`
    mutation LikeReview($reviewId: ID!) {
  likeReview(reviewId: $reviewId) {
    ...ReviewFragment
  }
}
    ${ReviewFragmentFragmentDoc}`;
export type LikeReviewMutationFn = Apollo.MutationFunction<LikeReviewMutation, LikeReviewMutationVariables>;

/**
 * __useLikeReviewMutation__
 *
 * To run a mutation, you first call `useLikeReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeReviewMutation, { data, loading, error }] = useLikeReviewMutation({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *   },
 * });
 */
export function useLikeReviewMutation(baseOptions?: Apollo.MutationHookOptions<LikeReviewMutation, LikeReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeReviewMutation, LikeReviewMutationVariables>(LikeReviewDocument, options);
      }
export type LikeReviewMutationHookResult = ReturnType<typeof useLikeReviewMutation>;
export type LikeReviewMutationResult = Apollo.MutationResult<LikeReviewMutation>;
export type LikeReviewMutationOptions = Apollo.BaseMutationOptions<LikeReviewMutation, LikeReviewMutationVariables>;
export const WalletPageDocument = gql`
    query WalletPage {
  viewer {
    id
    balance
    createSetupIntentForStripe {
      clientSecret
    }
    storedCardPaymentMethodsForStripe {
      id
      brand
      last4
    }
    refundsForStripe {
      id
      amount
      brand
      last4
    }
  }
}
    `;

/**
 * __useWalletPageQuery__
 *
 * To run a query within a React component, call `useWalletPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletPageQuery(baseOptions?: Apollo.QueryHookOptions<WalletPageQuery, WalletPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletPageQuery, WalletPageQueryVariables>(WalletPageDocument, options);
      }
export function useWalletPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletPageQuery, WalletPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletPageQuery, WalletPageQueryVariables>(WalletPageDocument, options);
        }
export type WalletPageQueryHookResult = ReturnType<typeof useWalletPageQuery>;
export type WalletPageLazyQueryHookResult = ReturnType<typeof useWalletPageLazyQuery>;
export type WalletPageQueryResult = Apollo.QueryResult<WalletPageQuery, WalletPageQueryVariables>;
export const StudentWithdrawDocument = gql`
    mutation StudentWithdraw($input: WithdrawInput!) {
  withdraw: withdrawForStripe(input: $input) {
    refundIntent {
      id
    }
  }
}
    `;
export type StudentWithdrawMutationFn = Apollo.MutationFunction<StudentWithdrawMutation, StudentWithdrawMutationVariables>;

/**
 * __useStudentWithdrawMutation__
 *
 * To run a mutation, you first call `useStudentWithdrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentWithdrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentWithdrawMutation, { data, loading, error }] = useStudentWithdrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentWithdrawMutation(baseOptions?: Apollo.MutationHookOptions<StudentWithdrawMutation, StudentWithdrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentWithdrawMutation, StudentWithdrawMutationVariables>(StudentWithdrawDocument, options);
      }
export type StudentWithdrawMutationHookResult = ReturnType<typeof useStudentWithdrawMutation>;
export type StudentWithdrawMutationResult = Apollo.MutationResult<StudentWithdrawMutation>;
export type StudentWithdrawMutationOptions = Apollo.BaseMutationOptions<StudentWithdrawMutation, StudentWithdrawMutationVariables>;
export const RemoveStudentCardDocument = gql`
    mutation RemoveStudentCard($cardId: String!) {
  removeCard: removeCardForStripe(cardId: $cardId) {
    id
  }
}
    `;
export type RemoveStudentCardMutationFn = Apollo.MutationFunction<RemoveStudentCardMutation, RemoveStudentCardMutationVariables>;

/**
 * __useRemoveStudentCardMutation__
 *
 * To run a mutation, you first call `useRemoveStudentCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentCardMutation, { data, loading, error }] = useRemoveStudentCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useRemoveStudentCardMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStudentCardMutation, RemoveStudentCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStudentCardMutation, RemoveStudentCardMutationVariables>(RemoveStudentCardDocument, options);
      }
export type RemoveStudentCardMutationHookResult = ReturnType<typeof useRemoveStudentCardMutation>;
export type RemoveStudentCardMutationResult = Apollo.MutationResult<RemoveStudentCardMutation>;
export type RemoveStudentCardMutationOptions = Apollo.BaseMutationOptions<RemoveStudentCardMutation, RemoveStudentCardMutationVariables>;
export const SyncUserDocument = gql`
    mutation SyncUser($auth0Key: String!) {
  syncUser(auth0Key: $auth0Key)
}
    `;
export type SyncUserMutationFn = Apollo.MutationFunction<SyncUserMutation, SyncUserMutationVariables>;

/**
 * __useSyncUserMutation__
 *
 * To run a mutation, you first call `useSyncUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserMutation, { data, loading, error }] = useSyncUserMutation({
 *   variables: {
 *      auth0Key: // value for 'auth0Key'
 *   },
 * });
 */
export function useSyncUserMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserMutation, SyncUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserMutation, SyncUserMutationVariables>(SyncUserDocument, options);
      }
export type SyncUserMutationHookResult = ReturnType<typeof useSyncUserMutation>;
export type SyncUserMutationResult = Apollo.MutationResult<SyncUserMutation>;
export type SyncUserMutationOptions = Apollo.BaseMutationOptions<SyncUserMutation, SyncUserMutationVariables>;